import { React, useState, useEffect, useRef, useContext } from "react";
import {
  RightLayoutContainer,
  PageTitleComp,
  TableLayoutData,
  DetailFields,
  HaberForm,
  DownArrowDraw,
  GroupTitle,
} from "../../styledElements";
import {
  Button,
  PageHeader,
  Table,
  Tooltip,
  Form,
  Input,
  Row,
  Col,
  Tabs,
  Checkbox,
  Progress,
  Select,
} from "antd";
import axios from "axios";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { Styled, StyledTab } from "../../pageStyled";
import { useNavigate, Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import { getFormObject, setFormObject } from "../../../Services/formServices";
import SearchContainer from "../../../Components/SearchBarHeader/searchBar";
import moment from "moment";
import {
  getDeckleMachineOrders,
  getDeckleMachineOrdersForMultiStage,
  getFilteredMachineOrders,
  getFilteredMachineOrdersForMultiStage,
  machineSelectedOrders,
  machineSelectedOrdersMultiStage,
  searchDeckleMachineOrders,
  searchDeckleMachineOrdersForMultiStage,
} from "../../../Services/machineServices";
import TableShimmer from "../../../Components/TableShimmer/tableShimmer";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import SelectOrderModal from "../../../Components/Modal/SelectOrderModal";
import warning from "../../../Assets/Icons/warning.png";
import styled from "styled-components";
import ViewDeckleOrder from "../DeckleOrderDrawer/viewDeckleOrder";
import OrderFilter from "../../../Components/OrderFilter/Filter";
import emptyState_Search from "../../../Assets/Images/emptyState_Search.svg";
import emptyState_NoData from "../../../Assets/Images/emptyState_NoData.svg";
import emptyState_ConnectionAPIError from "../../../Assets/Images/emptyState_ConnectionAPIError.svg";
import EmptyState from "../../../Components/EmptyState/emptyState";
import {
  cancelJobCard,
  saveBulkDeckleOrders,
} from "../../../Services/deckleMatchServices";
import {
  orderDim_Rewinder_Unit_Conversion,
  weight_Unit_Conversions,
  CoversionFactorCMToUnits,
  lengthUnit,
  weightUnit,
  CoversionFactorUnitsToCM,
  conversionFactorTonneToUnits,
  currency_List,
  conversionFactorUnitsToTonne,
} from "../../../Utils/Constant/MeasurementUnitList";
import { getUnitData } from "../../../Services/measurementService";
import {
  PaperMachineQualitySelect,
  PaperMachineGradeSelect,
} from "../../../Pages/pageStyled";
import Multiselect from "multiselect-react-dropdown";
import { getMachineGradeSelectForConfig, getReelCoreValues } from "../../../Services/settingsServices";
import {
  updateOrder,
  updateOrdersInBulk,
} from "../../../Services/orderServices";
import {
  getMergeGroupsData,
  setMergeGroupsData,
} from "../../../Services/mergeGroupServices";
import { ModalPopup } from "../../../Components/Modal/modal";
import ConfirmationModal from "../../../Components/Modal/ConfirmationModal";
import ReelCoreEditModal from "../../../Components/Modal/ReelCoreEditModal";
import MultiDiaEditOrderDrawer from "../../OrderEntry/OrderDetailDrawer/multiDiaEditOrderDrawer";
import JobCardDataContext from "../../../ContextApi/JobCardDataContext";
import { toHandlePOName } from "../../../Utils/helper/helper";
import { getWorkflowSettings } from "../../../Services/workFlowSettingsServices";

const DropdownArrowStyle = styled.div`
  position: relative;
  &:before {
    content: "";
    position: absolute;
    top: 0px;
    left: 0px;
    width: 7px;
    height: 7px;
    border-top: 2px solid #605e5c;
    border-right: 2px solid #605e5c;
    transform: rotate(135deg);
  }
`;

const OrderDetails = styled.div`
  .pendingDetailsStyle {
    display: block;
    text-align: right;
    padding-bottom: 16px;
    font-size: 14px;
    font-family: var(--sf-pro-display-m);
    color: var(--theme-color);
    line-height: 16px;
  }
  .pendingOrderStyle {
    padding-right: 20px;
  }
`;

const SelectStyle = styled.div`
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border: none;
    margin-top: 10px;
  }
  .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    padding-left: 3px;
    padding-right: 10px;
  }
`;

const multiselectStyle = {
  chips: {},
  searchBox: {
    border: "none",
  },
  option: {
    // To change css for dropdown options
    //background : "gray"
  },
};

const MultiSelectCard = styled.div`
  .optionContainer li:hover,
  .optionContainer .highlight {
    background: #edebe9;
    color: black;
  }
  .multiSelectContainer input[type="text"] {
    padding-left: 15px !important;
    width: 100%;
  }
  .optionContainer .highlight {
    background: white;
    color: black;
  }
  .optionListContainer {
    z-index: 100;
  }
  li.groupHeading {
    color: black;
    padding: 5px 15px;
    pointer-events: none;
    font-weight: 500;
  }
  .multiSelectContainer ul {
    border-radius: 0px;
    margin-top: 4px;
  }
  .multiSelectContainer input[type="checkbox"] {
    accent-color: rgb(234, 101, 91);
  }
  .ant-btn {
    border: 0px solid transparent !important;
  }
`;

const { Option } = Select;
const grainTypeData = ["Long", "Short"];

const Panes = Tabs.TabPane;

const capitalize = (item) => item.charAt(0).toUpperCase() + item.slice(1);

const OrderSummaryData = (props) => {
  const {
    paperMachineOrdersData,
    setPaperMachineOrdersData,
    setPaperMacineData,
    setOrderSummaryTable,
    handleResetAll,
  } = useContext(JobCardDataContext);
  const [userDetails, setUserDetails] = useState(
    JSON.parse(localStorage.getItem("user-details"))
  );
  const [settingsData, setSettingsData] = useState(
    JSON.parse(localStorage.getItem("setting-data"))
  );
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const location = useLocation();
  const [tableData, setTableData] = useState([]);
  const history = useNavigate();
  const source = axios.CancelToken.source();
  // const [retainForm,setRetainForm] = useState(true);
  const nextClickRef = useRef(false);
  const isCancelJobCard = useRef(true);
  const [buttonLoadings, setButtonLoadings] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [clearSearch, setClearSearch] = useState(false);
  const [allOrdersList, setAllOrdersList] = useState();
  const [totalRecords, setTotalRecords] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationParams, setPaginationParams] = useState({
    page: 1,
    size: settingsData?.settings?.default_page_size || 10,
    sort_by: "updated_at",
    sort_type: "descending",
  });
  const paginationParamsRef = useRef({
    page: 1,
    size: settingsData?.settings?.default_page_size || 10,
    sort_by: "updated_at",
    sort_type: "descending",
  });
  const [sortParams, setSortParams] = useState({
    sort_by: "updated_at",
    sort_type: "descending",
  });
  const [loading, setLoading] = useState(true);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedDataRows, setSelectedDataRows] = useState([]);
  const [selectedQuantity, setSelectedQuantity] = useState(0);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [isCheckboxClicked, setIsCheckboxClicked] = useState(false);
  const [visibleToaster, setVisibleToaster] = useState(false);
  const [actionToaster, setActionToaster] = useState();
  const [error, setError] = useState("");
  const [viewDeckleOrders, setViewDeckleOrders] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [filterTags, setFilterTags] = useState([]);
  const [rendering, setRendering] = useState(true);
  const [emptyStateLabel, setEmptyStateLabel] = useState();
  const [emptyStatePropsData, setEmptyStatePropsData] = useState();
  const paginationRef = useRef({ page: 1, size: settingsData?.settings?.default_page_size || 10 });
  const [orderType, setOrderType] = useState("selected_orders");
  const [defaultActiveKey, setDefaultActiveKey] = useState("0");
  const [selectedRecord, setSelectedReocord] = useState();
  const [selectedType, setSelectedType] = useState();
  const [selectedIndex, setSelectedIndex] = useState();
  const [tableRerender, setTableRerender] = useState(false);
  const [isEditClicked, setIsEditClicked] = useState({});
  const [isReelEditClicked, setReelIsEditClicked] = useState({});
  const [plannedQuantityErr, setPlannedQuantityErr] = useState({});
  const [plannedReelErr, setPlannedReelErr] = useState({});
  const [form] = Form.useForm();
  const [editReelCoreModal, setEditReelCoreModal] = useState(false);
  const tableDataRef = useRef();
  const [unitData, setUnitData] = useState(null);
  const [orderTypesData, setOrderTypesData] = useState(null);
  const [isAddRewinderDimension, setIsAddRewinderDimension] = useState(false);
  const [isMoveToSelection, setIsMoveToselection] = useState(false);
  const [selectedReelOD, setSelectedReelOD] = useState([]);
  const [selecteDia, setSelectedDia] = useState("constant");
  const [coreOdValidationError, setCoreOdValidationError] = useState(false);
  const tableDataCopyRef = useRef();
  const [reelODValidationError, setReelODValidationError] = useState(false);
  const diameterType = [
    { label: "Constant", value: "constant" },
    { label: "Range", value: "range" },
  ];
  const [reelValues, setReelvalues] = useState();
  const [coreValues, setCoreValues] = useState();
  const [selectedState, setSelectedState] = useState(false);
  const [measurementData, setMeasurementData] = useState();
  const [reelCoreData, setReelCoreData] = useState();
  const [ordersMoveToSelect, setOrderMoveToSelect] = useState([]);
  const [payload, setPayload] = useState([]);
  const [totalWeight, setTotalWeight] = useState(0);
  const totalRef = useRef(0);
  const [selectedId, setSelectedId] = useState(null);
  const [isTabChange, setIsTabChange] = useState(false);
  const [loadings, setLoadings] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [viewCancelModal, setViewCancelModal] = useState(false);
  const [resendApprovalData, setResendApprovalData] = useState(false);
  const [rangeValidationError, setRangeValidationError] = useState(false);
  const [pageRerender, setPageRerender] = useState(false);
  const [paginationParamsChange, setPaginationParamsChange] = useState(false);
  const [grainType, setGrainType] = useState();
  const [movedOrder, setMovedOrder] = useState([]);
  const [orderManagementSettings, setOrderManagementSettings] = useState(JSON.parse(localStorage.getItem("order-management-settings")));
  const columnBlacklist =
    settingsData?.settings?.orders_page?.tables?.select_orders || [];
  const filtersToBeShown =
    settingsData?.settings?.orders_page?.filters?.po_select_orders || [];
  const format = settingsData?.settings?.product_spec?.format || "";

  const filterOptions = [
    {
      key: 0,
      label: "Filter by Grade/Quality",
      value: "grade_quality",
      type: "grade",
      hiddenColValue: "",
    },
    {
      key: 1,
      label: "Filter by GSM",
      value: "gsm",
      type: "inputSelect",
      hiddenColValue: "",
    },
    {
      key: 2,
      label: "Filter by Burst Factor",
      value: "burst_factor",
      type: "inputSelect",
      hiddenColValue: "",
    },
    {
      key: 3,
      label: "Filter by PO Date",
      value: "po_date",
      type: "date",
      hiddenColValue: "podate",
    },
    {
      key: 4,
      label: "Filter by Delivery Date",
      value: "delivery_date",
      type: "date",
      hiddenColValue: "deliverydate",
    },
    {
      key: 5,
      label: "Filter by Customer",
      value: "customer",
      type: "multiSelect",
      hiddenColValue: "",
    },
    {
      key: 6,
      label: "Filter by Order Type",
      value: "order_type",
      type: "multiSelect",
      hiddenColValue: "type",
    },
    {
      key: 7,
      label: "Filter by Created Date",
      value: "created_date",
      type: "date",
      hiddenColValue: "createddate",
    },
    {
      key: 8,
      label: "Filter by Reel OD",
      value: "reel_od",
      type: "inputSelect",
      unitType: "length",
      hiddenColValue: "",
    },
    {
      key: 9,
      label: "Filter by Core ID",
      value: "core_id",
      type: "inputSelect",
      unitType: "length",
      hiddenColValue: "",
    },
    {
      key: 10,
      label: "Filter by Size",
      value: "size",
      type: "rangeTypeSelect",
      unitType: "length",
      hiddenColValue: "",
    },
    {
      key: 11,
      label: "Filter by Consignee",
      value: "consignee",
      type: "multiSelect",
      hiddenColValue: "consignee_alias",
    },
    // {
    //   key: 10,
    //   label: "Filter by Status",
    //   value: "orderStatus",
    //   type: "multiSelect",
    // },
  ];

  //removing hidden columns
  const updatedFilterOptions = filterOptions.filter(
    (filter) => !columnBlacklist.includes(filter.hiddenColValue)
  );

  //removing first 4 filters
  const finalFilters = updatedFilterOptions
    .filter((filter) => !filtersToBeShown.includes(filter.value))
    .map((filter, index) => ({
      ...filter,
      key: index,
    }));

  // const columnsHead = useRef([
  //   // {
  //   //   title: "Select",
  //   //   dataIndex: "select",
  //   //   width: "1.8%",
  //   //   fixed: "left",
  //   //   align: "center",
  //   //   render: (value, record, rowIndex) => (
  //   //     <div>
  //   //        <Styled>
  //   //     <Checkbox
  //   //       checked={value}
  //   //       onChange={handleCheckboxChangeFactory(rowIndex, "select")}
  //   //     />
  //   //     </Styled>
  //   //     </div>
  //   //   ),
  //   // },
  //   {
  //     title: "Po/So.No",
  //     dataIndex: "pono",
  //     width: "4%",
  //     fixed: "left",
  //     sorter: () => {},

  //     render: (text, record) => (
  //       <span style={{ whiteSpace: 'normal', wordBreak: 'break-word', lineHeight: '1.4' }}>
  //         {
  //           `${record.category === "so" ? record.sono : record.pono}`
  //             .match(/.{1,15}/g)
  //             ?.map((chunk, index) => (
  //               <span key={index}>
  //                 {chunk}
  //                 <br />
  //               </span>
  //             ))
  //         }
  //       </span>
  //     )
  //   },
  //   {
  //     title: "Order No",
  //     dataIndex: "orderno",
  //     width: "3%",
  //     fixed: "left",
  //     sorter: () => {},
  //   },
  //   {
  //     title: "PO Date",
  //     dataIndex: "podate",
  //     width: "3%",
  //     fixed: "left",
  //     sorter: {
  //       compare: (a, b) => new Date(a.podate) - new Date(b.podate),
  //     },
  //   },

  //   {
  //     title: "Customer",
  //     dataIndex: "customer_alias",
  //     width: "3%",
  //     align: "left",
  //     render: (text, record) => (
  //       <div className="actionBtn2">
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={`${record.customercode}-${record.customerName}`}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             {record?.customer_alias||'-'}
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //   },
  //   {
  //     title: "Consignee",
  //     dataIndex: "consignee_alias",
  //     width: "3%",
  //     align: "left",
  //     render: (text, record) => (
  //       <div className="actionBtn2">
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={`${record.consignee}-${record.consignee_name}`}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             {record?.consignee_alias||'-'}
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //   },
  //   // {
  //   //   title: "Prod. Code",
  //   //   dataIndex: "productcode",
  //   //   width: "2.5%",
  //   // },
  //   {
  //     title: (
  //       <div>
  //         Product
  //         <Styled style={{ display: "inline-flex" }}>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={
  //               "The product specification is in the format of Grade/GSM/BF/Quality/Moisture"
  //             }
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <span className="infoIcon"></span>
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //     render: (text, record) => (
  //       <Styled>
  //         {" "}
  //         <span style={{ fontSize: "10px" }}>{record.productspec} </span>
  //         <br />
  //         <span style={{ textAlign: "center" }}>{record.productcode}</span>
  //       </Styled>
  //     ),
  //     //dataIndex: "productspec",
  //     width: "5%",
  //   },
  //   {
  //     title: "Type",
  //     dataIndex: "type",
  //     width: "3%",
  //   },
  //   {
  //     title: "Ply",
  //     dataIndex: "ply",
  //     width: "3%",
  //   },
  //   {
  //     title: "Size(WxL)",
  //     dataIndex: "size",
  //     width: "4%",
  //   },
  //   {
  //     title: "Grain",
  //     dataIndex: "grain",
  //     width: "4%",
  //     render: (text, record, index) => (
  //       <Styled>
  //        { record.order_type.toLowerCase() == 'sheet' ? ( <div style={{ display: "flex" }}>
  //        <Row className="centerAlign">
  //        <div className="boxFormType">
  //         <SelectStyle>
  //         <Form.Item
  //                         name={`grain${record.id}`}
  //                         rules={[
  //                           {
  //                             required: true,
  //                             message: "This field is required",
  //                           },
  //                         ]}
  //                         className="selectForm"
  //                         style={{ marginBottom: 4 }}
  //                         initialValue={record.grain ? record.grain == 'short' ? 'Short' :
  //                         'Long' : null}
  //                       >
  //                         <Select
  //                           placeholder={"Select"}
  //                           suffixIcon={<DropdownArrowStyle />}
  //                           onChange={(e) => onGrainChange(e,record,index)}
  //                           >
  //                           {grainTypeData.map((grainType) => (
  //                             <Option key={grainType}>{grainType}</Option>
  //                           ))}
  //                         </Select>
  //         </Form.Item>
  //         </SelectStyle>
  //         </div>
  //         </Row>
  //         </div>
  //         ): ''}
  //       </Styled>
  //     ),
  //   },
  //   // {
  //   //   title: "Order Weight",
  //   //   dataIndex: "weight",
  //   //   width: "3%",
  //   //   render: (text, record) =>
  //   //     record.quantity_type === "reel_sheet" ? "-" : `${text} ${record.units  && record.item_type !== "split_group" ? weightUnit[record.units.weight]?.displayName?.toUpperCase() : weightUnit[record.units.total_weight].displayName?.toUpperCase()}`,
  //   // },
  //   {
  //     title: "Order Quantity",
  //     dataIndex: "quantity",
  //     width: "4%",
  //     render: (text, record) =>
  //     <Styled>

  //     {" "}
  //    { record.type.toLowerCase() == "sheet" && record.quantity_type.toLowerCase() == "reel_sheet" ?
  //    <><span style={{textAlign:"center",fontSize:'12px'}}>{text}</span><br/> <span> {record.no_of_sheets + ' Sheets'} </span>
  //      </> : `${text} `}
  // </Styled>
  //   },
  //   {
  //     title: "Pending Quantity",
  //     dataIndex: "pendingQuant",
  //     width: "4%",
  //     render: (text, record) =>
  //     <Styled>

  //     {" "}
  //    { record.type.toLowerCase() == "sheet" && record.quantity_type.toLowerCase() == "reel_sheet" ?
  //    <><span style={{textAlign:"center",fontSize:'12px'}}>{text}</span><br/> <span> {record.total_pending_quantity.quantity + ' Sheets'} </span>
  //      </> : `${text} `}
  // </Styled>
  //   },
  //   {
  //     title: "Quantity to be planned",
  //     dataIndex: "plannedQuant",
  //     width: "8%",
  //     render: (text, record, index) => (
  //       <div
  //         className="actionBtn"
  //         style={{
  //           marginTop:
  //             isEditClicked?.[record.orderno] &&
  //             isEditClicked?.[record.orderno].isEditable
  //               ? "10px"
  //               : "5px",
  //           justifyContent: "left",
  //         }}
  //       >
  //         {(!isEditClicked?.[record.orderno] ||
  //           (isEditClicked?.[record.orderno] &&
  //             !isEditClicked?.[record.orderno].isEditable)) && (
  //           <Col span={12}>
  //             {" "}
  //             {text} {record.plannedUnit}{" "}
  //           </Col>
  //         )}
  //         {(!isEditClicked?.[record.orderno] ||
  //           (isEditClicked?.[record.orderno] &&
  //             !isEditClicked?.[record.orderno].isEditable &&
  //             userDetails?.roles?.job_cards.edit)) && (
  //           <Col span={12}>
  //             <Styled style={{ marginTop: "-7px" }}>
  //               <Tooltip
  //                 placement="bottomRight"
  //                 title={"Edit planned quantity"}
  //                 className="edit-tooltip"
  //                 getPopupContainer={(triggerNode) => triggerNode}
  //               >
  //                 <Button
  //                   onClick={() => {
  //                     handleEditColumn(index, record, true);
  //                   }}
  //                 >
  //                   <Iconmoon icon="edit" size={16} color="#A19F9D" />
  //                 </Button>
  //               </Tooltip>
  //             </Styled>
  //           </Col>
  //         )}
  //         {isEditClicked?.[record.orderno] &&
  //           isEditClicked?.[record.orderno].isEditable && (
  //             <DetailFields style={{ paddingBottom: "0px" }}>
  //               <Styled>
  //                 <HaberForm>
  //                   {/* <Form
  //                 id="form"
  //                 form={form}
  //                 name="basic"
  //                 autoComplete="off"
  //                 className="qtyToBePlannedInput"
  //                 onFinish={onFinish}
  //               > */}
  //                   <Row className="centerAlign justifyCSBetween">
  //                     <Col span={14} style={{ paddingRight: "5px" }}>
  //                       <div className="boxFormType">
  //                         <Form.Item
  //                           name={`plannedQuanty${record?.orderno}`}
  //                           rules={[
  //                             {
  //                               required: true,
  //                               message: "This field is required.",
  //                             },
  //                             {
  //                               pattern: new RegExp(
  //                                 /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
  //                               ),
  //                               message:
  //                                 "This value should be a non-zero positive value.",
  //                             },
  //                             {
  //                               validator(_, value) {
  //                                 if (
  //                                   record.pendingQuant &&
  //                                   record.pendingQuant?.split(" ")[0] &&
  //                                   parseFloat(value) > 0
  //                                 ) {
  //                                   if (
  //                                     parseFloat(
  //                                       onValitdateQtyChange(
  //                                         value,
  //                                         record,
  //                                         index
  //                                       )
  //                                     ) <=
  //                                     parseFloat(
  //                                       record.pendingQuant?.split(" ")[0]
  //                                     )
  //                                   ) {
  //                                     return Promise.resolve();
  //                                   } else {
  //                                     return Promise.reject(
  //                                       record?.quantity_type == "reel_sheet" &&
  //                                         record?.type == "Sheet"
  //                                         ? `The weight of ${value} sheets (${parseFloat(
  //                                             onValitdateQtyChange(
  //                                               value,
  //                                               record,
  //                                               index
  //                                             )
  //                                           )} ${capitalize(
  //                                             weightUnit[
  //                                               record.total_pending_quantity
  //                                                 .units.weight
  //                                             ]?.displayName
  //                                           )}), can't be more than pending quantity.`
  //                                         : "Quantity to be planned can't be more than the pending quantity."
  //                                     );
  //                                   }
  //                                 } else {
  //                                   return Promise.reject("");
  //                                 }
  //                               },
  //                             },
  //                           ]}
  //                           className="dBlock"
  //                           initialValue={text}
  //                         >
  //                           <Input
  //                             onChange={(e) => {
  //                               onPlannedQuntyChange(e, record, index);
  //                             }}
  //                           />
  //                         </Form.Item>
  //                         <span
  //                           className="nonEditable"
  //                           style={{ marginTop: "0px" }}
  //                         >
  //                           {record.plannedUnit}
  //                         </span>
  //                       </div>
  //                     </Col>
  //                     <Col
  //                       span={10}
  //                       style={{ paddingRight: "5px", marginTop: "0px" }}
  //                     >
  //                       <div
  //                         className="boxFormType"
  //                         style={{ marginBottom: "0", marginTop: "7px" }}
  //                       >
  //                         {(!plannedQuantityErr?.[record.orderno] ||
  //                           (plannedQuantityErr?.[record.orderno] &&
  //                             !plannedQuantityErr?.[record.orderno].error)) && (
  //                           <Tooltip title={"Save the entered value"}>
  //                             <Button
  //                               key="1"
  //                               className="edit-btn"
  //                               style={{
  //                                 padding: "0px",
  //                                 margin: "0px",
  //                                 width: "28px",
  //                                 border: "none",
  //                                 display: "inline-block",
  //                                 marginRight: "10px",
  //                               }}
  //                               onClick={() =>
  //                                 onActionChange(index, "save", record)
  //                               }
  //                             >
  //                               <Iconmoon
  //                                 icon="check"
  //                                 size={18}
  //                                 color="#3FBD61"
  //                               />
  //                             </Button>
  //                           </Tooltip>
  //                         )}

  //                         <Tooltip title={"Remove the entered value"}>
  //                           <Button
  //                             key="2"
  //                             className="edit-btn"
  //                             style={{
  //                               padding: "0px",
  //                               margin: "0px",
  //                               width: "28px",
  //                               border: "none",
  //                               display: "inline-block",
  //                             }}
  //                             onClick={() =>
  //                               onActionChange(index, "remove", record)
  //                             }
  //                           >
  //                             <Iconmoon icon="cancel" size={18} color="red" />
  //                           </Button>
  //                         </Tooltip>
  //                       </div>
  //                     </Col>
  //                   </Row>
  //                   {/* </Form> */}
  //                 </HaberForm>
  //               </Styled>
  //             </DetailFields>
  //           )}
  //       </div>
  //     ),
  //   },
  //   {
  //     title: "Reel OD for Rewinding",
  //     dataIndex: "reelod",
  //     width: "5%",
  //     render: (text, record, index) => (
  //       <Styled>
  //         <div style={{ display: "flex" }}>
  //           {record.id_od_type == "range" && (
  //             <div style={{ color: "var(--para-text)",display : 'flex' , width : "70%",alignSelf:'center' }}>
  //             {(record.minimum_reel_od && record.maximum_reel_od) ? (record.minimum_reel_od + "-" + record.maximum_reel_od + " " +
  //                 (record.units.maximum_reel_od ? lengthUnit[record.units.maximum_reel_od].displayName : "")) : ""}
  //           </div>
  //           )}
  //           {record.id_od_type == "constant" && (
  //             <div
  //               style={{
  //                 display: "flex",
  //                 width: "70%",
  //                 flexDirection: "column",
  //                 alignSelf: "center",
  //               }}
  //             >
  //               {record.reelod &&
  //                 record.reelod?.map((item, index) => {
  //                   return (
  //                     index < 2 && (
  //                       <div>
  //                         {item}{" "}
  //                         {index == 1
  //                           ? "...,"
  //                           : record.reelod.length > 1
  //                           ? ","
  //                           : ""}
  //                       </div>
  //                     )
  //                   );
  //                 })}

  //               {record.reelod &&
  //                 record.reelod?.length >= 2 &&
  //                 record.reelod?.map((item, index) => {
  //                   let tooltipData = "";
  //                   for (
  //                     let index = 2;
  //                     index < record.reelod?.length;
  //                     index++
  //                   ) {
  //                     const data = record.reelod[index];
  //                     tooltipData = tooltipData + data + ", ";
  //                   }
  //                   tooltipData = tooltipData.substring(
  //                     0,
  //                     tooltipData.length - 1
  //                   );
  //                   return (
  //                     index == 2 && (
  //                       <Tooltip title={tooltipData}>
  //                         {" "}
  //                         <span
  //                           style={{
  //                             display: "flex",
  //                             fontSize: "10px",
  //                             fontWeight: "bold",
  //                           }}
  //                         >
  //                           & {record.reelod.length - 2} More
  //                         </span>
  //                       </Tooltip>
  //                     )
  //                   );
  //                 })}
  //             </div>
  //           )}
  //           <div style={{ display: "flex", width: "30%" }}>
  //             <div className="actionBtn">
  //               {" "}
  //               {userDetails?.roles?.job_cards.edit && (
  //                 <Button
  //                   onClick={() => showEditReelCoreModal(record, "reel", index)}
  //                   style={{ background: "none" }}
  //                 >
  //                   <Iconmoon icon="down" size={30} color="var(--para-text)" />
  //                 </Button>
  //               )}{" "}
  //             </div>
  //           </div>
  //         </div>
  //       </Styled>
  //     ),
  //   },
  //   {
  //     title: "Core OD for Rewinding",
  //     dataIndex: "coreid",
  //     width: "4%",
  //     render: (text, record, index) => (
  //       <div className="actionBtn">
  //         <Styled>
  //           <div style={{ display: "flex" }}>
  //             <div
  //               style={{
  //                 color: "var(--para-text)",
  //                 display: "flex",
  //                 width: "70%",
  //                 alignSelf: "center",
  //               }}
  //             >
  //               {record.coreid}
  //             </div>

  //             <div style={{ display: "flex", width: "30%" }}>
  //               <div className="actionBtn">
  //                 {" "}
  //                 {userDetails?.roles?.job_cards.edit && (
  //                   <Button
  //                     onClick={() =>
  //                       showEditReelCoreModal(record, "core", index)
  //                     }
  //                     style={{ background: "none" }}
  //                   >
  //                     <Iconmoon
  //                       icon="down"
  //                       size={30}
  //                       color="var(--para-text)"
  //                     />
  //                   </Button>
  //                 )}{" "}
  //               </div>
  //             </div>
  //           </div>
  //         </Styled>
  //       </div>
  //     ),
  //   },

  //   {
  //     title: "Planned Reels",
  //     dataIndex: "rewinderreels",
  //     width: "8%",
  //     render: (text, record, index) => (
  //       <div
  //         className="actionBtn"
  //         style={{
  //           marginTop:
  //             isReelEditClicked?.[record.orderno] &&
  //             isReelEditClicked?.[record.orderno].isEditable
  //               ? "10px"
  //               : "5px",
  //           justifyContent: "left",
  //         }}
  //       >
  //         {(!isReelEditClicked?.[record.orderno] ||
  //           (isReelEditClicked?.[record.orderno] &&
  //             !isReelEditClicked?.[record.orderno].isEditable)) && (
  //           <Col span={12}>
  //             {" "}
  //             {record.rewinderreels != 0 ? (  record.rewinderreels + ' Reels') : '-'}
  //           </Col>
  //         )}
  //         {((!isReelEditClicked?.[record.orderno] ||
  //           (isReelEditClicked?.[record.orderno] &&
  //             !isReelEditClicked?.[record.orderno].isEditable &&
  //             userDetails?.roles?.job_cards.edit)) &&
  //          ( record.reelod.length === 1 && record.id_od_type == 'constant') && ( record.order_type  == 'sheet' || ( record.order_type  == 'reel' && record.quantity_type == 'weight'))) && (
  //             <Col span={12}>
  //               <Styled style={{ marginTop: "-7px" }}>
  //                 <Tooltip
  //                   placement="bottomRight"
  //                   title={"Edit planned quantity"}
  //                   className="edit-tooltip"
  //                   getPopupContainer={(triggerNode) => triggerNode}
  //                 >
  //                   <Button
  //                     onClick={() => {
  //                       handleReelEditColumn(index, record, true);
  //                     }}
  //                   >
  //                     <Iconmoon icon="edit" size={16} color="#A19F9D" />
  //                   </Button>
  //                 </Tooltip>
  //               </Styled>
  //             </Col>
  //           )}
  //         {isReelEditClicked?.[record.orderno] &&
  //           isReelEditClicked?.[record.orderno].isEditable && (
  //             <DetailFields style={{ paddingBottom: "0px" }}>
  //               <Styled>
  //                 <HaberForm>
  //                   {/* <Form
  //                 id="form"
  //                 form={form}
  //                 name="basic"
  //                 autoComplete="off"
  //                 className="qtyToBePlannedInput"
  //                 onFinish={onFinish}
  //               > */}
  //                   <Row className="centerAlign justifyCSBetween">
  //                     <Col span={14} style={{ paddingRight: "5px" }}>
  //                       <div className="boxFormType">
  //                         <Form.Item
  //                           name={`rewinderreels${record?.orderno}`}
  //                           rules={[
  //                             {
  //                               required: true,
  //                               message: "This field is required.",
  //                             },
  //                             {
  //                               pattern: new RegExp(
  //                                 /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
  //                               ),
  //                               message:
  //                                 "This value should be a non-zero positive value.",
  //                             },
  //                           ]}
  //                           className="dBlock"
  //                           initialValue={text}
  //                         >
  //                           <Input
  //                             onChange={(e) => {
  //                               onPlannedReelChange(e, record, index);
  //                             }}
  //                           />
  //                         </Form.Item>
  //                         <span
  //                           className="nonEditable"
  //                           style={{ marginTop: "0px" }}
  //                         >
  //                           {"Reels"}
  //                         </span>
  //                       </div>
  //                     </Col>
  //                     <Col
  //                       span={10}
  //                       style={{ paddingRight: "5px", marginTop: "0px" }}
  //                     >
  //                       <div
  //                         className="boxFormType"
  //                         style={{ marginBottom: "0", marginTop: "7px" }}
  //                       >
  //                         {(!plannedReelErr?.[record.orderno] ||
  //                           (plannedReelErr?.[record.orderno] &&
  //                             !plannedReelErr?.[record.orderno].error)) && (
  //                           <Tooltip title={"Save the entered value"}>
  //                             <Button
  //                               key="1"
  //                               className="edit-btn"
  //                               style={{
  //                                 padding: "0px",
  //                                 margin: "0px",
  //                                 width: "28px",
  //                                 border: "none",
  //                                 display: "inline-block",
  //                                 marginRight: "10px",
  //                               }}
  //                               onClick={() =>
  //                                 onPlannedReelActionChange(
  //                                   index,
  //                                   "save",
  //                                   record
  //                                 )
  //                               }
  //                             >
  //                               <Iconmoon
  //                                 icon="check"
  //                                 size={18}
  //                                 color="#3FBD61"
  //                               />
  //                             </Button>
  //                           </Tooltip>
  //                         )}

  //                         <Tooltip title={"Remove the entered value"}>
  //                           <Button
  //                             key="2"
  //                             className="edit-btn"
  //                             style={{
  //                               padding: "0px",
  //                               margin: "0px",
  //                               width: "28px",
  //                               border: "none",
  //                               display: "inline-block",
  //                             }}
  //                             onClick={() =>
  //                               onPlannedReelActionChange(
  //                                 index,
  //                                 "remove",
  //                                 record
  //                               )
  //                             }
  //                           >
  //                             <Iconmoon icon="cancel" size={18} color="red" />
  //                           </Button>
  //                         </Tooltip>
  //                       </div>
  //                     </Col>
  //                   </Row>
  //                   {/* </Form> */}
  //                 </HaberForm>
  //               </Styled>
  //             </DetailFields>
  //           )}
  //       </div>
  //     ),
  //   },
  //   {
  //     title: "Planned Weight",
  //     dataIndex: "plannedweight",
  //     width: "3%",
  //     render: (text, record) => `${text}`,
  //   },
  //   {
  //     title: "Created Date",
  //     dataIndex: "createddate",
  //     width: "4%",
  //   },
  //   {
  //     title: "Delivery Date",
  //     dataIndex: "deliverydate",
  //     width: "4%",
  //   },
  //   {
  //     title: "Remarks",
  //     dataIndex: "remarks",
  //     width: "4%",
  //     render: (text, record) => (
  //       <div className="actionBtn">
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={record.remarks}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <Button style={{ cursor: "default" }}>
  //               <Iconmoon icon="message" size={16} color="#EA655B" />
  //             </Button>
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //     align: "center",
  //   },
  //   {
  //     title: "Progress",
  //     dataIndex: "progress",
  //     width: "5%",
  //     render: (text, record) => {
  //       // if(record.item_type && record.item_type === "order"){
  //       if (
  //         record?.order_type === "sheet" ||
  //         (record?.order_type === "reel" &&
  //           record?.quantity_type === "weight"
  //           )
  //       ) {
  //         const totalProd =
  //           ((record?.progressbar_info?.completed?.weight + record?.progressbar_info?.in_production?.weight) /
  //            (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
  //           100;
  //         const totalCompleted =
  //           (record?.progressbar_info?.completed?.weight /
  //           (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
  //           100;
  //         //const weightUnitKey =  ((record?.units && record?.units?.weight) ? capitalize(weightUnit[record.units.weight]?.displayName) : "T") ;
  //         return (
  //           <div className="progressLvl">
  //             <Styled>
  //               <Tooltip
  //                 placement="bottomRight"
  //                 title={`${
  //                   record?.progressbar_info?.completed
  //                     ? (record?.progressbar_info?.completed?.weight).toFixed(3)
  //                     : 0.0
  //                 } ${capitalize(weightUnit[record?.progressbar_info?.completed?.units?.weight].displayName)} Weight produced
  //                         ${
  //                           record?.progressbar_info?.in_production
  //                           ? (record?.progressbar_info?.in_production?.weight).toFixed(3)
  //                           : 0.0
  //                       } ${capitalize(weightUnit[record?.progressbar_info?.in_production?.units?.weight].displayName)} Weight in production
  //                       ${
  //                         record?.progressbar_info?.pending
  //                         ? (record?.progressbar_info?.pending?.weight).toFixed(3)
  //                         : 0.0
  //                     } ${capitalize(weightUnit[record?.progressbar_info?.pending?.units?.weight].displayName)} Weight pending for deckle match`}
  //                 className="edit-tooltip"
  //                 getPopupContainer={(triggerNode) => triggerNode}
  //               >
  //                 <Progress
  //                   percent={totalProd}
  //                   success={{
  //                     percent: totalCompleted ,
  //                   }}
  //                   strokeColor={"#cbe2cd"}
  //                 />
  //               </Tooltip>
  //             </Styled>
  //           </div>
  //         );
  //       } else {
  //         const production =
  //           ((record?.progressbar_info?.completed?.quantity + record?.progressbar_info?.in_production?.quantity) /
  //           (record?.no_of_reel_sheet - record.cancelled_quantity?.quantity)) *
  //           100;
  //         const completed = (record?.progressbar_info?.completed?.quantity / (record?.no_of_reel_sheet - record.cancelled_quantity?.quantity)) * 100;

  //         return (
  //           <div className="progressLvl">
  //             <Styled>
  //               <Tooltip
  //                 placement="bottomRight"
  //                 title={`${ record?.progressbar_info?.completed
  //                   ? (record?.progressbar_info?.completed?.quantity)
  //                   : 0} Reels produced
  //                         ${record?.progressbar_info?.in_production
  //                           ? (record?.progressbar_info?.in_production?.quantity) : 0} Reels in production
  //                         ${record?.progressbar_info?.pending
  //                           ? (record?.progressbar_info?.pending?.quantity)
  //                           : 0} Reels pending for deckle match`}
  //                 className="edit-tooltip"
  //                 getPopupContainer={(triggerNode) => triggerNode}
  //               >
  //                 <Progress
  //                   percent={production}
  //                   success={{
  //                     percent: completed,
  //                   }}
  //                   strokeColor={"#cbe2cd"}
  //                 />
  //               </Tooltip>
  //             </Styled>
  //           </div>
  //         );
  //       }

  //     },
  //     align: "center",
  //   },
  //   {
  //     title: "Actions",
  //     dataIndex: "action",
  //     width: "5%",
  //     render: (text, record) => (
  //       <div className="actionBtn">
  //         {userDetails.roles.job_cards.edit ? (
  //           <Styled>
  //             <Tooltip
  //               placement="bottomRight"
  //               title={"Edit planning details"}
  //               className="edit-tooltip"
  //               getPopupContainer={(triggerNode) => triggerNode}
  //             >
  //               <Button
  //                 onClick={() => {
  //                   handleEditAction(record);
  //                 }}
  //               >
  //                 <Iconmoon icon="edit" size={16} color="#A19F9D" />
  //               </Button>
  //             </Tooltip>
  //           </Styled>
  //         ) : (
  //           <div style={{ display: "flex" }}>
  //             <div style={{ width: "38px" }}></div>
  //           </div>
  //         )}
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={"View details of this order"}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <Button
  //               onClick={() => {
  //                 handleActions(record);
  //               }}
  //               // disabled={!userDetails.roles.job_cards.view}
  //               disabled={
  //                 !(
  //                   userDetails?.roles?.approve_jobcards.view ||
  //                   userDetails?.roles?.job_cards.view ||
  //                   userDetails?.roles?.job_cards.edit ||
  //                   userDetails?.role_type == "ADMIN" ||
  //                   userDetails?.role_type == "SUPER_ADMIN"
  //                 )
  //               }
  //             >
  //               <Iconmoon icon="file-view" size={16} color="#A19F9D" />
  //             </Button>
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //     align: "center",
  //   },
  // ]);

  // const cutterSelectedOrderColumnsHead = useRef([
  //   {
  //     title: "Po/So.No",
  //     dataIndex: "pono",
  //     width: "4%",
  //     fixed: "left",
  //     // align: "left",
  //     sorter: () => {},
  //     render: (text, record) => (
  //       <span style={{ whiteSpace: 'normal', wordBreak: 'break-word', lineHeight: '1.4' }}>
  //         {
  //           `${record.category === "so" ? record.sono : record.pono}`
  //             .match(/.{1,15}/g)
  //             ?.map((chunk, index) => (
  //               <span key={index}>
  //                 {chunk}
  //                 <br />
  //               </span>
  //             ))
  //         }
  //       </span>
  //     )
  //   },
  //   {
  //     title: "Order No",
  //     dataIndex: "orderno",
  //     width: "3%",
  //     fixed: "left",
  //     sorter: () => {},
  //   },
  //   {
  //     title: "PO Date",
  //     dataIndex: "podate",
  //     width: "3%",
  //     fixed: "left",
  //     sorter: {
  //       compare: (a, b) => new Date(a.podate) - new Date(b.podate),
  //     },
  //   },

  //   {
  //     title: "Customer",
  //     dataIndex: "customer_alias",
  //     width: "3%",
  //     align: "left",
  //     render: (text, record) => (
  //       <div className="actionBtn2">
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={`${record.customercode}-${record.customerName}`}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             {record?.customer_alias||'-'}
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //   },
  //   {
  //     title: "Consignee",
  //     dataIndex: "consignee_alias",
  //     width: "3%",
  //     align: "left",
  //     render: (text, record) => (
  //       <div className="actionBtn2">
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={`${record.consignee}-${record.consignee_name}`}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             {record?.consignee_alias||'-'}
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //   },
  //   // {
  //   //   title: "Prod. Code",
  //   //   dataIndex: "productcode",
  //   //   width: "2.5%",
  //   // },
  //   {
  //     title: (
  //       <div>
  //         Product
  //         <Styled style={{ display: "inline-flex" }}>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={
  //               "The product specification is in the format of Grade/GSM/BF/Quality/Moisture"
  //             }
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <span className="infoIcon"></span>
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //     render: (text, record) => (
  //       <Styled>
  //         {" "}
  //         <span style={{ fontSize: "10px" }}>{record.productspec} </span>
  //         <br />
  //         <span style={{ textAlign: "center" }}>{record.productcode}</span>
  //       </Styled>
  //     ),
  //     //dataIndex: "productspec",
  //     width: "5%",
  //   },
  //   {
  //     title: "Size(WxL)",
  //     dataIndex: "size",
  //     width: "4%",
  //   },
  //   {
  //     title: "Grain",
  //     dataIndex: "grain",
  //     width: "4%",
  //     render: (text, record, index) => (
  //       <Styled>
  //        { record.order_type.toLowerCase() == 'sheet' ? ( <div style={{ display: "flex" }}>
  //        <Row className="centerAlign">
  //        <div className="boxFormType">
  //         <SelectStyle>
  //         <Form.Item
  //                         name={`grain${record.id}`}
  //                         rules={[
  //                           {
  //                             required: true,
  //                             message: "This field is required",
  //                           },
  //                         ]}
  //                         className="selectForm"
  //                         style={{ marginBottom: 4 }}
  //                         initialValue={record.grain ? record.grain == 'short' ? 'Short' :
  //                         'Long' : null}
  //                       >
  //                         <Select
  //                           placeholder={"Select"}
  //                           suffixIcon={<DropdownArrowStyle />}
  //                           onChange={(e) => onGrainChange(e,record,index)}
  //                           >
  //                           {grainTypeData.map((grainType) => (
  //                             <Option key={grainType}>{grainType}</Option>
  //                           ))}
  //                         </Select>
  //         </Form.Item>
  //         </SelectStyle>
  //         </div>
  //         </Row>
  //         </div>
  //         ): ''}
  //       </Styled>
  //     ),
  //   },
  //   {
  //     title: "Order Quantity",
  //     dataIndex: "quantity",
  //     width: "4%",
  //     render: (text, record) =>
  //     <Styled>

  //     {" "}
  //    { record.type.toLowerCase() == "sheet" && record.quantity_type.toLowerCase() == "reel_sheet" ?
  //    <><span style={{textAlign:"center",fontSize:'12px'}}>{text}</span><br/> <span> {record.no_of_sheets + ' Sheets'} </span>
  //      </> : `${text} `}
  // </Styled>
  //   },
  //   {
  //     title: "Pending Quantity",
  //     dataIndex: "pendingQuant",
  //     width: "4%",
  //     render: (text, record) =>
  //     <Styled>

  //     {" "}
  //    { record.type.toLowerCase() == "sheet" && record.quantity_type.toLowerCase() == "reel_sheet" ?
  //    <><span style={{textAlign:"center",fontSize:'12px'}}>{text}</span><br/> <span> {record.total_pending_quantity.quantity + ' Sheets'} </span>
  //      </> : `${text} `}
  // </Styled>
  //   },
  //   {
  //     title: "Quantity to be planned",
  //     dataIndex: "plannedQuant",
  //     width: "8%",
  //     render: (text, record, index) => (
  //       <div
  //         className="actionBtn"
  //         style={{
  //           marginTop:
  //             isEditClicked?.[record.orderno] &&
  //             isEditClicked?.[record.orderno].isEditable
  //               ? "10px"
  //               : "5px",
  //           justifyContent: "left",
  //         }}
  //       >
  //         {(!isEditClicked?.[record.orderno] ||
  //           (isEditClicked?.[record.orderno] &&
  //             !isEditClicked?.[record.orderno].isEditable)) && (
  //           <Col span={12}>
  //             {" "}
  //             {text} {record.plannedUnit}{" "}
  //           </Col>
  //         )}
  //         {(!isEditClicked?.[record.orderno] ||
  //           (isEditClicked?.[record.orderno] &&
  //             !isEditClicked?.[record.orderno].isEditable &&
  //             userDetails?.roles?.job_cards.edit)) && (
  //           <Col span={12}>
  //             <Styled style={{ marginTop: "-7px" }}>
  //               <Tooltip
  //                 placement="bottomRight"
  //                 title={"Edit planned quantity"}
  //                 className="edit-tooltip"
  //                 getPopupContainer={(triggerNode) => triggerNode}
  //               >
  //                 <Button
  //                   onClick={() => {
  //                     handleEditColumn(index, record, true);
  //                   }}
  //                 >
  //                   <Iconmoon icon="edit" size={16} color="#A19F9D" />
  //                 </Button>
  //               </Tooltip>
  //             </Styled>
  //           </Col>
  //         )}
  //         {isEditClicked?.[record.orderno] &&
  //           isEditClicked?.[record.orderno].isEditable && (
  //             <DetailFields style={{ paddingBottom: "0px" }}>
  //               <Styled>
  //                 <HaberForm>
  //                   {/* <Form
  //                 id="form"
  //                 form={form}
  //                 name="basic"
  //                 autoComplete="off"
  //                 className="qtyToBePlannedInput"
  //                 onFinish={onFinish}
  //               > */}
  //                   <Row className="centerAlign justifyCSBetween">
  //                     <Col span={14} style={{ paddingRight: "5px" }}>
  //                       <div className="boxFormType">
  //                         <Form.Item
  //                           name={`plannedQuanty${record?.orderno}`}
  //                           rules={[
  //                             {
  //                               required: true,
  //                               message: "This field is required.",
  //                             },
  //                             {
  //                               pattern: new RegExp(
  //                                 /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
  //                               ),
  //                               message:
  //                                 "This value should be a non-zero positive value.",
  //                             },
  //                             {
  //                               validator(_, value) {
  //                                 if (
  //                                   record.pendingQuant &&
  //                                   record.pendingQuant?.split(" ")[0] &&
  //                                   parseFloat(value) > 0
  //                                 ) {
  //                                   if (
  //                                     parseFloat(
  //                                       onValitdateQtyChange(
  //                                         value,
  //                                         record,
  //                                         index
  //                                       )
  //                                     ) <=
  //                                     parseFloat(
  //                                       record.pendingQuant?.split(" ")[0]
  //                                     )
  //                                   ) {
  //                                     return Promise.resolve();
  //                                   } else {
  //                                     return Promise.reject(
  //                                       record?.quantity_type == "reel_sheet" &&
  //                                         record?.type == "Sheet"
  //                                         ? `The weight of ${value} sheets (${parseFloat(
  //                                             onValitdateQtyChange(
  //                                               value,
  //                                               record,
  //                                               index
  //                                             )
  //                                           )} ${capitalize(
  //                                             weightUnit[
  //                                               record.total_pending_quantity
  //                                                 .units.weight
  //                                             ]?.displayName
  //                                           )}), can't be more than pending quantity.`
  //                                         : "Quantity to be planned can't be more than the pending quantity."
  //                                     );
  //                                   }
  //                                 } else {
  //                                   return Promise.reject("");
  //                                 }
  //                               },
  //                             },
  //                           ]}
  //                           className="dBlock"
  //                           initialValue={text}
  //                         >
  //                           <Input
  //                             onChange={(e) => {
  //                               onPlannedQuntyChange(e, record, index);
  //                             }}
  //                           />
  //                         </Form.Item>
  //                         <span
  //                           className="nonEditable"
  //                           style={{ marginTop: "0px" }}
  //                         >
  //                           {record.plannedUnit}
  //                         </span>
  //                       </div>
  //                     </Col>
  //                     <Col
  //                       span={10}
  //                       style={{ paddingRight: "5px", marginTop: "0px" }}
  //                     >
  //                       <div
  //                         className="boxFormType"
  //                         style={{ marginBottom: "0", marginTop: "7px" }}
  //                       >
  //                         {(!plannedQuantityErr?.[record.orderno] ||
  //                           (plannedQuantityErr?.[record.orderno] &&
  //                             !plannedQuantityErr?.[record.orderno].error)) && (
  //                           <Tooltip title={"Save the entered value"}>
  //                             <Button
  //                               key="1"
  //                               className="edit-btn"
  //                               style={{
  //                                 padding: "0px",
  //                                 margin: "0px",
  //                                 width: "28px",
  //                                 border: "none",
  //                                 display: "inline-block",
  //                                 marginRight: "10px",
  //                               }}
  //                               onClick={() =>
  //                                 onActionChange(index, "save", record)
  //                               }
  //                             >
  //                               <Iconmoon
  //                                 icon="check"
  //                                 size={18}
  //                                 color="#3FBD61"
  //                               />
  //                             </Button>
  //                           </Tooltip>
  //                         )}

  //                         <Tooltip title={"Remove the entered value"}>
  //                           <Button
  //                             key="2"
  //                             className="edit-btn"
  //                             style={{
  //                               padding: "0px",
  //                               margin: "0px",
  //                               width: "28px",
  //                               border: "none",
  //                               display: "inline-block",
  //                             }}
  //                             onClick={() =>
  //                               onActionChange(index, "remove", record)
  //                             }
  //                           >
  //                             <Iconmoon icon="cancel" size={18} color="red" />
  //                           </Button>
  //                         </Tooltip>
  //                       </div>
  //                     </Col>
  //                   </Row>
  //                   {/* </Form> */}
  //                 </HaberForm>
  //               </Styled>
  //             </DetailFields>
  //           )}
  //       </div>
  //     ),
  //   },
  //   {
  //     title: "Delivery Date",
  //     dataIndex: "deliverydate",
  //     width: "2.9%",
  //     sorter: {
  //       compare: (a, b) => new Date(a.deliverydate) - new Date(b.deliverydate),
  //     },
  //   },
  //   {
  //     title: "Created Date",
  //     dataIndex: "createddate",
  //     width: "2.9%",
  //     sorter: {
  //       compare: (a, b) => new Date(a.deliverydate) - new Date(b.deliverydate),
  //     },
  //   },
  //   {
  //     title: "Priority",
  //     dataIndex: "priority",
  //     width: "5%",
  //     render: (text, record) => (
  //       <div className="actionBtn">
  //         <Button style={{ cursor: "default" }}>
  //           <Iconmoon
  //             icon={record.priority ? "correct" : "wrong"}
  //             size={16}
  //             color={record.priority ? "#3FBD61" : "#a19f9d"}
  //           />
  //         </Button>
  //       </div>
  //     ),
  //     align: "center",
  //   },
  //   {
  //     title: "Remarks",
  //     dataIndex: "remarks",
  //     width: "4%",
  //     render: (text, record) => (
  //       <div className="actionBtn">
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={record.remarks}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <Button style={{ cursor: "default" }}>
  //               <Iconmoon icon="message" size={16} color="#EA655B" />
  //             </Button>
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //     align: "center",
  //   },
  //   {
  //     title: "Progress",
  //     dataIndex: "progress",
  //     width: "5%",
  //     render: (text, record) => {
  //       // if(record.item_type && record.item_type === "order"){
  //       if (
  //         record?.order_type === "sheet" ||
  //         (record?.order_type === "reel" &&
  //           record?.quantity_type === "weight"
  //           )
  //       ) {
  //         const totalProd =
  //           ((record?.progressbar_info?.completed?.weight + record?.progressbar_info?.in_production?.weight) /
  //            (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
  //           100;
  //         const totalCompleted =
  //           (record?.progressbar_info?.completed?.weight /
  //           (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
  //           100;
  //         //const weightUnitKey =  ((record?.units && record?.units?.weight) ? capitalize(weightUnit[record.units.weight]?.displayName) : "T") ;
  //         return (
  //           <div className="progressLvl">
  //             <Styled>
  //               <Tooltip
  //                 placement="bottomRight"
  //                 title={`${
  //                   record?.progressbar_info?.completed
  //                     ? (record?.progressbar_info?.completed?.weight).toFixed(3)
  //                     : 0.0
  //                 } ${capitalize(weightUnit[record?.progressbar_info?.completed?.units?.weight].displayName)} Weight produced
  //                         ${
  //                           record?.progressbar_info?.in_production
  //                           ? (record?.progressbar_info?.in_production?.weight).toFixed(3)
  //                           : 0.0
  //                       } ${capitalize(weightUnit[record?.progressbar_info?.in_production?.units?.weight].displayName)} Weight in production
  //                       ${
  //                         record?.progressbar_info?.pending
  //                         ? (record?.progressbar_info?.pending?.weight).toFixed(3)
  //                         : 0.0
  //                     } ${capitalize(weightUnit[record?.progressbar_info?.pending?.units?.weight].displayName)} Weight pending for deckle match`}
  //                 className="edit-tooltip"
  //                 getPopupContainer={(triggerNode) => triggerNode}
  //               >
  //                 <Progress
  //                   percent={totalProd}
  //                   success={{
  //                     percent: totalCompleted ,
  //                   }}
  //                   strokeColor={"#cbe2cd"}
  //                 />
  //               </Tooltip>
  //             </Styled>
  //           </div>
  //         );
  //       } else {
  //         const production =
  //           ((record?.progressbar_info?.completed?.quantity + record?.progressbar_info?.in_production?.quantity) /
  //           (record?.no_of_reel_sheet - record.cancelled_quantity?.quantity)) *
  //           100;
  //         const completed = (record?.progressbar_info?.completed?.quantity / (record?.no_of_reel_sheet - record.cancelled_quantity?.quantity)) * 100;

  //         return (
  //           <div className="progressLvl">
  //             <Styled>
  //               <Tooltip
  //                 placement="bottomRight"
  //                 title={`${ record?.progressbar_info?.completed
  //                   ? (record?.progressbar_info?.completed?.quantity)
  //                   : 0} Reels produced
  //                         ${record?.progressbar_info?.in_production
  //                           ? (record?.progressbar_info?.in_production?.quantity) : 0} Reels in production
  //                         ${record?.progressbar_info?.pending
  //                           ? (record?.progressbar_info?.pending?.quantity)
  //                           : 0} Reels pending for deckle match`}
  //                 className="edit-tooltip"
  //                 getPopupContainer={(triggerNode) => triggerNode}
  //               >
  //                 <Progress
  //                   percent={production}
  //                   success={{
  //                     percent: completed,
  //                   }}
  //                   strokeColor={"#cbe2cd"}
  //                 />
  //               </Tooltip>
  //             </Styled>
  //           </div>
  //         );
  //       }

  //     },
  //     align: "center",
  //   },
  //   {
  //     title: "Actions",
  //     dataIndex: "action",
  //     width: "5%",
  //     render: (text, record) => (
  //       <div className="actionBtn">
  //         {userDetails.roles.job_cards.edit ? (
  //           <Styled>
  //             <Tooltip
  //               placement="bottomRight"
  //               title={"Edit planning details"}
  //               className="edit-tooltip"
  //               getPopupContainer={(triggerNode) => triggerNode}
  //             >
  //               <Button
  //                 onClick={() => {
  //                   handleEditAction(record);
  //                 }}
  //               >
  //                 <Iconmoon icon="edit" size={16} color="#A19F9D" />
  //               </Button>
  //             </Tooltip>
  //           </Styled>
  //         ) : (
  //           <div style={{ display: "flex" }}>
  //             <div style={{ width: "38px" }}></div>
  //           </div>
  //         )}
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={"View details of this order"}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <Button
  //               onClick={() => {
  //                 handleActions(record);
  //               }}
  //               // disabled={!userDetails.roles.job_cards.view}
  //               disabled={
  //                 !(
  //                   userDetails?.roles?.approve_jobcards.view ||
  //                   userDetails?.roles?.job_cards.view ||
  //                   userDetails?.roles?.job_cards.edit ||
  //                   userDetails?.role_type == "ADMIN" ||
  //                   userDetails?.role_type == "SUPER_ADMIN"
  //                 )
  //               }
  //             >
  //               <Iconmoon icon="file-view" size={16} color="#A19F9D" />
  //             </Button>
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //     align: "center",
  //   },
  // ]);

  // const cutterOtherOrderColumnsHead = useRef([
  //   {
  //     title: "Po/So.No",
  //     dataIndex: "pono",
  //     width: "4%",
  //     fixed: "left",
  //     // align: "left",
  //     sorter: () => {},
  //     render: (text, record) => (
  //       <span style={{ whiteSpace: 'normal', wordBreak: 'break-word', lineHeight: '1.4' }}>
  //         {
  //           `${record.category === "so" ? record.sono : record.pono}`
  //             .match(/.{1,15}/g)
  //             ?.map((chunk, index) => (
  //               <span key={index}>
  //                 {chunk}
  //                 <br />
  //               </span>
  //             ))
  //         }
  //       </span>
  //     )
  //   },
  //   {
  //     title: "Order No",
  //     dataIndex: "orderno",
  //     width: "3%",
  //     fixed: "left",
  //     sorter: () => {},
  //   },
  //   {
  //     title: "PO Date",
  //     dataIndex: "podate",
  //     width: "3%",
  //     fixed: "left",
  //     sorter: {
  //       compare: (a, b) => new Date(a.podate) - new Date(b.podate),
  //     },
  //   },

  //   {
  //     title: "Customer",
  //     dataIndex: "customer_alias",
  //     width: "3%",
  //     align: "left",
  //     render: (text, record) => (
  //       <div className="actionBtn2">
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={`${record.customercode}-${record.customerName}`}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             {record?.customer_alias||'-'}
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //   },
  //   {
  //     title: "Consignee",
  //     dataIndex: "consignee_alias",
  //     width: "3%",
  //     align: "left",
  //     render: (text, record) => (
  //       <div className="actionBtn2">
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={`${record.consignee}-${record.consignee_name}`}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             {record?.consignee_alias||'-'}
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //   },
  //   {
  //     title: (
  //       <div>
  //         Product
  //         <Styled style={{ display: "inline-flex" }}>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={
  //               "The product specification is in the format of Grade/GSM/BF/Quality/Moisture"
  //             }
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <span className="infoIcon"></span>
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //     render: (text, record) => (
  //       <Styled>
  //         {" "}
  //         <span style={{ fontSize: "10px" }}>{record.productspec} </span>
  //         <br />
  //         <span style={{ textAlign: "center" }}>{record.productcode}</span>
  //       </Styled>
  //     ),
  //     //dataIndex: "productspec",
  //     width: "5%",
  //   },
  //   {
  //     title: "Size(WxL)",
  //     dataIndex: "size",
  //     width: "4%",
  //   },
  //   {
  //     title: "Grain",
  //     dataIndex: "grain",
  //     width: "4%",
  //     render: (text, record, index) => (
  //       <Styled>
  //        { record.order_type.toLowerCase() == 'sheet' ? ( <div style={{ display: "flex" }}>
  //        <Row className="centerAlign">
  //        <div className="boxFormType">
  //        <SelectStyle>
  //         <Form.Item
  //                         name={`grain${record.id}`}
  //                         rules={[
  //                           {
  //                             required: true,
  //                             message: "This field is required",
  //                           },
  //                         ]}
  //                         className="selectForm"
  //                         style={{ marginBottom: 4 }}
  //                         initialValue={record.grain ? record.grain == 'short' ? 'Short' :
  //                         'Long' : null}
  //                       >
  //                         <Select
  //                           placeholder={"Select"}
  //                           suffixIcon={<DropdownArrowStyle />}
  //                           onChange={(e) => onGrainChange(e,record,index)}
  //                           >
  //                           {grainTypeData.map((grainType) => (
  //                             <Option key={grainType}>{grainType}</Option>
  //                           ))}
  //                         </Select>
  //         </Form.Item>
  //         </SelectStyle>
  //         </div>
  //         </Row>
  //         </div>
  //         ): ''}
  //       </Styled>
  //     ),
  //   },
  //   {
  //     title: "Order Quantity",
  //     dataIndex: "quantity",
  //     width: "4%",
  //     render: (text, record) =>
  //     <Styled>

  //     {" "}
  //    { record.type.toLowerCase() == "sheet" && record.quantity_type.toLowerCase() == "reel_sheet" ?
  //    <><span style={{textAlign:"center",fontSize:'12px'}}>{text}</span><br/> <span> {record.no_of_sheets + ' Sheets'} </span>
  //      </> : `${text} `}
  // </Styled>
  //   },
  //   {
  //     title: "Pending Quantity",
  //     dataIndex: "pendingQuant",
  //     width: "4%",
  //     render: (text, record) =>
  //     <Styled>

  //     {" "}
  //    { record.type.toLowerCase() == "sheet" && record.quantity_type.toLowerCase() == "reel_sheet" ?
  //    <><span style={{textAlign:"center",fontSize:'12px'}}>{text}</span><br/> <span> {record.total_pending_quantity.quantity + ' Sheets'} </span>
  //      </> : `${text} `}
  // </Styled>
  //   },
  //   {
  //     title: "Quantity to be planned",
  //     dataIndex: "plannedQuant",
  //     width: "8%",
  //     render: (text, record, index) => (
  //       <div
  //         className="actionBtn"
  //         style={{
  //           marginTop:
  //             isEditClicked?.[record.orderno] &&
  //             isEditClicked?.[record.orderno].isEditable
  //               ? "10px"
  //               : "5px",
  //           justifyContent: "left",
  //         }}
  //       >
  //         {(!isEditClicked?.[record.orderno] ||
  //           (isEditClicked?.[record.orderno] &&
  //             !isEditClicked?.[record.orderno].isEditable)) && (
  //           <Col span={12}>
  //             {" "}
  //             {text} {record.plannedUnit}{" "}
  //           </Col>
  //         )}
  //         {(!isEditClicked?.[record.orderno] ||
  //           (isEditClicked?.[record.orderno] &&
  //             !isEditClicked?.[record.orderno].isEditable &&
  //             userDetails?.roles?.job_cards.edit)) && (
  //           <Col span={12}>
  //             <Styled style={{ marginTop: "-7px" }}>
  //               <Tooltip
  //                 placement="bottomRight"
  //                 title={"Edit planned quantity"}
  //                 className="edit-tooltip"
  //                 getPopupContainer={(triggerNode) => triggerNode}
  //               >
  //                 <Button
  //                   onClick={() => {
  //                     handleEditColumn(index, record, true);
  //                   }}
  //                 >
  //                   <Iconmoon icon="edit" size={16} color="#A19F9D" />
  //                 </Button>
  //               </Tooltip>
  //             </Styled>
  //           </Col>
  //         )}
  //         {isEditClicked?.[record.orderno] &&
  //           isEditClicked?.[record.orderno].isEditable && (
  //             <DetailFields style={{ paddingBottom: "0px" }}>
  //               <Styled>
  //                 <HaberForm>
  //                   {/* <Form
  //                 id="form"
  //                 form={form}
  //                 name="basic"
  //                 autoComplete="off"
  //                 className="qtyToBePlannedInput"
  //                 onFinish={onFinish}
  //               > */}
  //                   <Row className="centerAlign justifyCSBetween">
  //                     <Col span={14} style={{ paddingRight: "5px" }}>
  //                       <div className="boxFormType">
  //                         <Form.Item
  //                           name={`plannedQuanty${record?.orderno}`}
  //                           rules={[
  //                             {
  //                               required: true,
  //                               message: "This field is required.",
  //                             },
  //                             {
  //                               pattern: new RegExp(
  //                                 /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
  //                               ),
  //                               message:
  //                                 "This value should be a non-zero positive value.",
  //                             },
  //                             {
  //                               validator(_, value) {
  //                                 if (
  //                                   record.pendingQuant &&
  //                                   record.pendingQuant?.split(" ")[0] &&
  //                                   parseFloat(value) > 0
  //                                 ) {
  //                                   if (
  //                                     parseFloat(
  //                                       onValitdateQtyChange(
  //                                         value,
  //                                         record,
  //                                         index
  //                                       )
  //                                     ) <=
  //                                     parseFloat(
  //                                       record.pendingQuant?.split(" ")[0]
  //                                     )
  //                                   ) {
  //                                     return Promise.resolve();
  //                                   } else {
  //                                     return Promise.reject(
  //                                       record?.quantity_type == "reel_sheet" &&
  //                                         record?.type == "Sheet"
  //                                         ? `The weight of ${value} sheets (${parseFloat(
  //                                             onValitdateQtyChange(
  //                                               value,
  //                                               record,
  //                                               index
  //                                             )
  //                                           )} ${capitalize(
  //                                             weightUnit[
  //                                               record.total_pending_quantity
  //                                                 .units.weight
  //                                             ]?.displayName
  //                                           )}), can't be more than pending quantity.`
  //                                         : "Quantity to be planned can't be more than the pending quantity."
  //                                     );
  //                                   }
  //                                 } else {
  //                                   return Promise.reject("");
  //                                 }
  //                               },
  //                             },
  //                           ]}
  //                           className="dBlock"
  //                           initialValue={text}
  //                         >
  //                           <Input
  //                             onChange={(e) => {
  //                               onPlannedQuntyChange(e, record, index);
  //                             }}
  //                           />
  //                         </Form.Item>
  //                         <span
  //                           className="nonEditable"
  //                           style={{ marginTop: "0px" }}
  //                         >
  //                           {record.plannedUnit}
  //                         </span>
  //                       </div>
  //                     </Col>
  //                     <Col
  //                       span={10}
  //                       style={{ paddingRight: "5px", marginTop: "0px" }}
  //                     >
  //                       <div
  //                         className="boxFormType"
  //                         style={{ marginBottom: "0", marginTop: "7px" }}
  //                       >
  //                         {(!plannedQuantityErr?.[record.orderno] ||
  //                           (plannedQuantityErr?.[record.orderno] &&
  //                             !plannedQuantityErr?.[record.orderno].error)) && (
  //                           <Tooltip title={"Save the entered value"}>
  //                             <Button
  //                               key="1"
  //                               className="edit-btn"
  //                               style={{
  //                                 padding: "0px",
  //                                 margin: "0px",
  //                                 width: "28px",
  //                                 border: "none",
  //                                 display: "inline-block",
  //                                 marginRight: "10px",
  //                               }}
  //                               onClick={() =>
  //                                 onActionChange(index, "save", record)
  //                               }
  //                             >
  //                               <Iconmoon
  //                                 icon="check"
  //                                 size={18}
  //                                 color="#3FBD61"
  //                               />
  //                             </Button>
  //                           </Tooltip>
  //                         )}

  //                         <Tooltip title={"Remove the entered value"}>
  //                           <Button
  //                             key="2"
  //                             className="edit-btn"
  //                             style={{
  //                               padding: "0px",
  //                               margin: "0px",
  //                               width: "28px",
  //                               border: "none",
  //                               display: "inline-block",
  //                             }}
  //                             onClick={() =>
  //                               onActionChange(index, "remove", record)
  //                             }
  //                           >
  //                             <Iconmoon icon="cancel" size={18} color="red" />
  //                           </Button>
  //                         </Tooltip>
  //                       </div>
  //                     </Col>
  //                   </Row>
  //                   {/* </Form> */}
  //                 </HaberForm>
  //               </Styled>
  //             </DetailFields>
  //           )}
  //       </div>
  //     ),
  //   },
  //   {
  //     title: "Reel OD for Rewinding",
  //     dataIndex: "reelod",
  //     width: "5%",
  //     render: (text, record, index) => (
  //       <Styled>
  //         <div style={{ display: "flex" }}>
  //           {record.id_od_type == "range" && (
  //             <div style={{ color: "var(--para-text)",display : 'flex' , width : "70%",alignSelf:'center' }}>
  //             {(record.minimum_reel_od && record.maximum_reel_od) ? (record.minimum_reel_od + "-" + record.maximum_reel_od + " " +
  //                 (record.units.maximum_reel_od ? lengthUnit[record.units.maximum_reel_od].displayName : "")) : ""}
  //           </div>
  //           )}
  //           {record.id_od_type == "constant" && (
  //             <div
  //               style={{
  //                 display: "flex",
  //                 width: "70%",
  //                 flexDirection: "column",
  //                 alignSelf: "center",
  //               }}
  //             >
  //               {record.reelod &&
  //                 record.reelod?.map((item, index) => {
  //                   return (
  //                     index < 2 && (
  //                       <div>
  //                         {item}{" "}
  //                         {index == 1
  //                           ? "...,"
  //                           : record.reelod.length > 1
  //                           ? ","
  //                           : ""}
  //                       </div>
  //                     )
  //                   );
  //                 })}

  //               {record.reelod &&
  //                 record.reelod?.length >= 2 &&
  //                 record.reelod?.map((item, index) => {
  //                   let tooltipData = "";
  //                   for (
  //                     let index = 2;
  //                     index < record.reelod?.length;
  //                     index++
  //                   ) {
  //                     const data = record.reelod[index];
  //                     tooltipData = tooltipData + data + ", ";
  //                   }
  //                   tooltipData = tooltipData.substring(
  //                     0,
  //                     tooltipData.length - 1
  //                   );
  //                   return (
  //                     index == 2 && (
  //                       <Tooltip title={tooltipData}>
  //                         {" "}
  //                         <span
  //                           style={{
  //                             display: "flex",
  //                             fontSize: "10px",
  //                             fontWeight: "bold",
  //                           }}
  //                         >
  //                           & {record.reelod.length - 2} More
  //                         </span>
  //                       </Tooltip>
  //                     )
  //                   );
  //                 })}
  //             </div>
  //           )}
  //         </div>
  //       </Styled>
  //     ),
  //   },
  //   {
  //     title: "Core OD for Rewinding",
  //     dataIndex: "coreid",
  //     width: "4%",
  //     render: (text, record, index) => (
  //       <Styled>
  //         <div style={{ display: "flex" }}>
  //           <div
  //             style={{
  //               color: "var(--para-text)",
  //               display: "flex",
  //               width: "100%",
  //               alignSelf: "center",
  //             }}
  //           >
  //             {record.coreid}
  //           </div>
  //         </div>
  //       </Styled>
  //     ),
  //   },
  //   {
  //     title: "Delivery Date",
  //     dataIndex: "deliverydate",
  //     width: "2.9%",
  //     sorter: {
  //       compare: (a, b) => new Date(a.deliverydate) - new Date(b.deliverydate),
  //     },
  //   },
  //   {
  //     title: "Created Date",
  //     dataIndex: "createddate",
  //     width: "2.9%",
  //     sorter: {
  //       compare: (a, b) => new Date(a.deliverydate) - new Date(b.deliverydate),
  //     },
  //   },
  //   {
  //     title: "Priority",
  //     dataIndex: "priority",
  //     width: "5%",
  //     render: (text, record) => (
  //       <div className="actionBtn">
  //         <Button style={{ cursor: "default" }}>
  //           <Iconmoon
  //             icon={record.priority ? "correct" : "wrong"}
  //             size={16}
  //             color={record.priority ? "#3FBD61" : "#a19f9d"}
  //           />
  //         </Button>
  //       </div>
  //     ),
  //     align: "center",
  //   },
  //   {
  //     title: "Remarks",
  //     dataIndex: "remarks",
  //     width: "4%",
  //     render: (text, record) => (
  //       <div className="actionBtn">
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={record.remarks}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <Button style={{ cursor: "default" }}>
  //               <Iconmoon icon="message" size={16} color="#EA655B" />
  //             </Button>
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //     align: "center",
  //   },
  //   {
  //     title: "Progress",
  //     dataIndex: "progress",
  //     width: "5%",
  //     render: (text, record) => {
  //       // if(record.item_type && record.item_type === "order"){
  //       if (
  //         record?.order_type === "sheet" ||
  //         (record?.order_type === "reel" &&
  //           record?.quantity_type === "weight"
  //           )
  //       ) {
  //         const totalProd =
  //           ((record?.progressbar_info?.completed?.weight + record?.progressbar_info?.in_production?.weight) /
  //            (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
  //           100;
  //         const totalCompleted =
  //           (record?.progressbar_info?.completed?.weight /
  //           (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
  //           100;
  //         //const weightUnitKey =  ((record?.units && record?.units?.weight) ? capitalize(weightUnit[record.units.weight]?.displayName) : "T") ;
  //         return (
  //           <div className="progressLvl">
  //             <Styled>
  //               <Tooltip
  //                 placement="bottomRight"
  //                 title={`${
  //                   record?.progressbar_info?.completed
  //                     ? (record?.progressbar_info?.completed?.weight).toFixed(3)
  //                     : 0.0
  //                 } ${capitalize(weightUnit[record?.progressbar_info?.completed?.units?.weight].displayName)} Weight produced
  //                         ${
  //                           record?.progressbar_info?.in_production
  //                           ? (record?.progressbar_info?.in_production?.weight).toFixed(3)
  //                           : 0.0
  //                       } ${capitalize(weightUnit[record?.progressbar_info?.in_production?.units?.weight].displayName)} Weight in production
  //                       ${
  //                         record?.progressbar_info?.pending
  //                         ? (record?.progressbar_info?.pending?.weight).toFixed(3)
  //                         : 0.0
  //                     } ${capitalize(weightUnit[record?.progressbar_info?.pending?.units?.weight].displayName)} Weight pending for deckle match`}
  //                 className="edit-tooltip"
  //                 getPopupContainer={(triggerNode) => triggerNode}
  //               >
  //                 <Progress
  //                   percent={totalProd}
  //                   success={{
  //                     percent: totalCompleted ,
  //                   }}
  //                   strokeColor={"#cbe2cd"}
  //                 />
  //               </Tooltip>
  //             </Styled>
  //           </div>
  //         );
  //       } else {
  //         const production =
  //           ((record?.progressbar_info?.completed?.quantity + record?.progressbar_info?.in_production?.quantity) /
  //           (record?.no_of_reel_sheet - record.cancelled_quantity?.quantity)) *
  //           100;
  //         const completed = (record?.progressbar_info?.completed?.quantity / (record?.no_of_reel_sheet - record.cancelled_quantity?.quantity)) * 100;

  //         return (
  //           <div className="progressLvl">
  //             <Styled>
  //               <Tooltip
  //                 placement="bottomRight"
  //                 title={`${ record?.progressbar_info?.completed
  //                   ? (record?.progressbar_info?.completed?.quantity)
  //                   : 0} Reels produced
  //                         ${record?.progressbar_info?.in_production
  //                           ? (record?.progressbar_info?.in_production?.quantity) : 0} Reels in production
  //                         ${record?.progressbar_info?.pending
  //                           ? (record?.progressbar_info?.pending?.quantity)
  //                           : 0} Reels pending for deckle match`}
  //                 className="edit-tooltip"
  //                 getPopupContainer={(triggerNode) => triggerNode}
  //               >
  //                 <Progress
  //                   percent={production}
  //                   success={{
  //                     percent: completed,
  //                   }}
  //                   strokeColor={"#cbe2cd"}
  //                 />
  //               </Tooltip>
  //             </Styled>
  //           </div>
  //         );
  //       }

  //     },
  //     align: "center",
  //   },
  //   {
  //     title: "Actions",
  //     dataIndex: "action",
  //     width: "5%",
  //     render: (text, record) => (
  //       <div className="actionBtn">
  //         {userDetails.roles.job_cards.edit ? (
  //           <Styled>
  //             <Tooltip
  //               placement="bottomRight"
  //               title={"Edit planning details"}
  //               className="edit-tooltip"
  //               getPopupContainer={(triggerNode) => triggerNode}
  //             >
  //               <Button
  //                 onClick={() => {
  //                   handleEditAction(record);
  //                 }}
  //               >
  //                 <Iconmoon icon="edit" size={16} color="#A19F9D" />
  //               </Button>
  //             </Tooltip>
  //           </Styled>
  //         ) : (
  //           <div style={{ display: "flex" }}>
  //             <div style={{ width: "38px" }}></div>
  //           </div>
  //         )}
  //         <Styled>
  //           <Tooltip
  //             placement="bottomRight"
  //             title={"View details of this order"}
  //             className="edit-tooltip"
  //             getPopupContainer={(triggerNode) => triggerNode}
  //           >
  //             <Button
  //               onClick={() => {
  //                 handleActions(record);
  //               }}
  //               // disabled={!userDetails.roles.job_cards.view}
  //               disabled={
  //                 !(
  //                   userDetails?.roles?.approve_jobcards.view ||
  //                   userDetails?.roles?.job_cards.view ||
  //                   userDetails?.roles?.job_cards.edit ||
  //                   userDetails?.role_type == "ADMIN" ||
  //                   userDetails?.role_type == "SUPER_ADMIN"
  //                 )
  //               }
  //             >
  //               <Iconmoon icon="file-view" size={16} color="#A19F9D" />
  //             </Button>
  //           </Tooltip>
  //         </Styled>
  //       </div>
  //     ),
  //     align: "center",
  //   },
  // ]);

  const fullColumnsHead = [
    // {
    //   title: "Select",
    //   dataIndex: "select",
    //   width: "1.8%",
    //   fixed: "left",
    //   align: "center",
    //   render: (value, record, rowIndex) => (
    //     <div>
    //        <Styled>
    //     <Checkbox
    //       checked={value}
    //       onChange={handleCheckboxChangeFactory(rowIndex, "select")}
    //     />
    //     </Styled>
    //     </div>
    //   ),
    // },
    {
      title: "Po/So.No",
      dataIndex: "pono",
      width: "4%",
      fixed: "left",
      sorter: () => { },

      render: (text, record) => (
        <span
          style={{
            whiteSpace: "normal",
            wordBreak: "break-word",
            lineHeight: "1.4",
          }}
        >
          {`${record.category === "so"
              ? toHandlePOName(record.sono)
              : toHandlePOName(record.pono)
            }`
            .match(/.{1,15}/g)
            ?.map((chunk, index) => (
              <span key={index}>
                {chunk}
                <br />
              </span>
            ))}
        </span>
      ),
    },
    {
      title: "Order No",
      dataIndex: "orderno",
      width: "3%",
      fixed: "left",
      sorter: () => { },
    },
    {
      title: "PO Date",
      dataIndex: "podate",
      width: "3%",
      fixed: "left",
      sorter: {
        compare: (a, b) => new Date(a.podate) - new Date(b.podate),
      },
    },

    {
      title: "Customer",
      dataIndex: "customer_alias",
      width: "3%",
      align: "left",
      render: (text, record) => (
        <div className="actionBtn2">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={`${record.customercode}-${record.customerName}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {record?.customer_alias || "-"}
            </Tooltip>
          </Styled>
        </div>
      ),
    },
    {
      title: "Consignee",
      dataIndex: "consignee_alias",
      width: "3%",
      align: "left",
      render: (text, record) => (
        <div className="actionBtn2">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={`${record.consignee}-${record.consignee_name}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {record?.consignee_alias || "-"}
            </Tooltip>
          </Styled>
        </div>
      ),
    },
    // {
    //   title: "Prod. Code",
    //   dataIndex: "productcode",
    //   width: "2.5%",
    // },
    {
      title: (
        <div>
          Product
          <Styled style={{ display: "inline-flex" }}>
            <Tooltip
              placement="bottomRight"
              title={`The product specification is in the format of ${format}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <span className="infoIcon"></span>
            </Tooltip>
          </Styled>
        </div>
      ),
      // render: (text, record) => (
      //   <Styled>
      //     {" "}
      //     <span style={{ fontSize: "10px" }}>{record.productspec} </span>
      //     <br />
      //     <span style={{ textAlign: "center" }}>{record.productcode}</span>
      //   </Styled>
      // ),
      // //dataIndex: "productspec",
      // width: "5%",
      // title: "Product",
      dataIndex: "product_spec",
      width: "5%",
    },
    {
      title: "Type",
      dataIndex: "type",
      width: "3%",
    },
    {
      title: "Ply",
      dataIndex: "ply",
      width: "3%",
    },
    {
      title: "Size(WxL)",
      dataIndex: "size",
      width: "4%",
    },
    {
      title: "Grain",
      dataIndex: "grain",
      width: "4%",
      render: (text, record, index) => (
        <Styled>
          {record.order_type.toLowerCase() == "sheet" ? (
            <div style={{ display: "flex" }}>
              <Row className="centerAlign">
                <div className="boxFormType">
                  <SelectStyle>
                    <Form.Item
                      name={`grain${record.id}`}
                      rules={[
                        {
                          required: true,
                          message: "This field is required",
                        },
                      ]}
                      className="selectForm"
                      style={{ marginBottom: 4 }}
                      initialValue={
                        record.grain
                          ? record.grain == "short"
                            ? "Short"
                            : "Long"
                          : null
                      }
                    >
                      <Select
                        placeholder={"Select"}
                        suffixIcon={<DropdownArrowStyle />}
                        onChange={(e) => onGrainChange(e, record, index)}
                      >
                        {grainTypeData.map((grainType) => (
                          <Option key={grainType}>{grainType}</Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </SelectStyle>
                </div>
              </Row>
            </div>
          ) : (
            ""
          )}
        </Styled>
      ),
    },
    // {
    //   title: "Order Weight",
    //   dataIndex: "weight",
    //   width: "3%",
    //   render: (text, record) =>
    //     record.quantity_type === "reel_sheet" ? "-" : `${text} ${record.units  && record.item_type !== "split_group" ? weightUnit[record.units.weight]?.displayName?.toUpperCase() : weightUnit[record.units.total_weight].displayName?.toUpperCase()}`,
    // },
    {
      title: "Order Quantity",
      dataIndex: "quantity",
      width: "4%",
      render: (text, record) => (
        <Styled>
          {" "}
          {record.type.toLowerCase() == "sheet" &&
            record.quantity_type.toLowerCase() == "reel_sheet" ? (
            <>
              <span style={{ textAlign: "center", fontSize: "12px" }}>
                {text}
              </span>
              <br /> <span> {record.no_of_sheets + " Sheets"} </span>
            </>
          ) : (
            `${text} `
          )}
        </Styled>
      ),
    },
    {
      title: "Balance Quantity",
      dataIndex: "balance_qty",
      width: "7.4%",
    },
    {
      title: "Pending Quantity",
      dataIndex: "pendingQuant",
      width: "4%",
      render: (text, record) => (
        record.isConflictingstate ? "ND" :
          <Styled>
            {" "}
            {record.type.toLowerCase() == "sheet" &&
              record.quantity_type.toLowerCase() == "reel_sheet" ? (
              <>
                <span style={{ textAlign: "center", fontSize: "12px" }}>
                  {text}
                </span>
                <br />{" "}
                <span>
                  {" "}
                  {record.total_pending_quantity.quantity + " Sheets"}{" "}
                </span>
              </>
            ) : (
              `${text} `
            )}
          </Styled>
      ),
    },
    {
      title: "Quantity to be planned",
      dataIndex: "plannedQuant",
      width: "8%",
      render: (text, record, index) => (
        <div
          className="actionBtn"
          style={{
            marginTop:
              isEditClicked?.[record.orderno] &&
                isEditClicked?.[record.orderno].isEditable
                ? "10px"
                : "5px",
            justifyContent: "left",
          }}
        >
          {(!isEditClicked?.[record.orderno] ||
            (isEditClicked?.[record.orderno] &&
              !isEditClicked?.[record.orderno].isEditable)) && (
              <Col span={12}>
                {" "}
                {text} {record.plannedUnit}{" "}
              </Col>
            )}
          {(!isEditClicked?.[record.orderno] ||
            (isEditClicked?.[record.orderno] &&
              !isEditClicked?.[record.orderno].isEditable &&
              userDetails?.roles?.job_cards.edit)) && (
              <Col span={12}>
                <Styled style={{ marginTop: "-7px" }}>
                  <Tooltip
                    placement="bottomRight"
                    title={"Edit planned quantity"}
                    className="edit-tooltip"
                    getPopupContainer={(triggerNode) => triggerNode}
                  >
                    <Button
                      onClick={() => {
                        handleEditColumn(index, record, true);
                      }}
                    >
                      <Iconmoon icon="edit" size={16} color="#A19F9D" />
                    </Button>
                  </Tooltip>
                </Styled>
              </Col>
            )}
          {isEditClicked?.[record.orderno] &&
            isEditClicked?.[record.orderno].isEditable && (
              <DetailFields style={{ paddingBottom: "0px" }}>
                <Styled>
                  <HaberForm>
                    {/* <Form
                  id="form"
                  form={form}
                  name="basic"
                  autoComplete="off"
                  className="qtyToBePlannedInput"
                  onFinish={onFinish}
                > */}
                    <Row className="centerAlign justifyCSBetween">
                      <Col span={14} style={{ paddingRight: "5px" }}>
                        <div className="boxFormType">
                          <Form.Item
                            name={`plannedQuanty${record?.orderno}`}
                            rules={[
                              {
                                required: true,
                                message: "This field is required.",
                              },
                              {
                                pattern: new RegExp(
                                  /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
                                ),
                                message:
                                  "This value should be a non-zero positive value.",
                              },
                              {
                                validator(_, value) {
                                  if (
                                    record.pendingQuant &&
                                    record.pendingQuant?.split(" ")[0] &&
                                    parseFloat(value) > 0
                                  ) {
                                    if (
                                      parseFloat(
                                        onValitdateQtyChange(
                                          value,
                                          record,
                                          index
                                        )
                                      ) <=
                                      parseFloat(
                                        record.pendingQuant?.split(" ")[0]
                                      )
                                    ) {
                                      return Promise.resolve();
                                    } else {
                                      return Promise.resolve();
                                      // Promise.reject(
                                      //   record?.quantity_type == "reel_sheet" &&
                                      //     record?.type == "Sheet"
                                      //     ? `The weight of ${value} sheets (${parseFloat(
                                      //         onValitdateQtyChange(
                                      //           value,
                                      //           record,
                                      //           index
                                      //         )
                                      //       )} ${capitalize(
                                      //         weightUnit[
                                      //           record.total_pending_quantity
                                      //             .units.weight
                                      //         ]?.displayName
                                      //       )}), can't be more than pending quantity.`
                                      //     : "Quantity to be planned can't be more than the pending quantity."
                                      // );
                                    }
                                  } else {
                                    return Promise.reject("");
                                  }
                                },
                              },
                            ]}
                            className="dBlock"
                            initialValue={text}
                          >
                            <Input
                              onChange={(e) => {
                                onPlannedQuntyChange(e, record, index);
                              }}
                            />
                          </Form.Item>
                          <span
                            className="nonEditable"
                            style={{ marginTop: "0px" }}
                          >
                            {record.plannedUnit}
                          </span>
                        </div>
                      </Col>
                      <Col
                        span={10}
                        style={{ paddingRight: "5px", marginTop: "0px" }}
                      >
                        <div
                          className="boxFormType"
                          style={{ marginBottom: "0", marginTop: "7px" }}
                        >
                          {(!plannedQuantityErr?.[record.orderno] ||
                            (plannedQuantityErr?.[record.orderno] &&
                              !plannedQuantityErr?.[record.orderno].error)) && (
                              <Tooltip title={"Save the entered value"}>
                                <Button
                                  key="1"
                                  className="edit-btn"
                                  style={{
                                    padding: "0px",
                                    margin: "0px",
                                    width: "28px",
                                    border: "none",
                                    display: "inline-block",
                                    marginRight: "10px",
                                  }}
                                  onClick={() =>
                                    onActionChange(index, "save", record)
                                  }
                                >
                                  <Iconmoon
                                    icon="check"
                                    size={18}
                                    color="#3FBD61"
                                  />
                                </Button>
                              </Tooltip>
                            )}

                          <Tooltip title={"Remove the entered value"}>
                            <Button
                              key="2"
                              className="edit-btn"
                              style={{
                                padding: "0px",
                                margin: "0px",
                                width: "28px",
                                border: "none",
                                display: "inline-block",
                              }}
                              onClick={() =>
                                onActionChange(index, "remove", record)
                              }
                            >
                              <Iconmoon icon="cancel" size={18} color="red" />
                            </Button>
                          </Tooltip>
                        </div>
                      </Col>
                    </Row>
                    {/* </Form> */}
                  </HaberForm>
                </Styled>
              </DetailFields>
            )}
        </div>
      ),
    },
    {
      title: "Reel OD",
      dataIndex: "reelod",
      width: "5%",
      render: (text, record, index) => (
        <Styled>
          <div style={{ display: "flex" }}>
            {record.id_od_type == "range" && (
              <div
                style={{
                  color: "var(--para-text)",
                  display: "flex",
                  width: "70%",
                  alignSelf: "center",
                }}
              >
                {record.minimum_reel_od && record.maximum_reel_od
                  ? record.minimum_reel_od +
                  "-" +
                  record.maximum_reel_od +
                  " " +
                  (record.units.maximum_reel_od
                    ? lengthUnit[record.units.maximum_reel_od].displayName
                    : "")
                  : ""}
              </div>
            )}
            {record.id_od_type == "constant" && (
              <div
                style={{
                  display: "flex",
                  width: "70%",
                  flexDirection: "column",
                  alignSelf: "center",
                }}
              >
                {record.reelod &&
                  record.reelod?.map((item, index) => {
                    return (
                      index < 2 && (
                        <div>
                          {item}{" "}
                          {index == 1
                            ? "...,"
                            : record.reelod.length > 1
                              ? ","
                              : ""}
                        </div>
                      )
                    );
                  })}

                {record.reelod &&
                  record.reelod?.length >= 2 &&
                  record.reelod?.map((item, index) => {
                    let tooltipData = "";
                    for (
                      let index = 2;
                      index < record.reelod?.length;
                      index++
                    ) {
                      const data = record.reelod[index];
                      tooltipData = tooltipData + data + ", ";
                    }
                    tooltipData = tooltipData.substring(
                      0,
                      tooltipData.length - 1
                    );
                    return (
                      index == 2 && (
                        <Tooltip title={tooltipData}>
                          {" "}
                          <span
                            style={{
                              display: "flex",
                              fontSize: "10px",
                              fontWeight: "bold",
                            }}
                          >
                            & {record.reelod.length - 2} More
                          </span>
                        </Tooltip>
                      )
                    );
                  })}
              </div>
            )}
            <div style={{ display: "flex", width: "30%" }}>
              <div className="actionBtn">
                {" "}
                {userDetails?.roles?.job_cards.edit && (
                  <Button
                    onClick={() => showEditReelCoreModal(record, "reel", index)}
                    style={{ background: "none" }}
                  >
                    <Iconmoon icon="down" size={30} color="var(--para-text)" />
                  </Button>
                )}{" "}
              </div>
            </div>
          </div>
        </Styled>
      ),
    },
    {
      title: "Core OD",
      dataIndex: "coreid",
      width: "4%",
      render: (text, record, index) => (
        <div className="actionBtn">
          <Styled>
            <div style={{ display: "flex" }}>
              <div
                style={{
                  color: "var(--para-text)",
                  display: "flex",
                  width: "70%",
                  alignSelf: "center",
                }}
              >
                {record.coreid}
              </div>

              <div style={{ display: "flex", width: "30%" }}>
                <div className="actionBtn">
                  {" "}
                  {userDetails?.roles?.job_cards.edit && (
                    <Button
                      onClick={() =>
                        showEditReelCoreModal(record, "core", index)
                      }
                      style={{ background: "none" }}
                    >
                      <Iconmoon
                        icon="down"
                        size={30}
                        color="var(--para-text)"
                      />
                    </Button>
                  )}{" "}
                </div>
              </div>
            </div>
          </Styled>
        </div>
      ),
    },

    {
      title: "Planned Reels",
      dataIndex: "rewinderreels",
      width: "8%",
      render: (text, record, index) => (
        <div
          className="actionBtn"
          style={{
            marginTop:
              isReelEditClicked?.[record.orderno] &&
                isReelEditClicked?.[record.orderno].isEditable
                ? "10px"
                : "5px",
            justifyContent: "left",
          }}
        >
          {(!isReelEditClicked?.[record.orderno] ||
            (isReelEditClicked?.[record.orderno] &&
              !isReelEditClicked?.[record.orderno].isEditable)) && (
              <Col span={12}>
                {" "}
                {record.rewinderreels != 0
                  ? record.rewinderreels + " Reels"
                  : "-"}
              </Col>
            )}
          {(!isReelEditClicked?.[record.orderno] ||
            (isReelEditClicked?.[record.orderno] &&
              !isReelEditClicked?.[record.orderno].isEditable &&
              userDetails?.roles?.job_cards.edit)) &&
            record.reelod.length === 1 &&
            record.id_od_type == "constant" &&
            (record.order_type == "sheet" ||
              (record.order_type == "reel" &&
                record.quantity_type == "weight")) && (
              <Col span={12}>
                <Styled style={{ marginTop: "-7px" }}>
                  <Tooltip
                    placement="bottomRight"
                    title={"Edit planned quantity"}
                    className="edit-tooltip"
                    getPopupContainer={(triggerNode) => triggerNode}
                  >
                    <Button
                      onClick={() => {
                        handleReelEditColumn(index, record, true);
                      }}
                    >
                      <Iconmoon icon="edit" size={16} color="#A19F9D" />
                    </Button>
                  </Tooltip>
                </Styled>
              </Col>
            )}
          {isReelEditClicked?.[record.orderno] &&
            isReelEditClicked?.[record.orderno].isEditable && (
              <DetailFields style={{ paddingBottom: "0px" }}>
                <Styled>
                  <HaberForm>
                    {/* <Form
                  id="form"
                  form={form}
                  name="basic"
                  autoComplete="off"
                  className="qtyToBePlannedInput"
                  onFinish={onFinish}
                > */}
                    <Row className="centerAlign justifyCSBetween">
                      <Col span={14} style={{ paddingRight: "5px" }}>
                        <div className="boxFormType">
                          <Form.Item
                            name={`rewinderreels${record?.orderno}`}
                            rules={[
                              {
                                required: true,
                                message: "This field is required.",
                              },
                              {
                                pattern: new RegExp(
                                  /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
                                ),
                                message:
                                  "This value should be a non-zero positive value.",
                              },
                            ]}
                            className="dBlock"
                            initialValue={text}
                          >
                            <Input
                              onChange={(e) => {
                                onPlannedReelChange(e, record, index);
                              }}
                            />
                          </Form.Item>
                          <span
                            className="nonEditable"
                            style={{ marginTop: "0px" }}
                          >
                            {"Reels"}
                          </span>
                        </div>
                      </Col>
                      <Col
                        span={10}
                        style={{ paddingRight: "5px", marginTop: "0px" }}
                      >
                        <div
                          className="boxFormType"
                          style={{ marginBottom: "0", marginTop: "7px" }}
                        >
                          {(!plannedReelErr?.[record.orderno] ||
                            (plannedReelErr?.[record.orderno] &&
                              !plannedReelErr?.[record.orderno].error)) && (
                              <Tooltip title={"Save the entered value"}>
                                <Button
                                  key="1"
                                  className="edit-btn"
                                  style={{
                                    padding: "0px",
                                    margin: "0px",
                                    width: "28px",
                                    border: "none",
                                    display: "inline-block",
                                    marginRight: "10px",
                                  }}
                                  onClick={() =>
                                    onPlannedReelActionChange(
                                      index,
                                      "save",
                                      record
                                    )
                                  }
                                >
                                  <Iconmoon
                                    icon="check"
                                    size={18}
                                    color="#3FBD61"
                                  />
                                </Button>
                              </Tooltip>
                            )}

                          <Tooltip title={"Remove the entered value"}>
                            <Button
                              key="2"
                              className="edit-btn"
                              style={{
                                padding: "0px",
                                margin: "0px",
                                width: "28px",
                                border: "none",
                                display: "inline-block",
                              }}
                              onClick={() =>
                                onPlannedReelActionChange(
                                  index,
                                  "remove",
                                  record
                                )
                              }
                            >
                              <Iconmoon icon="cancel" size={18} color="red" />
                            </Button>
                          </Tooltip>
                        </div>
                      </Col>
                    </Row>
                    {/* </Form> */}
                  </HaberForm>
                </Styled>
              </DetailFields>
            )}
        </div>
      ),
    },
    {
      title: "Planned Weight",
      dataIndex: "plannedweight",
      width: "3%",
      render: (text, record) => `${text}`,
    },
    {
      title: "Tolerance Level",
      dataIndex: "tolerancelevel",
      width: "6%",
      render: (text, record) =>
        `LB ${record.calculated_lower_tolerance + capitalize(record?.units?.calculated_lower_tolerance)} UB ${record.calculated_upper_tolerance + capitalize(record?.units?.calculated_upper_tolerance)}`,
    },
    {
      title: "Created Date",
      dataIndex: "createddate",
      width: "4%",
    },
    {
      title: "Delivery Date",
      dataIndex: "deliverydate",
      width: "4%",
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      width: "4%",
      render: (text, record) => (
        <div className="actionBtn">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={record.remarks}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button style={{ cursor: "default" }}>
                <Iconmoon icon="message" size={16} color="#EA655B" />
              </Button>
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },
    {
      title: "Progress",
      dataIndex: "progress",
      width: "5%",
      render: (text, record) => {
        // if(record.item_type && record.item_type === "order"){
        if (!record.isConflictingstate) {
          if (
            record?.order_type === "sheet" ||
            (record?.order_type === "reel" && record?.quantity_type === "weight")
          ) {
            const totalProd =
              ((record?.progressbar_info?.completed?.weight +
                record?.progressbar_info?.in_production?.weight) /
                (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
              100;
            const totalCompleted =
              (record?.progressbar_info?.completed?.weight /
                (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
              100;
            //const weightUnitKey =  ((record?.units && record?.units?.weight) ? capitalize(weightUnit[record.units.weight]?.displayName) : "T") ;
            return (
              <div className="progressLvl">
                <Styled>
                  <Tooltip
                    placement="bottomRight"
                    title={`${record?.progressbar_info?.completed
                        ? (record?.progressbar_info?.completed?.weight).toFixed(3)
                        : 0.0
                      } ${capitalize(
                        weightUnit[
                          record?.progressbar_info?.completed?.units?.weight
                        ].displayName
                      )} Weight produced
                          ${record?.progressbar_info?.in_production
                        ? (record?.progressbar_info?.in_production?.weight).toFixed(
                          3
                        )
                        : 0.0
                      } ${capitalize(
                        weightUnit[
                          record?.progressbar_info?.in_production?.units?.weight
                        ].displayName
                      )} Weight in production
                        ${record?.progressbar_info?.pending
                        ? (record?.progressbar_info?.pending?.weight).toFixed(
                          3
                        )
                        : 0.0
                      } ${capitalize(
                        weightUnit[record?.progressbar_info?.pending?.units?.weight]
                          .displayName
                      )} Weight pending for deckle match`}
                    className="edit-tooltip"
                    getPopupContainer={(triggerNode) => triggerNode}
                  >
                    <Progress
                      percent={totalProd}
                      success={{
                        percent: totalCompleted,
                      }}
                      strokeColor={"#cbe2cd"}
                    />
                  </Tooltip>
                </Styled>
              </div>
            );
          } else {
            const production =
              ((record?.progressbar_info?.completed?.quantity +
                record?.progressbar_info?.in_production?.quantity) /
                (record?.no_of_reel_sheet -
                  record.cancelled_quantity?.quantity)) *
              100;
            const completed =
              (record?.progressbar_info?.completed?.quantity /
                (record?.no_of_reel_sheet -
                  record.cancelled_quantity?.quantity)) *
              100;

            return (
              <div className="progressLvl">
                <Styled>
                  <Tooltip
                    placement="bottomRight"
                    title={`${record?.progressbar_info?.completed
                        ? record?.progressbar_info?.completed?.quantity
                        : 0
                      } Reels produced
                          ${record?.progressbar_info?.in_production
                        ? record?.progressbar_info?.in_production
                          ?.quantity
                        : 0
                      } Reels in production
                          ${record?.progressbar_info?.pending
                        ? record?.progressbar_info?.pending?.quantity
                        : 0
                      } Reels pending for deckle match`}
                    className="edit-tooltip"
                    getPopupContainer={(triggerNode) => triggerNode}
                  >
                    <Progress
                      percent={production}
                      success={{
                        percent: completed,
                      }}
                      strokeColor={"#cbe2cd"}
                    />
                  </Tooltip>
                </Styled>
              </div>
            );
          }
        }
      },
      align: "center",
    },
    {
      title: "Actions",
      dataIndex: "action",
      width: "5%",
      render: (text, record) => (
        <div className="actionBtn">
          {userDetails.roles.job_cards.edit ? (
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={"Edit planning details"}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button
                  onClick={() => {
                    handleEditAction(record);
                  }}
                >
                  <Iconmoon icon="edit" size={16} color="#A19F9D" />
                </Button>
              </Tooltip>
            </Styled>
          ) : (
            <div style={{ display: "flex" }}>
              <div style={{ width: "38px" }}></div>
            </div>
          )}
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={"View details of this order"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button
                onClick={() => {
                  handleActions(record);
                }}
                // disabled={!userDetails.roles.job_cards.view}
                disabled={
                  !(
                    userDetails?.roles?.approve_jobcards.view ||
                    userDetails?.roles?.job_cards.view ||
                    userDetails?.roles?.job_cards.edit ||
                    userDetails?.role_type == "ADMIN" ||
                    userDetails?.role_type == "SUPER_ADMIN"
                  )
                }
              >
                <Iconmoon icon="file-view" size={16} color="#A19F9D" />
              </Button>
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },
  ];

  const fullCutterSelectedOrderColumnsHead = [
    {
      title: "Po/So.No",
      dataIndex: "pono",
      width: "4%",
      fixed: "left",
      // align: "left",
      sorter: () => { },
      render: (text, record) => (
        <span
          style={{
            whiteSpace: "normal",
            wordBreak: "break-word",
            lineHeight: "1.4",
          }}
        >
          {`${record.category === "so"
              ? toHandlePOName(record.sono)
              : toHandlePOName(record.pono)
            }`
            .match(/.{1,15}/g)
            ?.map((chunk, index) => (
              <span key={index}>
                {chunk}
                <br />
              </span>
            ))}
        </span>
      ),
    },
    {
      title: "Order No",
      dataIndex: "orderno",
      width: "3%",
      fixed: "left",
      sorter: () => { },
    },
    {
      title: "PO Date",
      dataIndex: "podate",
      width: "3%",
      fixed: "left",
      sorter: {
        compare: (a, b) => new Date(a.podate) - new Date(b.podate),
      },
    },

    {
      title: "Customer",
      dataIndex: "customer_alias",
      width: "3%",
      align: "left",
      render: (text, record) => (
        <div className="actionBtn2">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={`${record.customercode}-${record.customerName}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {record?.customer_alias || "-"}
            </Tooltip>
          </Styled>
        </div>
      ),
    },
    {
      title: "Consignee",
      dataIndex: "consignee_alias",
      width: "3%",
      align: "left",
      render: (text, record) => (
        <div className="actionBtn2">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={`${record.consignee}-${record.consignee_name}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {record?.consignee_alias || "-"}
            </Tooltip>
          </Styled>
        </div>
      ),
    },
    // {
    //   title: "Prod. Code",
    //   dataIndex: "productcode",
    //   width: "2.5%",
    // },
    {
      title: (
        <div>
          Product
          <Styled style={{ display: "inline-flex" }}>
            <Tooltip
              placement="bottomRight"
              title={`The product specification is in the format of ${format}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <span className="infoIcon"></span>
            </Tooltip>
          </Styled>
        </div>
      ),
      // render: (text, record) => (
      //   <Styled>
      //     {" "}
      //     <span style={{ fontSize: "10px" }}>{record.productspec} </span>
      //     <br />
      //     <span style={{ textAlign: "center" }}>{record.productcode}</span>
      //   </Styled>
      // ),
      // //dataIndex: "productspec",
      // width: "5%",
      // title: "Product",
      dataIndex: "product_spec",
      width: "5%",
    },
    {
      title: "Size(WxL)",
      dataIndex: "size",
      width: "4%",
    },
    {
      title: "Grain",
      dataIndex: "grain",
      width: "4%",
      render: (text, record, index) => (
        <Styled>
          {record.order_type.toLowerCase() == "sheet" ? (
            <div style={{ display: "flex" }}>
              <Row className="centerAlign">
                <div className="boxFormType">
                  <SelectStyle>
                    <Form.Item
                      name={`grain${record.id}`}
                      rules={[
                        {
                          required: true,
                          message: "This field is required",
                        },
                      ]}
                      className="selectForm"
                      style={{ marginBottom: 4 }}
                      initialValue={
                        record.grain
                          ? record.grain == "short"
                            ? "Short"
                            : "Long"
                          : null
                      }
                    >
                      <Select
                        placeholder={"Select"}
                        suffixIcon={<DropdownArrowStyle />}
                        onChange={(e) => onGrainChange(e, record, index)}
                      >
                        {grainTypeData.map((grainType) => (
                          <Option key={grainType}>{grainType}</Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </SelectStyle>
                </div>
              </Row>
            </div>
          ) : (
            ""
          )}
        </Styled>
      ),
    },
    {
      title: "Order Quantity",
      dataIndex: "quantity",
      width: "4%",
      render: (text, record) => (
        <Styled>
          {" "}
          {record.type.toLowerCase() == "sheet" &&
            record.quantity_type.toLowerCase() == "reel_sheet" ? (
            <>
              <span style={{ textAlign: "center", fontSize: "12px" }}>
                {text}
              </span>
              <br /> <span> {record.no_of_sheets + " Sheets"} </span>
            </>
          ) : (
            `${text} `
          )}
        </Styled>
      ),
    },
    {
      title: "Balance Quantity",
      dataIndex: "balance_qty",
      width: "7.4%",
    },
    {
      title: "Pending Quantity",
      dataIndex: "pendingQuant",
      width: "4%",
      render: (text, record) => (
        record.isConflictingstate ? "ND" :
          <Styled>
            {" "}
            {record.type.toLowerCase() == "sheet" &&
              record.quantity_type.toLowerCase() == "reel_sheet" ? (
              <>
                <span style={{ textAlign: "center", fontSize: "12px" }}>
                  {text}
                </span>
                <br />{" "}
                <span>
                  {" "}
                  {record.total_pending_quantity.quantity + " Sheets"}{" "}
                </span>
              </>
            ) : (
              `${text} `
            )}
          </Styled>
      ),
    },
    {
      title: "Quantity to be planned",
      dataIndex: "plannedQuant",
      width: "8%",
      render: (text, record, index) => (
        <div
          className="actionBtn"
          style={{
            marginTop:
              isEditClicked?.[record.orderno] &&
                isEditClicked?.[record.orderno].isEditable
                ? "10px"
                : "5px",
            justifyContent: "left",
          }}
        >
          {(!isEditClicked?.[record.orderno] ||
            (isEditClicked?.[record.orderno] &&
              !isEditClicked?.[record.orderno].isEditable)) && (
              <Col span={12}>
                {" "}
                {text} {record.plannedUnit}{" "}
              </Col>
            )}
          {(!isEditClicked?.[record.orderno] ||
            (isEditClicked?.[record.orderno] &&
              !isEditClicked?.[record.orderno].isEditable &&
              userDetails?.roles?.job_cards.edit)) && (
              <Col span={12}>
                <Styled style={{ marginTop: "-7px" }}>
                  <Tooltip
                    placement="bottomRight"
                    title={"Edit planned quantity"}
                    className="edit-tooltip"
                    getPopupContainer={(triggerNode) => triggerNode}
                  >
                    <Button
                      onClick={() => {
                        handleEditColumn(index, record, true);
                      }}
                    >
                      <Iconmoon icon="edit" size={16} color="#A19F9D" />
                    </Button>
                  </Tooltip>
                </Styled>
              </Col>
            )}
          {isEditClicked?.[record.orderno] &&
            isEditClicked?.[record.orderno].isEditable && (
              <DetailFields style={{ paddingBottom: "0px" }}>
                <Styled>
                  <HaberForm>
                    {/* <Form
                  id="form"
                  form={form}
                  name="basic"
                  autoComplete="off"
                  className="qtyToBePlannedInput"
                  onFinish={onFinish}
                > */}
                    <Row className="centerAlign justifyCSBetween">
                      <Col span={14} style={{ paddingRight: "5px" }}>
                        <div className="boxFormType">
                          <Form.Item
                            name={`plannedQuanty${record?.orderno}`}
                            rules={[
                              {
                                required: true,
                                message: "This field is required.",
                              },
                              {
                                pattern: new RegExp(
                                  /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
                                ),
                                message:
                                  "This value should be a non-zero positive value.",
                              },
                              {
                                validator(_, value) {
                                  if (
                                    record.pendingQuant &&
                                    record.pendingQuant?.split(" ")[0] &&
                                    parseFloat(value) > 0
                                  ) {
                                    if (
                                      parseFloat(
                                        onValitdateQtyChange(
                                          value,
                                          record,
                                          index
                                        )
                                      ) <=
                                      parseFloat(
                                        record.pendingQuant?.split(" ")[0]
                                      )
                                    ) {
                                      return Promise.resolve();
                                    } else {
                                      return Promise.resolve();
                                      // Promise.reject(
                                      //   record?.quantity_type == "reel_sheet" &&
                                      //     record?.type == "Sheet"
                                      //     ? `The weight of ${value} sheets (${parseFloat(
                                      //         onValitdateQtyChange(
                                      //           value,
                                      //           record,
                                      //           index
                                      //         )
                                      //       )} ${capitalize(
                                      //         weightUnit[
                                      //           record.total_pending_quantity
                                      //             .units.weight
                                      //         ]?.displayName
                                      //       )}), can't be more than pending quantity.`
                                      //     : "Quantity to be planned can't be more than the pending quantity."
                                      // );
                                    }
                                  } else {
                                    return Promise.reject("");
                                  }
                                },
                              },
                            ]}
                            className="dBlock"
                            initialValue={text}
                          >
                            <Input
                              onChange={(e) => {
                                onPlannedQuntyChange(e, record, index);
                              }}
                            />
                          </Form.Item>
                          <span
                            className="nonEditable"
                            style={{ marginTop: "0px" }}
                          >
                            {record.plannedUnit}
                          </span>
                        </div>
                      </Col>
                      <Col
                        span={10}
                        style={{ paddingRight: "5px", marginTop: "0px" }}
                      >
                        <div
                          className="boxFormType"
                          style={{ marginBottom: "0", marginTop: "7px" }}
                        >
                          {(!plannedQuantityErr?.[record.orderno] ||
                            (plannedQuantityErr?.[record.orderno] &&
                              !plannedQuantityErr?.[record.orderno].error)) && (
                              <Tooltip title={"Save the entered value"}>
                                <Button
                                  key="1"
                                  className="edit-btn"
                                  style={{
                                    padding: "0px",
                                    margin: "0px",
                                    width: "28px",
                                    border: "none",
                                    display: "inline-block",
                                    marginRight: "10px",
                                  }}
                                  onClick={() =>
                                    onActionChange(index, "save", record)
                                  }
                                >
                                  <Iconmoon
                                    icon="check"
                                    size={18}
                                    color="#3FBD61"
                                  />
                                </Button>
                              </Tooltip>
                            )}

                          <Tooltip title={"Remove the entered value"}>
                            <Button
                              key="2"
                              className="edit-btn"
                              style={{
                                padding: "0px",
                                margin: "0px",
                                width: "28px",
                                border: "none",
                                display: "inline-block",
                              }}
                              onClick={() =>
                                onActionChange(index, "remove", record)
                              }
                            >
                              <Iconmoon icon="cancel" size={18} color="red" />
                            </Button>
                          </Tooltip>
                        </div>
                      </Col>
                    </Row>
                    {/* </Form> */}
                  </HaberForm>
                </Styled>
              </DetailFields>
            )}
        </div>
      ),
    },
    {
      title: "Delivery Date",
      dataIndex: "deliverydate",
      width: "2.9%",
      sorter: {
        compare: (a, b) => new Date(a.deliverydate) - new Date(b.deliverydate),
      },
    },
    {
      title: "Created Date",
      dataIndex: "createddate",
      width: "2.9%",
      sorter: {
        compare: (a, b) => new Date(a.deliverydate) - new Date(b.deliverydate),
      },
    },
    {
      title: "Priority",
      dataIndex: "priority",
      width: "5%",
      render: (text, record) => (
        <div className="actionBtn">
          <Button style={{ cursor: "default" }}>
            <Iconmoon
              icon={record.priority ? "correct" : "wrong"}
              size={16}
              color={record.priority ? "#3FBD61" : "#a19f9d"}
            />
          </Button>
        </div>
      ),
      align: "center",
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      width: "4%",
      render: (text, record) => (
        <div className="actionBtn">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={record.remarks}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button style={{ cursor: "default" }}>
                <Iconmoon icon="message" size={16} color="#EA655B" />
              </Button>
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },
    {
      title: "Progress",
      dataIndex: "progress",
      width: "5%",
      render: (text, record) => {
        // if(record.item_type && record.item_type === "order"){
        if (!record.isConflictingstate) {
          if (
            record?.order_type === "sheet" ||
            (record?.order_type === "reel" && record?.quantity_type === "weight")
          ) {
            const totalProd =
              ((record?.progressbar_info?.completed?.weight +
                record?.progressbar_info?.in_production?.weight) /
                (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
              100;
            const totalCompleted =
              (record?.progressbar_info?.completed?.weight /
                (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
              100;
            //const weightUnitKey =  ((record?.units && record?.units?.weight) ? capitalize(weightUnit[record.units.weight]?.displayName) : "T") ;
            return (
              <div className="progressLvl">
                <Styled>
                  <Tooltip
                    placement="bottomRight"
                    title={`${record?.progressbar_info?.completed
                        ? (record?.progressbar_info?.completed?.weight).toFixed(3)
                        : 0.0
                      } ${capitalize(
                        weightUnit[
                          record?.progressbar_info?.completed?.units?.weight
                        ].displayName
                      )} Weight produced
                          ${record?.progressbar_info?.in_production
                        ? (record?.progressbar_info?.in_production?.weight).toFixed(
                          3
                        )
                        : 0.0
                      } ${capitalize(
                        weightUnit[
                          record?.progressbar_info?.in_production?.units?.weight
                        ].displayName
                      )} Weight in production
                        ${record?.progressbar_info?.pending
                        ? (record?.progressbar_info?.pending?.weight).toFixed(
                          3
                        )
                        : 0.0
                      } ${capitalize(
                        weightUnit[record?.progressbar_info?.pending?.units?.weight]
                          .displayName
                      )} Weight pending for deckle match`}
                    className="edit-tooltip"
                    getPopupContainer={(triggerNode) => triggerNode}
                  >
                    <Progress
                      percent={totalProd}
                      success={{
                        percent: totalCompleted,
                      }}
                      strokeColor={"#cbe2cd"}
                    />
                  </Tooltip>
                </Styled>
              </div>
            );
          } else {
            const production =
              ((record?.progressbar_info?.completed?.quantity +
                record?.progressbar_info?.in_production?.quantity) /
                (record?.no_of_reel_sheet -
                  record.cancelled_quantity?.quantity)) *
              100;
            const completed =
              (record?.progressbar_info?.completed?.quantity /
                (record?.no_of_reel_sheet -
                  record.cancelled_quantity?.quantity)) *
              100;

            return (
              <div className="progressLvl">
                <Styled>
                  <Tooltip
                    placement="bottomRight"
                    title={`${record?.progressbar_info?.completed
                        ? record?.progressbar_info?.completed?.quantity
                        : 0
                      } Reels produced
                          ${record?.progressbar_info?.in_production
                        ? record?.progressbar_info?.in_production
                          ?.quantity
                        : 0
                      } Reels in production
                          ${record?.progressbar_info?.pending
                        ? record?.progressbar_info?.pending?.quantity
                        : 0
                      } Reels pending for deckle match`}
                    className="edit-tooltip"
                    getPopupContainer={(triggerNode) => triggerNode}
                  >
                    <Progress
                      percent={production}
                      success={{
                        percent: completed,
                      }}
                      strokeColor={"#cbe2cd"}
                    />
                  </Tooltip>
                </Styled>
              </div>
            );
          }
        }
      },
      align: "center",
    },
    {
      title: "Actions",
      dataIndex: "action",
      width: "5%",
      render: (text, record) => (
        <div className="actionBtn">
          {userDetails.roles.job_cards.edit ? (
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={"Edit planning details"}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button
                  onClick={() => {
                    handleEditAction(record);
                  }}
                >
                  <Iconmoon icon="edit" size={16} color="#A19F9D" />
                </Button>
              </Tooltip>
            </Styled>
          ) : (
            <div style={{ display: "flex" }}>
              <div style={{ width: "38px" }}></div>
            </div>
          )}
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={"View details of this order"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button
                onClick={() => {
                  handleActions(record);
                }}
                // disabled={!userDetails.roles.job_cards.view}
                disabled={
                  !(
                    userDetails?.roles?.approve_jobcards.view ||
                    userDetails?.roles?.job_cards.view ||
                    userDetails?.roles?.job_cards.edit ||
                    userDetails?.role_type == "ADMIN" ||
                    userDetails?.role_type == "SUPER_ADMIN"
                  )
                }
              >
                <Iconmoon icon="file-view" size={16} color="#A19F9D" />
              </Button>
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },
  ];

  const fullCutterOtherOrderColumnsHead = [
    {
      title: "Po/So.No",
      dataIndex: "pono",
      width: "4%",
      fixed: "left",
      // align: "left",
      sorter: () => { },
      render: (text, record) => (
        <span
          style={{
            whiteSpace: "normal",
            wordBreak: "break-word",
            lineHeight: "1.4",
          }}
        >
          {`${record.category === "so"
              ? toHandlePOName(record.sono)
              : toHandlePOName(record.pono)
            }`
            .match(/.{1,15}/g)
            ?.map((chunk, index) => (
              <span key={index}>
                {chunk}
                <br />
              </span>
            ))}
        </span>
      ),
    },
    {
      title: "Order No",
      dataIndex: "orderno",
      width: "3%",
      fixed: "left",
      sorter: () => { },
    },
    {
      title: "PO Date",
      dataIndex: "podate",
      width: "3%",
      fixed: "left",
      sorter: {
        compare: (a, b) => new Date(a.podate) - new Date(b.podate),
      },
    },

    {
      title: "Customer",
      dataIndex: "customer_alias",
      width: "3%",
      align: "left",
      render: (text, record) => (
        <div className="actionBtn2">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={`${record.customercode}-${record.customerName}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {record?.customer_alias || "-"}
            </Tooltip>
          </Styled>
        </div>
      ),
    },
    {
      title: "Consignee",
      dataIndex: "consignee_alias",
      width: "3%",
      align: "left",
      render: (text, record) => (
        <div className="actionBtn2">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={`${record.consignee}-${record.consignee_name}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {record?.consignee_alias || "-"}
            </Tooltip>
          </Styled>
        </div>
      ),
    },
    {
      title: (
        <div>
          Product
          <Styled style={{ display: "inline-flex" }}>
            <Tooltip
              placement="bottomRight"
              title={`The product specification is in the format of ${format}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <span className="infoIcon"></span>
            </Tooltip>
          </Styled>
        </div>
      ),
      // render: (text, record) => (
      //   <Styled>
      //     {" "}
      //     <span style={{ fontSize: "10px" }}>{record.productspec} </span>
      //     <br />
      //     <span style={{ textAlign: "center" }}>{record.productcode}</span>
      //   </Styled>
      // ),
      // //dataIndex: "productspec",
      // width: "5%",
      // title: "Product",
      dataIndex: "product_spec",
      width: "5%",
    },
    {
      title: "Size(WxL)",
      dataIndex: "size",
      width: "4%",
    },
    {
      title: "Grain",
      dataIndex: "grain",
      width: "4%",
      render: (text, record, index) => (
        <Styled>
          {record.order_type.toLowerCase() == "sheet" ? (
            <div style={{ display: "flex" }}>
              <Row className="centerAlign">
                <div className="boxFormType">
                  <SelectStyle>
                    <Form.Item
                      name={`grain${record.id}`}
                      rules={[
                        {
                          required: true,
                          message: "This field is required",
                        },
                      ]}
                      className="selectForm"
                      style={{ marginBottom: 4 }}
                      initialValue={
                        record.grain
                          ? record.grain == "short"
                            ? "Short"
                            : "Long"
                          : null
                      }
                    >
                      <Select
                        placeholder={"Select"}
                        suffixIcon={<DropdownArrowStyle />}
                        onChange={(e) => onGrainChange(e, record, index)}
                      >
                        {grainTypeData.map((grainType) => (
                          <Option key={grainType}>{grainType}</Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </SelectStyle>
                </div>
              </Row>
            </div>
          ) : (
            ""
          )}
        </Styled>
      ),
    },
    {
      title: "Order Quantity",
      dataIndex: "quantity",
      width: "4%",
      render: (text, record) => (
        <Styled>
          {" "}
          {record.type.toLowerCase() == "sheet" &&
            record.quantity_type.toLowerCase() == "reel_sheet" ? (
            <>
              <span style={{ textAlign: "center", fontSize: "12px" }}>
                {text}
              </span>
              <br /> <span> {record.no_of_sheets + " Sheets"} </span>
            </>
          ) : (
            `${text} `
          )}
        </Styled>
      ),
    },
    {
      title: "Balance Quantity",
      dataIndex: "balance_qty",
      width: "7.4%",
    },
    {
      title: "Pending Quantity",
      dataIndex: "pendingQuant",
      width: "4%",
      render: (text, record) => (
        record.isConflictingstate ? "ND" :
          <Styled>
            {" "}
            {record.type.toLowerCase() == "sheet" &&
              record.quantity_type.toLowerCase() == "reel_sheet" ? (
              <>
                <span style={{ textAlign: "center", fontSize: "12px" }}>
                  {text}
                </span>
                <br />{" "}
                <span>
                  {" "}
                  {record.total_pending_quantity.quantity + " Sheets"}{" "}
                </span>
              </>
            ) : (
              `${text} `
            )}
          </Styled>
      ),
    },
    {
      title: "Quantity to be planned",
      dataIndex: "plannedQuant",
      width: "8%",
      render: (text, record, index) => (
        <div
          className="actionBtn"
          style={{
            marginTop:
              isEditClicked?.[record.orderno] &&
                isEditClicked?.[record.orderno].isEditable
                ? "10px"
                : "5px",
            justifyContent: "left",
          }}
        >
          {(!isEditClicked?.[record.orderno] ||
            (isEditClicked?.[record.orderno] &&
              !isEditClicked?.[record.orderno].isEditable)) && (
              <Col span={12}>
                {" "}
                {text} {record.plannedUnit}{" "}
              </Col>
            )}
          {(!isEditClicked?.[record.orderno] ||
            (isEditClicked?.[record.orderno] &&
              !isEditClicked?.[record.orderno].isEditable &&
              userDetails?.roles?.job_cards.edit)) && (
              <Col span={12}>
                <Styled style={{ marginTop: "-7px" }}>
                  <Tooltip
                    placement="bottomRight"
                    title={"Edit planned quantity"}
                    className="edit-tooltip"
                    getPopupContainer={(triggerNode) => triggerNode}
                  >
                    <Button
                      onClick={() => {
                        handleEditColumn(index, record, true);
                      }}
                    >
                      <Iconmoon icon="edit" size={16} color="#A19F9D" />
                    </Button>
                  </Tooltip>
                </Styled>
              </Col>
            )}
          {isEditClicked?.[record.orderno] &&
            isEditClicked?.[record.orderno].isEditable && (
              <DetailFields style={{ paddingBottom: "0px" }}>
                <Styled>
                  <HaberForm>
                    {/* <Form
                  id="form"
                  form={form}
                  name="basic"
                  autoComplete="off"
                  className="qtyToBePlannedInput"
                  onFinish={onFinish}
                > */}
                    <Row className="centerAlign justifyCSBetween">
                      <Col span={14} style={{ paddingRight: "5px" }}>
                        <div className="boxFormType">
                          <Form.Item
                            name={`plannedQuanty${record?.orderno}`}
                            rules={[
                              {
                                required: true,
                                message: "This field is required.",
                              },
                              {
                                pattern: new RegExp(
                                  /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
                                ),
                                message:
                                  "This value should be a non-zero positive value.",
                              },
                              {
                                validator(_, value) {
                                  if (
                                    record.pendingQuant &&
                                    record.pendingQuant?.split(" ")[0] &&
                                    parseFloat(value) > 0
                                  ) {
                                    if (
                                      parseFloat(
                                        onValitdateQtyChange(
                                          value,
                                          record,
                                          index
                                        )
                                      ) <=
                                      parseFloat(
                                        record.pendingQuant?.split(" ")[0]
                                      )
                                    ) {
                                      return Promise.resolve();
                                    } else {
                                      return Promise.resolve();
                                      // Promise.reject(
                                      //   record?.quantity_type == "reel_sheet" &&
                                      //     record?.type == "Sheet"
                                      //     ? `The weight of ${value} sheets (${parseFloat(
                                      //         onValitdateQtyChange(
                                      //           value,
                                      //           record,
                                      //           index
                                      //         )
                                      //       )} ${capitalize(
                                      //         weightUnit[
                                      //           record.total_pending_quantity
                                      //             .units.weight
                                      //         ]?.displayName
                                      //       )}), can't be more than pending quantity.`
                                      //     : "Quantity to be planned can't be more than the pending quantity."
                                      // );
                                    }
                                  } else {
                                    return Promise.reject("");
                                  }
                                },
                              },
                            ]}
                            className="dBlock"
                            initialValue={text}
                          >
                            <Input
                              onChange={(e) => {
                                onPlannedQuntyChange(e, record, index);
                              }}
                            />
                          </Form.Item>
                          <span
                            className="nonEditable"
                            style={{ marginTop: "0px" }}
                          >
                            {record.plannedUnit}
                          </span>
                        </div>
                      </Col>
                      <Col
                        span={10}
                        style={{ paddingRight: "5px", marginTop: "0px" }}
                      >
                        <div
                          className="boxFormType"
                          style={{ marginBottom: "0", marginTop: "7px" }}
                        >
                          {(!plannedQuantityErr?.[record.orderno] ||
                            (plannedQuantityErr?.[record.orderno] &&
                              !plannedQuantityErr?.[record.orderno].error)) && (
                              <Tooltip title={"Save the entered value"}>
                                <Button
                                  key="1"
                                  className="edit-btn"
                                  style={{
                                    padding: "0px",
                                    margin: "0px",
                                    width: "28px",
                                    border: "none",
                                    display: "inline-block",
                                    marginRight: "10px",
                                  }}
                                  onClick={() =>
                                    onActionChange(index, "save", record)
                                  }
                                >
                                  <Iconmoon
                                    icon="check"
                                    size={18}
                                    color="#3FBD61"
                                  />
                                </Button>
                              </Tooltip>
                            )}

                          <Tooltip title={"Remove the entered value"}>
                            <Button
                              key="2"
                              className="edit-btn"
                              style={{
                                padding: "0px",
                                margin: "0px",
                                width: "28px",
                                border: "none",
                                display: "inline-block",
                              }}
                              onClick={() =>
                                onActionChange(index, "remove", record)
                              }
                            >
                              <Iconmoon icon="cancel" size={18} color="red" />
                            </Button>
                          </Tooltip>
                        </div>
                      </Col>
                    </Row>
                    {/* </Form> */}
                  </HaberForm>
                </Styled>
              </DetailFields>
            )}
        </div>
      ),
    },
    {
      title: "Reel OD",
      dataIndex: "reelod",
      width: "5%",
      render: (text, record, index) => (
        <Styled>
          <div style={{ display: "flex" }}>
            {record.id_od_type == "range" && (
              <div
                style={{
                  color: "var(--para-text)",
                  display: "flex",
                  width: "70%",
                  alignSelf: "center",
                }}
              >
                {record.minimum_reel_od && record.maximum_reel_od
                  ? record.minimum_reel_od +
                  "-" +
                  record.maximum_reel_od +
                  " " +
                  (record.units.maximum_reel_od
                    ? lengthUnit[record.units.maximum_reel_od].displayName
                    : "")
                  : ""}
              </div>
            )}
            {record.id_od_type == "constant" && (
              <div
                style={{
                  display: "flex",
                  width: "70%",
                  flexDirection: "column",
                  alignSelf: "center",
                }}
              >
                {record.reelod &&
                  record.reelod?.map((item, index) => {
                    return (
                      index < 2 && (
                        <div>
                          {item}{" "}
                          {index == 1
                            ? "...,"
                            : record.reelod.length > 1
                              ? ","
                              : ""}
                        </div>
                      )
                    );
                  })}

                {record.reelod &&
                  record.reelod?.length >= 2 &&
                  record.reelod?.map((item, index) => {
                    let tooltipData = "";
                    for (
                      let index = 2;
                      index < record.reelod?.length;
                      index++
                    ) {
                      const data = record.reelod[index];
                      tooltipData = tooltipData + data + ", ";
                    }
                    tooltipData = tooltipData.substring(
                      0,
                      tooltipData.length - 1
                    );
                    return (
                      index == 2 && (
                        <Tooltip title={tooltipData}>
                          {" "}
                          <span
                            style={{
                              display: "flex",
                              fontSize: "10px",
                              fontWeight: "bold",
                            }}
                          >
                            & {record.reelod.length - 2} More
                          </span>
                        </Tooltip>
                      )
                    );
                  })}
              </div>
            )}
          </div>
        </Styled>
      ),
    },
    {
      title: "Core OD",
      dataIndex: "coreid",
      width: "4%",
      render: (text, record, index) => (
        <Styled>
          <div style={{ display: "flex" }}>
            <div
              style={{
                color: "var(--para-text)",
                display: "flex",
                width: "100%",
                alignSelf: "center",
              }}
            >
              {record.coreid}
            </div>
          </div>
        </Styled>
      ),
    },
    {
      title: "Delivery Date",
      dataIndex: "deliverydate",
      width: "2.9%",
      sorter: {
        compare: (a, b) => new Date(a.deliverydate) - new Date(b.deliverydate),
      },
    },
    {
      title: "Created Date",
      dataIndex: "createddate",
      width: "2.9%",
      sorter: {
        compare: (a, b) => new Date(a.deliverydate) - new Date(b.deliverydate),
      },
    },
    {
      title: "Priority",
      dataIndex: "priority",
      width: "5%",
      render: (text, record) => (
        <div className="actionBtn">
          <Button style={{ cursor: "default" }}>
            <Iconmoon
              icon={record.priority ? "correct" : "wrong"}
              size={16}
              color={record.priority ? "#3FBD61" : "#a19f9d"}
            />
          </Button>
        </div>
      ),
      align: "center",
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      width: "4%",
      render: (text, record) => (
        <div className="actionBtn">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={record.remarks}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button style={{ cursor: "default" }}>
                <Iconmoon icon="message" size={16} color="#EA655B" />
              </Button>
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },
    {
      title: "Progress",
      dataIndex: "progress",
      width: "5%",
      render: (text, record) => {
        // if(record.item_type && record.item_type === "order"){
        if (!record.isConflictingstate) {
          if (
            record?.order_type === "sheet" ||
            (record?.order_type === "reel" && record?.quantity_type === "weight")
          ) {
            const totalProd =
              ((record?.progressbar_info?.completed?.weight +
                record?.progressbar_info?.in_production?.weight) /
                (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
              100;
            const totalCompleted =
              (record?.progressbar_info?.completed?.weight /
                (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
              100;
            //const weightUnitKey =  ((record?.units && record?.units?.weight) ? capitalize(weightUnit[record.units.weight]?.displayName) : "T") ;
            return (
              <div className="progressLvl">
                <Styled>
                  <Tooltip
                    placement="bottomRight"
                    title={`${record?.progressbar_info?.completed
                        ? (record?.progressbar_info?.completed?.weight).toFixed(3)
                        : 0.0
                      } ${capitalize(
                        weightUnit[
                          record?.progressbar_info?.completed?.units?.weight
                        ].displayName
                      )} Weight produced
                          ${record?.progressbar_info?.in_production
                        ? (record?.progressbar_info?.in_production?.weight).toFixed(
                          3
                        )
                        : 0.0
                      } ${capitalize(
                        weightUnit[
                          record?.progressbar_info?.in_production?.units?.weight
                        ].displayName
                      )} Weight in production
                        ${record?.progressbar_info?.pending
                        ? (record?.progressbar_info?.pending?.weight).toFixed(
                          3
                        )
                        : 0.0
                      } ${capitalize(
                        weightUnit[record?.progressbar_info?.pending?.units?.weight]
                          .displayName
                      )} Weight pending for deckle match`}
                    className="edit-tooltip"
                    getPopupContainer={(triggerNode) => triggerNode}
                  >
                    <Progress
                      percent={totalProd}
                      success={{
                        percent: totalCompleted,
                      }}
                      strokeColor={"#cbe2cd"}
                    />
                  </Tooltip>
                </Styled>
              </div>
            );
          } else {
            const production =
              ((record?.progressbar_info?.completed?.quantity +
                record?.progressbar_info?.in_production?.quantity) /
                (record?.no_of_reel_sheet -
                  record.cancelled_quantity?.quantity)) *
              100;
            const completed =
              (record?.progressbar_info?.completed?.quantity /
                (record?.no_of_reel_sheet -
                  record.cancelled_quantity?.quantity)) *
              100;

            return (
              <div className="progressLvl">
                <Styled>
                  <Tooltip
                    placement="bottomRight"
                    title={`${record?.progressbar_info?.completed
                        ? record?.progressbar_info?.completed?.quantity
                        : 0
                      } Reels produced
                          ${record?.progressbar_info?.in_production
                        ? record?.progressbar_info?.in_production
                          ?.quantity
                        : 0
                      } Reels in production
                          ${record?.progressbar_info?.pending
                        ? record?.progressbar_info?.pending?.quantity
                        : 0
                      } Reels pending for deckle match`}
                    className="edit-tooltip"
                    getPopupContainer={(triggerNode) => triggerNode}
                  >
                    <Progress
                      percent={production}
                      success={{
                        percent: completed,
                      }}
                      strokeColor={"#cbe2cd"}
                    />
                  </Tooltip>
                </Styled>
              </div>
            );
          }
        }
      },
      align: "center",
    },
    {
      title: "Actions",
      dataIndex: "action",
      width: "5%",
      render: (text, record) => (
        <div className="actionBtn">
          {userDetails.roles.job_cards.edit ? (
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={"Edit planning details"}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button
                  onClick={() => {
                    handleEditAction(record);
                  }}
                >
                  <Iconmoon icon="edit" size={16} color="#A19F9D" />
                </Button>
              </Tooltip>
            </Styled>
          ) : (
            <div style={{ display: "flex" }}>
              <div style={{ width: "38px" }}></div>
            </div>
          )}
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={"View details of this order"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button
                onClick={() => {
                  handleActions(record);
                }}
                // disabled={!userDetails.roles.job_cards.view}
                disabled={
                  !(
                    userDetails?.roles?.approve_jobcards.view ||
                    userDetails?.roles?.job_cards.view ||
                    userDetails?.roles?.job_cards.edit ||
                    userDetails?.role_type == "ADMIN" ||
                    userDetails?.role_type == "SUPER_ADMIN"
                  )
                }
              >
                <Iconmoon icon="file-view" size={16} color="#A19F9D" />
              </Button>
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },
  ];

  const filteredColumns1 = fullColumnsHead.filter(
    (col) => !columnBlacklist.includes(col.dataIndex) && (orderManagementSettings?.fetch_balance_quantity?.value || col.dataIndex != "balance_qty")
  );
  const filteredColumns2 = fullCutterSelectedOrderColumnsHead.filter(
    (col) => !columnBlacklist.includes(col.dataIndex) && (orderManagementSettings?.fetch_balance_quantity?.value || col.dataIndex != "balance_qty")
  );
  const filteredColumns3 = fullCutterOtherOrderColumnsHead.filter(
    (col) => !columnBlacklist.includes(col.dataIndex) && (orderManagementSettings?.fetch_balance_quantity?.value || col.dataIndex != "balance_qty")
  );

  const columnsHead = useRef(filteredColumns1);
  const cutterSelectedOrderColumnsHead = useRef(filteredColumns2);
  const cutterOtherOrderColumnsHead = useRef(filteredColumns3);

  const titleRef = useRef(null);
  const tabRef = useRef(null);
  const searchRef = useRef(null);
  const [stickyOffsets, setStickyOffsets] = useState({ title: 58, tabs: 95, search: 140, table: 226 });

  useEffect(() => {
    const observer = new ResizeObserver(() => {
      const baseTop = 58;
      const titleHeight = titleRef.current?.offsetHeight || 0;
      const tabsHeight = tabRef.current?.offsetHeight || 0;
      const searchHeight = searchRef.current?.offsetHeight || 0;

      setStickyOffsets({
        title: baseTop,
        tabs: baseTop + titleHeight,
        search: baseTop + titleHeight + tabsHeight,
        table: baseTop + titleHeight + tabsHeight
      });
    });

    if (titleRef.current) observer.observe(titleRef.current);
    if (tabRef.current) observer.observe(tabRef.current);
    if (searchRef.current) observer.observe(searchRef.current);

    return () => observer.disconnect();
  }, [tableData, unitData, measurementData, reelValues, coreValues]);

  const tabHeads = [
    {
      key: 0,
      state: "selected_orders",
      title: "Orders Available to Plan",
      defaultSort: {
        sort_by: "updated_at",
        sort_type: "descending",
      },
    },
    {
      key: 1,
      state: "other_orders",
      title: "Other Orders",
      defaultSort: {
        sort_by: "updated_at",
        sort_type: "descending",
      },
    },
  ];

  useEffect(() => {
    return () => {
      source.cancel("Page is redirected");
      setEmptyStateLabel("");
    };
  }, [orderType]);

  useEffect(() => {
    if (
      grainType &&
      selectedRecord &&
      (selectedIndex != "" || selectedIndex != undefined)
    ) {
      let selected = JSON.parse(JSON.stringify(selectedRecord));
      //setSelectedReocord({ ...selected });
      let dataSourceCopy = tableData;
      let selectedDataCopy = [...selectedDataRows];
      let selectedDataIndex = selectedDataRows?.findIndex(
        (ele) => ele.id == selectedRecord.id
      );
      let selectedRowData;
      if (selectedDataIndex == 0 || selectedDataIndex != -1) {
        selectedRowData = JSON.parse(
          JSON.stringify(selectedDataCopy[selectedDataIndex])
        );
        selectedRowData.grain = grainType;
      }
      selected.grain = grainType;

      dataSourceCopy[selectedIndex] = { ...selected };
      setTableData([...dataSourceCopy]);
      tableDataRef.current = [...dataSourceCopy];
      if (selectedDataIndex == 0 || selectedDataIndex != -1)
        selectedDataCopy[selectedDataIndex] = { ...selectedRowData };

      setSelectedDataRows([...selectedDataCopy]);

      plannedReelsCaln(
        selectedIndex,
        selected,
        selected.plannedQuant,
        selected.reelod,
        selected.inner_dia,
        orderType
      );
      setGrainType("");
      setTableRerender(true);
    }
  }, [selectedIndex, selectedRecord, grainType]);

  useEffect(() => {
    (async () => {
      try {
        const response = await getUnitData();
        setUnitData(response.data);
        setMeasurementData(response);

        let orderMangtSettings = await getWorkflowSettings("order_management");
        setOrderManagementSettings(orderMangtSettings?.data);

        const resp = await getMachineGradeSelectForConfig();
        if (!resp.error) {
          let data = resp?.data?.data?.settings?.order_types;
          const filteredOrderTypes = data?.filter(item => item.value === true && (item.name === "reel" || item.name === "sheet"))
            .map(item => ({ name: item.name, value: item.value }));
          setOrderTypesData(filteredOrderTypes);
        }

        const response1 = await getReelCoreValues();
        if (!response1.error) {
          setReelCoreData(response1);
          const reelData = response1.reel_data.map((item) => {
            return {
              value: item[0] + " " + item[1],
            };
          });
          const coreData = response1.core_data.map((item) => {
            return {
              value: item[0] + " " + item[1],
            };
          });
          setCoreValues(coreData);
          setReelvalues(reelData);
          form.setFieldsValue({
            coreDia: response1.default_core_id
              ? response1.default_core_id + " " + response1.default_core_unit
              : "",
          });
          form.setFieldsValue({
            core_Dia: response1.default_core_id
              ? response1.default_core_id + " " + response1.default_core_unit
              : "",
          });
          form.setFieldsValue({
            range_unit: response.data.units_management.length.default,
          });
        }
      } catch (error) {
        console.log(error);
      }
    })();
    return () => {
      if (!nextClickRef.current) {
        cancelJobCard();
        handleResetAll();
      }
      if (isCancelJobCard.current) setFormObject(null);
    };
  }, []);

  useEffect(() => {
    if (allOrdersList && allOrdersList.length) {
      setLoading(false);
      let orders = getData();
      let updateSelectedTableData = [...orders];
      if (isAddRewinderDimension)
        for (let index = 0; index < updateSelectedTableData.length; index++) {
          //const order = updateSelectedTableData[index];
          var indexValue = selectedDataRows.findIndex(
            (obj) => obj.id == updateSelectedTableData[index].id
          );
          if (indexValue != -1) {
            updateSelectedTableData[index] = JSON.parse(
              JSON.stringify(selectedDataRows[indexValue])
            );
          }
        }
      setTableData(updateSelectedTableData);
      // setTableData(orders);
      tableDataCopyRef.current = JSON.parse(JSON.stringify([...orders]));
      const result = selectedRowKeys.filter((f) =>
        orders.some((d) => d.key == f)
      );

      if (result.length === orders.length) setIsAllSelected(true);
      else setIsAllSelected(false);
      if (isAddRewinderDimension) setPaginationParamsChange(true);
    } else {
      setTableData([]);
      tableDataCopyRef.current = [];
    }
  }, [allOrdersList]);

  useEffect(() => {
    if (tableData && tableData.length && paginationParamsChange) {
      for (let index = 0; index < tableData.length; index++) {
        const order = tableData[index];
        var indexValue = selectedDataRows.findIndex(
          (obj) => obj.id == order.id
        );
        if (indexValue != -1) {
          handleSelectRewinderOnpagination({ ...order }, true, true);
        }
      }
      setPaginationParamsChange(false);
    }
  }, [tableData, paginationParamsChange]);

  useEffect(() => {
    if (rendering) {
      let machineParams = location.state.body;
      // machineParams['move_to_selected_orders'] = ordersMoveToSelect;

      setLoading(true);
      let req;

      req = {
        machine_data: {
          // move_to_selected_orders: ordersMoveToSelect
        },
        filter: [...appliedFilters],
      };

      let multiStageReq = {
        machine_data: location.state.body.machine_data,
        filter: [...appliedFilters],
      };

      if (appliedFilters.length) {
        setTotalRecords();
        setAllOrdersList();
        if (location.state.processType == "singleStage")
          getFilteredMachineOrders(
            req,
            paginationParamsRef.current,
            sortParams,
            location.state.code,
            "",
            "",
            orderType
          )
            .then((response) => {
              setEmptyStateLabel("filter");
              setTotalRecords(response.data.total_orders);
              setAllOrdersList(response.data.orders);
              setLoading(false);
            })
            .catch((error) => {
              setLoading(false);
              console.log(error);
              setEmptyStateLabel("connectionAPIError");
            });
        else
          getFilteredMachineOrdersForMultiStage(
            multiStageReq,
            paginationParamsRef.current,
            sortParams,
            location.state.code,
            "",
            "",
            orderType
          )
            .then((response) => {
              setEmptyStateLabel("filter");
              setTotalRecords(response.data.total_orders);
              setAllOrdersList(response.data.orders);
              setLoading(false);
            })
            .catch((error) => {
              setLoading(false);
              console.log(error);
              setEmptyStateLabel("connectionAPIError");
            });
      } else if (searchValue == "" && !appliedFilters.length) {
        const start =
          (paginationParamsRef.current.page - 1) *
          paginationParamsRef.current.size;
        const end = start + paginationParamsRef.current.size * 1;
        if (location.state.processType == "singleStage") {
          getDeckleMachineOrders(
            machineParams,
            paginationParamsRef.current.sort_by,
            paginationParamsRef.current.sort_type,
            start,
            end,
            orderType,
            source
          )
            .then((response) => {
              setEmptyStateLabel("noData");
              setAllOrdersList(response.data.data.orders);
              setTotalRecords(response.data.data.total_orders);
              setLoading(false);
            })
            .catch((error) => {
              setLoading(false);
              console.log("Error in search of order records:", error);
              if (!source.token._listeners) {
                setEmptyStateLabel("");
                setLoading(true);
              } else {
                setEmptyStateLabel("connectionAPIError");
              }
            });
        } else {
          getDeckleMachineOrdersForMultiStage(
            machineParams,
            paginationParamsRef.current.sort_by,
            paginationParamsRef.current.sort_type,
            start,
            end,
            orderType,
            source
          )
            .then((response) => {
              setEmptyStateLabel("noData");
              setAllOrdersList(response.data.data.orders);
              setTotalRecords(response.data.data.total_orders);
              setLoading(false);
            })
            .catch((error) => {
              setLoading(false);
              console.log("Error in search of order records:", error);
              if (!source.token._listeners) {
                setEmptyStateLabel("");
                setLoading(true);
              } else {
                setEmptyStateLabel("connectionAPIError");
              }
            });
        }
        // setRendering(false);
      } else if (searchValue !== "") {
        let req = {
          type: orderType,
          //move_to_selected_orders: ordersMoveToSelect
        };
        if (location.state.processType == "singleStage")
          searchDeckleMachineOrders(
            location.state.code,
            searchValue,
            req,
            paginationParamsRef.current
          )
            .then((response) => {
              setLoading(false);
              setEmptyStateLabel("search");
              setAllOrdersList(response.data);
              setTotalRecords(response.total_orders);
            })
            .catch((error) => {
              console.log("Error in deckle search:", error);
              setEmptyStateLabel("connectionAPIError");
            });
        else
          searchDeckleMachineOrdersForMultiStage(
            orderType,
            searchValue,
            machineParams,
            paginationParamsRef.current
          )
            .then((response) => {
              setLoading(false);
              setEmptyStateLabel("search");
              setAllOrdersList(response.data);
              setTotalRecords(response.total_orders);
            })
            .catch((error) => {
              console.log("Error in deckle search:", error);
              setEmptyStateLabel("connectionAPIError");
            });
      }

      setRendering(false);
    }
  }, [rendering]);

  useEffect(() => {
    if (pageRerender) setPageRerender(false);
  }, [pageRerender]);

  useEffect(() => {
    let propsData = {};
    if (emptyStateLabel === "noData") {
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records in this list";
      propsData["subHeading"] =
        "There are no records to show in this list. Add new records to view details here ";
    } else if (emptyStateLabel === "search") {
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records found";
      propsData["subHeading"] =
        "There is no record matching your search keyword. Try adjusting your search to find what you are looking for.";
    } else if (emptyStateLabel === "filter") {
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records found";
      propsData["subHeading"] =
        "There is no record matching your filter. Try changing your filter to find what you are looking for.";
    } else {
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "Something went wrong";
      propsData["subHeading"] =
        "Check your internet connection or try reloading the page.";
    }
    setEmptyStatePropsData(propsData);
  }, [emptyStateLabel]);

  useEffect(() => {
    if (tableRerender) {
      // columnsHead.current = [
      //   // {
      //   //   title: "Select",
      //   //   dataIndex: "select",
      //   //   width: "1.8%",
      //   //   fixed: "left",
      //   //   align: "center",
      //   //   render: (value, record, rowIndex) => (
      //   //     <div>
      //   //        <Styled>
      //   //     <Checkbox
      //   //       checked={value}
      //   //       onChange={handleCheckboxChangeFactory(rowIndex, "select")}
      //   //     />
      //   //     </Styled>
      //   //     </div>
      //   //   ),
      //   // },
      //   {
      //     title: "Po/So.No",
      //     dataIndex: "pono",
      //     width: "4%",
      //     fixed: "left",
      //     // align: "left",
      //     sorter: () => {},
      //     render: (text, record) => (
      //       <span style={{ whiteSpace: 'normal', wordBreak: 'break-word', lineHeight: '1.4' }}>
      //         {
      //           `${record.category === "so" ? record.sono : record.pono}`
      //             .match(/.{1,15}/g)
      //             ?.map((chunk, index) => (
      //               <span key={index}>
      //                 {chunk}
      //                 <br />
      //               </span>
      //             ))
      //         }
      //       </span>
      //     )
      //   },
      //   {
      //     title: "Order No",
      //     dataIndex: "orderno",
      //     width: "3%",
      //     fixed: "left",
      //     sorter: () => {},
      //   },
      //   {
      //     title: "PO Date",
      //     dataIndex: "podate",
      //     width: "3%",
      //     fixed: "left",
      //     sorter: {
      //       compare: (a, b) => new Date(a.podate) - new Date(b.podate),
      //     },
      //   },

      //   {
      //     title: "Customer",
      //     dataIndex: "customer_alias",
      //     width: "3%",
      //     align: "left",
      //     render: (text, record) => (
      //       <div className="actionBtn2">
      //         <Styled>
      //           <Tooltip
      //             placement="bottomRight"
      //             title={`${record.customercode}-${record.customerName}`}
      //             className="edit-tooltip"
      //             getPopupContainer={(triggerNode) => triggerNode}
      //           >
      //             {record?.customer_alias||'-'}
      //           </Tooltip>
      //         </Styled>
      //       </div>
      //     ),
      //   },
      //   {
      //     title: "Consignee",
      //     dataIndex: "consignee_alias",
      //     width: "3%",
      //     align: "left",
      //     render: (text, record) => (
      //       <div className="actionBtn2">
      //         <Styled>
      //           <Tooltip
      //             placement="bottomRight"
      //             title={`${record.consignee}-${record.consignee_name}`}
      //             className="edit-tooltip"
      //             getPopupContainer={(triggerNode) => triggerNode}
      //           >
      //             {record?.consignee_alias||'-'}
      //           </Tooltip>
      //         </Styled>
      //       </div>
      //     ),
      //   },
      //   // {
      //   //   title: "Prod. Code",
      //   //   dataIndex: "productcode",
      //   //   width: "2.5%",
      //   // },
      //   {
      //     title: (
      //       <div>
      //         Product
      //         <Styled style={{ display: "inline-flex" }}>
      //           <Tooltip
      //             placement="bottomRight"
      //             title={
      //               "The product specification is in the format of Grade/GSM/BF/Quality/Moisture"
      //             }
      //             className="edit-tooltip"
      //             getPopupContainer={(triggerNode) => triggerNode}
      //           >
      //             <span className="infoIcon"></span>
      //           </Tooltip>
      //         </Styled>
      //       </div>
      //     ),
      //     render: (text, record) => (
      //       <Styled>
      //         {" "}
      //         <span style={{ fontSize: "10px" }}>{record.productspec} </span>
      //         <br />
      //         <span style={{ textAlign: "center" }}>{record.productcode}</span>
      //       </Styled>
      //     ),
      //     //dataIndex: "productspec",
      //     width: "5%",
      //   },
      //   {
      //     title: "Type",
      //     dataIndex: "type",
      //     width: "3%",
      //   },
      //   {
      //     title: "Ply",
      //     dataIndex: "ply",
      //     width: "3%",
      //   },
      //   {
      //     title: "Size(WxL)",
      //     dataIndex: "size",
      //     width: "4%",
      //   },
      //   {
      //     title: "Grain",
      //     dataIndex: "grain",
      //     width: "4%",
      //     render: (text, record, index) => (
      //       <Styled>
      //        { record.order_type.toLowerCase() == 'sheet' ? ( <div style={{ display: "flex" }}>
      //        <Row className="centerAlign">
      //        <div className="boxFormType">
      //        <SelectStyle>
      //         <Form.Item
      //                         name={`grain${record.id}`}
      //                         rules={[
      //                           {
      //                             required: true,
      //                             message: "This field is required",
      //                           },
      //                         ]}
      //                         className="selectForm"
      //                         style={{ marginBottom: 4 }}
      //                         initialValue={record.grain ? record.grain == 'short' ? 'Short' :
      //                         'Long' : null}
      //                       >
      //                         <Select
      //                           placeholder={"Select"}
      //                           suffixIcon={<DropdownArrowStyle />}
      //                           onChange={(e) => onGrainChange(e,record,index)}
      //                           >
      //                           {grainTypeData.map((grainType) => (
      //                             <Option key={grainType}>{grainType}</Option>
      //                           ))}
      //                         </Select>
      //         </Form.Item>
      //         </SelectStyle>
      //         </div>
      //         </Row>
      //         </div>
      //         ): ''}
      //       </Styled>
      //     ),
      //   },
      //   // {
      //   //   title: "Order Weight",
      //   //   dataIndex: "weight",
      //   //   width: "3%",
      //   //   render: (text, record) =>
      //   //     record.quantity_type === "reel_sheet" ? "-" : `${text} ${record.units  && record.item_type !== "split_group" ? weightUnit[record.units.weight]?.displayName?.toUpperCase() : weightUnit[record.units.total_weight].displayName?.toUpperCase()}`,
      //   // },
      //   {
      //     title: "Order Quantity",
      //     dataIndex: "quantity",
      //     width: "4%",
      //     render: (text, record) =>
      //     <Styled>

      //     {" "}
      //    { record.type.toLowerCase() == "sheet" && record.quantity_type.toLowerCase() == "reel_sheet" ?
      //    <><span style={{textAlign:"center",fontSize:'12px'}}>{text}</span><br/> <span> {record.no_of_sheets + ' Sheets'} </span>
      //      </> : `${text} `}
      // </Styled>
      //   },
      //   {
      //     title: "Pending Quantity",
      //     dataIndex: "pendingQuant",
      //     width: "4%",
      //     render: (text, record) =>
      //     <Styled>

      //     {" "}
      //    { record.type.toLowerCase() == "sheet" && record.quantity_type.toLowerCase() == "reel_sheet" ?
      //    <><span style={{textAlign:"center",fontSize:'12px'}}>{text}</span><br/> <span> {record.total_pending_quantity.quantity + ' Sheets'} </span>
      //      </> : `${text} `}
      // </Styled>
      //   },
      //   {
      //     title: "Quantity to be planned",
      //     dataIndex: "plannedQuant",
      //     width: "8%",
      //     render: (text, record, index) => (
      //       <div
      //         className="actionBtn"
      //         style={{
      //           marginTop:
      //             isEditClicked?.[record.orderno] &&
      //             isEditClicked?.[record.orderno].isEditable
      //               ? "10px"
      //               : "5px",
      //           justifyContent: "left",
      //         }}
      //       >
      //         {(!isEditClicked?.[record.orderno] ||
      //           (isEditClicked?.[record.orderno] &&
      //             !isEditClicked?.[record.orderno].isEditable)) && (
      //           <Col span={12}>
      //             {" "}
      //             {text} {record.plannedUnit}{" "}
      //           </Col>
      //         )}
      //         {(!isEditClicked?.[record.orderno] ||
      //           (isEditClicked?.[record.orderno] &&
      //             !isEditClicked?.[record.orderno].isEditable &&
      //             userDetails?.roles?.job_cards.edit)) && (
      //           <Col span={12}>
      //             <Styled style={{ marginTop: "-7px" }}>
      //               <Tooltip
      //                 placement="bottomRight"
      //                 title={"Edit planned quantity"}
      //                 className="edit-tooltip"
      //                 getPopupContainer={(triggerNode) => triggerNode}
      //               >
      //                 <Button
      //                   onClick={() => {
      //                     handleEditColumn(index, record, true);
      //                   }}
      //                 >
      //                   <Iconmoon icon="edit" size={16} color="#A19F9D" />
      //                 </Button>
      //               </Tooltip>
      //             </Styled>
      //           </Col>
      //         )}
      //         {isEditClicked?.[record.orderno] &&
      //           isEditClicked?.[record.orderno].isEditable && (
      //             <DetailFields style={{ paddingBottom: "0px" }}>
      //               <Styled>
      //                 <HaberForm>
      //                   {/* <Form
      //                 id="form"
      //                 form={form}
      //                 name="basic"
      //                 autoComplete="off"
      //                 className="qtyToBePlannedInput"
      //                 onFinish={onFinish}
      //               > */}
      //                   <Row className="centerAlign justifyCSBetween">
      //                     <Col span={14} style={{ paddingRight: "5px" }}>
      //                       <div className="boxFormType">
      //                         <Form.Item
      //                           name={`plannedQuanty${record?.orderno}`}
      //                           rules={[
      //                             {
      //                               required: true,
      //                               message: "This field is required.",
      //                             },
      //                             {
      //                               pattern: new RegExp(
      //                                 /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
      //                               ),
      //                               message:
      //                                 "This value should be a non-zero positive value.",
      //                             },
      //                             {
      //                               validator(_, value) {
      //                                 if (
      //                                   record.pendingQuant &&
      //                                   record.pendingQuant?.split(" ")[0] &&
      //                                   parseFloat(value) > 0
      //                                 ) {
      //                                   if (
      //                                     parseFloat(
      //                                       onValitdateQtyChange(
      //                                         value,
      //                                         record,
      //                                         index
      //                                       )
      //                                     ) <=
      //                                     parseFloat(
      //                                       record.pendingQuant?.split(" ")[0]
      //                                     )
      //                                   ) {
      //                                     return Promise.resolve();
      //                                   } else {
      //                                     return Promise.reject(
      //                                       record?.quantity_type ==
      //                                         "reel_sheet" &&
      //                                         record?.type == "Sheet"
      //                                         ? `The weight of ${value} sheets (${parseFloat(
      //                                             onValitdateQtyChange(
      //                                               value,
      //                                               record,
      //                                               index
      //                                             )
      //                                           )} ${capitalize(
      //                                             weightUnit[
      //                                               record
      //                                                 .total_pending_quantity
      //                                                 .units.weight
      //                                             ]?.displayName
      //                                           )}), can't be more than pending quantity.`
      //                                         : "Quantity to be planned can't be more than the pending quantity."
      //                                     );
      //                                   }
      //                                 } else {
      //                                   return Promise.reject("");
      //                                 }
      //                               },
      //                             },
      //                           ]}
      //                           className="dBlock"
      //                           initialValue={text}
      //                         >
      //                           <Input
      //                             onChange={(e) => {
      //                               onPlannedQuntyChange(e, record, index);
      //                             }}
      //                           />
      //                         </Form.Item>
      //                         <span
      //                           className="nonEditable"
      //                           style={{ marginTop: "0px" }}
      //                         >
      //                           {record.plannedUnit}
      //                         </span>
      //                       </div>
      //                     </Col>
      //                     <Col
      //                       span={10}
      //                       style={{ paddingRight: "5px", marginTop: "0px" }}
      //                     >
      //                       <div
      //                         className="boxFormType"
      //                         style={{ marginBottom: "0", marginTop: "7px" }}
      //                       >
      //                         {(!plannedQuantityErr?.[record.orderno] ||
      //                           (plannedQuantityErr?.[record.orderno] &&
      //                             !plannedQuantityErr?.[record.orderno]
      //                               .error)) && (
      //                           <Tooltip title={"Save the entered value"}>
      //                             <Button
      //                               key="1"
      //                               className="edit-btn"
      //                               style={{
      //                                 padding: "0px",
      //                                 margin: "0px",
      //                                 width: "28px",
      //                                 border: "none",
      //                                 display: "inline-block",
      //                                 marginRight: "10px",
      //                               }}
      //                               onClick={() =>
      //                                 onActionChange(index, "save", record)
      //                               }
      //                             >
      //                               <Iconmoon
      //                                 icon="check"
      //                                 size={18}
      //                                 color="#3FBD61"
      //                               />
      //                             </Button>
      //                           </Tooltip>
      //                         )}

      //                         <Tooltip title={"Remove the entered value"}>
      //                           <Button
      //                             key="2"
      //                             className="edit-btn"
      //                             style={{
      //                               padding: "0px",
      //                               margin: "0px",
      //                               width: "28px",
      //                               border: "none",
      //                               display: "inline-block",
      //                             }}
      //                             onClick={() =>
      //                               onActionChange(index, "remove", record)
      //                             }
      //                           >
      //                             <Iconmoon
      //                               icon="cancel"
      //                               size={18}
      //                               color="red"
      //                             />
      //                           </Button>
      //                         </Tooltip>
      //                       </div>
      //                     </Col>
      //                   </Row>
      //                   {/* </Form> */}
      //                 </HaberForm>
      //               </Styled>
      //             </DetailFields>
      //           )}
      //       </div>
      //     ),
      //   },
      //   {
      //     title: "Reel OD for Rewinding",
      //     dataIndex: "reelod",
      //     width: "5%",
      //     render: (text, record, index) => (
      //       <Styled>
      //         <div style={{ display: "flex" }}>
      //           {record.id_od_type == "range" && (
      //             <div style={{ color: "var(--para-text)",display : 'flex' , width : "70%",alignSelf:'center' }}>
      //             {(record.minimum_reel_od && record.maximum_reel_od) ? (record.minimum_reel_od + "-" + record.maximum_reel_od + " " +
      //                 (record.units.maximum_reel_od ? lengthUnit[record.units.maximum_reel_od].displayName : "")) : ""}
      //           </div>
      //           )}
      //           {record.id_od_type == "constant" && (
      //             <div
      //               style={{
      //                 display: "flex",
      //                 width: "70%",
      //                 flexDirection: "column",
      //                 alignSelf: "center",
      //               }}
      //             >
      //               {record.reelod &&
      //                 record.reelod?.map((item, index) => {
      //                   return (
      //                     index < 2 && (
      //                       <div>
      //                         {item}{" "}
      //                         {index == 1
      //                           ? "...,"
      //                           : record.reelod.length > 1
      //                           ? ","
      //                           : ""}
      //                       </div>
      //                     )
      //                   );
      //                 })}

      //               {record.reelod &&
      //                 record.reelod?.length >= 2 &&
      //                 record.reelod?.map((item, index) => {
      //                   let tooltipData = "";
      //                   for (
      //                     let index = 2;
      //                     index < record.reelod?.length;
      //                     index++
      //                   ) {
      //                     const data = record.reelod[index];
      //                     tooltipData = tooltipData + data + ", ";
      //                   }
      //                   tooltipData = tooltipData.substring(
      //                     0,
      //                     tooltipData.length - 1
      //                   );
      //                   return (
      //                     index == 2 && (
      //                       <Tooltip title={tooltipData}>
      //                         {" "}
      //                         <span
      //                           style={{
      //                             display: "flex",
      //                             fontSize: "10px",
      //                             fontWeight: "bold",
      //                           }}
      //                         >
      //                           & {record.reelod.length - 2} More
      //                         </span>
      //                       </Tooltip>
      //                     )
      //                   );
      //                 })}
      //             </div>
      //           )}
      //           <div style={{ display: "flex", width: "30%" }}>
      //             <div className="actionBtn">
      //               {" "}
      //               {userDetails?.roles?.job_cards.edit && (
      //                 <Button
      //                   onClick={() =>
      //                     showEditReelCoreModal(record, "reel", index)
      //                   }
      //                   style={{ background: "none" }}
      //                 >
      //                   <Iconmoon
      //                     icon="down"
      //                     size={30}
      //                     color="var(--para-text)"
      //                   />
      //                 </Button>
      //               )}{" "}
      //             </div>
      //           </div>
      //         </div>
      //       </Styled>
      //     ),
      //   },
      //   {
      //     title: "Core OD for Rewinding",
      //     dataIndex: "coreid",
      //     width: "4%",
      //     render: (text, record, index) => (
      //       <div className="actionBtn">
      //         <Styled>
      //           <div style={{ display: "flex" }}>
      //             <div
      //               style={{
      //                 color: "var(--para-text)",
      //                 display: "flex",
      //                 width: "70%",
      //                 alignSelf: "center",
      //               }}
      //             >
      //               {record.coreid}
      //             </div>

      //             <div style={{ display: "flex", width: "30%" }}>
      //               <div className="actionBtn">
      //                 {" "}
      //                 {userDetails?.roles?.job_cards.edit && (
      //                   <Button
      //                     onClick={() =>
      //                       showEditReelCoreModal(record, "core", index)
      //                     }
      //                     style={{ background: "none" }}
      //                   >
      //                     <Iconmoon
      //                       icon="down"
      //                       size={30}
      //                       color="var(--para-text)"
      //                     />
      //                   </Button>
      //                 )}{" "}
      //               </div>
      //             </div>
      //           </div>
      //         </Styled>
      //       </div>
      //     ),
      //   },

      //   {
      //     title: "Planned Reels",
      //     dataIndex: "rewinderreels",
      //     width: "8%",
      //     render: (text, record, index) => (
      //       <div
      //         className="actionBtn"
      //         style={{
      //           marginTop:
      //             isReelEditClicked?.[record.orderno] &&
      //             isReelEditClicked?.[record.orderno].isEditable
      //               ? "10px"
      //               : "5px",
      //           justifyContent: "left",
      //         }}
      //       >
      //         {(!isReelEditClicked?.[record.orderno] ||
      //           (isReelEditClicked?.[record.orderno] &&
      //             !isReelEditClicked?.[record.orderno].isEditable)) && (
      //           <Col span={12}>
      //             {" "}
      //             {record.rewinderreels != 0 ? (  record.rewinderreels + ' Reels') : '-'}
      //           </Col>
      //         )}
      //         {((!isReelEditClicked?.[record.orderno] ||
      //           (isReelEditClicked?.[record.orderno] &&
      //             !isReelEditClicked?.[record.orderno].isEditable &&
      //             userDetails?.roles?.job_cards.edit)) &&
      //           (record.reelod?.length === 1 && record.id_od_type == 'constant') && ( record.order_type  == 'sheet' || ( record.order_type  == 'reel' && record.quantity_type == 'weight'))) && (
      //             <Col span={12}>
      //               <Styled style={{ marginTop: "-7px" }}>
      //                 <Tooltip
      //                   placement="bottomRight"
      //                   title={"Edit planned quantity"}
      //                   className="edit-tooltip"
      //                   getPopupContainer={(triggerNode) => triggerNode}
      //                 >
      //                   <Button
      //                     onClick={() => {
      //                       handleReelEditColumn(index, record, true);
      //                     }}
      //                   >
      //                     <Iconmoon icon="edit" size={16} color="#A19F9D" />
      //                   </Button>
      //                 </Tooltip>
      //               </Styled>
      //             </Col>
      //           )}
      //         {isReelEditClicked?.[record.orderno] &&
      //           isReelEditClicked?.[record.orderno].isEditable && (
      //             <DetailFields style={{ paddingBottom: "0px" }}>
      //               <Styled>
      //                 <HaberForm>
      //                   {/* <Form
      //                 id="form"
      //                 form={form}
      //                 name="basic"
      //                 autoComplete="off"
      //                 className="qtyToBePlannedInput"
      //                 onFinish={onFinish}
      //               > */}
      //                   <Row className="centerAlign justifyCSBetween">
      //                     <Col span={14} style={{ paddingRight: "5px" }}>
      //                       <div className="boxFormType">
      //                         <Form.Item
      //                           name={`rewinderreels${record?.orderno}`}
      //                           rules={[
      //                             {
      //                               required: true,
      //                               message: "This field is required.",
      //                             },
      //                             {
      //                               pattern: new RegExp(
      //                                 /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
      //                               ),
      //                               message:
      //                                 "This value should be a non-zero positive value.",
      //                             },
      //                           ]}
      //                           className="dBlock"
      //                           initialValue={text}
      //                         >
      //                           <Input
      //                             onChange={(e) => {
      //                               onPlannedReelChange(e, record, index);
      //                             }}
      //                           />
      //                         </Form.Item>
      //                         <span
      //                           className="nonEditable"
      //                           style={{ marginTop: "0px" }}
      //                         >
      //                           {"Reels"}
      //                         </span>
      //                       </div>
      //                     </Col>
      //                     <Col
      //                       span={10}
      //                       style={{ paddingRight: "5px", marginTop: "0px" }}
      //                     >
      //                       <div
      //                         className="boxFormType"
      //                         style={{ marginBottom: "0", marginTop: "7px" }}
      //                       >
      //                         {(!plannedReelErr?.[record.orderno] ||
      //                           (plannedReelErr?.[record.orderno] &&
      //                             !plannedReelErr?.[record.orderno].error)) && (
      //                           <Tooltip title={"Save the entered value"}>
      //                             <Button
      //                               key="1"
      //                               className="edit-btn"
      //                               style={{
      //                                 padding: "0px",
      //                                 margin: "0px",
      //                                 width: "28px",
      //                                 border: "none",
      //                                 display: "inline-block",
      //                                 marginRight: "10px",
      //                               }}
      //                               onClick={() =>
      //                                 onPlannedReelActionChange(
      //                                   index,
      //                                   "save",
      //                                   record
      //                                 )
      //                               }
      //                             >
      //                               <Iconmoon
      //                                 icon="check"
      //                                 size={18}
      //                                 color="#3FBD61"
      //                               />
      //                             </Button>
      //                           </Tooltip>
      //                         )}

      //                         <Tooltip title={"Remove the entered value"}>
      //                           <Button
      //                             key="2"
      //                             className="edit-btn"
      //                             style={{
      //                               padding: "0px",
      //                               margin: "0px",
      //                               width: "28px",
      //                               border: "none",
      //                               display: "inline-block",
      //                             }}
      //                             onClick={() =>
      //                               onPlannedReelActionChange(
      //                                 index,
      //                                 "remove",
      //                                 record
      //                               )
      //                             }
      //                           >
      //                             <Iconmoon
      //                               icon="cancel"
      //                               size={18}
      //                               color="red"
      //                             />
      //                           </Button>
      //                         </Tooltip>
      //                       </div>
      //                     </Col>
      //                   </Row>
      //                   {/* </Form> */}
      //                 </HaberForm>
      //               </Styled>
      //             </DetailFields>
      //           )}
      //       </div>
      //     ),
      //   },
      //   {
      //     title: "Planned Weight",
      //     dataIndex: "plannedweight",
      //     width: "3%",
      //     render: (text, record) => `${text}`,
      //   },
      //   {
      //     title: "Created Date",
      //     dataIndex: "createddate",
      //     width: "4%",
      //   },
      //   {
      //     title: "Delivery Date",
      //     dataIndex: "deliverydate",
      //     width: "4%",
      //   },
      //   {
      //     title: "Remarks",
      //     dataIndex: "remarks",
      //     width: "4%",
      //     render: (text, record) => (
      //       <div className="actionBtn">
      //         <Styled>
      //           <Tooltip
      //             placement="bottomRight"
      //             title={record.remarks}
      //             className="edit-tooltip"
      //             getPopupContainer={(triggerNode) => triggerNode}
      //           >
      //             <Button style={{ cursor: "default" }}>
      //               <Iconmoon icon="message" size={16} color="#EA655B" />
      //             </Button>
      //           </Tooltip>
      //         </Styled>
      //       </div>
      //     ),
      //     align: "center",
      //   },
      //   {
      //     title: "Progress",
      //     dataIndex: "progress",
      //     width: "5%",
      //     render: (text, record) => {
      //       // if(record.item_type && record.item_type === "order"){
      //       if (
      //         record?.order_type === "sheet" ||
      //         (record?.order_type === "reel" &&
      //           record?.quantity_type === "weight"
      //           )
      //       ) {
      //         const totalProd =
      //           ((record?.progressbar_info?.completed?.weight + record?.progressbar_info?.in_production?.weight) /
      //            (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
      //           100;
      //         const totalCompleted =
      //           (record?.progressbar_info?.completed?.weight /
      //           (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
      //           100;
      //         //const weightUnitKey =  ((record?.units && record?.units?.weight) ? capitalize(weightUnit[record.units.weight]?.displayName) : "T") ;
      //         return (
      //           <div className="progressLvl">
      //             <Styled>
      //               <Tooltip
      //                 placement="bottomRight"
      //                 title={`${
      //                   record?.progressbar_info?.completed
      //                     ? (record?.progressbar_info?.completed?.weight).toFixed(3)
      //                     : 0.0
      //                 } ${capitalize(weightUnit[record?.progressbar_info?.completed?.units?.weight].displayName)} Weight produced
      //                         ${
      //                           record?.progressbar_info?.in_production
      //                           ? (record?.progressbar_info?.in_production?.weight).toFixed(3)
      //                           : 0.0
      //                       } ${capitalize(weightUnit[record?.progressbar_info?.in_production?.units?.weight].displayName)} Weight in production
      //                       ${
      //                         record?.progressbar_info?.pending
      //                         ? (record?.progressbar_info?.pending?.weight).toFixed(3)
      //                         : 0.0
      //                     } ${capitalize(weightUnit[record?.progressbar_info?.pending?.units?.weight].displayName)} Weight pending for deckle match`}
      //                 className="edit-tooltip"
      //                 getPopupContainer={(triggerNode) => triggerNode}
      //               >
      //                 <Progress
      //                   percent={totalProd}
      //                   success={{
      //                     percent: totalCompleted ,
      //                   }}
      //                   strokeColor={"#cbe2cd"}
      //                 />
      //               </Tooltip>
      //             </Styled>
      //           </div>
      //         );
      //       } else {
      //         const production =
      //           ((record?.progressbar_info?.completed?.quantity + record?.progressbar_info?.in_production?.quantity) /
      //           (record?.no_of_reel_sheet - record.cancelled_quantity?.quantity)) *
      //           100;
      //         const completed = (record?.progressbar_info?.completed?.quantity / (record?.no_of_reel_sheet - record.cancelled_quantity?.quantity)) * 100;

      //         return (
      //           <div className="progressLvl">
      //             <Styled>
      //               <Tooltip
      //                 placement="bottomRight"
      //                 title={`${ record?.progressbar_info?.completed
      //                   ? (record?.progressbar_info?.completed?.quantity)
      //                   : 0} Reels produced
      //                         ${record?.progressbar_info?.in_production
      //                           ? (record?.progressbar_info?.in_production?.quantity) : 0} Reels in production
      //                         ${record?.progressbar_info?.pending
      //                           ? (record?.progressbar_info?.pending?.quantity)
      //                           : 0} Reels pending for deckle match`}
      //                 className="edit-tooltip"
      //                 getPopupContainer={(triggerNode) => triggerNode}
      //               >
      //                 <Progress
      //                   percent={production}
      //                   success={{
      //                     percent: completed,
      //                   }}
      //                   strokeColor={"#cbe2cd"}
      //                 />
      //               </Tooltip>
      //             </Styled>
      //           </div>
      //         );
      //       }

      //     },
      //     align: "center",
      //   },
      //   {
      //     title: "Actions",
      //     dataIndex: "action",
      //     width: "5%",
      //     render: (text, record) => (
      //       <div className="actionBtn">
      //         {userDetails.roles.job_cards.edit ? (
      //           <Styled>
      //             <Tooltip
      //               placement="bottomRight"
      //               title={"Edit planning details"}
      //               className="edit-tooltip"
      //               getPopupContainer={(triggerNode) => triggerNode}
      //             >
      //               <Button
      //                 onClick={() => {
      //                   handleEditAction(record);
      //                 }}
      //               >
      //                 <Iconmoon icon="edit" size={16} color="#A19F9D" />
      //               </Button>
      //             </Tooltip>
      //           </Styled>
      //         ) : (
      //           <div style={{ display: "flex" }}>
      //             <div style={{ width: "38px" }}></div>
      //           </div>
      //         )}
      //         <Styled>
      //           <Tooltip
      //             placement="bottomRight"
      //             title={"View details of this order"}
      //             className="edit-tooltip"
      //             getPopupContainer={(triggerNode) => triggerNode}
      //           >
      //             <Button
      //               onClick={() => {
      //                 handleActions(record);
      //               }}
      //               // disabled={!userDetails.roles.job_cards.view}
      //               disabled={
      //                 !(
      //                   userDetails?.roles?.approve_jobcards.view ||
      //                   userDetails?.roles?.job_cards.view ||
      //                   userDetails?.roles?.job_cards.edit ||
      //                   userDetails?.role_type == "ADMIN" ||
      //                   userDetails?.role_type == "SUPER_ADMIN"
      //                 )
      //               }
      //             >
      //               <Iconmoon icon="file-view" size={16} color="#A19F9D" />
      //             </Button>
      //           </Tooltip>
      //         </Styled>
      //       </div>
      //     ),
      //     align: "center",
      //   },
      // ];

      // cutterSelectedOrderColumnsHead.current = [
      //   {
      //     title: "Po/So.No",
      //     dataIndex: "pono",
      //     width: "4%",
      //     fixed: "left",
      //     // align: "left",
      //     sorter: () => {},
      //     render: (text, record) => (
      //       <span style={{ whiteSpace: 'normal', wordBreak: 'break-word', lineHeight: '1.4' }}>
      //         {
      //           `${record.category === "so" ? record.sono : record.pono}`
      //             .match(/.{1,15}/g)
      //             ?.map((chunk, index) => (
      //               <span key={index}>
      //                 {chunk}
      //                 <br />
      //               </span>
      //             ))
      //         }
      //       </span>
      //     )
      //   },
      //   {
      //     title: "Order No",
      //     dataIndex: "orderno",
      //     width: "3%",
      //     fixed: "left",
      //     sorter: () => {},
      //   },
      //   {
      //     title: "PO Date",
      //     dataIndex: "podate",
      //     width: "3%",
      //     fixed: "left",
      //     sorter: {
      //       compare: (a, b) => new Date(a.podate) - new Date(b.podate),
      //     },
      //   },

      //   {
      //     title: "Customer",
      //     dataIndex: "customer_alias",
      //     width: "3%",
      //     align: "left",
      //     render: (text, record) => (
      //       <div className="actionBtn2">
      //         <Styled>
      //           <Tooltip
      //             placement="bottomRight"
      //             title={`${record.customercode}-${record.customerName}`}
      //             className="edit-tooltip"
      //             getPopupContainer={(triggerNode) => triggerNode}
      //           >
      //             {record?.customer_alias||'-'}
      //           </Tooltip>
      //         </Styled>
      //       </div>
      //     ),
      //   },
      //   {
      //     title: "Consignee",
      //     dataIndex: "consignee_alias",
      //     width: "3%",
      //     align: "left",
      //     render: (text, record) => (
      //       <div className="actionBtn2">
      //         <Styled>
      //           <Tooltip
      //             placement="bottomRight"
      //             title={`${record.consignee}-${record.consignee_name}`}
      //             className="edit-tooltip"
      //             getPopupContainer={(triggerNode) => triggerNode}
      //           >
      //             {record?.consignee_alias||'-'}
      //           </Tooltip>
      //         </Styled>
      //       </div>
      //     ),
      //   },
      //   // {
      //   //   title: "Prod. Code",
      //   //   dataIndex: "productcode",
      //   //   width: "2.5%",
      //   // },
      //   {
      //     title: (
      //       <div>
      //         Product
      //         <Styled style={{ display: "inline-flex" }}>
      //           <Tooltip
      //             placement="bottomRight"
      //             title={
      //               "The product specification is in the format of Grade/GSM/BF/Quality/Moisture"
      //             }
      //             className="edit-tooltip"
      //             getPopupContainer={(triggerNode) => triggerNode}
      //           >
      //             <span className="infoIcon"></span>
      //           </Tooltip>
      //         </Styled>
      //       </div>
      //     ),
      //     render: (text, record) => (
      //       <Styled>
      //         {" "}
      //         <span style={{ fontSize: "10px" }}>{record.productspec} </span>
      //         <br />
      //         <span style={{ textAlign: "center" }}>{record.productcode}</span>
      //       </Styled>
      //     ),
      //     //dataIndex: "productspec",
      //     width: "5%",
      //   },
      //   {
      //     title: "Size(WxL)",
      //     dataIndex: "size",
      //     width: "4%",
      //   },
      //   {
      //     title: "Grain",
      //     dataIndex: "grain",
      //     width: "4%",
      //     render: (text, record, index) => (
      //       <Styled>
      //        { record.order_type.toLowerCase() == 'sheet' ? ( <div style={{ display: "flex" }}>
      //        <Row className="centerAlign">
      //        <div className="boxFormType">
      //        <SelectStyle>
      //         <Form.Item
      //                         name={`grain${record.id}`}
      //                         rules={[
      //                           {
      //                             required: true,
      //                             message: "This field is required",
      //                           },
      //                         ]}
      //                         className="selectForm"
      //                         style={{ marginBottom: 4 }}
      //                         initialValue={record.grain ? record.grain == 'short' ? 'Short' :
      //                         'Long' : null}
      //                       >
      //                         <Select
      //                           placeholder={"Select"}
      //                           suffixIcon={<DropdownArrowStyle />}
      //                           onChange={(e) => onGrainChange(e,record,index)}
      //                           >
      //                           {grainTypeData.map((grainType) => (
      //                             <Option key={grainType}>{grainType}</Option>
      //                           ))}
      //                         </Select>
      //         </Form.Item>
      //         </SelectStyle>
      //         </div>
      //         </Row>
      //         </div>
      //         ): ''}
      //       </Styled>
      //     ),
      //   },
      //   {
      //     title: "Order Quantity",
      //     dataIndex: "quantity",
      //     width: "4%",
      //     render: (text, record) =>
      //     <Styled>

      //     {" "}
      //    { record.type.toLowerCase() == "sheet" && record.quantity_type.toLowerCase() == "reel_sheet" ?
      //    <><span style={{textAlign:"center",fontSize:'12px'}}>{text}</span><br/> <span> {record.no_of_sheets + ' Sheets'} </span>
      //      </> : `${text} `}
      // </Styled>
      //   },
      //   {
      //     title: "Pending Quantity",
      //     dataIndex: "pendingQuant",
      //     width: "4%",
      //     render: (text, record) =>
      //     <Styled>

      //     {" "}
      //    { record.type.toLowerCase() == "sheet" && record.quantity_type.toLowerCase() == "reel_sheet" ?
      //    <><span style={{textAlign:"center",fontSize:'12px'}}>{text}</span><br/> <span> {record.total_pending_quantity.quantity + ' Sheets'} </span>
      //      </> : `${text} `}
      // </Styled>
      //   },
      //   {
      //     title: "Quantity to be planned",
      //     dataIndex: "plannedQuant",
      //     width: "8%",
      //     render: (text, record, index) => (
      //       <div
      //         className="actionBtn"
      //         style={{
      //           marginTop:
      //             isEditClicked?.[record.orderno] &&
      //             isEditClicked?.[record.orderno].isEditable
      //               ? "10px"
      //               : "5px",
      //           justifyContent: "left",
      //         }}
      //       >
      //         {(!isEditClicked?.[record.orderno] ||
      //           (isEditClicked?.[record.orderno] &&
      //             !isEditClicked?.[record.orderno].isEditable)) && (
      //           <Col span={12}>
      //             {" "}
      //             {text} {record.plannedUnit}{" "}
      //           </Col>
      //         )}
      //         {(!isEditClicked?.[record.orderno] ||
      //           (isEditClicked?.[record.orderno] &&
      //             !isEditClicked?.[record.orderno].isEditable &&
      //             userDetails?.roles?.job_cards.edit)) && (
      //           <Col span={12}>
      //             <Styled style={{ marginTop: "-7px" }}>
      //               <Tooltip
      //                 placement="bottomRight"
      //                 title={"Edit planned quantity"}
      //                 className="edit-tooltip"
      //                 getPopupContainer={(triggerNode) => triggerNode}
      //               >
      //                 <Button
      //                   onClick={() => {
      //                     handleEditColumn(index, record, true);
      //                   }}
      //                 >
      //                   <Iconmoon icon="edit" size={16} color="#A19F9D" />
      //                 </Button>
      //               </Tooltip>
      //             </Styled>
      //           </Col>
      //         )}
      //         {isEditClicked?.[record.orderno] &&
      //           isEditClicked?.[record.orderno].isEditable && (
      //             <DetailFields style={{ paddingBottom: "0px" }}>
      //               <Styled>
      //                 <HaberForm>
      //                   {/* <Form
      //                 id="form"
      //                 form={form}
      //                 name="basic"
      //                 autoComplete="off"
      //                 className="qtyToBePlannedInput"
      //                 onFinish={onFinish}
      //               > */}
      //                   <Row className="centerAlign justifyCSBetween">
      //                     <Col span={14} style={{ paddingRight: "5px" }}>
      //                       <div className="boxFormType">
      //                         <Form.Item
      //                           name={`plannedQuanty${record?.orderno}`}
      //                           rules={[
      //                             {
      //                               required: true,
      //                               message: "This field is required.",
      //                             },
      //                             {
      //                               pattern: new RegExp(
      //                                 /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
      //                               ),
      //                               message:
      //                                 "This value should be a non-zero positive value.",
      //                             },
      //                             {
      //                               validator(_, value) {
      //                                 if (
      //                                   record.pendingQuant &&
      //                                   record.pendingQuant?.split(" ")[0] &&
      //                                   parseFloat(value) > 0
      //                                 ) {
      //                                   if (
      //                                     parseFloat(
      //                                       onValitdateQtyChange(
      //                                         value,
      //                                         record,
      //                                         index
      //                                       )
      //                                     ) <=
      //                                     parseFloat(
      //                                       record.pendingQuant?.split(" ")[0]
      //                                     )
      //                                   ) {
      //                                     return Promise.resolve();
      //                                   } else {
      //                                     return Promise.reject(
      //                                       record?.quantity_type ==
      //                                         "reel_sheet" &&
      //                                         record?.type == "Sheet"
      //                                         ? `The weight of ${value} sheets (${parseFloat(
      //                                             onValitdateQtyChange(
      //                                               value,
      //                                               record,
      //                                               index
      //                                             )
      //                                           )} ${capitalize(
      //                                             weightUnit[
      //                                               record
      //                                                 .total_pending_quantity
      //                                                 .units.weight
      //                                             ]?.displayName
      //                                           )}), can't be more than pending quantity.`
      //                                         : "Quantity to be planned can't be more than the pending quantity."
      //                                     );
      //                                   }
      //                                 } else {
      //                                   return Promise.reject("");
      //                                 }
      //                               },
      //                             },
      //                           ]}
      //                           className="dBlock"
      //                           initialValue={text}
      //                         >
      //                           <Input
      //                             onChange={(e) => {
      //                               onPlannedQuntyChange(e, record, index);
      //                             }}
      //                           />
      //                         </Form.Item>
      //                         <span
      //                           className="nonEditable"
      //                           style={{ marginTop: "0px" }}
      //                         >
      //                           {record.plannedUnit}
      //                         </span>
      //                       </div>
      //                     </Col>
      //                     <Col
      //                       span={10}
      //                       style={{ paddingRight: "5px", marginTop: "0px" }}
      //                     >
      //                       <div
      //                         className="boxFormType"
      //                         style={{ marginBottom: "0", marginTop: "7px" }}
      //                       >
      //                         {(!plannedQuantityErr?.[record.orderno] ||
      //                           (plannedQuantityErr?.[record.orderno] &&
      //                             !plannedQuantityErr?.[record.orderno]
      //                               .error)) && (
      //                           <Tooltip title={"Save the entered value"}>
      //                             <Button
      //                               key="1"
      //                               className="edit-btn"
      //                               style={{
      //                                 padding: "0px",
      //                                 margin: "0px",
      //                                 width: "28px",
      //                                 border: "none",
      //                                 display: "inline-block",
      //                                 marginRight: "10px",
      //                               }}
      //                               onClick={() =>
      //                                 onActionChange(index, "save", record)
      //                               }
      //                             >
      //                               <Iconmoon
      //                                 icon="check"
      //                                 size={18}
      //                                 color="#3FBD61"
      //                               />
      //                             </Button>
      //                           </Tooltip>
      //                         )}

      //                         <Tooltip title={"Remove the entered value"}>
      //                           <Button
      //                             key="2"
      //                             className="edit-btn"
      //                             style={{
      //                               padding: "0px",
      //                               margin: "0px",
      //                               width: "28px",
      //                               border: "none",
      //                               display: "inline-block",
      //                             }}
      //                             onClick={() =>
      //                               onActionChange(index, "remove", record)
      //                             }
      //                           >
      //                             <Iconmoon
      //                               icon="cancel"
      //                               size={18}
      //                               color="red"
      //                             />
      //                           </Button>
      //                         </Tooltip>
      //                       </div>
      //                     </Col>
      //                   </Row>
      //                   {/* </Form> */}
      //                 </HaberForm>
      //               </Styled>
      //             </DetailFields>
      //           )}
      //       </div>
      //     ),
      //   },
      //   {
      //     title: "Delivery Date",
      //     dataIndex: "deliverydate",
      //     width: "2.9%",
      //     sorter: {
      //       compare: (a, b) =>
      //         new Date(a.deliverydate) - new Date(b.deliverydate),
      //     },
      //   },
      //   {
      //     title: "Created Date",
      //     dataIndex: "createddate",
      //     width: "2.9%",
      //     sorter: {
      //       compare: (a, b) =>
      //         new Date(a.deliverydate) - new Date(b.deliverydate),
      //     },
      //   },
      //   {
      //     title: "Priority",
      //     dataIndex: "priority",
      //     width: "5%",
      //     render: (text, record) => (
      //       <div className="actionBtn">
      //         <Button style={{ cursor: "default" }}>
      //           <Iconmoon
      //             icon={record.priority ? "correct" : "wrong"}
      //             size={16}
      //             color={record.priority ? "#3FBD61" : "#a19f9d"}
      //           />
      //         </Button>
      //       </div>
      //     ),
      //     align: "center",
      //   },
      //   {
      //     title: "Remarks",
      //     dataIndex: "remarks",
      //     width: "4%",
      //     render: (text, record) => (
      //       <div className="actionBtn">
      //         <Styled>
      //           <Tooltip
      //             placement="bottomRight"
      //             title={record.remarks}
      //             className="edit-tooltip"
      //             getPopupContainer={(triggerNode) => triggerNode}
      //           >
      //             <Button style={{ cursor: "default" }}>
      //               <Iconmoon icon="message" size={16} color="#EA655B" />
      //             </Button>
      //           </Tooltip>
      //         </Styled>
      //       </div>
      //     ),
      //     align: "center",
      //   },
      //   {
      //     title: "Progress",
      //     dataIndex: "progress",
      //     width: "5%",
      //     render: (text, record) => {
      //       // if(record.item_type && record.item_type === "order"){
      //       if (
      //         record?.order_type === "sheet" ||
      //         (record?.order_type === "reel" &&
      //           record?.quantity_type === "weight"
      //           )
      //       ) {
      //         const totalProd =
      //           ((record?.progressbar_info?.completed?.weight + record?.progressbar_info?.in_production?.weight) /
      //            (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
      //           100;
      //         const totalCompleted =
      //           (record?.progressbar_info?.completed?.weight /
      //           (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
      //           100;
      //         //const weightUnitKey =  ((record?.units && record?.units?.weight) ? capitalize(weightUnit[record.units.weight]?.displayName) : "T") ;
      //         return (
      //           <div className="progressLvl">
      //             <Styled>
      //               <Tooltip
      //                 placement="bottomRight"
      //                 title={`${
      //                   record?.progressbar_info?.completed
      //                     ? (record?.progressbar_info?.completed?.weight).toFixed(3)
      //                     : 0.0
      //                 } ${capitalize(weightUnit[record?.progressbar_info?.completed?.units?.weight].displayName)} Weight produced
      //                         ${
      //                           record?.progressbar_info?.in_production
      //                           ? (record?.progressbar_info?.in_production?.weight).toFixed(3)
      //                           : 0.0
      //                       } ${capitalize(weightUnit[record?.progressbar_info?.in_production?.units?.weight].displayName)} Weight in production
      //                       ${
      //                         record?.progressbar_info?.pending
      //                         ? (record?.progressbar_info?.pending?.weight).toFixed(3)
      //                         : 0.0
      //                     } ${capitalize(weightUnit[record?.progressbar_info?.pending?.units?.weight].displayName)} Weight pending for deckle match`}
      //                 className="edit-tooltip"
      //                 getPopupContainer={(triggerNode) => triggerNode}
      //               >
      //                 <Progress
      //                   percent={totalProd}
      //                   success={{
      //                     percent: totalCompleted ,
      //                   }}
      //                   strokeColor={"#cbe2cd"}
      //                 />
      //               </Tooltip>
      //             </Styled>
      //           </div>
      //         );
      //       } else {
      //         const production =
      //           ((record?.progressbar_info?.completed?.quantity + record?.progressbar_info?.in_production?.quantity) /
      //           (record?.no_of_reel_sheet - record.cancelled_quantity?.quantity)) *
      //           100;
      //         const completed = (record?.progressbar_info?.completed?.quantity / (record?.no_of_reel_sheet - record.cancelled_quantity?.quantity)) * 100;

      //         return (
      //           <div className="progressLvl">
      //             <Styled>
      //               <Tooltip
      //                 placement="bottomRight"
      //                 title={`${ record?.progressbar_info?.completed
      //                   ? (record?.progressbar_info?.completed?.quantity)
      //                   : 0} Reels produced
      //                         ${record?.progressbar_info?.in_production
      //                           ? (record?.progressbar_info?.in_production?.quantity) : 0} Reels in production
      //                         ${record?.progressbar_info?.pending
      //                           ? (record?.progressbar_info?.pending?.quantity)
      //                           : 0} Reels pending for deckle match`}
      //                 className="edit-tooltip"
      //                 getPopupContainer={(triggerNode) => triggerNode}
      //               >
      //                 <Progress
      //                   percent={production}
      //                   success={{
      //                     percent: completed,
      //                   }}
      //                   strokeColor={"#cbe2cd"}
      //                 />
      //               </Tooltip>
      //             </Styled>
      //           </div>
      //         );
      //       }

      //     },
      //     align: "center",
      //   },
      //   {
      //     title: "Actions",
      //     dataIndex: "action",
      //     width: "5%",
      //     render: (text, record) => (
      //       <div className="actionBtn">
      //         {userDetails.roles.job_cards.edit ? (
      //           <Styled>
      //             <Tooltip
      //               placement="bottomRight"
      //               title={"Edit planning details"}
      //               className="edit-tooltip"
      //               getPopupContainer={(triggerNode) => triggerNode}
      //             >
      //               <Button
      //                 onClick={() => {
      //                   handleEditAction(record);
      //                 }}
      //               >
      //                 <Iconmoon icon="edit" size={16} color="#A19F9D" />
      //               </Button>
      //             </Tooltip>
      //           </Styled>
      //         ) : (
      //           <div style={{ display: "flex" }}>
      //             <div style={{ width: "38px" }}></div>
      //           </div>
      //         )}
      //         <Styled>
      //           <Tooltip
      //             placement="bottomRight"
      //             title={"View details of this order"}
      //             className="edit-tooltip"
      //             getPopupContainer={(triggerNode) => triggerNode}
      //           >
      //             <Button
      //               onClick={() => {
      //                 handleActions(record);
      //               }}
      //               // disabled={!userDetails.roles.job_cards.view}
      //               disabled={
      //                 !(
      //                   userDetails?.roles?.approve_jobcards.view ||
      //                   userDetails?.roles?.job_cards.view ||
      //                   userDetails?.roles?.job_cards.edit ||
      //                   userDetails?.role_type == "ADMIN" ||
      //                   userDetails?.role_type == "SUPER_ADMIN"
      //                 )
      //               }
      //             >
      //               <Iconmoon icon="file-view" size={16} color="#A19F9D" />
      //             </Button>
      //           </Tooltip>
      //         </Styled>
      //       </div>
      //     ),
      //     align: "center",
      //   },
      // ];
      // cutterOtherOrderColumnsHead.current = [
      //   {
      //     title: "Po/So.No",
      //     dataIndex: "pono",
      //     width: "4%",
      //     fixed: "left",
      //     // align: "left",
      //     sorter: () => {},
      //     render: (text, record) => (
      //       <span style={{ whiteSpace: 'normal', wordBreak: 'break-word', lineHeight: '1.4' }}>
      //         {
      //           `${record.category === "so" ? record.sono : record.pono}`
      //             .match(/.{1,15}/g)
      //             ?.map((chunk, index) => (
      //               <span key={index}>
      //                 {chunk}
      //                 <br />
      //               </span>
      //             ))
      //         }
      //       </span>
      //     )
      //   },
      //   {
      //     title: "Order No",
      //     dataIndex: "orderno",
      //     width: "3%",
      //     fixed: "left",
      //     sorter: () => {},
      //   },
      //   {
      //     title: "PO Date",
      //     dataIndex: "podate",
      //     width: "3%",
      //     fixed: "left",
      //     sorter: {
      //       compare: (a, b) => new Date(a.podate) - new Date(b.podate),
      //     },
      //   },

      //   {
      //     title: "Customer",
      //     dataIndex: "customer_alias",
      //     width: "3%",
      //     align: "left",
      //     render: (text, record) => (
      //       <div className="actionBtn2">
      //         <Styled>
      //           <Tooltip
      //             placement="bottomRight"
      //             title={`${record.customercode}-${record.customerName}`}
      //             className="edit-tooltip"
      //             getPopupContainer={(triggerNode) => triggerNode}
      //           >
      //             {record?.customer_alias||'-'}
      //           </Tooltip>
      //         </Styled>
      //       </div>
      //     ),
      //   },
      //   {
      //     title: "Consignee",
      //     dataIndex: "consignee_alias",
      //     width: "3%",
      //     align: "left",
      //     render: (text, record) => (
      //       <div className="actionBtn2">
      //         <Styled>
      //           <Tooltip
      //             placement="bottomRight"
      //             title={`${record.consignee}-${record.consignee_name}`}
      //             className="edit-tooltip"
      //             getPopupContainer={(triggerNode) => triggerNode}
      //           >
      //             {record?.consignee_alias||'-'}
      //           </Tooltip>
      //         </Styled>
      //       </div>
      //     ),
      //   },
      //   {
      //     title: (
      //       <div>
      //         Product
      //         <Styled style={{ display: "inline-flex" }}>
      //           <Tooltip
      //             placement="bottomRight"
      //             title={
      //               "The product specification is in the format of Grade/GSM/BF/Quality/Moisture"
      //             }
      //             className="edit-tooltip"
      //             getPopupContainer={(triggerNode) => triggerNode}
      //           >
      //             <span className="infoIcon"></span>
      //           </Tooltip>
      //         </Styled>
      //       </div>
      //     ),
      //     render: (text, record) => (
      //       <Styled>
      //         {" "}
      //         <span style={{ fontSize: "10px" }}>{record.productspec} </span>
      //         <br />
      //         <span style={{ textAlign: "center" }}>{record.productcode}</span>
      //       </Styled>
      //     ),
      //     //dataIndex: "productspec",
      //     width: "5%",
      //   },
      //   {
      //     title: "Size(WxL)",
      //     dataIndex: "size",
      //     width: "4%",
      //   },
      //   {
      //     title: "Grain",
      //     dataIndex: "grain",
      //     width: "4%",
      //     render: (text, record, index) => (
      //       <Styled>
      //        { record.order_type.toLowerCase() == 'sheet' ? ( <div style={{ display: "flex" }}>
      //        <Row className="centerAlign">
      //        <div className="boxFormType">
      //        <SelectStyle>
      //         <Form.Item
      //                         name={`grain${record.id}`}
      //                         rules={[
      //                           {
      //                             required: true,
      //                             message: "This field is required",
      //                           },
      //                         ]}
      //                         className="selectForm"
      //                         style={{ marginBottom: 4 }}
      //                         initialValue={record.grain ? record.grain == 'short' ? 'Short' :
      //                         'Long' : null}
      //                       >
      //                         <Select
      //                           placeholder={"Select"}
      //                           suffixIcon={<DropdownArrowStyle />}
      //                           onChange={(e) => onGrainChange(e,record,index)}
      //                           >
      //                           {grainTypeData.map((grainType) => (
      //                             <Option key={grainType}>{grainType}</Option>
      //                           ))}
      //                         </Select>
      //         </Form.Item>
      //         </SelectStyle>
      //         </div>
      //         </Row>
      //         </div>
      //         ): ''}
      //       </Styled>
      //     ),
      //   },
      //   {
      //     title: "Order Quantity",
      //     dataIndex: "quantity",
      //     width: "4%",
      //     render: (text, record) =>
      //     <Styled>

      //     {" "}
      //    { record.type.toLowerCase() == "sheet" && record.quantity_type.toLowerCase() == "reel_sheet" ?
      //    <><span style={{textAlign:"center",fontSize:'12px'}}>{text}</span><br/> <span> {record.no_of_sheets + ' Sheets'} </span>
      //      </> : `${text} `}
      // </Styled>
      //   },
      //   {
      //     title: "Pending Quantity",
      //     dataIndex: "pendingQuant",
      //     width: "4%",
      //     render: (text, record) =>
      //     <Styled>

      //     {" "}
      //    { record.type.toLowerCase() == "sheet" && record.quantity_type.toLowerCase() == "reel_sheet" ?
      //    <><span style={{textAlign:"center",fontSize:'12px'}}>{text}</span><br/> <span> {record.total_pending_quantity.quantity + ' Sheets'} </span>
      //      </> : `${text} `}
      // </Styled>
      //   },
      //   {
      //     title: "Quantity to be planned",
      //     dataIndex: "plannedQuant",
      //     width: "8%",
      //     render: (text, record, index) => (
      //       <div
      //         className="actionBtn"
      //         style={{
      //           marginTop:
      //             isEditClicked?.[record.orderno] &&
      //             isEditClicked?.[record.orderno].isEditable
      //               ? "10px"
      //               : "5px",
      //           justifyContent: "left",
      //         }}
      //       >
      //         {(!isEditClicked?.[record.orderno] ||
      //           (isEditClicked?.[record.orderno] &&
      //             !isEditClicked?.[record.orderno].isEditable)) && (
      //           <Col span={12}>
      //             {" "}
      //             {text} {record.plannedUnit}{" "}
      //           </Col>
      //         )}
      //         {(!isEditClicked?.[record.orderno] ||
      //           (isEditClicked?.[record.orderno] &&
      //             !isEditClicked?.[record.orderno].isEditable &&
      //             userDetails?.roles?.job_cards.edit)) && (
      //           <Col span={12}>
      //             <Styled style={{ marginTop: "-7px" }}>
      //               <Tooltip
      //                 placement="bottomRight"
      //                 title={"Edit planned quantity"}
      //                 className="edit-tooltip"
      //                 getPopupContainer={(triggerNode) => triggerNode}
      //               >
      //                 <Button
      //                   onClick={() => {
      //                     handleEditColumn(index, record, true);
      //                   }}
      //                 >
      //                   <Iconmoon icon="edit" size={16} color="#A19F9D" />
      //                 </Button>
      //               </Tooltip>
      //             </Styled>
      //           </Col>
      //         )}
      //         {isEditClicked?.[record.orderno] &&
      //           isEditClicked?.[record.orderno].isEditable && (
      //             <DetailFields style={{ paddingBottom: "0px" }}>
      //               <Styled>
      //                 <HaberForm>
      //                   {/* <Form
      //                 id="form"
      //                 form={form}
      //                 name="basic"
      //                 autoComplete="off"
      //                 className="qtyToBePlannedInput"
      //                 onFinish={onFinish}
      //               > */}
      //                   <Row className="centerAlign justifyCSBetween">
      //                     <Col span={14} style={{ paddingRight: "5px" }}>
      //                       <div className="boxFormType">
      //                         <Form.Item
      //                           name={`plannedQuanty${record?.orderno}`}
      //                           rules={[
      //                             {
      //                               required: true,
      //                               message: "This field is required.",
      //                             },
      //                             {
      //                               pattern: new RegExp(
      //                                 /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
      //                               ),
      //                               message:
      //                                 "This value should be a non-zero positive value.",
      //                             },
      //                             {
      //                               validator(_, value) {
      //                                 if (
      //                                   record.pendingQuant &&
      //                                   record.pendingQuant?.split(" ")[0] &&
      //                                   parseFloat(value) > 0
      //                                 ) {
      //                                   if (
      //                                     parseFloat(
      //                                       onValitdateQtyChange(
      //                                         value,
      //                                         record,
      //                                         index
      //                                       )
      //                                     ) <=
      //                                     parseFloat(
      //                                       record.pendingQuant?.split(" ")[0]
      //                                     )
      //                                   ) {
      //                                     return Promise.resolve();
      //                                   } else {
      //                                     return Promise.reject(
      //                                       record?.quantity_type ==
      //                                         "reel_sheet" &&
      //                                         record?.type == "Sheet"
      //                                         ? `The weight of ${value} sheets (${parseFloat(
      //                                             onValitdateQtyChange(
      //                                               value,
      //                                               record,
      //                                               index
      //                                             )
      //                                           )} ${capitalize(
      //                                             weightUnit[
      //                                               record
      //                                                 .total_pending_quantity
      //                                                 .units.weight
      //                                             ]?.displayName
      //                                           )}), can't be more than pending quantity.`
      //                                         : "Quantity to be planned can't be more than the pending quantity."
      //                                     );
      //                                   }
      //                                 } else {
      //                                   return Promise.reject("");
      //                                 }
      //                               },
      //                             },
      //                           ]}
      //                           className="dBlock"
      //                           initialValue={text}
      //                         >
      //                           <Input
      //                             onChange={(e) => {
      //                               onPlannedQuntyChange(e, record, index);
      //                             }}
      //                           />
      //                         </Form.Item>
      //                         <span
      //                           className="nonEditable"
      //                           style={{ marginTop: "0px" }}
      //                         >
      //                           {record.plannedUnit}
      //                         </span>
      //                       </div>
      //                     </Col>
      //                     <Col
      //                       span={10}
      //                       style={{ paddingRight: "5px", marginTop: "0px" }}
      //                     >
      //                       <div
      //                         className="boxFormType"
      //                         style={{ marginBottom: "0", marginTop: "7px" }}
      //                       >
      //                         {(!plannedQuantityErr?.[record.orderno] ||
      //                           (plannedQuantityErr?.[record.orderno] &&
      //                             !plannedQuantityErr?.[record.orderno]
      //                               .error)) && (
      //                           <Tooltip title={"Save the entered value"}>
      //                             <Button
      //                               key="1"
      //                               className="edit-btn"
      //                               style={{
      //                                 padding: "0px",
      //                                 margin: "0px",
      //                                 width: "28px",
      //                                 border: "none",
      //                                 display: "inline-block",
      //                                 marginRight: "10px",
      //                               }}
      //                               onClick={() =>
      //                                 onActionChange(index, "save", record)
      //                               }
      //                             >
      //                               <Iconmoon
      //                                 icon="check"
      //                                 size={18}
      //                                 color="#3FBD61"
      //                               />
      //                             </Button>
      //                           </Tooltip>
      //                         )}

      //                         <Tooltip title={"Remove the entered value"}>
      //                           <Button
      //                             key="2"
      //                             className="edit-btn"
      //                             style={{
      //                               padding: "0px",
      //                               margin: "0px",
      //                               width: "28px",
      //                               border: "none",
      //                               display: "inline-block",
      //                             }}
      //                             onClick={() =>
      //                               onActionChange(index, "remove", record)
      //                             }
      //                           >
      //                             <Iconmoon
      //                               icon="cancel"
      //                               size={18}
      //                               color="red"
      //                             />
      //                           </Button>
      //                         </Tooltip>
      //                       </div>
      //                     </Col>
      //                   </Row>
      //                   {/* </Form> */}
      //                 </HaberForm>
      //               </Styled>
      //             </DetailFields>
      //           )}
      //       </div>
      //     ),
      //   },
      //   {
      //     title: "Reel OD for Rewinding",
      //     dataIndex: "reelod",
      //     width: "5%",
      //     render: (text, record, index) => (
      //       <Styled>
      //         <div style={{ display: "flex" }}>
      //           {record.id_od_type == "range" && (
      //             <div style={{ color: "var(--para-text)",display : 'flex' , width : "70%",alignSelf:'center' }}>
      //             {(record.minimum_reel_od && record.maximum_reel_od) ? (record.minimum_reel_od + "-" + record.maximum_reel_od + " " +
      //                 (record.units.maximum_reel_od ? lengthUnit[record.units.maximum_reel_od].displayName : "")) : ""}
      //           </div>
      //           )}
      //           {record.id_od_type == "constant" && (
      //             <div
      //               style={{
      //                 display: "flex",
      //                 width: "70%",
      //                 flexDirection: "column",
      //                 alignSelf: "center",
      //               }}
      //             >
      //               {record.reelod &&
      //                 record.reelod?.map((item, index) => {
      //                   return (
      //                     index < 2 && (
      //                       <div>
      //                         {item}{" "}
      //                         {index == 1
      //                           ? "...,"
      //                           : record.reelod.length > 1
      //                           ? ","
      //                           : ""}
      //                       </div>
      //                     )
      //                   );
      //                 })}

      //               {record.reelod &&
      //                 record.reelod?.length >= 2 &&
      //                 record.reelod?.map((item, index) => {
      //                   let tooltipData = "";
      //                   for (
      //                     let index = 2;
      //                     index < record.reelod?.length;
      //                     index++
      //                   ) {
      //                     const data = record.reelod[index];
      //                     tooltipData = tooltipData + data + ", ";
      //                   }
      //                   tooltipData = tooltipData.substring(
      //                     0,
      //                     tooltipData.length - 1
      //                   );
      //                   return (
      //                     index == 2 && (
      //                       <Tooltip title={tooltipData}>
      //                         {" "}
      //                         <span
      //                           style={{
      //                             display: "flex",
      //                             fontSize: "10px",
      //                             fontWeight: "bold",
      //                           }}
      //                         >
      //                           & {record.reelod.length - 2} More
      //                         </span>
      //                       </Tooltip>
      //                     )
      //                   );
      //                 })}
      //             </div>
      //           )}
      //         </div>
      //       </Styled>
      //     ),
      //   },
      //   {
      //     title: "Core OD for Rewinding",
      //     dataIndex: "coreid",
      //     width: "4%",
      //     render: (text, record, index) => (
      //       <div className="actionBtn">
      //         <Styled>
      //           <div style={{ display: "flex" }}>
      //             <div
      //               style={{
      //                 color: "var(--para-text)",
      //                 display: "flex",
      //                 width: "100%",
      //                 alignSelf: "center",
      //               }}
      //             >
      //               {record.coreid}
      //             </div>
      //           </div>
      //         </Styled>
      //       </div>
      //     ),
      //   },
      //   {
      //     title: "Delivery Date",
      //     dataIndex: "deliverydate",
      //     width: "2.9%",
      //     sorter: {
      //       compare: (a, b) =>
      //         new Date(a.deliverydate) - new Date(b.deliverydate),
      //     },
      //   },
      //   {
      //     title: "Created Date",
      //     dataIndex: "createddate",
      //     width: "2.9%",
      //     sorter: {
      //       compare: (a, b) =>
      //         new Date(a.deliverydate) - new Date(b.deliverydate),
      //     },
      //   },
      //   {
      //     title: "Priority",
      //     dataIndex: "priority",
      //     width: "5%",
      //     render: (text, record) => (
      //       <div className="actionBtn">
      //         <Button style={{ cursor: "default" }}>
      //           <Iconmoon
      //             icon={record.priority ? "correct" : "wrong"}
      //             size={16}
      //             color={record.priority ? "#3FBD61" : "#a19f9d"}
      //           />
      //         </Button>
      //       </div>
      //     ),
      //     align: "center",
      //   },
      //   {
      //     title: "Remarks",
      //     dataIndex: "remarks",
      //     width: "4%",
      //     render: (text, record) => (
      //       <div className="actionBtn">
      //         <Styled>
      //           <Tooltip
      //             placement="bottomRight"
      //             title={record.remarks}
      //             className="edit-tooltip"
      //             getPopupContainer={(triggerNode) => triggerNode}
      //           >
      //             <Button style={{ cursor: "default" }}>
      //               <Iconmoon icon="message" size={16} color="#EA655B" />
      //             </Button>
      //           </Tooltip>
      //         </Styled>
      //       </div>
      //     ),
      //     align: "center",
      //   },
      //   {
      //     title: "Progress",
      //     dataIndex: "progress",
      //     width: "5%",
      //     render: (text, record) => {
      //       // if(record.item_type && record.item_type === "order"){
      //       if (
      //         record?.order_type === "sheet" ||
      //         (record?.order_type === "reel" &&
      //           record?.quantity_type === "weight"
      //           )
      //       ) {
      //         const totalProd =
      //           ((record?.progressbar_info?.completed?.weight + record?.progressbar_info?.in_production?.weight) /
      //            (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
      //           100;
      //         const totalCompleted =
      //           (record?.progressbar_info?.completed?.weight /
      //           (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
      //           100;
      //         //const weightUnitKey =  ((record?.units && record?.units?.weight) ? capitalize(weightUnit[record.units.weight]?.displayName) : "T") ;
      //         return (
      //           <div className="progressLvl">
      //             <Styled>
      //               <Tooltip
      //                 placement="bottomRight"
      //                 title={`${
      //                   record?.progressbar_info?.completed
      //                     ? (record?.progressbar_info?.completed?.weight).toFixed(3)
      //                     : 0.0
      //                 } ${capitalize(weightUnit[record?.progressbar_info?.completed?.units?.weight].displayName)} Weight produced
      //                         ${
      //                           record?.progressbar_info?.in_production
      //                           ? (record?.progressbar_info?.in_production?.weight).toFixed(3)
      //                           : 0.0
      //                       } ${capitalize(weightUnit[record?.progressbar_info?.in_production?.units?.weight].displayName)} Weight in production
      //                       ${
      //                         record?.progressbar_info?.pending
      //                         ? (record?.progressbar_info?.pending?.weight).toFixed(3)
      //                         : 0.0
      //                     } ${capitalize(weightUnit[record?.progressbar_info?.pending?.units?.weight].displayName)} Weight pending for deckle match`}
      //                 className="edit-tooltip"
      //                 getPopupContainer={(triggerNode) => triggerNode}
      //               >
      //                 <Progress
      //                   percent={totalProd}
      //                   success={{
      //                     percent: totalCompleted ,
      //                   }}
      //                   strokeColor={"#cbe2cd"}
      //                 />
      //               </Tooltip>
      //             </Styled>
      //           </div>
      //         );
      //       } else {
      //         const production =
      //           ((record?.progressbar_info?.completed?.quantity + record?.progressbar_info?.in_production?.quantity) /
      //           (record?.no_of_reel_sheet - record.cancelled_quantity?.quantity)) *
      //           100;
      //         const completed = (record?.progressbar_info?.completed?.quantity / (record?.no_of_reel_sheet - record.cancelled_quantity?.quantity)) * 100;

      //         return (
      //           <div className="progressLvl">
      //             <Styled>
      //               <Tooltip
      //                 placement="bottomRight"
      //                 title={`${ record?.progressbar_info?.completed
      //                   ? (record?.progressbar_info?.completed?.quantity)
      //                   : 0} Reels produced
      //                         ${record?.progressbar_info?.in_production
      //                           ? (record?.progressbar_info?.in_production?.quantity) : 0} Reels in production
      //                         ${record?.progressbar_info?.pending
      //                           ? (record?.progressbar_info?.pending?.quantity)
      //                           : 0} Reels pending for deckle match`}
      //                 className="edit-tooltip"
      //                 getPopupContainer={(triggerNode) => triggerNode}
      //               >
      //                 <Progress
      //                   percent={production}
      //                   success={{
      //                     percent: completed,
      //                   }}
      //                   strokeColor={"#cbe2cd"}
      //                 />
      //               </Tooltip>
      //             </Styled>
      //           </div>
      //         );
      //       }

      //     },
      //     align: "center",
      //   },
      //   {
      //     title: "Actions",
      //     dataIndex: "action",
      //     width: "5%",
      //     render: (text, record) => (
      //       <div className="actionBtn">
      //         {userDetails.roles.job_cards.edit ? (
      //           <Styled>
      //             <Tooltip
      //               placement="bottomRight"
      //               title={"Edit planning details"}
      //               className="edit-tooltip"
      //               getPopupContainer={(triggerNode) => triggerNode}
      //             >
      //               <Button
      //                 onClick={() => {
      //                   handleEditAction(record);
      //                 }}
      //               >
      //                 <Iconmoon icon="edit" size={16} color="#A19F9D" />
      //               </Button>
      //             </Tooltip>
      //           </Styled>
      //         ) : (
      //           <div style={{ display: "flex" }}>
      //             <div style={{ width: "38px" }}></div>
      //           </div>
      //         )}
      //         <Styled>
      //           <Tooltip
      //             placement="bottomRight"
      //             title={"View details of this order"}
      //             className="edit-tooltip"
      //             getPopupContainer={(triggerNode) => triggerNode}
      //           >
      //             <Button
      //               onClick={() => {
      //                 handleActions(record);
      //               }}
      //               // disabled={!userDetails.roles.job_cards.view}
      //               disabled={
      //                 !(
      //                   userDetails?.roles?.approve_jobcards.view ||
      //                   userDetails?.roles?.job_cards.view ||
      //                   userDetails?.roles?.job_cards.edit ||
      //                   userDetails?.role_type == "ADMIN" ||
      //                   userDetails?.role_type == "SUPER_ADMIN"
      //                 )
      //               }
      //             >
      //               <Iconmoon icon="file-view" size={16} color="#A19F9D" />
      //             </Button>
      //           </Tooltip>
      //         </Styled>
      //       </div>
      //     ),
      //     align: "center",
      //   },
      // ];

      const filteredColumns1 = fullColumnsHead.filter(
        (col) => !columnBlacklist.includes(col.dataIndex)
      );
      const filteredColumns2 = fullCutterSelectedOrderColumnsHead.filter(
        (col) => !columnBlacklist.includes(col.dataIndex)
      );
      const filteredColumns3 = fullCutterOtherOrderColumnsHead.filter(
        (col) => !columnBlacklist.includes(col.dataIndex)
      );

      columnsHead.current = filteredColumns1;
      cutterSelectedOrderColumnsHead.current = filteredColumns2;
      cutterOtherOrderColumnsHead.current = filteredColumns3;

      setTableRerender(false);
    }
  }, [tableRerender]);

  useEffect(() => {
    if (selectedDataRows && selectedDataRows?.length && selectedState) {
      let coreIDValue = form.getFieldValue("coreDia");
      if (
        selecteDia == "constant" &&
        selectedReelOD &&
        selectedReelOD?.length &&
        coreIDValue
      ) {
        let selectedRowIndex;

        for (let i = 0; i < selectedDataRows?.length; i++) {
          let record = selectedDataRows[i];
          let reelArr = [];
          if (record.type == "Reel" && record.quantity_type == "reel_sheet") {
            reelArr.push(selectedReelOD[0].value);
          } else {
            for (let j = 0; j < selectedReelOD.length; j++) {
              reelArr.push(selectedReelOD[j].value);
            }
          }

          selectedRowIndex = tableData?.findIndex(
            (ele) => ele.orderno == record.orderno
          );
          if (
            (selectedRowIndex == 0 || selectedRowIndex) &&
            selectedRowIndex != -1
          ) {
            plannedReelsCaln(
              selectedRowIndex,
              { ...record },
              record.plannedQuant,
              reelArr,
              coreIDValue,
              "incomplete_orders"
            );
          } else {
            plannedReelsCalnForIncompleteOrder(
              i,
              { ...record },
              record.plannedQuant,
              reelArr,
              coreIDValue,
              "incomplete_orders"
            );
          }
        }
      }
      if (
        selecteDia == "constant" &&
        (selectedReelOD?.length == 0 || !coreIDValue)
      ) {
        for (let i = 0; i < selectedDataRows?.length; i++) {
          let record = selectedDataRows[i];
          let selectedRowIndex = tableData?.findIndex(
            (ele) => ele.orderno == record.orderno
          );
          if (
            (selectedRowIndex == 0 || selectedRowIndex) &&
            selectedRowIndex != -1
          ) {
            plannedReelsCaln(
              selectedRowIndex,
              { ...record },
              record.plannedQuant,
              record.outer_dia,
              record.inner_dia,
              "incomplete_orders"
            );
          } else {
            plannedReelsCalnForIncompleteOrder(
              i,
              { ...record },
              record.plannedQuant,
              record.outer_dia,
              record.inner_dia,
              "incomplete_orders"
            );
          }
        }
      }
      if (selecteDia == "range") {
        for (let i = 0; i < selectedDataRows?.length; i++) {
          let record = selectedDataRows[i];
          let selectedRowIndex = tableData?.findIndex(
            (ele) => ele.orderno == record.orderno
          );
          if (
            (record.type?.toLowerCase() == "reel" &&
              record.quantity_type != "reel_sheet") ||
            record.type?.toLowerCase() == "sheet"
          ) {
            record.outer_dia = [];
            record.reelod = "";
            if (
              (selectedRowIndex == 0 || selectedRowIndex) &&
              selectedRowIndex != -1
            ) {
              plannedReelsCaln(
                selectedRowIndex,
                { ...record },
                record.plannedQuant,
                record.outer_dia,
                record.inner_dia,
                "incomplete_orders"
              );
            } else {
              plannedReelsCalnForIncompleteOrder(
                i,
                { ...record },
                record.plannedQuant,
                record.outer_dia,
                record.inner_dia,
                "incomplete_orders"
              );
            }
          }
        }
      }
      setSelectedState(false);
    }
    setSelectedState(false);
  }, [selectedState]);

  const handleEditAction = (record) => {
    setSelectedReocord(record);
    showNewResendApproval();
  };

  const handleActions = (record) => {
    setSelectedReocord(record);
    showViewDeckleDrawer();
  };

  const onCancelButtonPress = () => {
    setIsAddRewinderDimension(false);
    setIsMoveToselection(true);
    setLoading(true);
    // setTableData([]);
    setFilterTags([]);
    setAppliedFilters([]);
    setSearchValue("");
    setClearSearch(true);
    form.resetFields();
    setSelectedDia("constant");
    form.setFieldsValue({ diameter_type: "constant" });
    setSelectedReelOD([]);
    setSelectedDataRows([]);
    setSelectedRowKeys([]);
    setTotalWeight(0);
    totalRef.current = 0;
    setIsAllSelected(false);
    // setAppliedFilters([]);
    setPaginationParams({
      page: 1,
      size: settingsData?.settings?.default_page_size || 10,
      sort_by: "updated_at",
      sort_type: "descending",
    });
    // paginationRef.current = {
    //   page: 1,
    //   size: 10,
    // };
    setCurrentPage(1);

    setRendering(true);
  };

  const showNewResendApproval = () => {
    setResendApprovalData(true);
  };

  const showViewDeckleDrawer = () => {
    setViewDeckleOrders(true);
  };

  const confirmCancelModal = () => {
    history("../job-cards");
    setMergeGroupsData(null);
    setViewCancelModal(false);
    setFormObject(null);
  };

  const closeCancelModal = () => {
    setViewCancelModal(false);
  };

  const onCloseNewGrade = () => {
    //setSelectedReocord();
    setResendApprovalData(false);

    setLoading(true);

    setRendering(false);
    setSearchValue("");
    setClearSearch(true);
    setAppliedFilters([]);
    setFilterTags([]);
  };

  const showCancelModal = () => {
    setViewCancelModal(true);
  };

  const getData = (orderData) => {
    const orders = (orderData || allOrdersList)?.map((item) => {
      let processQuantity;
      let pendingQuantity;
      let cancelledQuantity;
      let pendingQuantityValue;

      let quantityValue;
      let rewinderReels;
      if (item.type == "reel" && item.quantity_type == "reel_sheet") {
        pendingQuantityValue =
          item.this_item_type == "order"
            ? Math.round(item.total_pending_quantity.quantity)
            : Math.round(item.total_pending_quantity.quantity);
        processQuantity =
          item.this_item_type == "order"
            ? Math.round(item.total_processed_quantity.quantity) + " Reels"
            : Math.round(item.total_processed_quantity.quantity) + " Reels";
        pendingQuantity =
          item.this_item_type == "order"
            ? Math.round(item.total_pending_quantity.quantity) + " Reels"
            : Math.round(item.total_pending_quantity.quantity) + " Reels";
        cancelledQuantity =
          item.this_item_type == "order"
            ? Math.round(item.cancelled_quantity.quantity) + " Reels"
            : Math.round(item.total_cancelled_quantity.quantity) + " Reels";
        quantityValue =
          item.this_item_type == "order"
            ? Math.round(item.no_of_reel_sheet) + " Reels"
            : Math.round(item.total_quantity) + " Reels";
        rewinderReels =
          item.this_item_type == "order"
            ? Math.round(item.quantity)
            : Math.round(item.total_quantity);
      } else if (item.type == "sheet" && item.quantity_type == "reel_sheet") {
        quantityValue =
          item.this_item_type == "order"
            ? item.weight
              ? item.weight.toFixed(3) +
              " " +
              capitalize(weightUnit[item.units?.planned_weight]?.displayName)
              : "-"
            : item.total_weight
              ? item.total_weight +
              " " +
              capitalize(weightUnit[item.units?.total_weight]?.displayName)
              : "-";
        rewinderReels =
          item.this_item_type == "order"
            ? Math.round(item.quantity)
            : Math.round(item.total_quantity);
        processQuantity =
          item.this_item_type == "order"
            ? item.total_processed_quantity.weight +
            "" +
            capitalize(
              weightUnit[item.total_processed_quantity.units?.weight]
                ?.displayName
            )
            : item.total_processed_quantity.weight +
            " " +
            capitalize(
              weightUnit[item.total_processed_quantity.units?.weight]
                ?.displayName
            );
        pendingQuantity =
          item.this_item_type == "order"
            ? item.total_pending_quantity.weight +
            " " +
            capitalize(
              weightUnit[item.total_pending_quantity.units?.weight]
                ?.displayName
            )
            : item.total_pending_quantity.weight +
            " " +
            capitalize(
              weightUnit[item.total_pending_quantity.units?.weight]
                ?.displayName
            );
        cancelledQuantity =
          item.this_item_type == "order"
            ? item.cancelled_quantity.weight +
            " " +
            capitalize(weightUnit[item.cancelled_quantity.units]?.displayName)
            : item.total_cancelled_quantity.weight +
            " " +
            capitalize(
              weightUnit[item.total_cancelled_quantity.units.weight]
                ?.displayName
            );
        pendingQuantityValue =
          item.this_item_type == "order"
            ? item.total_pending_quantity.weight
            : item.total_pending_quantity.weight;
      } else if (
        (item.type == "reel" || item.type == "sheet") &&
        item.quantity_type == "weight"
      ) {
        quantityValue =
          item.this_item_type == "order"
            ? item.weight
              ? item.weight.toFixed(3) +
              " " +
              capitalize(weightUnit[item.units?.planned_weight]?.displayName)
              : "-"
            : item.total_weight
              ? item.total_weight +
              " " +
              capitalize(weightUnit[item.units?.total_weight]?.displayName)
              : "-";
        rewinderReels =
          item.this_item_type == "order"
            ? Math.round(item.quantity)
            : Math.round(item.total_quantity);
        processQuantity =
          item.this_item_type == "order"
            ? item.total_processed_quantity.weight +
            " " +
            capitalize(
              weightUnit[item.total_processed_quantity.units?.weight]
                ?.displayName
            )
            : item.total_processed_quantity.weight +
            " " +
            capitalize(
              weightUnit[item.total_processed_quantity.units?.weight]
                ?.displayName
            );
        pendingQuantity =
          item.this_item_type == "order"
            ? item.total_pending_quantity.weight +
            " " +
            capitalize(
              weightUnit[item.total_pending_quantity.units?.weight]
                ?.displayName
            )
            : item.total_pending_quantity.weight +
            " " +
            capitalize(
              weightUnit[item.total_pending_quantity.units?.weight]
                ?.displayName
            );
        cancelledQuantity =
          item.this_item_type == "order"
            ? item.cancelled_quantity.weight +
            " " +
            capitalize(weightUnit[item.cancelled_quantity.units].displayName)
            : item.total_cancelled_quantity.weight +
            " " +
            capitalize(
              weightUnit[item.total_cancelled_quantity.units.weight]
                .displayName
            );
        pendingQuantityValue =
          item.this_item_type == "order"
            ? item.total_pending_quantity.weight
            : item.total_pending_quantity.weight;
      }
      let pendingValue;
      if (item.type === "sheet" && !item.core_id && !item.reel_od) {
        pendingValue =
          item.this_item_type == "order"
            ? item.pending_quantity_weight
            : item.total_planned_weight -
            item.total_weight_completed -
            item.total_weight_in_production -
            item.total_weight_in_process;
      } else {
        pendingValue =
          item.this_item_type == "order"
            ? item.quantity -
            item.completed -
            item.in_production -
            item.in_process
            : item.total_quantity -
            item.total_weight_completed -
            item.total_weight_in_production -
            item.total_weight_in_process;
      }
      let planned_weight;
      if (item.this_item_type == "order") {
        planned_weight = item.planned_weight
          ? `${item.planned_weight !== 0 ? item.planned_weight?.toFixed(3) : 0
          } ${item.units
            ? capitalize(weightUnit[item.units.planned_weight]?.displayName)
            : ""
          }`
          : "-";
      } else {
        planned_weight = item.total_planned_weight
          ? `${item.total_planned_weight !== 0
            ? item.total_planned_weight?.toFixed(3)
            : 0
          } ${item.units
            ? capitalize(weightUnit[item.units?.total_weight]?.displayName)
            : ""
          }`
          : "-";
      }

      let plannedQuantity;
      let plannedUnit;
      if (item.quantity_type == "reel_sheet") {
        if (item.type == "reel") plannedUnit = "Reels";
        else plannedUnit = "Sheets";

        plannedQuantity = item.planning_quantity;
      } else {
        plannedQuantity = item.planning_weight;
        plannedUnit = capitalize(weightUnit[item.units.weight]?.displayName);
      }

      let currencySymbol;
      if (item?.units?.net_price) {
        currencySymbol = currency_List.filter(
          (currUnit) => currUnit.code === item.units.net_price
        );
      } else {
        currencySymbol = "";
      }
      let currencySymbolDealer;
      if (item?.units?.dealer_price) {
        currencySymbolDealer = currency_List.filter(
          (currUnit) => currUnit.code === item.units.dealer_price
        );
      } else {
        currencySymbolDealer = "";
      }
      let jobID = []
      if (item?.jobcards?.jobcards) {
        item?.jobcards?.jobcards.map((item, index) => {
          jobID.push(item.jobcard)
        })
      }
      const balance_qty = (item?.balance_weight == 0) ? "-" : item.balance_weight + " " + capitalize(item.units.weight)
      return {
        select: true,
        id: item.id,
        key: item.number,
        jobcards: item.jobID,
        isConflictingstate: item.conflicting_state === "non_conflicting" ? false : true,
        pono:
          item.po && typeof item.po === "string"
            ? item.po.toUpperCase()
            : item.po,
        sono:
          item.so && typeof item.so === "string"
            ? item.so.toUpperCase()
            : item.so,
        category: item.category,
        savedPO: item.po,
        orderno: item.number ? item.number : "-",
        createddate: moment(item.created_at).format("DD MMM YYYY"),
        podate: moment(
          item.category === "po" ? item.po_date : item.so_date
        ).format("DD MMM YYYY"),
        customercode: item.customer,
        productcode: item.product,
        productspec: item.product_spec,
        type: item.type ? capitalize(item.type) : "-",
        units: item.units ? item.units : "",
        size: item.width
          ? `${item.width}${item.length ? ` x ${item.length}` : ""} ${item.units
            ? lengthUnit[item.units.width]?.displayName?.toUpperCase()
            : ""
          }`
          : "-",
        quantity: quantityValue ? quantityValue : "-",
        rewinderreels: rewinderReels ? rewinderReels : "0",
        weight:
          item.this_item_type == "order"
            ? `${parseFloat(item.weight).toFixed(3)}`
            : `${parseFloat(item.total_weight).toFixed(3)}`,
        coreid: item.inner_dia,
        reelod: item.outer_dia,
        price: item.dealer_price ? item.dealer_price : 0,
        netprice:
          item.net_price &&
            item.quantity_type == "reel_sheet" &&
            item.type == "reel"
            ? ""
            : item.net_price
              ? `${item.units && currencySymbol ? currencySymbol[0].symbol : ""
              }` +
              " " +
              parseFloat(item.net_price).toFixed(3)
              : "",
        dealerPrice: item.dealer_price
          ? `${item.units && currencySymbolDealer
            ? currencySymbolDealer[0].symbol
            : ""
          }` +
          " " +
          parseFloat(item.dealer_price).toFixed(3) +
          " " +
          `${item?.units?.per_weight_unit
            ? " / " +
            capitalize(
              weightUnit[item.units.per_weight_unit]?.displayName
            )
            : ""
          }`
          : "-",
        deliverydate: item.delivery_date
          ? moment(item.delivery_date).format("DD MMM YYYY")
          : "-",

        approvedby: item.approved_by ? item.approved_by : "-",
        remarks: item.remarks ? item.remarks : "-",
        priority: item.forced,
        // Proper state values for 'changes req' and 'on hold'
        status:
          item.this_item_type == "order"
            ? capitalize(
              item.state === "review"
                ? "changes Req"
                : item.state === "hold"
                  ? "On Hold"
                  : item.state === "in_production"
                    ? "In Production"
                    : item.state === "cancel"
                      ? "Cancelled"
                      : item.state
            )
            : "-",
        completed:
          item.this_item_type == "order"
            ? item.completed
            : item.total_completed,
        in_production:
          item.this_item_type == "order"
            ? item.in_production + item.in_process
            : item.total_in_production + item.total_in_process,
        // pending: item.this_item_type == 'order'
        //   ? item.quantity - item.completed - item.in_production - item.in_process
        //   : item.total_quantity - item.total_completed - item.total_in_production - item.total_in_process,

        calculated_lower_tolerance: item.calculated_lower_tolerance.toFixed(3),
        calculated_upper_tolerance: item.calculated_upper_tolerance.toFixed(3),

        pending: pendingValue,
        customerName: item.customer_name,
        quantity_type: item.quantity_type ? item.quantity_type : "-",
        // plannedweight: item.planned_weight ? `${item.planned_weight !== 0 ? item.planned_weight?.toFixed(3) : 0
        //   } Tonnes` : '-',
        plannedweight: planned_weight,
        user: item.user ? item.user : "-",
        item_type: item.this_item_type,
        groupno: item.this_item_type == "order" ? "-" : item.id,
        length: item.length,
        width: item.width,
        grain: item.grain,
        order_type: item.type,
        product_spec: item.product_spec,
        in_process: item.in_process,
        parent: item.parent,
        other_parents: item.other_parents,
        reel_diameter: item.reel_diameter,
        customer_alias: item.customer_alias,
        consignee_alias: item.consignee_alias,
        consignee: item.consignee,
        consignee_name: item.consignee_name,
        previous_state: item.previous_state,
        sheet_completed_weight: item.sheet_completed_weight
          ? item.sheet_completed_weight
          : 0,
        sheet_processed_weight: item.sheet_processed_weight
          ? item.sheet_processed_weight
          : 0,
        sheet_production_weight: item.sheet_production_weight
          ? item.sheet_production_weight
          : 0,
        pending_quantity_weight: item.pending_quantity_weight,
        total_weight_in_process: item.total_weight_in_process
          ? item.total_weight_in_process
          : 0,
        total_weight_in_production: item.total_weight_in_production
          ? item.total_weight_in_production
          : 0,
        total_weight_completed: item.total_weight_completed
          ? item.total_weight_completed
          : 0,
        cancelledQuantity,
        pendingQuant: pendingQuantity,
        processQuantity,
        pendingQuantityValue,
        total_pending_quantity: item.total_pending_quantity,
        // total_rewinder_quantity : item.total_rewinder_quantity,
        // total_sheet_quantity : item.total_sheet_quantity
        progressbar_info: item.progressbar_info,
        plannedQuant: plannedQuantity,
        plannedReels: item.quantity,
        plannedUnit,
        id_od_type: item.id_od_type,
        outer_dia: item.outer_dia,
        inner_dia: item.inner_dia,
        product_info: item.product_info,
        minimum_reel_od: item.minimum_reel_od,
        maximum_reel_od: item.maximum_reel_od,
        dealer_price: item.dealer_price,
        no_of_reel_sheet: item.no_of_reel_sheet
          ? `${item.no_of_reel_sheet}`
          : "-",
        no_of_sheets: item.no_of_sheets,
        cancelled_quantity: item.cancelled_quantity,
        ply: item.ply,
        balance_qty: balance_qty,
      };
    });
    return orders;
  };
  useEffect(() => {
    if (movedOrder.length > 0 && orderType === 'selected_orders') {
      const orders = getData(movedOrder);

      orders?.forEach((order) => {
        if (!selectedRowKeys.includes(order.key)) {
          setSelectedRowKeys((keys) => [...keys, order.key]);
          addSelectedQuantity(order);
          setSelectedDataRows((prevRows) => [...prevRows, order]);
        }
      });
    }
  }, [movedOrder, orderType]);

  const onChange = (pagination, filters, sorter, extra, orderState) => {
    setLoading(true);
    // setClearSearch(true);
    columnsHead?.current?.map((item) => {
      if (item.dataIndex !== sorter?.field) {
        item["sortOrder"] = null;
      }
      if (item.dataIndex == sorter?.field) {
        item["sortOrder"] = sorter ? sorter.order : "";
      }
    });

    const currentSorter = sorter.order
      ? {
        sort_by:
          sorter.field === "pono"
            ? "po"
            : sorter.field === "orderno"
              ? "id"
              : sorter.field === "createddate"
                ? "created_at"
                : sorter.field === "deliverydate"
                  ? "delivery_date"
                  : sorter.field === "groupno"
                    ? "split_group"
                    : orderState === "rejected" ||
                      orderState === "pending" ||
                      orderState === "review" ||
                      orderState === "hold" ||
                      orderState === "cancel"
                      ? "updated_at"
                      : "updated_at",

        sort_type: sorter.order === "ascend" ? "ascending" : "descending",
      }
      : orderState === "rejected" ||
        orderState === "pending" ||
        orderState === "review" ||
        orderState === "hold" ||
        orderState === "cancel"
        ? {
          sort_by: "updated_at",
          sort_type: "descending",
        }
        : {
          sort_by: "updated_at",
          sort_type: "ascending",
        };
    if (
      sorter.field &&
      (currentSorter.sort_type !== paginationParams.sort_type ||
        currentSorter.sort_by !== paginationParams.sort_by)
    ) {
      // setSortParams(currentSorter);
      setCurrentPage(1);
      setPaginationParams({
        ...currentSorter,
        page: 1,
        size: pagination.pageSize,
      });
      paginationParamsRef.current = {
        ...currentSorter,
        page: 1,
        size: pagination.pageSize,
      };
    } else {
      setCurrentPage(pagination.current);
      setPaginationParams({
        ...currentSorter,
        page: pagination.current,
        size: pagination.pageSize,
      });
      paginationParamsRef.current = {
        ...currentSorter,
        page: pagination.current,
        size: pagination.pageSize,
      };
    }
    setRendering(true);
  };

  const searchOrders = async (value = "") => {
    columnsHead.current?.map((item) => {
      item["sortOrder"] = null;
    });
    for (let i = 0; i < tableDataRef.current?.length; i++) {
      if (isEditClicked[tableDataRef.current[i]?.orderno]?.isEditable) {
        form.setFieldsValue({
          [`plannedQuanty${tableDataRef.current[i]?.orderno}`]:
            tableDataRef.current[i]?.plannedQuant,
        });
      }
    }
    setIsEditClicked({});
    setPlannedQuantityErr({});
    setTableRerender(true);

    setLoading(true);
    setSearchValue(value);
    setCurrentPage(1);
    setPaginationParams((prevState) => ({
      ...prevState,
      page: 1,
      size: settingsData?.settings?.default_page_size || 10,
    }));
    paginationParamsRef.current = {
      sort_by: paginationParamsRef.current.sort_by,
      sort_type: paginationParamsRef.current.sort_type,
      page: 1,
      size: settingsData?.settings?.default_page_size || 10,
    };
    let machineParams = location.state.body;
    if (
      orderType == "other_orders" &&
      location?.state?.selected_type === "cutting"
    ) {
      //machineParams['move_to_selected_orders'] = ordersMoveToSelect;
    }
    if (value === "" || value === null) {
      const start =
        (paginationParamsRef.current.page - 1) *
        paginationParamsRef.current.size;
      const end = start + paginationParamsRef.current.size * 1;
      if (location.state.processType == "singleStage") {
        getDeckleMachineOrders(
          machineParams,
          paginationParamsRef.current.sort_by,
          sortParams.sort_type,
          start,
          end
        )
          .then((response) => {
            setEmptyStateLabel("noData");
            setAllOrdersList(response.data.data.orders);
            setTotalRecords(response.data.data.total_orders);
            setLoading(false);
          })
          .catch((error) => {
            //setLoading(false);
            console.log("Error in search of order records:", error);
            setEmptyStateLabel("connectionAPIError");
            setLoading(false);
          });
      } else {
        getDeckleMachineOrdersForMultiStage(
          machineParams,
          paginationParamsRef.current.sort_by,
          sortParams.sort_type,
          start,
          end
        )
          .then((response) => {
            setEmptyStateLabel("noData");
            setAllOrdersList(response.data.data.orders);
            setTotalRecords(response.data.data.total_orders);
            setLoading(false);
          })
          .catch((error) => {
            //setLoading(false);
            console.log("Error in search of order records:", error);
            setEmptyStateLabel("connectionAPIError");
            setLoading(false);
          });
      }
    } else {
      setClearSearch(false);

      let req = {
        type: orderType,
        // move_to_selected_orders: ordersMoveToSelect
      };
      if (location.state.processType == "singleStage")
        searchDeckleMachineOrders(
          location.state.code,
          value,
          req,
          paginationParamsRef.current
        )
          .then((response) => {
            setLoading(false);
            setEmptyStateLabel("search");
            setAllOrdersList(response.data);
            setTotalRecords(response.total_orders);
          })
          .catch((error) => {
            console.log("Error in deckle search:", error);
            setEmptyStateLabel("connectionAPIError");
            setLoading(false);
          });
      else
        searchDeckleMachineOrdersForMultiStage(
          orderType,
          value,
          machineParams,
          paginationParamsRef.current
        )
          .then((response) => {
            setLoading(false);
            setEmptyStateLabel("search");
            setAllOrdersList(response.data);
            setTotalRecords(response.total_orders);
          })
          .catch((error) => {
            console.log("Error in deckle search:", error);
            setEmptyStateLabel("connectionAPIError");
            setLoading(false);
          });
    }
  };

  const handleEditColumn = (index, record, value) => {
    if (!isEditClicked.hasOwnProperty(record?.orderno)) {
      isEditClicked[record?.orderno] = {};
    }
    isEditClicked[record?.orderno].isEditable = true;
    setIsEditClicked(isEditClicked);
    setTableRerender(true);
  };

  const handleReelEditColumn = (index, record, value) => {
    form.setFieldsValue({ [`rewinderreels${record?.orderno}`]: record.rewinderreels })
    if (!isReelEditClicked.hasOwnProperty(record?.orderno)) {
      isReelEditClicked[record?.orderno] = {};
    }
    isReelEditClicked[record?.orderno].isEditable = true;
    setReelIsEditClicked(isReelEditClicked);
    setTableRerender(true);
  };
  useEffect(() => {
    setPaperMacineData({
      state: {
        body: location.state.body,
        maximum_burst_factor: location.state.maximum_burst_factor,
        minimum_burst_factor: location.state.minimum_burst_factor,
        maximum_gsm: location.state.maximum_gsm,
        minimum_gsm: location.state.minimum_gsm,
        selected_rewinder: location.state.selected_rewinder,
        selected_cutter: location.state.selected_cutter,
        selected_rewinder_unit: location.state.selected_rewinder_unit,
        selected_cutter_unit: location.state.selected_cutter_unit,
        rewinder_data: location.state.rewinder_data,
        cutter_data: location.state.cutter_data,
        selected_type: location.state.selected_type,
        rewinder_minWidth: location.state.rewinder_minWidth,
        rewinder_maxWidth: location.state.rewinder_maxWidth,
        cutter_minWidth: location.state.cutter_minWidth,
        cutter_maxWidth: location.state.cutter_maxWidth,
        max_NoOfCutters: location.state.max_NoOfCutters,
        minWeight: location.state.minWeight,
        minWeight: location.state.minWeight,
        left_edge_trim: location.state.left_edge_trim,
        right_edge_trim: location.state.right_edge_trim,
        code: location.state.code,
        initital_OrderType: location.state.initital_OrderType,
        is_enabled: location.state.is_enabled,
        machine_code: location.state.machine_code,
        partitionWeightUnit: location.state.partitionWeightUnit,
        max_NoOfCutters_cutter: location.state.max_NoOfCutters_cutter,
        left_edge_trim_cutter: location.state.left_edge_trim_cutter,
        right_edge_trim_cutter: location.state.right_edge_trim_cutter,
        processType: location.state.processType,
        max_NoOfCutters_cutter: location.state.max_NoOfCutters_cutter,
        left_edge_trim_cutter: location.state.left_edge_trim_cutter,
        right_edge_trim_cutter: location.state.right_edge_trim_cutter,
        processType: location.state.processType,
      }
    })

  }, [])
  const handleSelect = (record, selected) => {
    var array = [...selectedDataRows];
    let allKeys = [];
    if (selected) {
      // if (orderType === "other_orders") {
      //   setMovedOrder((prevState) => [...prevState, record]);
      // }
      record.select = true;
      setSelectedRowKeys((keys) => [...keys, record.key]);
      addSelectedQuantity(record);
      array.push(record);
      setSelectedDataRows([...selectedDataRows, record]);
      allKeys = [...selectedRowKeys, record.key];
    } else {
      record.select = false;
      // if (orderType === "other_orders") {
      //   setMovedOrder((prevState) =>
      //     prevState.filter((item) => item.key !== record.key)
      //   );
      // }
      setSelectedRowKeys((keys) => {
        const index = keys.indexOf(record.key);
        return [...keys.slice(0, index), ...keys.slice(index + 1)];
      });

      allKeys = [
        ...selectedRowKeys.slice(0, index),
        ...selectedRowKeys.slice(index + 1),
      ];

      var index = array.findIndex((obj) => obj.id == record.key);

      if (index !== -1) {
        array.splice(index, 1);
        setSelectedDataRows(array);
        array?.length ? removeDeslectedQuantity(record) : setTotalWeight(0);
        if (!array?.length) {
          totalRef.current = 0;
        }
      }
    }

    if (array.length > 0) setIsCheckboxClicked(true);
    else setIsCheckboxClicked(false);

    const result = allKeys.filter((f) => tableData.some((d) => d.key == f));

    if (result.length === tableData.length) setIsAllSelected(true);
    else setIsAllSelected(false);
  };

  const toggleSelectAll = (e) => {
    // setSelectedRowKeys((keys) =>
    //   keys.length === tableData.length ? [] : tableData.map((r) => r.key)
    // );

    const newCheckboxState = [...tableData];

    if (!e.target.checked) {
      setIsAllSelected(false);
      newCheckboxState.forEach((item) => {
        item.select = false;
      });
      removeDeslectedQuantity(newCheckboxState);
      setSelectedDataRows(
        selectedDataRows.filter((f) => !tableData.some((d) => d.key == f.id))
      );
      setSelectedRowKeys(
        selectedRowKeys.filter((f) => !tableData.some((d) => d.key == f))
      );
    } else {
      setIsAllSelected(true);
      newCheckboxState.forEach((item) => {
        item.select = true;
      });
      const uniqueArr = tableData.filter(
        (
          (set) => (a) =>
            false === set.has(a.orderno)
        )(new Set(selectedDataRows.map((b) => b.id)))
      );
      let unique = [...new Set([...selectedDataRows, ...tableData])];
      unique = [
        ...new Map(unique.map((item) => [item["orderno"], item])).values(),
      ];

      let uniqueKeys = [
        ...new Set([
          ...selectedRowKeys,
          ...tableData.map((item) => item.orderno),
        ]),
      ];
      setSelectedRowKeys(uniqueKeys);
      addSelectedQuantity(uniqueArr);
      setSelectedDataRows(unique);
    }

    setTableData(newCheckboxState);
    tableDataRef.current = newCheckboxState;
    const temp = newCheckboxState.filter((item) => item.select === true);
    if (temp.length > 0) setIsCheckboxClicked(true);
    else setIsCheckboxClicked(false);
  };

  const handleSelectRewinderOnpagination = async (
    record,
    selected,
    isPagination
  ) => {
    //setPageLoaded(false);
    setSelectedState(false);
    var array = [...selectedDataRows];
    let selectedRowIndex = tableData?.findIndex(
      (ele) => ele.orderno == record.orderno
    );
    let coreIDValue = form.getFieldValue("coreDia");

    if (selected) {
      if (
        (selecteDia == "range" &&
          ((record.type == "Reel" && record.quantity_type != "reel_sheet") ||
            record.type == "Sheet")) ||
        (selecteDia == "constant" &&
          record.type == "Reel" &&
          record.quantity_type == "reel_sheet" &&
          (selectedReelOD.length == 1 || selectedReelOD.length == 0)) ||
        (selecteDia == "constant" &&
          ((record.type == "Reel" && record.quantity_type != "reel_sheet") ||
            record.type == "Sheet"))
      ) {
        if (!isPagination) setSelectedRowKeys((keys) => [...keys, record.key]);
      }

      let dataCopy = [...tableData];
      if (selecteDia == "constant") {
        let reelODArr = [];
        for (let i = 0; i < selectedReelOD?.length; i++) {
          reelODArr.push(selectedReelOD[i]?.value);
        }
        if (
          (selecteDia == "constant" &&
            record.type == "Reel" &&
            record.quantity_type == "reel_sheet" &&
            (selectedReelOD.length == 1 || selectedReelOD.length == 0)) ||
          (selecteDia == "constant" &&
            ((record.type == "Reel" && record.quantity_type != "reel_sheet") ||
              record.type == "Sheet"))
        ) {
          record.reelod = reelODArr;
          record.coreid = coreIDValue;
          record.outer_dia = reelODArr;
          record.inner_dia = coreIDValue;
          dataCopy[selectedRowIndex].reelod = reelODArr;
          dataCopy[selectedRowIndex].coreid = coreIDValue;
          dataCopy[selectedRowIndex].outer_dia = reelODArr;
          dataCopy[selectedRowIndex].inner_dia = coreIDValue;
        }
      } else {
        if (
          selecteDia == "range" &&
          ((record.type == "Reel" && record.quantity_type != "reel_sheet") ||
            record.type == "Sheet")
        ) {
          let minValue = form.getFieldValue("min_reel");
          let maxValue = form.getFieldValue("max_reel");
          record.minimum_reel_od = minValue ? minValue : "";
          record.maximum_reel_od = maxValue ? maxValue : "";
          record.units["minimum_reel_od"] = minValue
            ? form.getFieldValue("range_unit")
            : "";
          record.units["maximum_reel_od"] = maxValue
            ? form.getFieldValue("range_unit")
            : "";
          record.coreid = form.getFieldValue("core_Dia");
          record.inner_dia = form.getFieldValue("core_Dia");
          dataCopy[selectedRowIndex].minimum_reel_od = minValue
            ? form.getFieldValue("min_reel")
            : "";
          dataCopy[selectedRowIndex].maximum_reel_od = maxValue
            ? form.getFieldValue("max_reel")
            : "";
          dataCopy[selectedRowIndex].units["minimum_reel_od"] = minValue
            ? form.getFieldValue("range_unit")
            : "";
          dataCopy[selectedRowIndex].units["maximum_reel_od"] = maxValue
            ? form.getFieldValue("range_unit")
            : "";
          dataCopy[selectedRowIndex].coreid = form.getFieldValue("core_Dia");
          dataCopy[selectedRowIndex].inner_dia = form.getFieldValue("core_Dia");
        }
      }
      if (
        (selecteDia == "range" &&
          ((record.type == "Reel" && record.quantity_type != "reel_sheet") ||
            record.type == "Sheet")) ||
        (selecteDia == "constant" &&
          record.type == "Reel" &&
          record.quantity_type == "reel_sheet" &&
          (selectedReelOD.length == 1 || selectedReelOD.length == 0)) ||
        (selecteDia == "constant" &&
          ((record.type == "Reel" && record.quantity_type != "reel_sheet") ||
            record.type == "Sheet"))
      ) {
        record.id_od_type = selecteDia;
        dataCopy[selectedRowIndex].id_od_type = selecteDia;
      }

      // array.push(record);
      if (
        (selecteDia == "range" &&
          ((record.type == "Reel" && record.quantity_type != "reel_sheet") ||
            record.type == "Sheet")) ||
        (selecteDia == "constant" &&
          record.type == "Reel" &&
          record.quantity_type == "reel_sheet" &&
          (selectedReelOD.length == 1 || selectedReelOD.length == 0)) ||
        (selecteDia == "constant" &&
          ((record.type == "Reel" && record.quantity_type != "reel_sheet") ||
            record.type == "Sheet"))
      ) {
        if (!isPagination) {
          setSelectedDataRows([...selectedDataRows, record]);
          array.push(record);
        }
      }

      setTableData([...dataCopy]);
      tableDataRef.current = [...dataCopy];
      setSelectedState(true);
    } else {
      setSelectedRowKeys((keys) => {
        const index = keys.indexOf(record.key);
        return [...keys.slice(0, index), ...keys.slice(index + 1)];
      });

      var index = array.findIndex((obj) => obj.key == record.key);
      if (index !== -1) {
        array.splice(index, 1);
        setSelectedDataRows(array);
      }
      //update deselected table data row
      // console.log(dataCopy);
      let dataCopy = [...tableData];
      dataCopy[selectedRowIndex] = JSON.parse(
        JSON.stringify(tableDataCopyRef.current[selectedRowIndex])
      );
      setTableData([...dataCopy]);
      tableDataRef.current = [...dataCopy];
      setSelectedState(false);
    }

    if (array.length > 0) setIsCheckboxClicked(true);
    else setIsCheckboxClicked(false);

    const productCodes = [...new Set(array.map((r) => r.productcode))];
    const result = array.filter((f) => tableData.some((d) => d.key == f.key));
    if (result.length == tableData.length) {
      setIsAllSelected(true);
    } else {
      setIsAllSelected(false);
    }
    // await getProductDetailsForSelectedOrders(productCodes)
    //   .then((response) => {
    //     setProductDataForSelectedRows(response);
    //   })
    //   .catch((error) => {
    //     console.log("Error in getting product specification list");
    //   });

    // const result = array.filter((f) => tableData.some((d) => d.key == f.key));
    // // setSelectedRowKeys(result.map((r) => r.key));
    // if (result.length == tableData.length) {
    //   setIsAllSelected(true);
    // } else {
    //   setIsAllSelected(false);
    // }
    setPageRerender(true);
    setTableRerender(true);
  };

  const handleSelectRewinder = async (record, selected) => {
    //setPageLoaded(false);
    setSelectedState(false);
    var array = [...selectedDataRows];
    let selectedRowIndex = tableData?.findIndex(
      (ele) => ele.orderno == record.orderno
    );
    let coreIDValue = form.getFieldValue("coreDia");

    if (selected) {
      if (
        (selecteDia == "range" &&
          ((record.type == "Reel" && record.quantity_type != "reel_sheet") ||
            record.type == "Sheet")) ||
        (selecteDia == "constant" &&
          record.type == "Reel" &&
          record.quantity_type == "reel_sheet" &&
          (selectedReelOD.length == 1 || selectedReelOD.length == 0)) ||
        (selecteDia == "constant" &&
          ((record.type == "Reel" && record.quantity_type != "reel_sheet") ||
            record.type == "Sheet"))
      ) {
        setSelectedRowKeys((keys) => [...keys, record.key]);
        addSelectedQuantity(record);
      }

      let dataCopy = [...tableData];
      if (selecteDia == "constant") {
        let reelODArr = [];
        for (let i = 0; i < selectedReelOD?.length; i++) {
          reelODArr.push(selectedReelOD[i]?.value);
        }
        if (
          (selecteDia == "constant" &&
            record.type == "Reel" &&
            record.quantity_type == "reel_sheet" &&
            (selectedReelOD.length == 1 || selectedReelOD.length == 0)) ||
          (selecteDia == "constant" &&
            ((record.type == "Reel" && record.quantity_type != "reel_sheet") ||
              record.type == "Sheet"))
        ) {
          record.reelod = reelODArr;
          record.coreid = coreIDValue;
          record.outer_dia = reelODArr;
          record.inner_dia = coreIDValue;
          dataCopy[selectedRowIndex].reelod = reelODArr;
          dataCopy[selectedRowIndex].coreid = coreIDValue;
          dataCopy[selectedRowIndex].outer_dia = reelODArr;
          dataCopy[selectedRowIndex].inner_dia = coreIDValue;
        }
      } else {
        if (
          selecteDia == "range" &&
          ((record.type == "Reel" && record.quantity_type != "reel_sheet") ||
            record.type == "Sheet")
        ) {
          let minValue = form.getFieldValue("min_reel");
          let maxValue = form.getFieldValue("max_reel");
          record.minimum_reel_od = minValue ? minValue : "";
          record.maximum_reel_od = maxValue ? maxValue : "";
          record.units["minimum_reel_od"] = minValue
            ? form.getFieldValue("range_unit")
            : "";
          record.units["maximum_reel_od"] = maxValue
            ? form.getFieldValue("range_unit")
            : "";
          record.coreid = form.getFieldValue("core_Dia");
          record.inner_dia = form.getFieldValue("core_Dia");
          dataCopy[selectedRowIndex].minimum_reel_od = minValue
            ? form.getFieldValue("min_reel")
            : "";
          dataCopy[selectedRowIndex].maximum_reel_od = maxValue
            ? form.getFieldValue("max_reel")
            : "";
          dataCopy[selectedRowIndex].units["minimum_reel_od"] = minValue
            ? form.getFieldValue("range_unit")
            : "";
          dataCopy[selectedRowIndex].units["maximum_reel_od"] = maxValue
            ? form.getFieldValue("range_unit")
            : "";
          dataCopy[selectedRowIndex].coreid = form.getFieldValue("core_Dia");
          dataCopy[selectedRowIndex].inner_dia = form.getFieldValue("core_Dia");
        }
      }
      if (
        (selecteDia == "range" &&
          ((record.type == "Reel" && record.quantity_type != "reel_sheet") ||
            record.type == "Sheet")) ||
        (selecteDia == "constant" &&
          record.type == "Reel" &&
          record.quantity_type == "reel_sheet" &&
          (selectedReelOD.length == 1 || selectedReelOD.length == 0)) ||
        (selecteDia == "constant" &&
          ((record.type == "Reel" && record.quantity_type != "reel_sheet") ||
            record.type == "Sheet"))
      ) {
        record.id_od_type = selecteDia;
        dataCopy[selectedRowIndex].id_od_type = selecteDia;
      }

      // array.push(record);
      if (
        (selecteDia == "range" &&
          ((record.type == "Reel" && record.quantity_type != "reel_sheet") ||
            record.type == "Sheet")) ||
        (selecteDia == "constant" &&
          record.type == "Reel" &&
          record.quantity_type == "reel_sheet" &&
          (selectedReelOD.length == 1 || selectedReelOD.length == 0)) ||
        (selecteDia == "constant" &&
          ((record.type == "Reel" && record.quantity_type != "reel_sheet") ||
            record.type == "Sheet"))
      ) {
        setSelectedDataRows([...selectedDataRows, record]);
        array.push(record);
      }

      setTableData([...dataCopy]);
      tableDataRef.current = [...dataCopy];
      setSelectedState(true);
    } else {
      setSelectedRowKeys((keys) => {
        const index = keys.indexOf(record.key);
        return [...keys.slice(0, index), ...keys.slice(index + 1)];
      });

      var index = array.findIndex((obj) => obj.key == record.key);
      if (index !== -1) {
        array.splice(index, 1);
        setSelectedDataRows(array);
        array?.length ? removeDeslectedQuantity(record) : setTotalWeight(0);
        if (!array?.length) {
          totalRef.current = 0;
        }
      }
      //update deselected table data row
      // console.log(dataCopy);
      let dataCopy = [...tableData];
      dataCopy[selectedRowIndex] = JSON.parse(
        JSON.stringify(tableDataCopyRef.current[selectedRowIndex])
      );
      setTableData([...dataCopy]);
      tableDataRef.current = [...dataCopy];
      setSelectedState(false);
    }

    if (array.length > 0) setIsCheckboxClicked(true);
    else setIsCheckboxClicked(false);

    const productCodes = [...new Set(array.map((r) => r.productcode))];
    const result = array.filter((f) => tableData.some((d) => d.key == f.key));
    if (result.length == tableData.length) {
      setIsAllSelected(true);
    } else {
      setIsAllSelected(false);
    }
    // await getProductDetailsForSelectedOrders(productCodes)
    //   .then((response) => {
    //     setProductDataForSelectedRows(response);
    //   })
    //   .catch((error) => {
    //     console.log("Error in getting product specification list");
    //   });

    // const result = array.filter((f) => tableData.some((d) => d.key == f.key));
    // // setSelectedRowKeys(result.map((r) => r.key));
    // if (result.length == tableData.length) {
    //   setIsAllSelected(true);
    // } else {
    //   setIsAllSelected(false);
    // }
    setPageRerender(true);
    setTableRerender(true);
  };

  const toggleSelectAllRewinder = async (e) => {
    let selectedOrders = [...selectedDataRows];
    let selectedOrderKeys = [...selectedRowKeys];
    let currentTableData = [...tableData];
    let currentSelectedRows = [];
    setSelectedState(true);
    let tempSelectedRowKeys = selectedRowKeys;
    let keys = [];
    let tempTableData = [];
    // if(tempSelectedRowKeys?.length == tableData.length){
    //   setSelectedRowKeys([]);
    //   tempTableData = tableData;
    // } else{
    tableData.map((r) => {
      if (
        (selecteDia == "range" &&
          ((r.type == "Reel" && r.quantity_type != "reel_sheet") ||
            r.type == "Sheet")) ||
        (selecteDia == "constant" &&
          r.type == "Reel" &&
          r.quantity_type == "reel_sheet" &&
          (selectedReelOD.length == 1 || selectedReelOD.length == 0)) ||
        (selecteDia == "constant" &&
          ((r.type == "Reel" && r.quantity_type != "reel_sheet") ||
            r.type == "Sheet"))
      ) {
        keys.push(r.key);
        tempTableData.push(r);
      }
    });

    //setSelectedRowKeys([...new Set(keys)]);
    // }
    // setSelectedRowKeys((keys) => keys.length === tableData.length ? [] : tableData.map((r) => r.key);

    const newCheckboxState = [...tableData];
    const newCheckboxStateTableRef = [...tableDataCopyRef.current];
    if (!e.target.checked) {
      setIsAllSelected(false);
      newCheckboxState.forEach((item) => {
        item.select = false;
      });

      tableData.forEach((item) => {
        item.select = false;
      });
      //const intersection = tempTableData.filter(element => !selectedRowKeys.includes(element.id));
      //setSelectedRowKeys([...new Set(intersection)]);

      setSelectedDataRows(
        selectedDataRows.filter((f) => !tableData.some((d) => d.key == f.id))
      );
      currentSelectedRows = selectedDataRows.filter(
        (f) => !tableData.some((d) => d.id == f.id)
      );
      setTableData(JSON.parse(JSON.stringify(newCheckboxStateTableRef)));
      tableDataRef.current = JSON.parse(
        JSON.stringify(tableDataCopyRef.current)
      );
      setSelectedState(false);
      // removeDeslectedQuantity(newCheckboxState);
    } else {
      setIsAllSelected(true);
      newCheckboxState.forEach((item) => {
        if (
          (selecteDia == "range" &&
            ((item.type == "Reel" && item.quantity_type != "reel_sheet") ||
              item.type == "Sheet")) ||
          (selecteDia == "constant" &&
            item.type == "Reel" &&
            item.quantity_type == "reel_sheet" &&
            (selectedReelOD.length == 1 || selectedReelOD.length == 0)) ||
          (selecteDia == "constant" &&
            ((item.type == "Reel" && item.quantity_type != "reel_sheet") ||
              item.type == "Sheet"))
        ) {
          item.select = true;
        }
      });
      let unique = [...new Set([...selectedDataRows, ...tempTableData])];
      currentSelectedRows = [
        ...new Map(unique.map((item) => [item["id"], item])).values(),
      ];
      let coreIDValue = form.getFieldValue("coreDia");
      if (currentSelectedRows && currentSelectedRows?.length) {
        for (let i = 0; i < currentSelectedRows?.length; i++) {
          if (selecteDia == "constant") {
            let reelODArr = [];
            for (let j = 0; j < selectedReelOD?.length; j++) {
              reelODArr.push(selectedReelOD[j]?.value);
            }
            if (
              (selecteDia == "constant" &&
                currentSelectedRows[i].type == "Reel" &&
                currentSelectedRows[i].quantity_type == "reel_sheet" &&
                (selectedReelOD.length == 1 || selectedReelOD.length == 0)) ||
              (selecteDia == "constant" &&
                ((currentSelectedRows[i].type == "Reel" &&
                  currentSelectedRows[i].quantity_type != "reel_sheet") ||
                  currentSelectedRows[i].type == "Sheet"))
            ) {
              currentSelectedRows[i].reelod = reelODArr;
              currentSelectedRows[i].coreid = coreIDValue;
              currentSelectedRows[i].outer_dia = reelODArr;
              currentSelectedRows[i].inner_dia = coreIDValue;
            }
          } else {
            if (
              selecteDia == "range" &&
              ((currentSelectedRows[i].type == "Reel" &&
                currentSelectedRows[i].quantity_type != "reel_sheet") ||
                currentSelectedRows[i].type == "Sheet")
            ) {
              currentSelectedRows[i].minimum_reel_od =
                form.getFieldValue("min_reel");
              currentSelectedRows[i].maximum_reel_od =
                form.getFieldValue("max_reel");
              currentSelectedRows[i].units["minimum_reel_od"] =
                form.getFieldValue("range_unit");
              currentSelectedRows[i].units["maximum_reel_od"] =
                form.getFieldValue("range_unit");
              currentSelectedRows[i].coreid = form.getFieldValue("core_Dia");
              currentSelectedRows[i].inner_dia = form.getFieldValue("core_Dia");
            }
          }
          if (
            (selecteDia == "range" &&
              ((currentSelectedRows[i].type == "Reel" &&
                currentSelectedRows[i].quantity_type != "reel_sheet") ||
                currentSelectedRows[i].type == "Sheet")) ||
            (selecteDia == "constant" &&
              currentSelectedRows[i].type == "Reel" &&
              currentSelectedRows[i].quantity_type == "reel_sheet" &&
              (selectedReelOD.length == 1 || selectedReelOD.length == 0)) ||
            (selecteDia == "constant" &&
              ((currentSelectedRows[i].type == "Reel" &&
                currentSelectedRows[i].quantity_type != "reel_sheet") ||
                currentSelectedRows[i].type == "Sheet"))
          ) {
            currentSelectedRows[i].id_od_type = selecteDia;
          }
        }
        // console.log(currentSelectedRows);
        let selectedDataRowsCopy = [];
        for (let ele = 0; ele < currentSelectedRows?.length; ele++) {
          if (
            (((currentSelectedRows[ele].type == "Reel" &&
              currentSelectedRows[ele].quantity_type != "reel_sheet") ||
              currentSelectedRows[ele].type == "Sheet") &&
              selecteDia == "range") ||
            (selecteDia == "constant" &&
              currentSelectedRows[ele].type == "Reel" &&
              currentSelectedRows[ele].quantity_type == "reel_sheet" &&
              (selectedReelOD.length == 1 || selectedReelOD.length == 0)) ||
            (selecteDia == "constant" &&
              ((currentSelectedRows[ele].type == "Reel" &&
                currentSelectedRows[ele].quantity_type != "reel_sheet") ||
                currentSelectedRows[ele].type == "Sheet"))
          ) {
            selectedDataRowsCopy.push(currentSelectedRows[ele]);
          }
        }
        setSelectedDataRows([...selectedDataRowsCopy]);

        let updatedTableData = [...tableData];

        for (let j = 0; j < updatedTableData?.length; j++) {
          if (selecteDia == "constant") {
            let reelODArr = [];
            for (let k = 0; k < selectedReelOD?.length; k++) {
              reelODArr.push(selectedReelOD[k]?.value);
            }
            if (
              (selecteDia == "constant" &&
                updatedTableData[j].type == "Reel" &&
                updatedTableData[j].quantity_type == "reel_sheet" &&
                (selectedReelOD.length == 1 || selectedReelOD.length == 0)) ||
              (selecteDia == "constant" &&
                ((updatedTableData[j].type == "Reel" &&
                  updatedTableData[j].quantity_type != "reel_sheet") ||
                  updatedTableData[j].type == "Sheet"))
            ) {
              updatedTableData[j].reelod = reelODArr;
              updatedTableData[j].coreid = coreIDValue;
              updatedTableData[j].outer_dia = reelODArr;
              updatedTableData[j].inner_dia = coreIDValue;
            }
          } else {
            if (
              selecteDia == "range" &&
              ((updatedTableData[j].type == "Reel" &&
                updatedTableData[j].quantity_type != "reel_sheet") ||
                updatedTableData[j].type == "Sheet")
            ) {
              updatedTableData[j].minimum_reel_od =
                form.getFieldValue("min_reel");
              updatedTableData[j].maximum_reel_od =
                form.getFieldValue("max_reel");
              updatedTableData[j].units["minimum_reel_od"] =
                form.getFieldValue("range_unit");
              updatedTableData[j].units["maximum_reel_od"] =
                form.getFieldValue("range_unit");
              updatedTableData[j].coreid = form.getFieldValue("core_Dia");
              updatedTableData[j].inner_dia = form.getFieldValue("core_Dia");
            }
          }
          if (
            (selecteDia == "range" &&
              ((updatedTableData[j].type == "Reel" &&
                updatedTableData[j].quantity_type != "reel_sheet") ||
                updatedTableData[j].type == "Sheet")) ||
            (selecteDia == "constant" &&
              updatedTableData[j].type == "Reel" &&
              updatedTableData[j].quantity_type == "reel_sheet" &&
              (selectedReelOD.length == 1 || selectedReelOD.length == 0)) ||
            (selecteDia == "constant" &&
              ((updatedTableData[j].type == "Reel" &&
                updatedTableData[j].quantity_type != "reel_sheet") ||
                updatedTableData[j].type == "Sheet"))
          ) {
            updatedTableData[j].id_od_type = selecteDia;
          }
        }
        // addSelectedQuantity(updatedTableData);
        setTableData([...updatedTableData]);
        tableDataRef.current = [...updatedTableData];
      }
    }

    if (!e.target.checked) {
      setIsAllSelected(false);
      // newCheckboxState.forEach((item) => {
      //   item.select = false;
      // });
      let newData = currentTableData.filter((item) => {
        if (
          (selecteDia == "range" &&
            ((item.type == "Reel" && item.quantity_type != "reel_sheet") ||
              item.type == "Sheet")) ||
          (selecteDia == "constant" &&
            item.type == "Reel" &&
            item.quantity_type == "reel_sheet" &&
            (selectedReelOD.length == 1 || selectedReelOD.length == 0)) ||
          (selecteDia == "constant" &&
            ((item.type == "Reel" && item.quantity_type != "reel_sheet") ||
              item.type == "Sheet"))
        ) {
          return item;
        }
      });
      removeDeslectedQuantity(newData);
      // setSelectedDataRows(
      //   selectedDataRows.filter((f) => !tableData.some((d) => d.key == f.id))
      // );
      setSelectedRowKeys(
        selectedRowKeys.filter((f) => !tableData.some((d) => d.key == f))
      );
      if (
        !selectedRowKeys.filter((f) => !tableData.some((d) => d.key == f))
          .length
      )
        setTotalWeight(0);
    } else {
      setIsAllSelected(true);
      // newCheckboxState.forEach((item) => {
      //   item.select = true;
      // });
      let newData = currentTableData.filter((item) => {
        if (
          (selecteDia == "range" &&
            ((item.type == "Reel" && item.quantity_type != "reel_sheet") ||
              item.type == "Sheet")) ||
          (selecteDia == "constant" &&
            item.type == "Reel" &&
            item.quantity_type == "reel_sheet" &&
            (selectedReelOD.length == 1 || selectedReelOD.length == 0)) ||
          (selecteDia == "constant" &&
            ((item.type == "Reel" && item.quantity_type != "reel_sheet") ||
              item.type == "Sheet"))
        ) {
          return item;
        }
      });
      // const uniqueArr = newData.filter(
      //   (
      //     (set) => (a) =>
      //       false === set.has(a.id)
      //   )(new Set(selectedOrders.map((b) => b.id)))
      // );
      // let unique = [...new Set([...selectedDataRows, ...tableData])];
      // unique = [
      //   ...new Map(unique.map((item) => [item["orderno"], item])).values(),
      // ];

      let uniqueKeys = [
        ...new Set([...selectedOrderKeys, ...newData.map((item) => item.id)]),
      ];
      let dataToAdd = newData.filter(
        (f) => !selectedOrders.some((d) => d.id == f.id)
      );
      setSelectedRowKeys(uniqueKeys);
      if (!uniqueKeys.length) setTotalWeight(0);
      addSelectedQuantity(dataToAdd);
      //setSelectedDataRows(unique);
    }

    const productCodes = [
      ...new Set(currentSelectedRows.map((r) => r.productcode)),
    ];

    // await getProductDetailsForSelectedOrders(productCodes)
    //   .then((response) => {
    //     setProductDataForSelectedRows(response);
    //   })
    //   .catch((error) => {
    //     console.log("Error in getting product specification list");
    //   });

    //setTableData(newCheckboxState);
    const temp = newCheckboxState.filter((item) => item.select === true);
    if (temp.length > 0) setIsCheckboxClicked(true);
    else setIsCheckboxClicked(false);
    setPageRerender(true);
    setTableRerender(true);
    //setPageLoaded(false);
  };

  const headerCheckbox = (
    <div style={{ paddingBottom: "4px" }}>
      <Styled>
        <Checkbox
          checked={isAllSelected}
          indeterminate={
            selectedRowKeys &&
            selectedRowKeys.length > 0 &&
            selectedRowKeys.length < tableData
          }
          onChange={
            orderType == "other_orders" &&
              location?.state?.selected_type === "rewinding" &&
              isAddRewinderDimension
              ? toggleSelectAllRewinder
              : toggleSelectAll
          }
        ></Checkbox>
      </Styled>
    </div>
  );

  const onFinish = () => {
    let minValue = form.getFieldValue("min_reel");
    let maxValue = form.getFieldValue("max_reel");
    let coreValue = form.getFieldValue("core_Dia");
    let rangeUnit = form.getFieldValue("range_unit");
    let coreodValue = form.getFieldValue("coreDia");

    if (
      ((!coreOdValidationError &&
        !reelODValidationError &&
        selectedReelOD?.length &&
        coreodValue) ||
        (minValue &&
          maxValue &&
          coreValue &&
          rangeUnit &&
          !rangeValidationError)) &&
      payload.length
    ) {
      let requestArray = [...payload];
      updateOrdersInBulk(requestArray)
        .then((response) => {
          setLoading(true);

          setActionToaster({
            error: response.error,
            msg: "Orders are successfully updated",
          });
          setMovedOrder(response.data)
          showToaster();
          setFilterTags([]);
          setAppliedFilters([]);
          setSearchValue("");
          setClearSearch(true);
          form.resetFields();
          form.resetFields();
          form.setFieldsValue({
            coreDia: reelCoreData.default_core_id
              ? reelCoreData.default_core_id +
              " " +
              reelCoreData.default_core_unit
              : "",
          });
          form.setFieldsValue({
            core_Dia: reelCoreData.default_core_id
              ? reelCoreData.default_core_id +
              " " +
              reelCoreData.default_core_unit
              : "",
          });
          form.setFieldsValue({
            range_unit: measurementData.data.units_management.length.default,
          });
          reelCoreData?.default_reel_od
            ? setSelectedReelOD([
              {
                value:
                  reelCoreData?.default_reel_od +
                  " " +
                  reelCoreData?.default_reel_unit,
              },
            ])
            : setSelectedReelOD([]);
          setTotalWeight(0);
          totalRef.current = 0;
          setSelectedDia("constant");
          setSelectedReelOD([]);
          setIsMoveToselection(true);
          setIsAddRewinderDimension(false);
          // setAppliedFilters([]);
          setPaginationParams({
            page: 1,
            size: settingsData?.settings?.default_page_size || 10,
            sort_by: "updated_at",
            sort_type: "descending",
          });
          paginationParamsRef.current = {
            page: 1,
            size: settingsData?.settings?.default_page_size || 10,
            sort_by: "updated_at",
            sort_type: "descending",
          };
          setPayload([]);
          setSelectedDataRows([]);
          setSelectedRowKeys([]);
          setCurrentPage(1);
        })
        .catch((error) => {
          setActionToaster({
            error: error.response.data.error,
            msg: error.response.data.msg,
          });
          showToaster();
        });
    }
    setRendering(true);
  };

  const onReviewAndUpdateClick = () => {
    form.submit();
  };

  const modalShow = (id) => {
    setSelectedId(id);
    setIsVisibleModal(true);
  };

  const modalClose = async () => {
    setSelectedId(null);
    setIsVisibleModal(false);
  };

  const showEditReelCoreModal = (record, type, index) => {
    setSelectedReocord(record);
    setSelectedType(type);
    setSelectedIndex(index);
    setEditReelCoreModal(true);
  };

  const closeEditReelCoreModal = () => {
    setEditReelCoreModal(false);
  };

  const confirmEditReelCoreModal = (e) => {
    setEditReelCoreModal(false);
    if (e.type === "reel") {
      let selected = selectedRecord;
      setSelectedReocord({ ...selected });
      let dataSourceCopy = tableData;
      let selectedDataCopy = [...selectedDataRows];
      let selectedDataIndex = selectedDataRows?.findIndex(
        (ele) => ele.orderno == e?.orderData?.orderno
      );
      let selectedRowData = selectedDataCopy[selectedDataIndex];
      if (e.reel_type == "constant") {
        selected.reelod = e.outer_dia;
        selected.outer_dia = e.outer_dia;
        if (selectedDataIndex == 0 || selectedDataIndex != -1) {
          selectedRowData.reelod = e.outer_dia;
          selectedRowData.outer_dia = e.outer_dia;
        }
      } else {
        selected.minimum_reel_od = e.minimum_reel_od;
        selected.maximum_reel_od = e.maximum_reel_od;
        selected.units["minimum_reel_od"] = e.units.minimum_reel_od;
        selected.units["maximum_reel_od"] = e.units.maximum_reel_od;
        selected.id_od_type = "range";
        selected.outer_dia = [];
        selected.reelod = [];

        if (selectedDataIndex == 0 || selectedDataIndex != -1) {
          selectedRowData.minimum_reel_od = e.minimum_reel_od;
          selectedRowData.maximum_reel_od = e.maximum_reel_od;
          selectedRowData.units["minimum_reel_od"] = e.units.minimum_reel_od;
          selectedRowData.units["maximum_reel_od"] = e.units.maximum_reel_od;
          selectedRowData.id_od_type = "range";
          selectedRowData.outer_dia = [];
          selectedRowData.reelod = [];
        }
      }
      selected.id_od_type = e.reel_type;
      if (selectedDataIndex == 0 || selectedDataIndex != -1) {
        selectedRowData.id_od_type = e.reel_type;
      }
      dataSourceCopy[selectedIndex] = { ...selected };
      setTableData([...dataSourceCopy]);
      tableDataRef.current = [...dataSourceCopy];

      selectedDataCopy[selectedDataIndex] = { ...selectedRowData };
      setSelectedDataRows([...selectedDataCopy]);
      plannedReelsCaln(
        selectedIndex,
        selected,
        selected.plannedQuant,
        e.outer_dia,
        selected.coreid,
        orderType
      );
    }
    if (e.type == "core") {
      // let selected = selectedRecord;
      let selected = JSON.parse(JSON.stringify(selectedRecord));
      setSelectedReocord({ ...selected });
      let dataSourceCopy = tableData;
      let selectedDataCopy = [...selectedDataRows];
      let selectedDataIndex = selectedDataRows?.findIndex(
        (ele) => ele.orderno == e?.orderData?.orderno
      );
      let selectedRowData;
      if (selectedDataIndex == 0 || selectedDataIndex != -1)
        selectedRowData = JSON.parse(
          JSON.stringify(selectedDataCopy[selectedDataIndex])
        );

      selected.coreid = e.inner_dia;
      selected.inner_dia = e.inner_dia;
      if (selectedDataIndex == 0 || selectedDataIndex != -1) {
        selectedRowData.coreid = e.inner_dia;
        selectedRowData.inner_dia = e.inner_dia;
        if (e?.orderData.id_od_type == "range") {
          selectedRowData.outer_dia = [];
          selectedRowData.reelod = [];
        }
      }
      if (e?.orderData.id_od_type == "range") {
        selected.outer_dia = [];
        selected.reelod = [];
      }

      dataSourceCopy[selectedIndex] = { ...selected };
      setTableData([...dataSourceCopy]);
      tableDataRef.current = [...dataSourceCopy];
      if (selectedDataIndex == 0 || selectedDataIndex != -1)
        selectedDataCopy[selectedDataIndex] = { ...selectedRowData };

      setSelectedDataRows([...selectedDataCopy]);

      plannedReelsCaln(
        selectedIndex,
        selected,
        selected.plannedQuant,
        selected.reelod,
        e.inner_dia,
        orderType
      );
    }
    // setTableRerender(true);
  };

  const modalConfirm = async () => { };

  const routeChange = () => {
    history("../review-selected-order");
  };

  const GoBackRouteChange = () => {
    // setRetainForm(true);
    // if (location.state.type && location.state.type === "selectOrders") {
    //   history("../paper-machine-orders", {
    //     state: {
    //       body: location.state.body,
    //       maximum_burst_factor: location.state.maximum_burst_factor,
    //       minimum_burst_factor: location.state.minimum_burst_factor,
    //       maximum_gsm: location.state.maximum_gsm,
    //       minimum_gsm: location.state.minimum_gsm,
    //       selected_rewinder: location.state.selected_rewinder,
    //       selected_cutter: location.state.selected_cutter,
    //       selected_rewinder_unit: location.state.selected_rewinder_unit,
    //       selected_cutter_unit: location.state.selected_cutter_unit,
    //       rewinder_data: location.state.rewinder_data,
    //       cutter_data: location.state.cutter_data,
    //       selected_type: location.state.selected_type,
    //       rewinder_minWidth: location.state.rewinder_minWidth,
    //       rewinder_maxWidth: location.state.rewinder_maxWidth,
    //       cutter_minWidth: location.state.cutter_minWidth,
    //       cutter_maxWidth: location.state.cutter_maxWidth,
    //       max_NoOfCutters: location.state.max_NoOfCutters,
    //       minWeight: location.state.minWeight,
    //       minWeight: location.state.minWeight,
    //       left_edge_trim: location.state.left_edge_trim,
    //       right_edge_trim: location.state.right_edge_trim,
    //       code: location.state.code,
    //       initital_OrderType: location.state.initital_OrderType,
    //       is_enabled: location.state.is_enabled,
    //       machine_code: location.state.machine_code,
    //       partitionWeightUnit: location.state.partitionWeightUnit,
    //     },
    //   });
    //   isCancelJobCard.current = false;
    //   setMergeGroupsData(null);
    // } else {
    isCancelJobCard.current = false;
    setMergeGroupsData(null);
    handleResetAll();
    history("../create-new-job-cards", {
      state: {
        body: location.state.body,
        maximum_burst_factor: location.state.maximum_burst_factor,
        minimum_burst_factor: location.state.minimum_burst_factor,
        maximum_gsm: location.state.maximum_gsm,
        minimum_gsm: location.state.minimum_gsm,
        selected_rewinder: location.state.selected_rewinder,
        selected_cutter: location.state.selected_cutter,
        selected_rewinder_unit: location.state.selected_rewinder_unit,
        selected_cutter_unit: location.state.selected_cutter_unit,
        rewinder_data: location.state.rewinder_data,
        cutter_data: location.state.cutter_data,
        selected_type: location.state.selected_type,
        rewinder_minWidth: location.state.rewinder_minWidth,
        rewinder_maxWidth: location.state.rewinder_maxWidth,
        cutter_minWidth: location.state.cutter_minWidth,
        cutter_maxWidth: location.state.cutter_maxWidth,
        max_NoOfCutters: location.state.max_NoOfCutters,
        minWeight: location.state.minWeight,
        minWeight: location.state.minWeight,
        left_edge_trim: location.state.left_edge_trim,
        right_edge_trim: location.state.right_edge_trim,
        code: location.state.code,
        initital_OrderType: location.state.initital_OrderType,
        is_enabled: location.state.is_enabled,
        machine_code: location.state.machine_code,
        partitionWeightUnit: location.state.partitionWeightUnit,
        max_NoOfCutters_cutter: location.state.max_NoOfCutters_cutter,
        left_edge_trim_cutter: location.state.left_edge_trim_cutter,
        right_edge_trim_cutter: location.state.right_edge_trim_cutter,
        processType: location.state.processType,
        max_NoOfCutters_cutter: location.state.max_NoOfCutters_cutter,
        left_edge_trim_cutter: location.state.left_edge_trim_cutter,
        right_edge_trim_cutter: location.state.right_edge_trim_cutter,
        processType: location.state.processType,
      },
    });
    //}
  };

  const calculatePlannedWeight = (
    data,
    size,
    bulk,
    reelOd,
    coreOd,
    plannedReels
  ) => {
    const value =
      (3.14 *
        parseFloat(size) *
        (Math.pow(parseFloat(reelOd), 2) - Math.pow(parseFloat(coreOd), 2)) *
        parseFloat(plannedReels)) /
      (1000 * 1000 * parseFloat(bulk) * 4);
    let plannedWeightValue = parseFloat(
      value * conversionFactorTonneToUnits[data?.units?.planned_weight]
    )?.toFixed(3);
    return plannedWeightValue;
  };

  const plannedWeightCalculation = (
    index,
    data,
    orderQuantity,
    reelOd,
    coreOd,
    calculatedReels
  ) => {
    let size;
    if (data.type === "Reel") {
      size = data?.width;
    } else {
      size =
        data?.grain === "Long" ||
          data?.grain === "long" ||
          data?.grain === "long grain"
          ? parseFloat(data?.width) > parseFloat(data?.length)
            ? data?.length
            : data?.width
          : parseFloat(data?.length) > parseFloat(data?.width)
            ? data?.length
            : data?.width;
    }

    if (size && coreOd && reelOd && reelOd?.length == 1) {
      let reelConversionValue =
        orderDim_Rewinder_Unit_Conversion[reelOd[0]?.split(" ")[1]];
      let coreConversionValue =
        orderDim_Rewinder_Unit_Conversion[coreOd?.split(" ")[1]];
      let conversionValue =
        orderDim_Rewinder_Unit_Conversion[data?.units?.width];
      return calculatePlannedWeight(
        data,
        size * conversionValue,
        data?.product_info?.bulk,
        reelOd[0]?.split(" ")[0] * reelConversionValue,
        coreOd.split(" ")[0] * coreConversionValue,
        calculatedReels
      );
    } else {
      if (data.type === "Reel") {
        return 0;
      } else {
        if (data.type == "Sheet" && data.quantity_type === "weight") {
          if (orderQuantity) {
            return orderQuantity;
          } else {
            return 0;
          }
        } else {
          let weightUnit = data?.units?.planned_weight;

          let dimensionUnit = data?.units?.width;
          let conversionValue =
            orderDim_Rewinder_Unit_Conversion[dimensionUnit];

          let length_Value = data.length * conversionValue;
          let width_Value = data.width * conversionValue;

          const value =
            (length_Value *
              width_Value *
              orderQuantity *
              data?.product_info?.gsm) /
            (10000 * 1000000);
          let plannedWeightValue =
            value * conversionFactorTonneToUnits[weightUnit];
          let plannedWt = plannedWeightValue
            ? plannedWeightValue.toFixed(3)
            : 0;
          return plannedWt;
        }
      }
    }
  };

  const plannedReelsCalculation = (
    index,
    data,
    size,
    length,
    width,
    orderQuantity,
    bulk,
    gsm,
    coreOd,
    reelOd
  ) => {
    let weightConversionValue =
      weight_Unit_Conversions[data.units?.planned_weight];
    const value =
      data?.quantity_type === "weight"
        ? ((orderQuantity
          ? parseFloat(orderQuantity * weightConversionValue)
          : 0) *
          1000 *
          1000 *
          parseFloat(bulk) *
          4) /
        (3.14 *
          parseFloat(size) *
          (Math.pow(parseFloat(reelOd), 2) - Math.pow(parseFloat(coreOd), 2)))
        : (parseFloat(length) *
          parseFloat(width) *
          parseFloat(orderQuantity) *
          parseFloat(gsm) *
          parseFloat(bulk) *
          4) /
        (3.14 *
          parseFloat(size) *
          (Math.pow(parseFloat(reelOd), 2) -
            Math.pow(parseFloat(coreOd), 2)) *
          10000);
    return value;
  };

  const rewinderReelsCal = (index, data, orderQuantity, reelOd, coreOd) => {
    let size;
    if (data.type === "Reel") {
      size = data.width;
    } else {
      size =
        data.grain === "Long" ||
          data.grain === "long" ||
          data.grain === "long grain"
          ? parseFloat(data.width) > parseFloat(data.length)
            ? data.length
            : data.width
          : parseFloat(data.length) > parseFloat(data.width)
            ? data.length
            : data.width;
    }

    if (
      data.type === "Reel" &&
      data.quantity_type === "reel_sheet" &&
      orderQuantity
    ) {
      return orderQuantity;
    } else {
      if (orderQuantity) {
        if (
          size &&
          coreOd &&
          reelOd &&
          reelOd?.length == 1 &&
          data?.product_info?.bulk &&
          size !== 0 &&
          parseFloat(coreOd.split(" ")[0]) !==
          parseFloat(reelOd[0]?.split(" ")[0])
        ) {
          let reelConversionValue =
            orderDim_Rewinder_Unit_Conversion[reelOd[0]?.split(" ")[1]];
          let coreConversionValue =
            orderDim_Rewinder_Unit_Conversion[coreOd?.split(" ")[1]];
          let conversionValue =
            orderDim_Rewinder_Unit_Conversion[data?.units?.width];

          return plannedReelsCalculation(
            index,
            data,
            size * conversionValue,
            data?.length * conversionValue,
            data?.width * conversionValue,
            orderQuantity,
            data?.product_info?.bulk,
            data?.product_info?.gsm,
            coreOd.split(" ")[0] * coreConversionValue,
            reelOd[0]?.split(" ")[0] * reelConversionValue
          );
        } else {
          return 0;
        }
      } else {
        return 0;
      }
    }
  };

  const plannedReelsCaln = (
    index,
    { ...data },
    orderQuantity,
    reelOd,
    coreOd
  ) => {
    let calculatedReels;
    let calculatedPlannedWt;
    let currentPlannedWeight;

    if (
      reelOd != "-" &&
      reelOd &&
      reelOd?.length == 1 &&
      coreOd != "-" &&
      coreOd &&
      data.width
    ) {
      calculatedReels = rewinderReelsCal(
        index,
        data,
        orderQuantity,
        reelOd,
        coreOd
      );
      let reels = Math.round(parseFloat(calculatedReels)?.toFixed(3))
        ? Math.round(parseFloat(calculatedReels * 1)?.toFixed(3))
        : 1;
      calculatedPlannedWt = plannedWeightCalculation(
        index,
        data,
        orderQuantity,
        reelOd,
        coreOd,
        reels
      );
    } else if (
      // ((!coreOd || coreOd == "-") || (!reelOd && !reelOd?.length)) && data.type == "Sheet"
      ((coreOd && coreOd != "-" && reelOd && reelOd.length == 1) ||
        ((!coreOd || coreOd == "-") && reelOd && reelOd.length == 0) ||
        ((!coreOd || coreOd == "-") && reelOd && reelOd.length == 1) ||
        (coreOd && coreOd != "-" && reelOd && reelOd.length == 0)) &&
      data.type?.toLowerCase() == "sheet"
    ) {
      if (data.type == "Sheet" && data.quantity_type === "weight") {
        if (orderQuantity) {
          calculatedReels = 0;
          calculatedPlannedWt = parseFloat(orderQuantity).toFixed(3);
        } else {
          calculatedReels = 0;
          calculatedPlannedWt = 0;
        }
      } else {
        let weightUnit = data?.units?.planned_weight;

        let dimensionUnit = data?.units?.width;
        let conversionValue = orderDim_Rewinder_Unit_Conversion[dimensionUnit];

        let length_Value = data.length * conversionValue;
        let width_Value = data.width * conversionValue;

        if (selecteDia == "constant") {
          const value =
            (length_Value *
              width_Value *
              orderQuantity *
              data?.product_info?.gsm) /
            (10000 * 1000000);
          let plannedWeightValue =
            value * conversionFactorTonneToUnits[weightUnit];
          calculatedReels = 0;
          calculatedPlannedWt = plannedWeightValue
            ? plannedWeightValue.toFixed(3)
            : 0;
        } else {
          calculatedReels = 0;
          calculatedPlannedWt = data.plannedQuant;
        }
      }
    } else {
      if (data.type == "Reel" && data.quantity_type === "reel_sheet") {
        calculatedReels = orderQuantity;
      } else {
        calculatedReels = 0;
      }
      calculatedPlannedWt = orderQuantity;
    }

    let dataSourceCopy = [...tableData];
    let record = dataSourceCopy[index];
    let calculatedNetPrice;
    let requiredWeightValue;
    if (data?.product_info) {
      let plannedWtConversion;
      let unitPlaceholder = data.units?.planned_weight;
      let priceUnit = data?.units?.per_weight_unit;
      if (data.quantity_type == "weight") {
        requiredWeightValue = data.weight;
      } else {
        requiredWeightValue = calculatedPlannedWt ? calculatedPlannedWt : 0;
      }
      if (unitPlaceholder?.toLowerCase() !== priceUnit?.toLowerCase()) {
        let unitToTonneConv =
          requiredWeightValue * weight_Unit_Conversions[unitPlaceholder];
        plannedWtConversion =
          unitToTonneConv * conversionFactorTonneToUnits[priceUnit];
      } else {
        plannedWtConversion = requiredWeightValue;
      }
      calculatedNetPrice =
        parseFloat(data.price) * parseFloat(plannedWtConversion)
          ? (parseFloat(data.price) * parseFloat(plannedWtConversion))?.toFixed(
            3
          )
          : "";
    }

    if (coreOd && reelOd && reelOd.length == 1) {
      record["calculatedreels"] = parseFloat(calculatedReels)?.toFixed(3);
      record.rewinderreels = Math.round(parseFloat(calculatedReels)?.toFixed(3))
        ? Math.round(parseFloat(calculatedReels * 1)?.toFixed(3))
        : 1;
    } else {
      if (data.type == "Reel" && data.quantity_type === "reel_sheet") {
        record["calculatedreels"] = calculatedReels;
        record.rewinderreels = calculatedReels;
      } else {
        record["calculatedreels"] = 0;
        record.rewinderreels = 0;
      }
    }

    // if(data.id_od_type == "constant"){
    //   record.reelod = reelOd;
    //   record.outer_dia = reelOd;
    //   record.coreid = coreOd;
    //   record.inner_dia = coreOd;
    // } else{
    //   record.minimum_reel_od = data.minimum_reel_od;
    //   record.maximum_reel_od = data.maximum_reel_od;
    // }
    record.net_price = calculatedNetPrice;
    dataSourceCopy[index] = { ...record };

    if (orderType == "other_orders") {
      let selectedDataCopy = [...selectedDataRows];
      let selectedDataIndex = selectedDataRows?.findIndex(
        (ele) => ele.id == data.orderno
      );
      let selectedOrderRow = selectedDataCopy[selectedDataIndex];
      if (selectedOrderRow) {
        if (coreOd && reelOd && reelOd.length == 1) {
          currentPlannedWeight =
            totalRef.current -
            (tableData[index].plannedweight != "-" &&
              tableData[index].plannedweight != ""
              ? parseFloat(tableData[index].plannedweight.split(" ")[0]) *
              conversionFactorUnitsToTonne[
              tableData[index].units.planned_weight
              ] *
              conversionFactorTonneToUnits[
              unitData.units_management.weight.default
              ]
              : 0) +
            parseFloat(
              calculatedPlannedWt *
              conversionFactorUnitsToTonne[
              tableData[index].units.planned_weight
              ] *
              conversionFactorTonneToUnits[
              unitData.units_management.weight.default
              ]
            );
          setTotalWeight(currentPlannedWeight < 0 ? 0 : currentPlannedWeight);
          totalRef.current =
            currentPlannedWeight < 0 ? 0 : currentPlannedWeight;
          selectedOrderRow.calculatedreels =
            parseFloat(calculatedReels)?.toFixed(3);
          selectedOrderRow.rewinderreels = Math.round(
            parseFloat(calculatedReels)?.toFixed(3)
          )
            ? Math.round(parseFloat(calculatedReels * 1)?.toFixed(3))
            : 1;
        } else {
          if (data.type == "Reel" && data.quantity_type === "reel_sheet") {
            selectedOrderRow.calculatedreels = calculatedReels;
            selectedOrderRow.rewinderreels = calculatedReels;
          } else {
            selectedOrderRow.calculatedReels = 0;
            selectedOrderRow.rewinderreels = 0;
          }
          currentPlannedWeight =
            totalRef.current -
            (tableData[index].plannedweight != "-" &&
              tableData[index].plannedweight != ""
              ? parseFloat(tableData[index].plannedweight.split(" ")[0]) *
              conversionFactorUnitsToTonne[
              tableData[index].units.planned_weight
              ] *
              conversionFactorTonneToUnits[
              unitData.units_management.weight.default
              ]
              : 0) +
            parseFloat(
              calculatedPlannedWt *
              conversionFactorUnitsToTonne[
              tableData[index].units.planned_weight
              ] *
              conversionFactorTonneToUnits[
              unitData.units_management.weight.default
              ]
            );

          setTotalWeight(currentPlannedWeight < 0 ? 0 : currentPlannedWeight);
          totalRef.current =
            currentPlannedWeight < 0 ? 0 : currentPlannedWeight;
        }
        selectedOrderRow.plannedweight =
          parseFloat(calculatedPlannedWt) +
          " " +
          capitalize(weightUnit[record?.units?.planned_weight]?.displayName);
        selectedOrderRow.plannedQuant = parseFloat(orderQuantity);
        selectedOrderRow.net_price = calculatedNetPrice;
        if (data.id_od_type == "range") {
          selectedOrderRow.maximum_reel_od = data.maximum_reel_od;
          selectedOrderRow.minimum_reel_od = data.minimum_reel_od;
        } else {
          selectedOrderRow.outer_dia = data.outer_dia;
          selectedOrderRow.reelod = data.reelod;
        }
        selectedOrderRow.inner_dia = data.inner_dia;
        selectedOrderRow.coreid = data.coreid;

        selectedDataCopy[selectedDataIndex] = { ...selectedOrderRow };

        setSelectedDataRows([...selectedDataCopy]);
      }
    } else {
      let selectedDataCopy = [...selectedDataRows];
      let selectedDataIndex = selectedDataRows?.findIndex(
        (ele) => ele.id == data.orderno
      );
      let selectedOrderRow = selectedDataCopy[selectedDataIndex];
      if (selectedOrderRow) {
        //let currentPlannedWeight ;

        if (coreOd && reelOd && reelOd.length == 1) {
          currentPlannedWeight =
            totalRef.current -
            (tableData[index].plannedweight != "-" &&
              tableData[index].plannedweight != ""
              ? parseFloat(tableData[index].plannedweight.split(" ")[0]) *
              conversionFactorUnitsToTonne[
              tableData[index].units.planned_weight
              ] *
              conversionFactorTonneToUnits[
              unitData.units_management.weight.default
              ]
              : 0) +
            parseFloat(
              calculatedPlannedWt *
              conversionFactorUnitsToTonne[
              tableData[index].units.planned_weight
              ] *
              conversionFactorTonneToUnits[
              unitData.units_management.weight.default
              ]
            );
          setTotalWeight(currentPlannedWeight < 0 ? 0 : currentPlannedWeight);
          totalRef.current =
            currentPlannedWeight < 0 ? 0 : currentPlannedWeight;
        } else {
          currentPlannedWeight =
            totalRef.current -
            (tableData[index].plannedweight != "-" &&
              tableData[index].plannedweight != ""
              ? parseFloat(tableData[index].plannedweight.split(" ")[0]) *
              conversionFactorUnitsToTonne[
              tableData[index].units.planned_weight
              ] *
              conversionFactorTonneToUnits[
              unitData.units_management.weight.default
              ]
              : 0) +
            parseFloat(
              calculatedPlannedWt *
              conversionFactorUnitsToTonne[
              tableData[index].units.planned_weight
              ] *
              conversionFactorTonneToUnits[
              unitData.units_management.weight.default
              ]
            );
          setTotalWeight(currentPlannedWeight < 0 ? 0 : currentPlannedWeight);
          totalRef.current =
            currentPlannedWeight < 0 ? 0 : currentPlannedWeight;
        }
      }
    }
    record.plannedweight =
      parseFloat(calculatedPlannedWt) +
      " " +
      capitalize(weightUnit[record?.units?.planned_weight]?.displayName);
    record.plannedQuant = parseFloat(orderQuantity);
    dataSourceCopy[index] = JSON.parse(JSON.stringify(record));
    setTableData([...dataSourceCopy]);
    tableDataRef.current = [...dataSourceCopy];
    if (orderType === "selected_orders") {
      saveOrder(
        index,
        record,
        currentPlannedWeight < 0 ? 0 : currentPlannedWeight
      );
    } else if (isAddRewinderDimension) {
      saveIncompleteOrder();
      //setTableRerender(true);
    }
  };

  const plannedReelsCalnForIncompleteOrder = (
    index,
    { ...data },
    orderQuantity,
    reelOd,
    coreOd
  ) => {
    let calculatedReels;
    let calculatedPlannedWt;
    let currentPlannedWeight;

    if (
      reelOd != "-" &&
      reelOd &&
      reelOd?.length == 1 &&
      coreOd != "-" &&
      coreOd &&
      data.width
    ) {
      calculatedReels = rewinderReelsCal(
        index,
        data,
        orderQuantity,
        reelOd,
        coreOd
      );
      let reels = Math.round(parseFloat(calculatedReels)?.toFixed(3))
        ? Math.round(parseFloat(calculatedReels * 1)?.toFixed(3))
        : 1;
      calculatedPlannedWt = plannedWeightCalculation(
        index,
        data,
        orderQuantity,
        reelOd,
        coreOd,
        reels
      );
    } else if (
      // ((!coreOd || coreOd == "-") || (!reelOd && !reelOd?.length)) && data.type == "Sheet"
      ((coreOd && coreOd != "-" && reelOd && reelOd.length == 1) ||
        ((!coreOd || coreOd == "-") && reelOd && reelOd.length == 0) ||
        ((!coreOd || coreOd == "-") && reelOd && reelOd.length == 1) ||
        (coreOd && coreOd != "-" && reelOd && reelOd.length == 0)) &&
      data.type?.toLowerCase() == "sheet"
    ) {
      if (data.type == "Sheet" && data.quantity_type === "weight") {
        if (orderQuantity) {
          calculatedReels = 0;
          calculatedPlannedWt = parseFloat(orderQuantity).toFixed(3);
        } else {
          calculatedReels = 0;
          calculatedPlannedWt = 0;
        }
      } else {
        let weightUnit = data?.units?.planned_weight;

        let dimensionUnit = data?.units?.width;
        let conversionValue = orderDim_Rewinder_Unit_Conversion[dimensionUnit];

        let length_Value = data.length * conversionValue;
        let width_Value = data.width * conversionValue;

        if (selecteDia == "constant") {
          const value =
            (length_Value *
              width_Value *
              orderQuantity *
              data?.product_info?.gsm) /
            (10000 * 1000000);
          let plannedWeightValue =
            value * conversionFactorTonneToUnits[weightUnit];
          calculatedReels = 0;
          calculatedPlannedWt = plannedWeightValue
            ? plannedWeightValue.toFixed(3)
            : 0;
        } else {
          calculatedReels = 0;
          calculatedPlannedWt = data.plannedQuant;
        }
      }
    } else {
      if (data.type == "Reel" && data.quantity_type === "reel_sheet") {
        calculatedReels = orderQuantity;
      } else {
        calculatedReels = 0;
      }
      calculatedPlannedWt = data.plannedQuant;
    }

    let dataSourceCopy = [...selectedDataRows];
    let record = dataSourceCopy[index];
    let calculatedNetPrice;
    let requiredWeightValue;
    if (data?.product_info) {
      let plannedWtConversion;
      let unitPlaceholder = data.units?.planned_weight;
      let priceUnit = data?.units?.per_weight_unit;
      if (data.quantity_type == "weight") {
        requiredWeightValue = data.weight;
      } else {
        requiredWeightValue = calculatedPlannedWt ? calculatedPlannedWt : 0;
      }
      if (unitPlaceholder?.toLowerCase() !== priceUnit?.toLowerCase()) {
        let unitToTonneConv =
          requiredWeightValue * weight_Unit_Conversions[unitPlaceholder];
        plannedWtConversion =
          unitToTonneConv * conversionFactorTonneToUnits[priceUnit];
      } else {
        plannedWtConversion = requiredWeightValue;
      }
      calculatedNetPrice =
        parseFloat(data.price) * parseFloat(plannedWtConversion)
          ? (parseFloat(data.price) * parseFloat(plannedWtConversion))?.toFixed(
            3
          )
          : "";
    }

    if (coreOd && reelOd && reelOd.length == 1) {
      record["calculatedreels"] = parseFloat(calculatedReels)?.toFixed(3);
      record.rewinderreels = Math.round(parseFloat(calculatedReels)?.toFixed(3))
        ? Math.round(parseFloat(calculatedReels * 1)?.toFixed(3))
        : 1;
    } else {
      if (data.type == "Reel" && data.quantity_type === "reel_sheet") {
        record["calculatedreels"] = calculatedReels;
        record.rewinderreels = calculatedReels;
      } else {
        record["calculatedreels"] = 0;
        record.rewinderreels = 0;
      }
    }

    // if(data.id_od_type == "constant"){
    //   record.reelod = reelOd;
    //   record.outer_dia = reelOd;
    //   record.coreid = coreOd;
    //   record.inner_dia = coreOd;
    // } else{
    //   record.minimum_reel_od = data.minimum_reel_od;
    //   record.maximum_reel_od = data.maximum_reel_od;
    // }
    record.net_price = calculatedNetPrice;
    dataSourceCopy[index] = { ...record };

    if (orderType == "other_orders") {
      let selectedDataCopy = [...selectedDataRows];
      let selectedDataIndex = selectedDataRows?.findIndex(
        (ele) => ele.id == data.orderno
      );
      let selectedOrderRow = selectedDataCopy[selectedDataIndex];
      if (selectedOrderRow) {
        if (coreOd && reelOd && reelOd.length == 1) {
          currentPlannedWeight =
            totalRef.current -
            (selectedDataRows[index].plannedweight != "-" &&
              selectedDataRows[index].plannedweight != ""
              ? parseFloat(
                selectedDataRows[index].plannedweight.split(" ")[0]
              ) *
              conversionFactorUnitsToTonne[
              selectedDataRows[index].units.planned_weight
              ] *
              conversionFactorTonneToUnits[
              unitData.units_management.weight.default
              ]
              : 0) +
            parseFloat(
              calculatedPlannedWt *
              conversionFactorUnitsToTonne[
              selectedDataRows[index].units.planned_weight
              ] *
              conversionFactorTonneToUnits[
              unitData.units_management.weight.default
              ]
            );
          setTotalWeight(currentPlannedWeight < 0 ? 0 : currentPlannedWeight);
          totalRef.current =
            currentPlannedWeight < 0 ? 0 : currentPlannedWeight;
          selectedOrderRow.calculatedreels =
            parseFloat(calculatedReels)?.toFixed(3);
          selectedOrderRow.rewinderreels = Math.round(
            parseFloat(calculatedReels)?.toFixed(3)
          )
            ? Math.round(parseFloat(calculatedReels * 1)?.toFixed(3))
            : 1;
        } else {
          if (data.type == "Reel" && data.quantity_type === "reel_sheet") {
            selectedOrderRow.calculatedreels = calculatedReels;
            selectedOrderRow.rewinderreels = calculatedReels;
          } else {
            selectedOrderRow.calculatedReels = 0;
            selectedOrderRow.rewinderreels = 0;
          }
          currentPlannedWeight =
            totalRef.current -
            ((selectedDataRows[index].plannedweight != "-") &
              (selectedDataRows[index].plannedweight != "")
              ? parseFloat(
                selectedDataRows[index].plannedweight.split(" ")[0]
              ) *
              conversionFactorUnitsToTonne[
              selectedDataRows[index].units.planned_weight
              ] *
              conversionFactorTonneToUnits[
              unitData.units_management.weight.default
              ]
              : 0) +
            parseFloat(
              calculatedPlannedWt *
              conversionFactorUnitsToTonne[
              selectedDataRows[index].units.planned_weight
              ] *
              conversionFactorTonneToUnits[
              unitData.units_management.weight.default
              ]
            );

          setTotalWeight(currentPlannedWeight < 0 ? 0 : currentPlannedWeight);
          totalRef.current =
            currentPlannedWeight < 0 ? 0 : currentPlannedWeight;
        }
        selectedOrderRow.plannedweight =
          parseFloat(calculatedPlannedWt) +
          " " +
          capitalize(weightUnit[record?.units?.planned_weight]?.displayName);
        selectedOrderRow.plannedQuant = parseFloat(orderQuantity);
        selectedOrderRow.net_price = calculatedNetPrice;
        if (data.id_od_type == "range") {
          selectedOrderRow.maximum_reel_od = data.maximum_reel_od;
          selectedOrderRow.minimum_reel_od = data.minimum_reel_od;
        } else {
          selectedOrderRow.outer_dia = data.outer_dia;
          selectedOrderRow.reelod = data.reelod;
        }
        selectedOrderRow.inner_dia = data.inner_dia;
        selectedOrderRow.coreid = data.coreid;

        selectedDataCopy[selectedDataIndex] = { ...selectedOrderRow };

        setSelectedDataRows([...selectedDataCopy]);
      }
    } else {
      let selectedDataCopy = [...selectedDataRows];
      let selectedDataIndex = selectedDataRows?.findIndex(
        (ele) => ele.id == data.orderno
      );
      let selectedOrderRow = selectedDataCopy[selectedDataIndex];
      if (selectedOrderRow) {
        //let currentPlannedWeight ;

        if (coreOd && reelOd && reelOd.length == 1) {
          currentPlannedWeight =
            totalRef.current -
            ((selectedDataCopy[index].plannedweight != "-") &
              (selectedDataCopy[index].plannedweight != "")
              ? parseFloat(
                selectedDataCopy[index].plannedweight.split(" ")[0]
              ) *
              conversionFactorUnitsToTonne[
              selectedDataCopy[index].units.planned_weight
              ] *
              conversionFactorTonneToUnits[
              unitData.units_management.weight.default
              ]
              : 0) +
            parseFloat(
              calculatedPlannedWt *
              conversionFactorUnitsToTonne[
              selectedDataCopy[index].units.planned_weight
              ] *
              conversionFactorTonneToUnits[
              unitData.units_management.weight.default
              ]
            );
          setTotalWeight(currentPlannedWeight < 0 ? 0 : currentPlannedWeight);
          totalRef.current =
            currentPlannedWeight < 0 ? 0 : currentPlannedWeight;
        } else {
          currentPlannedWeight =
            totalRef.current -
            ((selectedDataCopy[index].plannedweight != "-") &
              (selectedDataCopy[index].plannedweight != "")
              ? parseFloat(
                selectedDataCopy[index].plannedweight.split(" ")[0]
              ) *
              conversionFactorUnitsToTonne[
              selectedDataCopy[index].units.planned_weight
              ] *
              conversionFactorTonneToUnits[
              unitData.units_management.weight.default
              ]
              : 0) +
            parseFloat(
              calculatedPlannedWt *
              conversionFactorUnitsToTonne[
              selectedDataCopy[index].units.planned_weight
              ] *
              conversionFactorTonneToUnits[
              unitData.units_management.weight.default
              ]
            );
          setTotalWeight(currentPlannedWeight < 0 ? 0 : currentPlannedWeight);
          totalRef.current =
            currentPlannedWeight < 0 ? 0 : currentPlannedWeight;
        }
      }
    }
    record.plannedweight =
      parseFloat(calculatedPlannedWt) +
      " " +
      capitalize(weightUnit[record?.units?.planned_weight]?.displayName);
    record.plannedQuant = parseFloat(orderQuantity);
    dataSourceCopy[index] = JSON.parse(JSON.stringify(record));
    //setTableData([...dataSourceCopy]);
    //tableDataRef.current = [...dataSourceCopy];

    saveIncompleteOrder();
    //setTableRerender(true);
  };

  const onActionChange = (index, action, data) => {
    if (action == "remove") {
      form.setFieldsValue({
        [`plannedQuanty${data.orderno}`]: data.plannedQuant,
      });
      let dataSourceCopy = tableData;
      let record = dataSourceCopy[index];
      record.plannedQuant = data.plannedQuant;
      dataSourceCopy[index] = record;
      setTableData([...dataSourceCopy]);
      tableDataRef.current = [...dataSourceCopy];
    } else {
      let enteredQuantity = form.getFieldValue(`plannedQuanty${data.orderno}`);
      plannedReelsCaln(index, data, enteredQuantity, data.reelod, data.coreid);
    }
    if (!isEditClicked.hasOwnProperty(data?.orderno)) {
      isEditClicked[data?.orderno] = {};
    }
    isEditClicked[data?.orderno].isEditable = false;
    setIsEditClicked(isEditClicked);
    setTableRerender(true);
  };

  const saveOrder = (index, data, currentPlannedWeight) => {
    let quantityKey = 0;
    let plannedSheetsValue = 0;
    let reelODArr = [];
    if (
      (data.reelod && data.reelod.length == 1) ||
      (data.type?.toLowerCase() == "reel" && data.quantity_type == "reel_sheet")
    ) {
      quantityKey = parseFloat(data?.rewinderreels);
    }
    if (
      data.quantity_type == "reel_sheet" &&
      data.type.toLowerCase() == "sheet"
    ) {
      plannedSheetsValue = parseFloat(data.plannedQuant);
    }

    let plannedWeightValue = 0;
    if (
      ((((data.coreid &&
        data.coreid != "-" &&
        data.reelod &&
        data.reelod.length == 1) ||
        ((!data.coreid || data.coreid == "-") &&
          data.reelod &&
          data.reelod.length == 0) ||
        ((!data.coreid || data.coreid == "-") &&
          data.reelod &&
          data.reelod.length == 1) ||
        (data.coreid &&
          data.coreid != "-" &&
          data.reelod &&
          data.reelod.length == 0)) &&
        data.type?.toLowerCase() == "sheet") ||
        (((data.coreid &&
          data.coreid != "-" &&
          ((data.reelod && data.reelod.length == 1) ||
            (data.reelod &&
              data.quantity_type == "reel_sheet" &&
              data.type?.toLowerCase() == "reel"))) ||
          ((!data.coreid || data.coreid == "-") &&
            ((data.reelod && data.reelod.length == 0) ||
              (!data.reelod &&
                data.quantity_type == "reel_sheet" &&
                data.type?.toLowerCase() == "reel")) &&
            data.quantity_type != "weight") ||
          ((!data.coreid || data.coreid == "-") &&
            ((data.reelod && data.reelod.length == 0) ||
              (!data.reelod &&
                data.quantity_type == "reel_sheet" &&
                data.type?.toLowerCase() == "reel")) &&
            data.quantity_type != "weight")) &&
          data.type?.toLowerCase() == "reel")) &&
      data.id_od_type == "constant"
    ) {
      plannedWeightValue = parseFloat(data?.plannedweight?.split(" ")[0]);
    } else if (
      (((data.reelod && data.reelod.length > 1) ||
        (data.coreid && data.coreid != "-")) &&
        data.quantity_type == "weight" &&
        data.id_od_type == "constant") ||
      (data.quantity_type == "weight" && data.id_od_type == "range")
    ) {
      plannedWeightValue = data.plannedQuant
        ? parseFloat(data.plannedQuant)
        : 0;
    } else if (
      (data.id_od_type == "range" && data.quantity_type != "weight") ||
      (data.reelod &&
        data.reelod.length > 1 &&
        data.quantity_type == "reel_sheet" &&
        data.id_od_type == "constant" &&
        data.type?.toLowerCase() == "sheet")
    ) {
      plannedWeightValue = 0;
    }

    let body = {
      type: data.type?.toLowerCase(),
      length: data?.length ? parseFloat(data.length) : 0,
      width: data?.width ? parseFloat(data.width) : 0,
      ...(data.quantity_type === "weight" && {
        weight: parseFloat(data.weight),
      }),
      product: data?.productcode,
      quantity_type: data.quantity_type === "weight" ? "weight" : "reel_sheet",
      ...(data.quantity_type !== "weight" && {
        no_of_reel_sheet:
          data.no_of_reel_sheet && data.no_of_reel_sheet != "-"
            ? parseFloat(data.no_of_reel_sheet)
            : 0,
      }),
      planned_weight: plannedWeightValue,
      // planned_weight: (data.reelod && data.reelod.length == 1 && data.id_od_type == "constant") ?  parseFloat(data?.plannedweight.split(" ")[0]) : (data.quantity_type === "weight" ?  parseFloat(data.plannedQuant) : 0),
      quantity: quantityKey,
      ...(data.quantity_type === "weight" && {
        planning_weight: data.plannedQuant ? parseFloat(data.plannedQuant) : 0,
      }),
      ...(data.quantity_type !== "weight" && {
        planning_quantity: data.plannedQuant
          ? parseFloat(data.plannedQuant)
          : 0,
      }),
      planned_sheets: plannedSheetsValue,
      net_price: data.net_price ? parseFloat(data.net_price) : 0,
      dealer_price: data.dealer_price ? parseFloat(data.dealer_price) : 0,
      customer_price: data?.customer_price
        ? parseFloat(data.customer_price)
        : 0,
      id_od_type: data.id_od_type,
      inner_dia: data.coreid && data.coreid != "-" ? data.coreid : "",
      ...(data.id_od_type == "constant" && {
        outer_dia: data.reelod && data.reelod != "-" ? data.reelod : reelODArr,
      }),
      ...(data.id_od_type == "range" && {
        minimum_reel_od: data.minimum_reel_od
          ? parseFloat(data.minimum_reel_od)
          : 0,
      }),
      ...(data.id_od_type == "range" && {
        maximum_reel_od: data.maximum_reel_od
          ? parseFloat(data.maximum_reel_od)
          : 0,
      }),
      units: {
        ...data?.units,
        ...(data.id_od_type == "range" && {
          minimum_reel_od: data.units?.minimum_reel_od,
        }),
        ...(data.id_od_type == "range" && {
          maximum_reel_od: data.units?.maximum_reel_od,
        }),
      },
      length: data?.length,
      width: data?.width,
      grain: data.grain
        ? data.grain == "Short" || data.grain == "short"
          ? "short"
          : "long"
        : null,
    };

    updateOrder(data.orderno, body, "deckleRecord")
      .then((response) => {
        setActionToaster({
          error: response.error,
          msg: `Changes are successfully saved to Order ${data.orderno}`,
        });
        if (
          (((data.reelod && data.reelod.length == 0) || !data.coreid) &&
            data.type.toLowerCase() == "reel" &&
            data.quantity_type.toLowerCase == "reel_sheet") ||
          (data.reelod &&
            !data.reelod.length > 1 &&
            data.type.toLowerCase() == "sheet" &&
            data.quantity_type.toLowerCase() == "reel_sheet" &&
            data.coreid) ||
          (data.type.toLowerCase() == "reel" &&
            data.quantity_type.toLowerCase() == "weight" &&
            ((data.reelod && data.reelod.length != 1) ||
              data.id_od_type == "range")) ||
          (data.type.toLowerCase() == "sheet" &&
            data.quantity_type.toLowerCase() == "weight" &&
            ((data.reelod && data.reelod.length > 0) ||
              data.id_od_type == "range"))
        ) {
          let calculatedWeight =
            currentPlannedWeight + response.data.planned_weight;
          setTotalWeight(calculatedWeight < 0 ? 0 : calculatedWeight);
          totalRef.current = calculatedWeight < 0 ? 0 : calculatedWeight;
        }
        showToaster();
        setFilterTags([]);
        setAppliedFilters([]);
        setSearchValue("");
        setClearSearch(true);
        setRendering(true);
      })
      .catch((error) => {
        console.log("Error in updating order:", error?.response?.data);
        setActionToaster({
          error: error.response.data.error,
          msg: error.response.data.msg,
        });
        setRendering(true);
        showToaster();
      });
  };

  const onPlannedQuntyChange = (e, record, index) => {
    const pendingQty =
      record.pendingQuant?.split(" ")[0] !== ""
        ? parseFloat(record.pendingQuant?.split(" ")[0])
        : record.pendingQuant?.split(" ")[0];
    let inputValue;
    if (record?.quantity_type == "reel_sheet" && record?.type == "Sheet") {
      let enteredSheets =
        e.target.value !== "" ? parseFloat(e.target.value) : e.target.value;
      let weightOfSheets = 0;
      let dimConversion = CoversionFactorUnitsToCM[record.units.width];
      weightOfSheets =
        (record?.length *
          dimConversion *
          (record?.width * dimConversion) *
          record.product_info.gsm *
          enteredSheets) /
        (10000 * 1000000);
      let weightInTonne =
        weightOfSheets *
        conversionFactorUnitsToTonne[
        record.total_pending_quantity.units.weight
        ];
      inputValue = weightInTonne;
    } else {
      inputValue =
        e.target.value !== "" ? parseFloat(e.target.value) : e.target.value;
    }
    const hasError =
      isNaN(inputValue) ||
      inputValue === 0 ||
      inputValue === "" ||
      (pendingQty && inputValue > 0 && inputValue > pendingQty);
    const orderno = record?.orderno;
    if ((plannedQuantityErr[orderno]?.error || false) !== hasError) {
      const tempPlannedQuntyErr = { ...plannedQuantityErr };
      tempPlannedQuntyErr[orderno] = { error: hasError };
      //setPlannedQuantityErr(tempPlannedQuntyErr);
      setTableRerender(true);
    }
  };

  const onPlannedReelChange = (e, record, index) => {
    let inputValue;

    inputValue =
      e.target.value !== "" ? parseFloat(e.target.value) : e.target.value;
    const hasError = isNaN(inputValue) || inputValue === 0 || inputValue === "";
    const orderno = record?.orderno;
    if ((plannedReelErr[orderno]?.error || false) !== hasError) {
      const tempPlannedReelErr = { ...plannedReelErr };
      tempPlannedReelErr[orderno] = { error: hasError };
      setPlannedReelErr(tempPlannedReelErr);
      setTableRerender(true);
    }
  };

  const onValitdateQtyChange = (e, record, index) => {
    let inputValue;
    if (record?.quantity_type == "reel_sheet" && record?.type == "Sheet") {
      let enteredSheets = e !== "" ? parseFloat(e) : e;
      let weightOfSheets = 0;
      let dimConversion = CoversionFactorUnitsToCM[record.units.width];
      weightOfSheets =
        (record?.length *
          dimConversion *
          (record?.width * dimConversion) *
          record.product_info.gsm *
          enteredSheets) /
        (10000 * 1000000);
      let weightInTonne =
        weightOfSheets *
        conversionFactorUnitsToTonne[
        record.total_pending_quantity.units.weight
        ];
      inputValue = weightInTonne;
    } else {
      inputValue = e !== "" ? parseFloat(e) : e;
    }
    return inputValue;
  };

  const onPlannedReelActionChange = (index, action, data) => {
    if (action == "remove") {
      form.setFieldsValue({
        [`rewinderreels${data.orderno}`]: data.plannedQuant,
      });
      let dataSourceCopy = tableData;
      let record = dataSourceCopy[index];
      record.rewinderreels = data.rewinderreels;
      dataSourceCopy[index] = record;
      setTableData([...dataSourceCopy]);
      tableDataRef.current = [...dataSourceCopy];
    } else {
      let enteredReels = form.getFieldValue(`rewinderreels${data.orderno}`);
      removeDeslectedQuantity(data)
      calculatePlannedWeightByChangedPlannedReel(
        index,
        data,
        data.plannedQuant,
        data.reelod,
        data.coreid,
        parseFloat(enteredReels)
      );
    }
    if (!isReelEditClicked.hasOwnProperty(data?.orderno)) {
      isReelEditClicked[data?.orderno] = {};
    }
    isReelEditClicked[data?.orderno].isEditable = false;
    setReelIsEditClicked(isReelEditClicked);
    setTableRerender(true);
    addSelectedQuantity(data);

  };

  // const calculatePlannedWeightByChangedPlannedReel = (
  //   index,
  //   data,
  //   orderQuantity,
  //   reelOd,
  //   coreOd,
  //   plannedReel
  // ) => {
  //   let calculatedPlannedWt;

  //   if (reelOd && reelOd.length == 1 && coreOd && data.width) {
  //     calculatedPlannedWt = plannedWeightCalculation(
  //       index,
  //       data,
  //       orderQuantity,
  //       reelOd,
  //       coreOd,
  //       plannedReel
  //     );
  //   } else if (
  //     !coreOd ||
  //     (!reelOd && !reelOd.length) ||
  //     coreOd ||
  //     (!reelOd && !reelOd.length) ||
  //     ((!coreOd || (reelOd && reelOd.length)) && data.type == "Sheet")
  //   ) {
  //     if (data.type == "Sheet" && data.quantity_type === "weight") {
  //       if (orderQuantity) {
  //         calculatedPlannedWt = parseFloat(orderQuantity).toFixed(3);
  //       } else {
  //         calculatedPlannedWt = 0;
  //       }
  //     } else {
  //       let weightUnit = data?.units?.planned_weight;

  //       let dimensionUnit = data?.units?.width;
  //       let conversionValue = orderDim_Rewinder_Unit_Conversion[dimensionUnit];

  //       let length_Value = data.length * conversionValue;
  //       let width_Value = data.width * conversionValue;

  //       const value =
  //         (length_Value *
  //           width_Value *
  //           orderQuantity *
  //           data?.product_info?.gsm) /
  //         (10000 * 1000000);
  //       let plannedWeightValue =
  //         value * conversionFactorTonneToUnits[weightUnit];
  //       calculatedPlannedWt = plannedWeightValue
  //         ? plannedWeightValue.toFixed(3)
  //         : 0;
  //     }
  //   } else {
  //     calculatedPlannedWt = 0;
  //   }

  //   let calculatedNetPrice;
  //   let requiredWeightValue;
  //   if (data?.product_info) {
  //     let plannedWtConversion;
  //     let unitPlaceholder = data.units?.planned_weight;
  //     let priceUnit = data?.units?.per_weight_unit;
  //     if (data.quantity_type == "weight") {
  //       requiredWeightValue = data.weight;
  //     } else {
  //       requiredWeightValue = calculatedPlannedWt ? calculatedPlannedWt : 0;
  //     }
  //     if (unitPlaceholder?.toLowerCase() !== priceUnit?.toLowerCase()) {
  //       let unitToTonneConv =
  //         requiredWeightValue * weight_Unit_Conversions[unitPlaceholder];
  //       plannedWtConversion =
  //         unitToTonneConv * conversionFactorTonneToUnits[priceUnit];
  //     } else {
  //       plannedWtConversion = requiredWeightValue;
  //     }
  //     calculatedNetPrice =
  //       parseFloat(data.price) * parseFloat(plannedWtConversion)
  //         ? (parseFloat(data.price) * parseFloat(plannedWtConversion))?.toFixed(
  //             3
  //           )
  //         : "";
  //   }

  //   let dataSourceCopy = tableData;
  //   let record = dataSourceCopy[index];
  //   record.net_price = calculatedNetPrice;
  //   // let currentPlannedWeight = (totalWeight - record.plannedweight.split(" ")[0]) + calculatedPlannedWt;
  //   // setTotalWeight(currentPlannedWeight);
  //   record.rewinderreels = Math.round(plannedReel?.toFixed(3))
  //     ? Math.round((plannedReel * 1).toFixed(3))
  //     : 1;
  //   record.plannedweight =
  //     calculatedPlannedWt +
  //     " " +
  //     weightUnit[record?.units?.weight]?.displayName?.toUpperCase();

  //   record.plannedQuantity = parseFloat(orderQuantity);
  //   dataSourceCopy[index] = { ...record };
  //   setTableData([...dataSourceCopy]);
  //   tableDataRef.current = [...dataSourceCopy];
  //   if (orderType === "selected_orders") {
  //     saveOrder(index, record);
  //   } else if(isAddRewinderDimension) {
  //     saveIncompleteOrder();
  //   }  };

  const calculatePlannedWeightByChangedPlannedReel = (
    index,
    data,
    orderQuantity,
    reelOd,
    coreOd,
    plannedReel
  ) => {
    let calculatedPlannedWt;
    let currentPlannedWeight;
    if (
      reelOd != "-" &&
      reelOd &&
      reelOd?.length == 1 &&
      coreOd != "-" &&
      coreOd &&
      data.width
    ) {
      calculatedPlannedWt = plannedWeightCalculation(
        index,
        data,
        orderQuantity,
        reelOd,
        coreOd,
        plannedReel
      );
    } else if (
      (!coreOd || (!reelOd && !reelOd?.length)) &&
      data.type == "Sheet"
    ) {
      if (data.type == "Sheet" && data.quantity_type === "weight") {
        if (orderQuantity) {
          calculatedPlannedWt = parseFloat(orderQuantity).toFixed(3);
        } else {
          calculatedPlannedWt = 0;
        }
      } else {
        let weightUnit = data?.units?.planned_weight;

        let dimensionUnit = data?.units?.width;
        let conversionValue = orderDim_Rewinder_Unit_Conversion[dimensionUnit];

        let length_Value = data.length * conversionValue;
        let width_Value = data.width * conversionValue;

        const value =
          (length_Value *
            width_Value *
            orderQuantity *
            data?.product_info?.gsm) /
          (10000 * 1000000);
        let plannedWeightValue =
          value * conversionFactorTonneToUnits[weightUnit];
        calculatedPlannedWt = plannedWeightValue
          ? plannedWeightValue.toFixed(3)
          : 0;
      }
    } else {
      calculatedPlannedWt = data.plannedQuant;
    }

    let dataSourceCopy = [...tableData];
    let record = dataSourceCopy[index];
    let calculatedNetPrice;
    let requiredWeightValue;
    if (data?.product_info) {
      let plannedWtConversion;
      let unitPlaceholder = data.units?.planned_weight;
      let priceUnit = data?.units?.per_weight_unit;
      if (data.quantity_type == "weight") {
        requiredWeightValue = data.weight;
      } else {
        requiredWeightValue = calculatedPlannedWt ? calculatedPlannedWt : 0;
      }
      if (unitPlaceholder?.toLowerCase() !== priceUnit?.toLowerCase()) {
        let unitToTonneConv =
          requiredWeightValue * weight_Unit_Conversions[unitPlaceholder];
        plannedWtConversion =
          unitToTonneConv * conversionFactorTonneToUnits[priceUnit];
      } else {
        plannedWtConversion = requiredWeightValue;
      }
      calculatedNetPrice =
        parseFloat(data.price) * parseFloat(plannedWtConversion)
          ? (parseFloat(data.price) * parseFloat(plannedWtConversion))?.toFixed(
            3
          )
          : "";
    }

    if (coreOd && reelOd && reelOd.length == 1) {
      record.calculatedreels = parseFloat(plannedReel)?.toFixed(3);
      record.rewinderreels = Math.round(parseFloat(plannedReel)?.toFixed(3))
        ? Math.round(parseFloat(plannedReel * 1)?.toFixed(3))
        : 1;
    } else {
      if (data.type == "Reel" && data.quantity_type === "reel_sheet") {
        record.calculatedreels = plannedReel;
        record.rewinderreels = plannedReel;
      } else {
        record.calculatedReels = plannedReel;
        record.rewinderreels = plannedReel;
      }
    }
    // let currentPlannedWeight = (totalWeight - record.plannedweight.split(" ")[0]) + calculatedPlannedWt;
    // setTotalWeight(currentPlannedWeight);
    record.plannedweight =
      parseFloat(calculatedPlannedWt) +
      " " +
      capitalize(weightUnit[record?.units?.planned_weight]?.displayName);
    record.plannedQuant = parseFloat(orderQuantity);
    record.net_price = calculatedNetPrice;
    dataSourceCopy[index] = { ...record };

    if (orderType == "other_orders") {
      let selectedDataCopy = [...selectedDataRows];
      let selectedDataIndex = selectedDataRows?.findIndex(
        (ele) => ele.id == data.orderno
      );
      let selectedOrderRow = selectedDataCopy[selectedDataIndex];
      if (selectedOrderRow) {
        if (coreOd && reelOd && reelOd.length == 1) {
          currentPlannedWeight =
            totalRef.current -
            (tableData[index].plannedweight != "-" &&
              tableData[index].plannedweight != ""
              ? parseFloat(tableData[index].plannedweight.split(" ")[0]) *
              conversionFactorUnitsToTonne[
              tableData[index].units.planned_weight
              ] *
              conversionFactorTonneToUnits[
              unitData.units_management.weight.default
              ]
              : 0) +
            parseFloat(
              calculatedPlannedWt *
              conversionFactorUnitsToTonne[
              tableData[index].units.planned_weight
              ] *
              conversionFactorTonneToUnits[
              unitData.units_management.weight.default
              ]
            );
          setTotalWeight(currentPlannedWeight < 0 ? 0 : currentPlannedWeight);
          totalRef.current =
            currentPlannedWeight < 0 ? 0 : currentPlannedWeight;
          selectedOrderRow.calculatedreels =
            parseFloat(plannedReel)?.toFixed(3);
          selectedOrderRow.rewinderreels = Math.round(
            parseFloat(plannedReel)?.toFixed(3)
          )
            ? Math.round(parseFloat(plannedReel * 1)?.toFixed(3))
            : 1;
        } else {
          currentPlannedWeight =
            totalRef.current -
            (tableData[index].plannedweight != "-" &&
              tableData[index].plannedweight != ""
              ? parseFloat(tableData[index].plannedweight.split(" ")[0]) *
              conversionFactorUnitsToTonne[
              tableData[index].units.planned_weight
              ] *
              conversionFactorTonneToUnits[
              unitData.units_management.weight.default
              ]
              : 0) +
            parseFloat(
              calculatedPlannedWt *
              conversionFactorUnitsToTonne[
              tableData[index].units.planned_weight
              ] *
              conversionFactorTonneToUnits[
              unitData.units_management.weight.default
              ]
            );
          setTotalWeight(currentPlannedWeight < 0 ? 0 : currentPlannedWeight);
          totalRef.current =
            currentPlannedWeight < 0 ? 0 : currentPlannedWeight;
          if (data.type == "Reel" && data.quantity_type === "reel_sheet") {
            selectedOrderRow.calculatedreels = plannedReel;
            selectedOrderRow.rewinderreels = plannedReel;
          } else {
            selectedOrderRow.calculatedReels = plannedReel;
            selectedOrderRow.rewinderreels = plannedReel;
          }
        }
        selectedOrderRow.plannedweight =
          parseFloat(calculatedPlannedWt) +
          " " +
          capitalize(weightUnit[record?.units?.planned_weight]?.displayName);
        selectedOrderRow.plannedQuant = parseFloat(orderQuantity);
        selectedOrderRow.net_price = calculatedNetPrice;
        if (data.id_od_type == "range") {
          selectedOrderRow.maximum_reel_od = data.maximum_reel_od;
          selectedOrderRow.minimum_reel_od = data.minimum_reel_od;
        } else {
          selectedOrderRow.outer_dia = data.outer_dia;
          selectedOrderRow.reelod = data.reelod;
        }
        selectedOrderRow.inner_dia = data.inner_dia;
        selectedOrderRow.coreid = data.coreid;

        selectedDataCopy[selectedDataIndex] = { ...selectedOrderRow };

        setSelectedDataRows([...selectedDataCopy]);
      }
    } else {
      let selectedDataCopy = [...selectedDataRows];
      let selectedDataIndex = selectedDataRows?.findIndex(
        (ele) => ele.id == data.orderno
      );
      let selectedOrderRow = selectedDataCopy[selectedDataIndex];
      if (selectedOrderRow) {
        if (coreOd && reelOd && reelOd.length == 1) {
          currentPlannedWeight =
            totalRef.current -
            (tableData[index].plannedweight != "-" &&
              tableData[index].plannedweight != ""
              ? parseFloat(tableData[index].plannedweight.split(" ")[0]) *
              conversionFactorUnitsToTonne[
              tableData[index].units.planned_weight
              ] *
              conversionFactorTonneToUnits[
              unitData.units_management.weight.default
              ]
              : 0) +
            parseFloat(
              calculatedPlannedWt *
              conversionFactorUnitsToTonne[
              tableData[index].units.planned_weight
              ] *
              conversionFactorTonneToUnits[
              unitData.units_management.weight.default
              ]
            );
          setTotalWeight(currentPlannedWeight < 0 ? 0 : currentPlannedWeight);
          totalRef.current =
            currentPlannedWeight < 0 ? 0 : currentPlannedWeight;
        } else {
          currentPlannedWeight =
            totalRef.current -
            (tableData[index].plannedweight != "-" &&
              tableData[index].plannedweight != ""
              ? parseFloat(tableData[index].plannedweight.split(" ")[0]) *
              conversionFactorUnitsToTonne[
              tableData[index].units.planned_weight
              ] *
              conversionFactorTonneToUnits[
              unitData.units_management.weight.default
              ]
              : 0) +
            parseFloat(
              calculatedPlannedWt *
              conversionFactorUnitsToTonne[
              tableData[index].units.planned_weight
              ] *
              conversionFactorTonneToUnits[
              unitData.units_management.weight.default
              ]
            );
          setTotalWeight(currentPlannedWeight < 0 ? 0 : currentPlannedWeight);
          totalRef.current =
            currentPlannedWeight < 0 ? 0 : currentPlannedWeight;
        }
      }
    }
    setTableData([...dataSourceCopy]);
    tableDataRef.current = [...dataSourceCopy];
    if (orderType === "selected_orders") {
      saveOrder(
        index,
        record,
        currentPlannedWeight < 0 ? 0 : currentPlannedWeight
      );
    } else if (isAddRewinderDimension) {
      saveIncompleteOrder();
    }
  };

  const saveIncompleteOrder = () => {
    let selectedOrdersData = [...selectedDataRows];
    let requestOrdersArray = [];
    for (let i = 0; i < selectedOrdersData?.length; i++) {
      let record = selectedOrdersData[i];
      let quantityKey = 0;
      let plannedSheetsValue = 0;
      let reelODArr = [];
      if (
        (record.reelod && record.reelod.length == 1) ||
        (record.quantity_type == "reel_sheet" &&
          record.type.toLowerCase() == "reel")
      ) {
        quantityKey = parseFloat(record.rewinderreels);
      }
      if (
        record.quantity_type == "reel_sheet" &&
        record.type.toLowerCase() == "sheet"
      ) {
        plannedSheetsValue = parseFloat(record.plannedQuant);
      }

      let plannedWeightValue = 0;
      if (
        ((((record.coreid &&
          record.coreid != "-" &&
          record.reelod &&
          record.reelod.length == 1) ||
          ((!record.coreid || record.coreid == "-") &&
            record.reelod &&
            record.reelod.length == 0) ||
          ((!record.coreid || record.coreid == "-") &&
            record.reelod &&
            record.reelod.length == 1) ||
          (record.coreid &&
            record.coreid != "-" &&
            record.reelod &&
            record.reelod.length == 0)) &&
          record.type?.toLowerCase() == "sheet") ||
          (((record.coreid &&
            record.coreid != "-" &&
            ((record.reelod && record.reelod.length == 1) ||
              (record.reelod &&
                record.quantity_type == "reel_sheet" &&
                record.type?.toLowerCase() == "reel"))) ||
            ((!record.coreid || record.coreid == "-") &&
              ((record.reelod && record.reelod.length == 0) ||
                (!record.reelod &&
                  record.quantity_type == "reel_sheet" &&
                  record.type?.toLowerCase() == "reel")) &&
              record.quantity_type != "weight") ||
            ((!record.coreid || record.coreid == "-") &&
              ((record.reelod && record.reelod.length == 0) ||
                (!record.reelod &&
                  record.quantity_type == "reel_sheet" &&
                  record.type?.toLowerCase() == "reel")) &&
              record.quantity_type != "weight")) &&
            record.type?.toLowerCase() == "reel")) &&
        record.id_od_type == "constant"
      ) {
        plannedWeightValue = parseFloat(record?.plannedweight?.split(" ")[0]);
      } else if (
        (((record.reelod && record.reelod.length > 1) ||
          (record.coreid && record.coreid != "-")) &&
          record.quantity_type == "weight" &&
          record.id_od_type == "constant") ||
        (record.quantity_type == "weight" && record.id_od_type == "range")
      ) {
        plannedWeightValue = record.plannedQuant
          ? parseFloat(record.plannedQuant)
          : 0;
      } else if (
        (record.id_od_type == "range" && record.quantity_type != "weight") ||
        (record.reelod &&
          record.reelod.length > 1 &&
          record.quantity_type == "reel_sheet" &&
          record.id_od_type == "constant" &&
          record.type?.toLowerCase() == "sheet")
      ) {
        plannedWeightValue = 0;
      }

      let requestPayload = {
        order: record.orderno,
        id_od_type: record.id_od_type,
        quantity_type:
          record.quantity_type === "weight" ? "weight" : "reel_sheet",
        inner_dia: record.coreid && record.coreid != "-" ? record.coreid : "",
        ...(record.id_od_type == "constant" && {
          outer_dia:
            record.reelod && record.reelod != "-" ? record.reelod : reelODArr,
        }),
        ...(record.quantity_type === "weight" && {
          planning_weight: record.plannedQuant
            ? parseFloat(record.plannedQuant)
            : 0,
        }),
        ...(record.quantity_type !== "weight" && {
          planning_quantity: record.plannedQuant
            ? parseFloat(record.plannedQuant)
            : 0,
        }),
        planned_sheets: plannedSheetsValue,
        type: record.type.toLowerCase(),
        quantity: quantityKey,
        ...(record.quantity_type !== "weight" && {
          no_of_reel_sheet:
            record.no_of_reel_sheet && record.no_of_reel_sheet != "-"
              ? parseFloat(record.no_of_reel_sheet)
              : 0,
        }),
        // planned_weight: (record.reelod && record.reelod.length == 1 && record.id_od_type == "constant") ?  parseFloat(record?.plannedweight.split(" ")[0]) : (record.quantity_type === "weight" ?  parseFloat(record.plannedQuant) : 0),
        planned_weight: plannedWeightValue,
        net_price: record.net_price ? parseFloat(record.net_price) : 0,
        dealer_price: record.dealer_price ? parseFloat(record.dealer_price) : 0,
        ...(record.id_od_type == "range" && {
          minimum_reel_od: record.minimum_reel_od
            ? parseFloat(record.minimum_reel_od)
            : 0,
        }),
        ...(record.id_od_type == "range" && {
          maximum_reel_od: record.maximum_reel_od
            ? parseFloat(record.maximum_reel_od)
            : 0,
        }),
        units: {
          ...record?.units,
          ...(record.id_od_type == "range" && {
            minimum_reel_od: record.units?.minimum_reel_od
              ? record.units?.minimum_reel_od
              : "cm",
          }),
          ...(record.id_od_type == "range" && {
            maximum_reel_od: record.units?.maximum_reel_od
              ? record.units?.maximum_reel_od
              : "cm",
          }),
        },
        length: record?.length,
        width: record?.width,
        grain: record.grain
          ? record.grain == "Short" || record.grain == "short"
            ? "short"
            : "long"
          : null,
      };
      requestOrdersArray.push(requestPayload);
    }
    setPayload([...requestOrdersArray]);
  };

  const handleTabChange = (key) => {
    setLoading(true);
    setDefaultActiveKey(key.toString());
    setIsTabChange(true);
    //setLoading(true);
    // setTableData([]);
    setFilterTags([]);
    setAppliedFilters([]);
    setSearchValue("");
    setClearSearch(true);
    setOrderType(tabHeads[key].state);
    form.resetFields();
    setSelectedDia("constant");
    setSelectedReelOD([]);
    if (tabHeads[key].state == "selected_orders") {
      setIsMoveToselection(false);
      setIsAddRewinderDimension(false);
    }
    setSelectedDataRows([]);
    setSelectedRowKeys([]);
    setTotalWeight(0);
    totalRef.current = 0;
    setIsAllSelected(false);
    // setAppliedFilters([]);
    setPaginationParams({
      page: 1,
      size: settingsData?.settings?.default_page_size || 10,
      sort_by: "updated_at",
      sort_type: "descending",
    });
    paginationParamsRef.current = {
      page: 1,
      size: settingsData?.settings?.default_page_size || 10,
      sort_by: "updated_at",
      sort_type: "descending",
    };
    // paginationRef.current = {
    //   page: 1,
    //   size: 10,
    // };
    setCurrentPage(1);
    setTableData([]);
    setRendering(true);
  };

  const addSelectedQuantity = (record) => {
    if (Array.isArray(record)) {

      let sum = totalRef.current;
      record.forEach((element) => {
        // element.quantity_type === 'weight' ? sum = sum + parseFloat(element.weight) : sum = sum + parseFloat(element.plannedweight);
        sum =
          sum +
          (element.plannedweight !== "-" && element.plannedweight !== ""
            ? parseFloat(
              parseFloat(element.plannedweight.split(" ")[0]) *
              conversionFactorUnitsToTonne[element.units.planned_weight] *
              conversionFactorTonneToUnits[
              unitData.units_management.weight.default
              ]
            )
            : 0);
      });
      setTotalWeight(sum);
      totalRef.current = sum;
    } else {

      // record.quantity_type === 'weight' ? setSelectedQuantity(selectedQuantity + parseFloat(record.weight)) : setSelectedQuantity(selectedQuantity + parseFloat(record.plannedweight));
      setTotalWeight(
        totalRef.current +
        (record.plannedweight !== "-" && record.plannedweight !== ""
          ? parseFloat(
            parseFloat(record.plannedweight.split(" ")[0]) *
            conversionFactorUnitsToTonne[record.units.planned_weight] *
            conversionFactorTonneToUnits[
            unitData.units_management.weight.default
            ]
          )
          : 0)
      );
      totalRef.current =
        totalRef.current +
        (record.plannedweight !== "-" && record.plannedweight !== ""
          ? parseFloat(
            parseFloat(record.plannedweight.split(" ")[0]) *
            conversionFactorUnitsToTonne[record.units.planned_weight] *
            conversionFactorTonneToUnits[
            unitData.units_management.weight.default
            ]
          )
          : 0);
    }
  };

  const removeDeslectedQuantity = (record) => {
    if (Array.isArray(record)) {
      let sum = totalRef.current;
      record.forEach((element) => {
        // element.quantity_type === 'weight' ? sum = sum - parseFloat(element.weight) : sum = sum - parseFloat(element.plannedweight);

        sum =
          sum -
          parseFloat(
            element.plannedweight !== "-" && element.element !== ""
              ? parseFloat(element.plannedweight.split(" ")[0]) *
              conversionFactorUnitsToTonne[element.units.planned_weight] *
              conversionFactorTonneToUnits[
              unitData.units_management.weight.default
              ]
              : 0
          );
      });
      sum > 0 ? setTotalWeight(sum) : setTotalWeight(0);
      sum > 0 ? (totalRef.current = sum) : (totalRef.current = 0);
    } else {
      // record.quantity_type === 'weight' ? setSelectedQuantity(selectedQuantity - parseFloat(record.weight)) : setSelectedQuantity(selectedQuantity - parseFloat(record.plannedweight));
      setTotalWeight(
        totalRef.current -
        parseFloat(
          record.plannedweight !== "-" && record.element !== ""
            ? parseFloat(record.plannedweight.split(" ")[0]) *
            conversionFactorUnitsToTonne[record.units.planned_weight] *
            conversionFactorTonneToUnits[
            unitData.units_management.weight.default
            ]
            : 0
        )
      );
      totalRef.current =
        totalRef.current -
        parseFloat(
          record.plannedweight !== "-" && record.element !== ""
            ? parseFloat(record.plannedweight.split(" ")[0]) *
            conversionFactorUnitsToTonne[record.units.planned_weight] *
            conversionFactorTonneToUnits[
            unitData.units_management.weight.default
            ]
            : 0
        );
    }
  };

  const onAddRewinderDimension = () => {
    setIsAddRewinderDimension(true);
    setIsMoveToselection(false);
    form.setFieldsValue({
      core_Dia: reelCoreData.default_core_id
        ? reelCoreData.default_core_id + " " + reelCoreData.default_core_unit
        : "",
    });
    form.setFieldsValue({
      range_unit: measurementData.data.units_management.length.default,
    });
    reelCoreData?.default_reel_od
      ? setSelectedReelOD([
        {
          value:
            reelCoreData?.default_reel_od +
            " " +
            reelCoreData?.default_reel_unit,
        },
      ])
      : setSelectedReelOD([]);
  };

  const onMoveToSelection = () => {
    let isReelCorePresent = true;

    let selectedRowsCopy = [...selectedDataRows];

    if (location?.state?.selected_type === "rewinding") {
      for (let index = 0; index < selectedDataRows.length; index++) {
        const order = selectedDataRows[index];

        let coreOd = order.coreid || order.inner_dia;
        let reelOd = order.reelod || order.outer_dia;

        if (
          !order.id_od_type ||
          (order.id_od_type == "constant" &&
            (!reelOd?.length || reelOd.includes("-") || !coreOd || coreOd === "-")) ||
          (order.id_od_type == "range" &&
            (!order.maximum_reel_od || !order.minimum_reel_od || !coreOd || coreOd === "-"))
        ) {
          isReelCorePresent = false;
        }
      }
    } else {
      for (let index = 0; index < selectedRowsCopy.length; index++) {
        selectedRowsCopy[index].reelod = [];
        selectedRowsCopy[index].coreid = "";
        selectedRowsCopy[index].inner_dia = "";
        selectedRowsCopy[index].outer_dia = [];
        selectedRowsCopy[index].maximum_reel_od = 0;
        selectedRowsCopy[index].minimum_reel_od = 0;
        selectedRowsCopy[index] = plannedReelsCalnForCutterOrders(
          selectedRowsCopy[index],
          { ...selectedRowsCopy[index] },
          selectedRowsCopy[index].plannedQuant,
          selectedRowsCopy[index].outer_dia,
          selectedRowsCopy[index].inner_dia,
          "incomplete_orders"
        );
      }
    }

    if (isReelCorePresent) {
      let selectedOrders = selectedRowsCopy.map((data) => {
        let quantityKey = 0;
        let plannedSheetsValue = 0;
        let reelODArr = [];
        if (
          (data.reelod && data.reelod.length == 1) ||
          (data.type?.toLowerCase() == "reel" &&
            data.quantity_type == "reel_sheet")
        ) {
          quantityKey = parseFloat(data?.rewinderreels);
        }
        if (
          data.quantity_type == "reel_sheet" &&
          data.type.toLowerCase() == "sheet"
        ) {
          plannedSheetsValue = parseFloat(data.plannedQuant);
        }

        let plannedWeightValue = 0;
        if (
          ((((data.coreid &&
            data.coreid != "-" &&
            data.reelod &&
            data.reelod.length == 1) ||
            ((!data.coreid || data.coreid == "-") &&
              data.reelod &&
              data.reelod.length == 0) ||
            ((!data.coreid || data.coreid == "-") &&
              data.reelod &&
              data.reelod.length == 1) ||
            (data.coreid &&
              data.coreid != "-" &&
              data.reelod &&
              data.reelod.length == 0)) &&
            data.type?.toLowerCase() == "sheet") ||
            (((data.coreid &&
              data.coreid != "-" &&
              ((data.reelod && data.reelod.length == 1) ||
                (data.reelod &&
                  data.quantity_type == "reel_sheet" &&
                  data.type?.toLowerCase() == "reel"))) ||
              ((!data.coreid || data.coreid == "-") &&
                ((data.reelod && data.reelod.length == 0) ||
                  (!data.reelod &&
                    data.quantity_type == "reel_sheet" &&
                    data.type?.toLowerCase() == "reel")) &&
                data.quantity_type != "weight") ||
              ((!data.coreid || data.coreid == "-") &&
                ((data.reelod && data.reelod.length == 0) ||
                  (!data.reelod &&
                    data.quantity_type == "reel_sheet" &&
                    data.type?.toLowerCase() == "reel")) &&
                data.quantity_type != "weight")) &&
              data.type?.toLowerCase() == "reel")) &&
          data.id_od_type == "constant"
        ) {
          plannedWeightValue = parseFloat(data?.plannedweight?.split(" ")[0]);
        } else if (
          (((data.reelod && data.reelod.length > 1) ||
            (data.coreid && data.coreid != "-")) &&
            data.quantity_type == "weight" &&
            data.id_od_type == "constant") ||
          (data.quantity_type == "weight" && data.id_od_type == "range")
        ) {
          plannedWeightValue = data.plannedQuant
            ? parseFloat(data.plannedQuant)
            : 0;
        } else if (
          (data.id_od_type == "range" && data.quantity_type != "weight") ||
          (data.reelod &&
            data.reelod.length > 1 &&
            data.quantity_type == "reel_sheet" &&
            data.id_od_type == "constant" &&
            data.type?.toLowerCase() == "sheet")
        ) {
          plannedWeightValue = 0;
        }

        let body = {
          id: data.orderno,
          type: data.type?.toLowerCase(),
          length: data?.length ? parseFloat(data.length) : 0,
          width: data?.width ? parseFloat(data.width) : 0,
          ...(data.quantity_type === "weight" && {
            weight: parseFloat(data.weight),
          }),
          product: data?.productcode,
          quantity_type:
            data.quantity_type === "weight" ? "weight" : "reel_sheet",
          ...(data.quantity_type !== "weight" && {
            no_of_reel_sheet:
              data.no_of_reel_sheet && data.no_of_reel_sheet != "-"
                ? parseFloat(data.no_of_reel_sheet)
                : 0,
          }),
          planned_weight: plannedWeightValue,
          // planned_weight: (data.reelod && data.reelod.length == 1 && data.id_od_type == "constant") ?  parseFloat(data?.plannedweight.split(" ")[0]) : (data.quantity_type === "weight" ?  parseFloat(data.plannedQuant) : 0),
          quantity: quantityKey,
          ...(data.quantity_type === "weight" && {
            planning_weight: data.plannedQuant
              ? parseFloat(data.plannedQuant)
              : 0,
          }),
          ...(data.quantity_type !== "weight" && {
            planning_quantity: data.plannedQuant
              ? parseFloat(data.plannedQuant)
              : 0,
          }),
          planned_sheets: plannedSheetsValue,
          net_price: data.net_price ? parseFloat(data.net_price) : 0,
          dealer_price: data.dealer_price ? parseFloat(data.dealer_price) : 0,
          customer_price: data?.customer_price
            ? parseFloat(data.customer_price)
            : 0,
          id_od_type: data.id_od_type,
          inner_dia: data.coreid && data.coreid != "-" ? data.coreid : "",
          ...(data.id_od_type == "constant" && {
            outer_dia:
              data.reelod && data.reelod != "-" ? data.reelod : reelODArr,
          }),
          ...(data.id_od_type == "range" && {
            minimum_reel_od: data.minimum_reel_od
              ? parseFloat(data.minimum_reel_od)
              : 0,
          }),
          ...(data.id_od_type == "range" && {
            maximum_reel_od: data.maximum_reel_od
              ? parseFloat(data.maximum_reel_od)
              : 0,
          }),
          units: {
            ...data?.units,
            ...(data.id_od_type == "range" && {
              minimum_reel_od: data.units?.minimum_reel_od,
            }),
            ...(data.id_od_type == "range" && {
              maximum_reel_od: data.units?.maximum_reel_od,
            }),
          },
          length: data?.length,
          width: data?.width,
        };
        return body;
      });

      saveBulkDeckleOrders(selectedOrders)
        .then((response) => {

          setMovedOrder(response.data);
          if (location?.state?.selected_type === "cutting")
            setOrderMoveToSelect([...selectedRowKeys]);

          setActionToaster({
            error: response.error,
            msg: response.msg,
          });
          showToaster();
          setFilterTags([]);
          setAppliedFilters([]);
          setSearchValue("");
          setClearSearch(true);
          form.resetFields();
          setSelectedDia("constant");
          setSelectedReelOD([]);
          setIsMoveToselection(true);
          setIsAddRewinderDimension(false);
          // setAppliedFilters([]);
          setPaginationParams({
            page: 1,
            size: settingsData?.settings?.default_page_size || 10,
            sort_by: "updated_at",
            sort_type: "descending",
          });
          setTotalWeight(0);
          totalRef.current = 0;
          setSelectedDataRows([]);
          setSelectedRowKeys([]);
          setCurrentPage(1);
          setIsAllSelected(false);
          setRendering(true);
        })
        .catch((error) => {
          console.log("Error in updating order:", error?.response?.data);
          setActionToaster({
            error: true,
            msg: "Error in updating order",
          });
          setRendering(true);
          showToaster();
        });
    } else {
      setActionToaster({
        error: true,
        msg: `Reel od and core id are not presents for some orders`,
      });
      showToaster();
    }
  };

  const plannedReelsCalnForCutterOrders = (
    index,
    { ...data },
    orderQuantity,
    reelOd,
    coreOd
  ) => {
    let calculatedReels;
    let calculatedPlannedWt;
    let updatedData = JSON.parse(JSON.stringify(data));
    if (
      reelOd != "-" &&
      reelOd &&
      reelOd?.length == 1 &&
      coreOd != "-" &&
      coreOd &&
      data.width
    ) {
      calculatedReels = rewinderReelsCal(
        index,
        data,
        orderQuantity,
        reelOd,
        coreOd
      );
      let reels = Math.round(parseFloat(calculatedReels)?.toFixed(3))
        ? Math.round(parseFloat(calculatedReels * 1)?.toFixed(3))
        : 1;
      calculatedPlannedWt = plannedWeightCalculation(
        index,
        data,
        orderQuantity,
        reelOd,
        coreOd,
        reels
      );
    } else if (
      // ((!coreOd || coreOd == "-") || (!reelOd && !reelOd?.length)) && data.type == "Sheet"
      ((coreOd && coreOd != "-" && reelOd && reelOd.length == 1) ||
        ((!coreOd || coreOd == "-") && reelOd && reelOd.length == 0) ||
        ((!coreOd || coreOd == "-") && reelOd && reelOd.length == 1) ||
        (coreOd && coreOd != "-" && reelOd && reelOd.length == 0)) &&
      data.type?.toLowerCase() == "sheet"
    ) {
      if (data.type == "Sheet" && data.quantity_type === "weight") {
        if (orderQuantity) {
          calculatedReels = 0;
          calculatedPlannedWt = parseFloat(orderQuantity).toFixed(3);
        } else {
          calculatedReels = 0;
          calculatedPlannedWt = 0;
        }
      } else {
        let weightUnit = data?.units?.planned_weight;

        let dimensionUnit = data?.units?.width;
        let conversionValue = orderDim_Rewinder_Unit_Conversion[dimensionUnit];

        let length_Value = data.length * conversionValue;
        let width_Value = data.width * conversionValue;

        if (selecteDia == "constant") {
          const value =
            (length_Value *
              width_Value *
              orderQuantity *
              data?.product_info?.gsm) /
            (10000 * 1000000);
          let plannedWeightValue =
            value * conversionFactorTonneToUnits[weightUnit];
          calculatedReels = 0;
          calculatedPlannedWt = plannedWeightValue
            ? plannedWeightValue.toFixed(3)
            : 0;
        } else {
          calculatedReels = 0;
          calculatedPlannedWt = data.plannedQuant;
        }
      }
    } else {
      if (data.type == "Reel" && data.quantity_type === "reel_sheet") {
        calculatedReels = orderQuantity;
      } else {
        calculatedReels = 0;
      }
      calculatedPlannedWt = data.plannedQuant;
    }

    let calculatedNetPrice;
    let requiredWeightValue;
    if (data?.product_info) {
      let plannedWtConversion;
      let unitPlaceholder = data.units?.planned_weight;
      let priceUnit = data?.units?.per_weight_unit;
      if (data.quantity_type == "weight") {
        requiredWeightValue = data.weight;
      } else {
        requiredWeightValue = calculatedPlannedWt ? calculatedPlannedWt : 0;
      }
      if (unitPlaceholder?.toLowerCase() !== priceUnit?.toLowerCase()) {
        let unitToTonneConv =
          requiredWeightValue * weight_Unit_Conversions[unitPlaceholder];
        plannedWtConversion =
          unitToTonneConv * conversionFactorTonneToUnits[priceUnit];
      } else {
        plannedWtConversion = requiredWeightValue;
      }
      calculatedNetPrice =
        parseFloat(data.price) * parseFloat(plannedWtConversion)
          ? (parseFloat(data.price) * parseFloat(plannedWtConversion))?.toFixed(
            3
          )
          : "";
    }

    if (coreOd && reelOd && reelOd.length == 1) {
      updatedData["calculatedreels"] = parseFloat(calculatedReels)?.toFixed(3);
      updatedData["rewinderreels"] = Math.round(
        parseFloat(calculatedReels)?.toFixed(3)
      )
        ? Math.round(parseFloat(calculatedReels * 1)?.toFixed(3))
        : 1;
    } else {
      if (data.type == "Reel" && data.quantity_type === "reel_sheet") {
        updatedData["calculatedreels"] = calculatedReels;
        updatedData.rewinderreels = calculatedReels;
      } else {
        updatedData["calculatedreels"] = 0;
        updatedData.rewinderreels = 0;
      }
    }

    updatedData["net_price"] = calculatedNetPrice;

    updatedData.plannedweight =
      parseFloat(calculatedPlannedWt) +
      " " +
      capitalize(weightUnit[data?.units?.planned_weight]?.displayName);
    updatedData.plannedQuant = parseFloat(orderQuantity);
    return updatedData;
  };

  const onDiameterChange = (e) => {
    setSelectedDia(e);
  };

  const onChangeReelOdSelect = (data) => {
    setSelectedReelOD(data);

    let coreid = form.getFieldValue("coreDia");
    let coreodConversion =
      orderDim_Rewinder_Unit_Conversion[coreid?.split(" ")[1]];
    let reelodConversion =
      orderDim_Rewinder_Unit_Conversion[data[0]?.value?.split(" ")[1]];
    let coreOD = coreid?.split(" ")[0] * coreodConversion;
    let reelOD = data[0]?.value?.split(" ")[0] * reelodConversion;
    if (data.length == 1) {
      if ((coreOD && parseFloat(coreOD)) > (reelOD && parseFloat(reelOD))) {
        setCoreOdValidationError(true);
      } else {
        if (selectedDataRows && selectedDataRows?.length) {
          for (let i = 0; i < selectedDataRows?.length; i++) {
            let tableRecordIndx = tableData.findIndex(
              (ele) => ele.orderno == selectedDataRows[i].orderno
            );
            let tableDataRecord = tableData[tableRecordIndx];
            let record = selectedDataRows[i];
            if (tableRecordIndx != -1 && tableDataRecord) {
              let reelData =
                data[0]?.value?.split(" ")[0] +
                " " +
                data[0]?.value?.split(" ")[1];
              record.reelod = [reelData];
              record.outer_dia = [reelData];
              tableDataRecord.reelod = [reelData];
              tableDataRecord.outer_dia = [reelData];

              record.coreid = coreid;
              record.inner_dia = coreid;
              tableDataRecord.coreid = coreid;
              tableDataRecord.inner_dia = coreid;

              record.id_od_type = selecteDia;
              tableDataRecord.id_od_type = selecteDia;

              selectedDataRows[i] = { ...record };
              tableData[tableRecordIndx] = { ...tableDataRecord };
            } else {
              let reelData =
                data[0]?.value?.split(" ")[0] +
                " " +
                data[0]?.value?.split(" ")[1];
              record.reelod = [reelData];
              record.outer_dia = [reelData];
              //tableDataRecord.reelod = [reelData];
              //tableDataRecord.outer_dia = [reelData];

              record.coreid = coreid;
              record.inner_dia = coreid;
              //tableDataRecord.coreid = coreid;
              //tableDataRecord.inner_dia = coreid;

              record.id_od_type = selecteDia;
              //tableDataRecord.id_od_type = selecteDia;

              selectedDataRows[i] = { ...record };
              //tableData[tableRecordIndx] = { ...tableDataRecord };
            }
          }
          setSelectedDataRows([...selectedDataRows]);
          setTableData([...tableData]);
        }
        setCoreOdValidationError(false);
        setSelectedState(true);
      }
    }

    if (data.length > 1) {
      let dataArr = [];
      for (let ind = 0; ind < data.length; ind++) {
        let convertedValue =
          data[ind]?.value?.split(" ")[0] *
          orderDim_Rewinder_Unit_Conversion[data[ind]?.value?.split(" ")[1]];
        dataArr.push(convertedValue);
      }
      let minValue = Math.min(...dataArr);

      if ((coreOD && parseFloat(coreOD)) > (minValue && parseFloat(minValue))) {
        setCoreOdValidationError(true);
      } else {
        if (selectedDataRows && selectedDataRows?.length) {
          for (let i = 0; i < selectedDataRows?.length; i++) {
            let tableRecordIndx = tableData.findIndex(
              (ele) => ele.orderno == selectedDataRows[i].orderno
            );
            let tableDataRecord = tableData[tableRecordIndx];
            let record = selectedDataRows[i];
            if (
              tableRecordIndx != -1 &&
              tableDataRecord &&
              ((selecteDia == "constant" &&
                record.type == "Reel" &&
                record.quantity_type == "reel_sheet" &&
                data.length == 1) ||
                (selecteDia == "constant" &&
                  ((record.type == "Reel" &&
                    record.quantity_type == "weight") ||
                    record.type == "Sheet")))
            ) {
              let reelDataArr = [];
              for (let k = 0; k < data.length; k++) {
                let reelData =
                  data[k]?.value?.split(" ")[0] +
                  " " +
                  data[k]?.value?.split(" ")[1];
                reelDataArr.push(reelData);
              }
              record.reelod = reelDataArr;
              record.outer_dia = reelDataArr;
              tableDataRecord.reelod = reelDataArr;
              tableDataRecord.outer_dia = reelDataArr;

              record.coreid = coreid;
              record.inner_dia = coreid;
              tableDataRecord.coreid = coreid;
              tableDataRecord.inner_dia = coreid;

              record.id_od_type = selecteDia;
              tableDataRecord.id_od_type = selecteDia;

              selectedDataRows[i] = { ...record };
              tableData[tableRecordIndx] = { ...tableDataRecord };
            } else if (
              (selecteDia == "constant" &&
                record.type == "Reel" &&
                record.quantity_type == "reel_sheet" &&
                data.length == 1) ||
              (selecteDia == "constant" &&
                ((record.type == "Reel" && record.quantity_type == "weight") ||
                  record.type == "Sheet"))
            ) {
              let reelDataArr = [];
              for (let k = 0; k < data.length; k++) {
                let reelData =
                  data[k]?.value?.split(" ")[0] +
                  " " +
                  data[k]?.value?.split(" ")[1];
                reelDataArr.push(reelData);
              }
              record.reelod = reelDataArr;
              record.outer_dia = reelDataArr;
              //tableDataRecord.reelod = reelDataArr;
              //tableDataRecord.outer_dia = reelDataArr;

              record.coreid = coreid;
              record.inner_dia = coreid;
              //tableDataRecord.coreid = coreid;
              //tableDataRecord.inner_dia = coreid;

              record.id_od_type = selecteDia;
              //tableDataRecord.id_od_type = selecteDia;

              selectedDataRows[i] = { ...record };
              //tableData[tableRecordIndx] = { ...tableDataRecord };
            }
          }
          let finalData = [...tableData];
          setSelectedDataRows([...selectedDataRows]);
          setTableData([...finalData]);
          setSelectedState(true);
        }
        setCoreOdValidationError(false);
      }
    }

    if (data.length == 0) {
      if (selectedDataRows && selectedDataRows?.length) {
        for (let i = 0; i < selectedDataRows?.length; i++) {
          let tableRecordIndx = tableData.findIndex(
            (ele) => ele.orderno == selectedDataRows[i].orderno
          );
          let tableDataRecord = tableData[tableRecordIndx];
          let record = selectedDataRows[i];
          if (tableRecordIndx != -1 && tableDataRecord) {
            record.reelod = JSON.parse(
              JSON.stringify(tableDataCopyRef.current[tableRecordIndx].reelod)
            );
            record.outer_dia = JSON.parse(
              JSON.stringify(
                tableDataCopyRef.current[tableRecordIndx].outer_dia
              )
            );
            tableDataRecord.reelod = JSON.parse(
              JSON.stringify(tableDataCopyRef.current[tableRecordIndx].reelod)
            );
            tableDataRecord.outer_dia = JSON.parse(
              JSON.stringify(
                tableDataCopyRef.current[tableRecordIndx].outer_dia
              )
            );

            selectedDataRows[i] = { ...record };
            tableData[tableRecordIndx] = { ...tableDataRecord };
          }
        }
        setSelectedDataRows([...selectedDataRows]);
        setTableData([...tableData]);
        setSelectedState(true);
      }
    }
    setTableRerender(true);
    setPageRerender(true);
  };

  const onCoreodChange = (e) => {
    let coreodConversion = orderDim_Rewinder_Unit_Conversion[e?.split(" ")[1]];
    let reelodConversion =
      orderDim_Rewinder_Unit_Conversion[
      selectedReelOD[0]?.value?.split(" ")[1]
      ];
    let coreOD = e?.split(" ")[0] * coreodConversion;
    let reelOD = selectedReelOD[0]?.value?.split(" ")[0] * reelodConversion;

    let dataArr = [];
    for (let ind = 0; ind < selectedReelOD.length; ind++) {
      let convertedValue =
        selectedReelOD[ind]?.value?.split(" ")[0] *
        orderDim_Rewinder_Unit_Conversion[
        selectedReelOD[ind]?.value?.split(" ")[1]
        ];
      dataArr.push(convertedValue);
    }
    let minValue = Math.min(...dataArr);

    if (
      ((coreOD && parseFloat(coreOD)) > (reelOD && parseFloat(reelOD)) &&
        selectedReelOD.length == 1) ||
      ((coreOD && parseFloat(coreOD)) > (minValue && parseFloat(minValue)) &&
        selectedReelOD.length > 1)
    ) {
      setCoreOdValidationError(true);
    } else {
      if (selectedDataRows && selectedDataRows?.length) {
        for (let i = 0; i < selectedDataRows?.length; i++) {
          let tableRecordIndx = tableData.findIndex(
            (ele) => ele.orderno == selectedDataRows[i].orderno
          );
          let tableDataRecord = tableData[tableRecordIndx];
          let record = selectedDataRows[i];
          if (tableRecordIndx != -1 && tableDataRecord) {
            record.coreid = e;
            record.inner_dia = e;
            tableDataRecord.coreid = e;
            tableDataRecord.inner_dia = e;

            let reelDataArr = [];
            if (
              record.type.toLowerCase() == "reel" &&
              record.quantity_type == "reel_sheet" &&
              selectedReelOD?.length
            ) {
              reelDataArr.push(selectedReelOD[0]?.value);
            } else {
              for (let k = 0; k < selectedReelOD.length; k++) {
                let reelData =
                  selectedReelOD[k]?.value?.split(" ")[0] +
                  " " +
                  selectedReelOD[k]?.value?.split(" ")[1];
                reelDataArr.push(reelData);
              }
            }

            record.reelod = reelDataArr;
            record.outer_dia = reelDataArr;
            tableDataRecord.reelod = reelDataArr;
            tableDataRecord.outer_dia = reelDataArr;

            record.id_od_type = selecteDia;
            tableDataRecord.id_od_type = selecteDia;

            selectedDataRows[i] = { ...record };
            tableData[tableRecordIndx] = { ...tableDataRecord };
          } else {
            record.coreid = e;
            record.inner_dia = e;

            let reelDataArr = [];
            if (
              record.type.toLowerCase() == "reel" &&
              record.quantity_type == "reel_sheet" &&
              selectedReelOD?.length
            ) {
              reelDataArr.push(selectedReelOD[0]?.value);
            } else {
              for (let k = 0; k < selectedReelOD.length; k++) {
                let reelData =
                  selectedReelOD[k]?.value?.split(" ")[0] +
                  " " +
                  selectedReelOD[k]?.value?.split(" ")[1];
                reelDataArr.push(reelData);
              }
            }

            record.reelod = reelDataArr;
            record.outer_dia = reelDataArr;

            record.id_od_type = selecteDia;
            // tableDataRecord.id_od_type = selecteDia;

            selectedDataRows[i] = { ...record };
            //tableData[tableRecordIndx] = { ...tableDataRecord };
          }
        }
        let finalselectedData = [...selectedDataRows];
        let finalData = [...tableData];
        setSelectedDataRows([...finalselectedData]);
        setTableData([...finalData]);
      }
      setCoreOdValidationError(false);
      setSelectedState(true);
    }
    setTableRerender(true);
    setPageRerender(true);
  };

  const onCoreDiaChange = (e) => {
    let rangeUnit = form.getFieldValue("range_unit");
    let minReel = form.getFieldValue("min_reel");
    let maxReel = form.getFieldValue("max_reel");

    let coreodConversion = orderDim_Rewinder_Unit_Conversion[e?.split(" ")[1]];
    let minReelConversion = orderDim_Rewinder_Unit_Conversion[rangeUnit];

    let coreOD = e?.split(" ")[0] * coreodConversion;
    let reelOD = minReel * minReelConversion;

    if ((reelOD && parseFloat(reelOD)) < (coreOD && parseFloat(coreOD))) {
      setRangeValidationError(true);
    } else {
      setRangeValidationError(false);
    }

    if (selectedDataRows && selectedDataRows?.length) {
      for (let i = 0; i < selectedDataRows?.length; i++) {
        let tableRecordIndx = tableData.findIndex(
          (ele) => ele.orderno == selectedDataRows[i].orderno
        );
        let tableDataRecord = tableData[tableRecordIndx];
        let record = selectedDataRows[i];
        if (
          tableRecordIndx != -1 &&
          tableDataRecord &&
          selecteDia == "range" &&
          ((record.quantity_type != "reel_sheet" && record.type == "Reel") ||
            record.type == "Sheet")
        ) {
          record.inner_dia = e;
          record.coreid = e;
          tableDataRecord.inner_dia = e;
          tableDataRecord.coreid = e;

          record.minimum_reel_od = minReel ? minReel : "";
          tableDataRecord.minimum_reel_od = minReel ? minReel : "";
          record.units["minimum_reel_od"] = minReel ? rangeUnit : "";
          tableDataRecord.units["minimum_reel_od"] = minReel ? rangeUnit : "";

          record.maximum_reel_od = maxReel ? maxReel : "";
          tableDataRecord.maximum_reel_od = maxReel ? maxReel : "";
          record.units["maximum_reel_od"] = maxReel ? rangeUnit : "";
          tableDataRecord.units["maximum_reel_od"] = maxReel ? rangeUnit : "";

          record.id_od_type = selecteDia;
          tableDataRecord.id_od_type = selecteDia;
        } else if (
          selecteDia == "range" &&
          ((record.quantity_type != "reel_sheet" && record.type == "Reel") ||
            record.type == "Sheet")
        ) {
          record.inner_dia = e;
          record.coreid = e;
          //tableDataRecord.inner_dia = e;
          // tableDataRecord.coreid = e;

          record.minimum_reel_od = minReel ? minReel : "";
          //tableDataRecord.minimum_reel_od = minReel ? minReel : "";
          record.units["minimum_reel_od"] = minReel ? rangeUnit : "";
          //tableDataRecord.units["minimum_reel_od"] = minReel ? rangeUnit : "";

          record.maximum_reel_od = maxReel ? maxReel : "";
          //tableDataRecord.maximum_reel_od = maxReel ? maxReel : "";
          record.units["maximum_reel_od"] = maxReel ? rangeUnit : "";
          //tableDataRecord.units["maximum_reel_od"] = maxReel ? rangeUnit : "";

          record.id_od_type = selecteDia;
          //tableDataRecord.id_od_type = selecteDia;
        }
        selectedDataRows[i] = { ...record };
        //tableData[tableRecordIndx] = { ...tableDataRecord };
      }
      setSelectedDataRows([...selectedDataRows]);
      setTableData([...tableData]);
      setSelectedState(true);
    }
    setReelODValidationError(false);
    setTableRerender(true);
  };

  const onRangeUnitChange = (e) => {
    if (selectedDataRows && selectedDataRows?.length) {
      let minReel = form.getFieldValue("min_reel");
      let maxReel = form.getFieldValue("max_reel");
      let coreDia = form.getFieldValue("core_Dia");

      let coreodConversion =
        orderDim_Rewinder_Unit_Conversion[coreDia?.split(" ")[1]];
      let minReelConversion = orderDim_Rewinder_Unit_Conversion[e];

      let coreOD = coreDia?.split(" ")[0] * coreodConversion;
      let reelOD = minReel * minReelConversion;

      if ((reelOD && parseFloat(reelOD)) < (coreOD && parseFloat(coreOD))) {
        setRangeValidationError(true);
      } else {
        setRangeValidationError(false);
      }

      for (let i = 0; i < selectedDataRows?.length; i++) {
        let tableRecordIndx = tableData.findIndex(
          (ele) => ele.orderno == selectedDataRows[i].orderno
        );
        let tableDataRecord = tableData[tableRecordIndx];
        let record = selectedDataRows[i];
        if (
          tableRecordIndx != -1 &&
          tableDataRecord &&
          selecteDia == "range" &&
          ((record.type == "Reel" && record.quantity_type != "reel_sheet") ||
            record.type == "Sheet")
        ) {
          record.maximum_reel_od = maxReel ? maxReel : "";
          tableDataRecord.maximum_reel_od = maxReel ? maxReel : "";
          record.units["maximum_reel_od"] = maxReel ? e : "";
          tableDataRecord.units["maximum_reel_od"] = maxReel ? e : "";

          record.minimum_reel_od = minReel ? minReel : "";
          tableDataRecord.minimum_reel_od = minReel ? minReel : "";
          record.units["minimum_reel_od"] = minReel ? e : "";
          tableDataRecord.units["minimum_reel_od"] = minReel ? e : "";

          record.id_od_type = selecteDia;
          tableDataRecord.id_od_type = selecteDia;

          record.inner_dia = coreDia;
          record.coreid = coreDia;
          tableDataRecord.inner_dia = coreDia;
          tableDataRecord.coreid = coreDia;
        } else if (
          selecteDia == "range" &&
          ((record.type == "Reel" && record.quantity_type != "reel_sheet") ||
            record.type == "Sheet")
        ) {
          record.maximum_reel_od = maxReel ? maxReel : "";
          //tableDataRecord.maximum_reel_od = maxReel ? maxReel : "";
          record.units["maximum_reel_od"] = maxReel ? e : "";
          //tableDataRecord.units["maximum_reel_od"] = maxReel ? e : "";

          record.minimum_reel_od = minReel ? minReel : "";
          // tableDataRecord.minimum_reel_od = minReel ? minReel : "";
          record.units["minimum_reel_od"] = minReel ? e : "";
          // tableDataRecord.units["minimum_reel_od"] = minReel ? e : "";

          record.id_od_type = selecteDia;
          // tableDataRecord.id_od_type = selecteDia;

          record.inner_dia = coreDia;
          record.coreid = coreDia;
          //tableDataRecord.inner_dia = coreDia;
          //tableDataRecord.coreid = coreDia;
        }
        selectedDataRows[i] = { ...record };
        //tableData[tableRecordIndx] = { ...tableDataRecord };
      }
      setSelectedDataRows([...selectedDataRows]);
      setTableData([...tableData]);
      setSelectedState(true);
    }
    setTableRerender(true);
  };

  const removeReelOD = (data) => {
    let array = selectedReelOD;
    let coreid = form.getFieldValue("coreDia");
    let newArray = array.filter((item) => {
      return !(item.value === data.value);
    });
    setSelectedReelOD(newArray);
    if (newArray && newArray?.length == 0) {
      if (selectedDataRows && selectedDataRows?.length) {
        for (let i = 0; i < selectedDataRows?.length; i++) {
          let tableRecordIndx = tableData.findIndex(
            (ele) => ele.orderno == selectedDataRows[i].orderno
          );
          let tableDataRecord = tableData[tableRecordIndx];
          let record = selectedDataRows[i];
          if (tableRecordIndx != -1 && tableDataRecord) {
            record.reelod = JSON.parse(
              JSON.stringify(tableDataCopyRef.current[tableRecordIndx].reelod)
            );
            record.outer_dia = JSON.parse(
              JSON.stringify(
                tableDataCopyRef.current[tableRecordIndx].outer_dia
              )
            );
            tableDataRecord.reelod = JSON.parse(
              JSON.stringify(tableDataCopyRef.current[tableRecordIndx].reelod)
            );
            tableDataRecord.outer_dia = JSON.parse(
              JSON.stringify(
                tableDataCopyRef.current[tableRecordIndx].outer_dia
              )
            );

            selectedDataRows[i] = { ...record };
            tableData[tableRecordIndx] = { ...tableDataRecord };
          } else {
            record.reelod = JSON.parse(
              JSON.stringify(tableDataCopyRef.current[tableRecordIndx].reelod)
            );
            record.outer_dia = JSON.parse(
              JSON.stringify(
                tableDataCopyRef.current[tableRecordIndx].outer_dia
              )
            );
            //tableDataRecord.reelod = JSON.parse(JSON.stringify(tableDataCopyRef.current[tableRecordIndx].reelod));
            //tableDataRecord.outer_dia = JSON.parse(JSON.stringify(tableDataCopyRef.current[tableRecordIndx].outer_dia));

            selectedDataRows[i] = { ...record };
            //tableData[tableRecordIndx] = {...tableDataRecord};
          }
        }
        let finalselectedData = [...selectedDataRows];
        let finalData = [...tableData];
        setSelectedDataRows([...finalselectedData]);
        setTableData([...finalData]);
        setSelectedState(true);
      }
      setCoreOdValidationError(false);
    }
    if (newArray && newArray?.length == 1) {
      let coreodConversion =
        orderDim_Rewinder_Unit_Conversion[coreid.split(" ")[1]];
      let reelodConversion =
        orderDim_Rewinder_Unit_Conversion[newArray[0]?.value?.split(" ")[1]];
      let coreOD = coreid?.split(" ")[0] * coreodConversion;
      let reelOD = newArray[0]?.value?.split(" ")[0] * reelodConversion;

      if ((coreOD && parseFloat(coreOD)) > (reelOD && parseFloat(reelOD))) {
        setCoreOdValidationError(true);
      } else {
        setCoreOdValidationError(false);
      }

      if (selectedDataRows && selectedDataRows?.length) {
        for (let i = 0; i < selectedDataRows?.length; i++) {
          let tableRecordIndx = tableData.findIndex(
            (ele) => ele.orderno == selectedDataRows[i].orderno
          );
          let tableDataRecord = tableData[tableRecordIndx];
          let record = selectedDataRows[i];
          if (tableRecordIndx != -1 && tableDataRecord) {
            let reelDataArr = [];
            for (let k = 0; k < newArray.length; k++) {
              let reelData =
                newArray[k]?.value?.split(" ")[0] +
                " " +
                newArray[k]?.value?.split(" ")[1];
              reelDataArr.push(reelData);
            }
            record.reelod = reelDataArr;
            record.outer_dia = reelDataArr;
            tableDataRecord.reelod = reelDataArr;
            tableDataRecord.outer_dia = reelDataArr;

            record.coreid = coreid;
            record.inner_dia = coreid;
            tableDataRecord.coreid = coreid;
            tableDataRecord.inner_dia = coreid;

            record.id_od_type = selecteDia;
            tableDataRecord.id_od_type = selecteDia;

            selectedDataRows[i] = { ...record };
            tableData[tableRecordIndx] = { ...tableDataRecord };
          } else {
            {
              let reelDataArr = [];
              for (let k = 0; k < newArray.length; k++) {
                let reelData =
                  newArray[k]?.value?.split(" ")[0] +
                  " " +
                  newArray[k]?.value?.split(" ")[1];
                reelDataArr.push(reelData);
              }
              record.reelod = reelDataArr;
              record.outer_dia = reelDataArr;
              // tableDataRecord.reelod = reelDataArr;
              //tableDataRecord.outer_dia = reelDataArr;

              record.coreid = coreid;
              record.inner_dia = coreid;
              //tableDataRecord.coreid = coreid;
              //tableDataRecord.inner_dia = coreid;

              record.id_od_type = selecteDia;
              //tableDataRecord.id_od_type = selecteDia;

              selectedDataRows[i] = { ...record };
              //tableData[tableRecordIndx] = {...tableDataRecord};
            }
          }
        }
        let finalselectedData = [...selectedDataRows];
        let finalData = [...tableData];
        setSelectedDataRows([...finalselectedData]);
        setTableData([...finalData]);
        setSelectedState(true);
      }
    }
    if (newArray.length > 1) {
      let coreodConversion =
        orderDim_Rewinder_Unit_Conversion[coreid.split(" ")[1]];
      let coreOD = coreid?.split(" ")[0] * coreodConversion;
      let dataArr = [];
      for (let ind = 0; ind < newArray.length; ind++) {
        let convertedValue =
          newArray[ind]?.value?.split(" ")[0] *
          orderDim_Rewinder_Unit_Conversion[
          newArray[ind]?.value?.split(" ")[1]
          ];
        dataArr.push(convertedValue);
      }
      let minValue = Math.min(...dataArr);

      if ((coreOD && parseFloat(coreOD)) > (minValue && parseFloat(minValue))) {
        setCoreOdValidationError(true);
      } else {
        setCoreOdValidationError(false);
      }

      if (selectedDataRows && selectedDataRows?.length) {
        for (let i = 0; i < selectedDataRows?.length; i++) {
          let tableRecordIndx = tableData.findIndex(
            (ele) => ele.orderno == selectedDataRows[i].orderno
          );
          let tableDataRecord = tableData[tableRecordIndx];
          let record = selectedDataRows[i];
          if (
            tableRecordIndx != -1 &&
            tableDataRecord &&
            ((selecteDia == "constant" &&
              record.type == "Reel" &&
              record.quantity_type == "reel_sheet" &&
              data.length == 1) ||
              (selecteDia == "constant" &&
                ((record.type == "Reel" &&
                  record.quantity_type != "reel_sheet") ||
                  record.type == "Sheet")))
          ) {
            let reelDataArr = [];
            for (let k = 0; k < newArray.length; k++) {
              let reelData =
                newArray[k]?.value?.split(" ")[0] +
                " " +
                newArray[k]?.value?.split(" ")[1];
              reelDataArr.push(reelData);
            }
            record.reelod = reelDataArr;
            record.outer_dia = reelDataArr;
            tableDataRecord.reelod = reelDataArr;
            tableDataRecord.outer_dia = reelDataArr;

            record.coreid = coreid;
            record.inner_dia = coreid;
            tableDataRecord.coreid = coreid;
            tableDataRecord.inner_dia = coreid;

            record.id_od_type = selecteDia;
            tableDataRecord.id_od_type = selecteDia;

            selectedDataRows[i] = { ...record };
            tableData[tableRecordIndx] = { ...tableDataRecord };
          } else if (
            (selecteDia == "constant" &&
              record.type == "Reel" &&
              record.quantity_type == "reel_sheet" &&
              data.length == 1) ||
            (selecteDia == "constant" &&
              ((record.type == "Reel" &&
                record.quantity_type != "reel_sheet") ||
                record.type == "Sheet"))
          ) {
            let reelDataArr = [];
            for (let k = 0; k < newArray.length; k++) {
              let reelData =
                newArray[k]?.value?.split(" ")[0] +
                " " +
                newArray[k]?.value?.split(" ")[1];
              reelDataArr.push(reelData);
            }
            record.reelod = reelDataArr;
            record.outer_dia = reelDataArr;
            //tableDataRecord.reelod = reelDataArr;
            //tableDataRecord.outer_dia = reelDataArr;

            record.coreid = coreid;
            record.inner_dia = coreid;
            // tableDataRecord.coreid = coreid;
            //tableDataRecord.inner_dia = coreid;

            record.id_od_type = selecteDia;
            //tableDataRecord.id_od_type = selecteDia;

            selectedDataRows[i] = { ...record };
            // tableData[tableRecordIndx] = {...tableDataRecord};
          }
        }
        let finalselectedData = [...selectedDataRows];
        let finalData = [...tableData];
        setSelectedDataRows([...finalselectedData]);
        setTableData([...finalData]);
        setSelectedState(true);
      }
    }
    setTableRerender(true);
    setPageRerender(true);
  };

  const onMinReelODChange = (e) => {
    let rangeInnerDia = form.getFieldValue("core_Dia");
    let rangeUnit = form.getFieldValue("range_unit");

    let coreodConversion =
      orderDim_Rewinder_Unit_Conversion[rangeInnerDia?.split(" ")[1]];
    let minReelConversion = orderDim_Rewinder_Unit_Conversion[rangeUnit];
    let coreOD = rangeInnerDia?.split(" ")[0] * coreodConversion;
    let reelOD = e.target.value * minReelConversion;

    if ((reelOD && parseFloat(reelOD)) < (coreOD && parseFloat(coreOD))) {
      setRangeValidationError(true);
    } else {
      setRangeValidationError(false);
    }

    if (
      (e.target.value && parseFloat(e.target.value)) >
      (form.getFieldValue("max_reel") &&
        parseFloat(form.getFieldValue("max_reel")))
    ) {
      setReelODValidationError(true);
    } else {
      if (selectedDataRows && selectedDataRows?.length) {
        let maxReel = form.getFieldValue("max_reel");
        for (let i = 0; i < selectedDataRows?.length; i++) {
          let tableRecordIndx = tableData.findIndex(
            (ele) => ele.orderno == selectedDataRows[i].orderno
          );
          let tableDataRecord = tableData[tableRecordIndx];
          let record = selectedDataRows[i];
          if (
            tableRecordIndx != -1 &&
            tableDataRecord &&
            selecteDia == "range" &&
            ((record.type == "Reel" && record.quantity_type != "reel_sheet") ||
              record.type == "Sheet")
          ) {
            record.minimum_reel_od = e.target.value ? e.target.value : "";
            tableDataRecord.minimum_reel_od = e.target.value
              ? e.target.value
              : "";
            record.units["minimum_reel_od"] = e.target.value ? rangeUnit : "";
            tableDataRecord.units["minimum_reel_od"] = e.target.value
              ? rangeUnit
              : "";

            record.maximum_reel_od = maxReel ? maxReel : "";
            tableDataRecord.maximum_reel_od = maxReel ? maxReel : "";
            record.units["maximum_reel_od"] = maxReel ? rangeUnit : "";
            tableDataRecord.units["maximum_reel_od"] = maxReel ? rangeUnit : "";

            record.id_od_type = selecteDia;
            tableDataRecord.id_od_type = selecteDia;

            record.inner_dia = rangeInnerDia;
            record.coreid = rangeInnerDia;
            tableDataRecord.inner_dia = rangeInnerDia;
            tableDataRecord.coreid = rangeInnerDia;

            selectedDataRows[i] = { ...record };
            tableData[tableRecordIndx] = { ...tableDataRecord };
          } else if (
            selecteDia == "range" &&
            ((record.type == "Reel" && record.quantity_type != "reel_sheet") ||
              record.type == "Sheet")
          ) {
            record.minimum_reel_od = e.target.value ? e.target.value : "";
            //tableDataRecord.minimum_reel_od = e.target.value ? e.target.value : "";
            record.units["minimum_reel_od"] = e.target.value ? rangeUnit : "";
            // tableDataRecord.units["minimum_reel_od"] = e.target.value ? rangeUnit : "";

            record.maximum_reel_od = maxReel ? maxReel : "";
            //tableDataRecord.maximum_reel_od = maxReel ? maxReel : "";
            record.units["maximum_reel_od"] = maxReel ? rangeUnit : "";
            //tableDataRecord.units["maximum_reel_od"] = maxReel ? rangeUnit : "";

            record.id_od_type = selecteDia;
            //tableDataRecord.id_od_type = selecteDia;

            record.inner_dia = rangeInnerDia;
            record.coreid = rangeInnerDia;
            //tableDataRecord.inner_dia = rangeInnerDia;
            //tableDataRecord.coreid = rangeInnerDia;

            selectedDataRows[i] = { ...record };
            //tableData[tableRecordIndx] = {...tableDataRecord};
          }
        }
        let finalselectedData = [...selectedDataRows];
        let finalData = [...tableData];
        setSelectedDataRows([...finalselectedData]);
        setTableData([...finalData]);
        setSelectedState(true);
      }
      setTableRerender(true);
      setReelODValidationError(false);
    }
    setTableRerender(true);
    setPageRerender(true);
  };

  const onMaxReelODChange = (e) => {
    if (
      (e.target.value && parseFloat(e.target.value)) <
      (form.getFieldValue("min_reel") &&
        parseFloat(form.getFieldValue("min_reel")))
    ) {
      setReelODValidationError(true);
    } else {
      if (selectedDataRows && selectedDataRows?.length) {
        let rangeUnit = form.getFieldValue("range_unit");
        let minReel = form.getFieldValue("min_reel");
        let rangeInnerDia = form.getFieldValue("core_Dia");
        for (let i = 0; i < selectedDataRows?.length; i++) {
          let tableRecordIndx = tableData.findIndex(
            (ele) => ele.orderno == selectedDataRows[i].orderno
          );
          if (tableRecordIndx == 0 || tableRecordIndx != -1) {
            let tableDataRecord = tableData[tableRecordIndx];
            let record = selectedDataRows[i];
            if (
              tableDataRecord &&
              selecteDia == "range" &&
              ((record.type == "Reel" &&
                record.quantity_type != "reel_sheet") ||
                record.type == "Sheet")
            ) {
              record["maximum_reel_od"] = e.target.value ? e.target.value : "";
              tableDataRecord["maximum_reel_od"] = e.target.value
                ? e.target.value
                : "";
              record.units["maximum_reel_od"] = e.target.value ? rangeUnit : "";
              tableDataRecord.units["maximum_reel_od"] = e.target.value
                ? rangeUnit
                : "";

              record["minimum_reel_od"] = minReel ? minReel : "";
              tableDataRecord["minimum_reel_od"] = minReel ? minReel : "";
              record.units["minimum_reel_od"] = minReel ? rangeUnit : "";
              tableDataRecord.units["minimum_reel_od"] = minReel
                ? rangeUnit
                : "";

              record.id_od_type = selecteDia;
              tableDataRecord.id_od_type = selecteDia;

              record.inner_dia = rangeInnerDia;
              record.coreid = rangeInnerDia;
              tableDataRecord.inner_dia = rangeInnerDia;
              tableDataRecord.coreid = rangeInnerDia;
            }

            selectedDataRows[i] = { ...record };

            tableData[tableRecordIndx] = { ...tableDataRecord };
          } else {
            let tableDataRecord = tableData[tableRecordIndx];
            let record = selectedDataRows[i];
            if (
              selecteDia == "range" &&
              ((record.type == "Reel" &&
                record.quantity_type != "reel_sheet") ||
                record.type == "Sheet")
            ) {
              record["maximum_reel_od"] = e.target.value ? e.target.value : "";
              // tableDataRecord["maximum_reel_od"] = e.target.value ? e.target.value : "";
              record.units["maximum_reel_od"] = e.target.value ? rangeUnit : "";
              //tableDataRecord.units["maximum_reel_od"] = e.target.value ? rangeUnit : "";

              record["minimum_reel_od"] = minReel ? minReel : "";
              // tableDataRecord["minimum_reel_od"] = minReel ? minReel : "";
              record.units["minimum_reel_od"] = minReel ? rangeUnit : "";
              // tableDataRecord.units["minimum_reel_od"] = minReel ? rangeUnit : "";

              record.id_od_type = selecteDia;
              // tableDataRecord.id_od_type = selecteDia;

              record.inner_dia = rangeInnerDia;
              record.coreid = rangeInnerDia;
              // tableDataRecord.inner_dia = rangeInnerDia;
              // tableDataRecord.coreid = rangeInnerDia;

              selectedDataRows[i] = { ...record };

              // tableData[tableRecordIndx] = {...tableDataRecord};
            }
          }
        }
        let finalselectedData = [...selectedDataRows];
        let finalData = [...tableData];
        setSelectedDataRows([...finalselectedData]);
        setTableData([...finalData]);
        setSelectedState(true);
      }
      setTableRerender(true);
      setReelODValidationError(false);
    }
    setTableRerender(true);
    setPageRerender(true);
  };

  const onClearSelection = () => {
    setSelectedRowKeys([]);
    setMovedOrder([]);
    const newCheckboxState = [...tableData];
    setIsAllSelected(false);
    newCheckboxState.forEach((item) => {
      item.select = false;
    });
    removeDeslectedQuantity(newCheckboxState);
    setTotalWeight(0);
    totalRef.current = 0;
    setSelectedDataRows([]);
    setIsCheckboxClicked(false);
  };

  const onGrainChange = (e, { ...record }, index) => {
    setSelectedReocord({ ...record });
    setGrainType(e);
    setSelectedIndex(index);
    // let selected = selectedRecord;

    // setTableRerender(true);
  };

  const PrepareRouteChange = async () => {
    setLoadings(true);

    const selectedOrders = selectedDataRows.map((item) => {
      return item.orderno;
    });

    let req = {
      data: selectedOrders,
    };
    req = { ...req, ...location.state.body };
    req["machine_code"] = location.state.machine_code;
    try {
      let response;
      if (location.state.processType == "singleStage")
        response = await machineSelectedOrders(req);
      else response = await machineSelectedOrdersMultiStage(req);
      nextClickRef.current = true;
      isCancelJobCard.current = false;
      setOrderSummaryTable({
        state: {
          type: "selectOrders",
          body: location.state.body,
          data: response.data,
          orderResponse: location.state.orderResponse,

          maximum_burst_factor: location.state.maximum_burst_factor,
          minimum_burst_factor: location.state.minimum_burst_factor,
          maximum_gsm: location.state.maximum_gsm,
          minimum_gsm: location.state.minimum_gsm,
          selected_rewinder: location.state.selected_rewinder,
          selected_cutter: location.state.selected_cutter,
          selected_rewinder_unit: location.state.selected_rewinder_unit,
          selected_cutter_unit: location.state.selected_cutter_unit,
          rewinder_data: location.state.rewinder_data,
          cutter_data: location.state.cutter_data,
          selected_type: location.state.selected_type,
          rewinder_minWidth: location.state.rewinder_minWidth,
          rewinder_maxWidth: location.state.rewinder_maxWidth,
          cutter_minWidth: location.state.cutter_minWidth,
          cutter_maxWidth: location.state.cutter_maxWidth,
          max_NoOfCutters: location.state.max_NoOfCutters,
          minWeight: location.state.minWeight,
          minWeight: location.state.minWeight,
          left_edge_trim: location.state.left_edge_trim,
          right_edge_trim: location.state.right_edge_trim,
          code: location.state.code,
          initital_OrderType: location.state.initital_OrderType,
          is_enabled: location.state.is_enabled,
          machine_code: location.state.machine_code,
          partitionWeightUnit: location.state.partitionWeightUnit,
          max_NoOfCutters_cutter: location.state.max_NoOfCutters_cutter,
          left_edge_trim_cutter: location.state.left_edge_trim_cutter,
          right_edge_trim_cutter: location.state.right_edge_trim_cutter,
          processType: location.state.processType,
        },
      });
      history("../order-summary", {
        state: {
          type: "selectOrders",
          body: location.state.body,
          data: response.data,
          orderResponse: location.state.orderResponse,

          maximum_burst_factor: location.state.maximum_burst_factor,
          minimum_burst_factor: location.state.minimum_burst_factor,
          maximum_gsm: location.state.maximum_gsm,
          minimum_gsm: location.state.minimum_gsm,
          selected_rewinder: location.state.selected_rewinder,
          selected_cutter: location.state.selected_cutter,
          selected_rewinder_unit: location.state.selected_rewinder_unit,
          selected_cutter_unit: location.state.selected_cutter_unit,
          rewinder_data: location.state.rewinder_data,
          cutter_data: location.state.cutter_data,
          selected_type: location.state.selected_type,
          rewinder_minWidth: location.state.rewinder_minWidth,
          rewinder_maxWidth: location.state.rewinder_maxWidth,
          cutter_minWidth: location.state.cutter_minWidth,
          cutter_maxWidth: location.state.cutter_maxWidth,
          max_NoOfCutters: location.state.max_NoOfCutters,
          minWeight: location.state.minWeight,
          minWeight: location.state.minWeight,
          left_edge_trim: location.state.left_edge_trim,
          right_edge_trim: location.state.right_edge_trim,
          code: location.state.code,
          initital_OrderType: location.state.initital_OrderType,
          is_enabled: location.state.is_enabled,
          machine_code: location.state.machine_code,
          partitionWeightUnit: location.state.partitionWeightUnit,
          max_NoOfCutters_cutter: location.state.max_NoOfCutters_cutter,
          left_edge_trim_cutter: location.state.left_edge_trim_cutter,
          right_edge_trim_cutter: location.state.right_edge_trim_cutter,
          processType: location.state.processType,
        },
      });
    } catch (error) {
      setActionToaster({
        error: error.response.data.error,
        msg: error.response.data.msg,
      });
      showToaster();
      setLoadings(false);

      setError(error.response.data.msg);
    }
  };

  const getRow = (record, index) => {
    if (index != 0 && tableData[index].pono !== tableData[index - 1].pono)
      return `highlight-bottom-border ${record.priority ? (record.select ? "check" : "true") : null
        }`;
    else return record.priority ? (record.select ? "check" : "true") : null;
  };

  const onCancel = () => {
    history("../job-cards");
    setFormObject(null);
  };

  const handleViewAction = (record) => {
    setSelectedOrder(record);
    setViewDeckleOrders(true);
  };

  const onCloseFullViewDrawer = () => {
    setViewDeckleOrders(false);
    setResendApprovalData(false);

    // setLoading(true);

    // setRendering(true);
    // setSearchValue("");
    // setClearSearch(true);
    // setAppliedFilters([]);
    // setFilterTags([]);
  };

  const onCloseViewDrawer = () => {
    setViewDeckleOrders(false);
    setResendApprovalData(false);

    // setLoading(true);

    // setRendering(true);
    // setSearchValue("");
    // setClearSearch(true);
    // setAppliedFilters([]);
    // setFilterTags([]);
  };

  const applyfilter = (filter) => {
    columnsHead.current?.map((item) => {
      item["sortOrder"] = null;
    });

    for (let i = 0; i < tableDataRef.current?.length; i++) {
      if (isEditClicked[tableDataRef.current[i]?.orderno]?.isEditable) {
        form.setFieldsValue({
          [`plannedQuanty${tableDataRef.current[i]?.orderno}`]:
            tableDataRef.current[i]?.plannedQuant,
        });
      }
    }
    setIsEditClicked({});
    setPlannedQuantityErr({});
    setTableRerender(true);

    let temp = appliedFilters;
    let alreadySetFilter = false;
    for (let i = 0; i < temp.length; i++) {
      if (temp[i].type === filter.type) {
        temp[i] = filter;
        alreadySetFilter = true;
      }
    }
    setCurrentPage(1);
    setPaginationParams((prevState) => ({
      ...prevState,
      page: 1,
      size: settingsData?.settings?.default_page_size || 10,
    }));
    paginationParamsRef.current = {
      page: 1,
      size: settingsData?.settings?.default_page_size || 10,
      sort_by: paginationParamsRef.current.sort_by,
      sort_type: paginationParamsRef.current.sort_type,
    };
    const tempVar = alreadySetFilter ? [...temp] : temp.concat(filter);
    setAppliedFilters(tempVar);
    setLoading(true);
    setFilterTags(tempVar.map(formatFilters));
    setRendering(true);
    setTableData([]);
  };

  const formatFilters = (item) => {
    switch (item.type) {
      case "customer":
        const value =
          item.names.length > 1
            ? `${item.names[0]} or ${item.names.length - 1} others`
            : `${item.names[0]}`;
        // const concatString = item.names.join(" or ");
        // const customerToolTip = `Country equals ${concatString}`;
        return {
          type: item.type,
          formattedType: "Customer",
          operand: "equals",
          value,
          // tooltip: customerToolTip,
        };
      case "consignee":
        const consigneeValue =
          item.names.length > 1
            ? `${item.names[0]} or ${item.names.length - 1} others`
            : `${item.names[0]}`;
        // const concatString = item.names.join(" or ");
        // const customerToolTip = `Country equals ${concatString}`;
        return {
          type: item.type,
          formattedType: "Consignee",
          operand: "equals",
          value: consigneeValue,
          // tooltip: customerToolTip,
        };
      case "order_type":
        const typeValue =
          item.order_type === "reel"
            ? "Reel"
            : item.order_type === "sheet"
              ? "Sheet"
              : "Reel or Sheet";
        return {
          type: item.type,
          formattedType: "Order Type",
          operand: "equals",
          value: typeValue,
          // tooltip: `Order Type equals ${typeValue}`,
        };
      case "created_date":
        let dateOperand = "";
        let dateValue = "";
        if (item.start_date === item.end_date) {
          dateOperand = "-";
          dateValue = moment(item.start_date).format("DD MMMM YY");
        } else {
          dateOperand = "between";
          dateValue = `${moment(item.start_date).format(
            "DD MMMM YY"
          )} - ${moment(item.end_date).format("DD MMMM YY")}`;
        }
        return {
          type: item.type,
          formattedType: "Created date",
          operand: dateOperand,
          value: dateValue,
        };
      case "po_date":
        let poDateOperand = "";
        let poDateValue = "";
        if (item.start_date === item.end_date) {
          poDateOperand = "-";
          poDateValue = moment(item.start_date).format("DD MMMM YY");
        } else {
          poDateOperand = "between";
          poDateValue = `${moment(item.start_date).format(
            "DD MMMM YY"
          )} - ${moment(item.end_date).format("DD MMMM YY")}`;
        }
        return {
          type: item.type,
          formattedType: "PO date",
          operand: poDateOperand,
          value: poDateValue,
        };
      case "delivery_date":
        let deliveryDateOperand = "";
        let deliveryDateValue = "";
        if (item.start_date === item.end_date) {
          deliveryDateOperand = "-";
          deliveryDateValue = moment(item.start_date).format("DD MMMM YY");
        } else {
          deliveryDateOperand = "between";
          deliveryDateValue = `${moment(item.start_date).format(
            "DD MMMM YY"
          )} - ${moment(item.end_date).format("DD MMMM YY")}`;
        }
        return {
          type: item.type,
          formattedType: "Delivery date",
          operand: deliveryDateOperand,
          value: deliveryDateValue,
        };
      case "gsm":
        const gsmValue =
          item.operator === "in_range"
            ? `${item.min_gsm} and ${item.max_gsm}`
            : `${item.gsm}`;
        const gsmOperand =
          item.operator === "in_range"
            ? "between"
            : item.operator === "equal_to"
              ? "equals"
              : item.operator === "less_than"
                ? "less than"
                : item.operator === "greater_than"
                  ? "greater than"
                  : "";
        return {
          type: item.type,
          formattedType: "GSM",
          operand: gsmOperand,
          value: gsmValue,
          // tooltip: `GSM ${gsmOperand} ${gsmValue}`,
        };
      case "burst_factor":
        const bfValue =
          item.operator === "in_range"
            ? `${item.min_burst_factor} and ${item.max_burst_factor}`
            : `${item.burst_factor}`;
        const bfOperand =
          item.operator === "in_range"
            ? "between"
            : item.operator === "equal_to"
              ? "equals"
              : item.operator === "less_than"
                ? "less than"
                : item.operator === "greater_than"
                  ? "greater than"
                  : "";
        return {
          type: item.type,
          formattedType: "Burst factor",
          operand: bfOperand,
          value: bfValue,
          // tooltip: `Burst factor ${bfOperand} ${bfValue}`,
        };
      case "reel_od":
        const reelOdValue =
          item.operator === "in_range"
            ? `${item.min_reel_od} and ${item.max_reel_od}`
            : `${item.reel_od}`;
        const reelOdOperand =
          item.operator === "in_range"
            ? "between"
            : item.operator === "equal_to"
              ? "equals"
              : item.operator === "less_than"
                ? "less than"
                : item.operator === "greater_than"
                  ? "greater than"
                  : "";
        return {
          type: item.type,
          formattedType: "Reel OD",
          operand: reelOdOperand,
          value: reelOdValue,
          // tooltip: `Reel OD ${reelOdOperand} ${reelOdValue}`,
        };
      case "core_id":
        const coreIdValue =
          item.operator === "in_range"
            ? `${item.min_core_id} and ${item.max_core_id}`
            : `${item.core_id}`;
        const coreIdOperand =
          item.operator === "in_range"
            ? "between"
            : item.operator === "equal_to"
              ? "equals"
              : item.operator === "less_than"
                ? "less than"
                : item.operator === "greater_than"
                  ? "greater than"
                  : "";
        return {
          type: item.type,
          formattedType: "Core ID",
          operand: coreIdOperand,
          value: coreIdValue,
          // tooltip: `Core ID ${coreIdOperand} ${coreIdValue}`,
        };
      case "grade_quality":
        const gradeValue =
          item.grades.length > 1
            ? `${item.grades[0].grade}(${item.grades[0].qualities.join()}) or ${item.grades.length - 1
            } others`
            : `${item.grades[0].grade}` +
            (item.grades[0].qualities?.length
              ? `"(${item.grades[0].qualities.join()})"`
              : ``);
        return {
          type: item.type,
          formattedType: "Grade",
          operand: "-",
          value: gradeValue,
          // tooltip: `Core ID ${coreIdOperand} ${coreIdValue}`
        };
      case "size":
        const sizeValue =
          item.operator === "in_range"
            ? `${item.min_size} and ${item.max_size}`
            : `${item.size}`;
        const sizetype =
          item.size_type === "width"
            ? "Width"
            : item.size_type === "length"
              ? "Length"
              : "Width / Length";
        const sizeOperand =
          item.operator === "in_range"
            ? "between"
            : item.operator === "equal_to"
              ? "equals"
              : item.operator === "less_than"
                ? "less than"
                : item.operator === "greater_than"
                  ? "greater than"
                  : "";
        return {
          type: item.type,
          formattedType: sizetype,
          operand: sizeOperand,
          value: sizeValue,
          // tooltip: `${sizetype} ${sizeOperand} ${sizeValue}`,
        };
    }
  };

  const removeFilter = (filter) => {
    columnsHead.current?.map((item) => {
      item["sortOrder"] = null;
    });
    const filterList = appliedFilters.filter((item) => {
      return item.type !== filter.type;
    });
    const formattedFilterList = filterTags.filter((item) => {
      return item.type !== filter.type;
    });
    setFilterTags(formattedFilterList);
    setAppliedFilters(filterList);
    setSearchValue("");
    setClearSearch(true);
    setLoading(true);
    setRendering(true);
  };

  const refresh = () => {
    setLoading(true);
    setSearchValue("");
    setClearSearch(true);
    setAppliedFilters([]);
    setRendering(true);
  };

  const showToaster = () => {
    setVisibleToaster(true);
    setTimeout(() => setVisibleToaster(false), 2000);
  };

  return tableData &&
    unitData &&
    measurementData &&
    reelValues &&
    coreValues ? (
    <RightLayoutContainer id="right-layout-container">
      <PageTitleComp ref={titleRef} style={{ borderBottom: "0", position: "sticky", top: stickyOffsets.title, zIndex: 100, backgroundColor: "#fff" }}>
        <PageHeader
          ghost={false}
          title="Select Orders"
          extra={[
            <Button
              key="1"
              className="textTypeBtn textBtnIcon"
              onClick={showCancelModal}
            >
              <Iconmoon
                icon="wrong"
                size={14}
                color="#EA4E2C"
                style={{ marginRight: "8px", top: "1px", position: "relative" }}
              />
              Cancel Job Card
            </Button>,
            <Button
              key="1"
              className="themeBtn noBg noMargin"
              onClick={GoBackRouteChange}
            >
              Go Back
            </Button>,
            <Button
              key="1"
              className="themeBtn"
              onClick={PrepareRouteChange}
              loading={loadings}
              disabled={orderType == "other_orders" || !selectedRowKeys.length}
            >
              {!loadings && (
                <Iconmoon icon="move-right" size={14} color="#ffffff" />
              )}
              {!loadings ? "Next" : ""}
            </Button>,
          ]}
        ></PageHeader>
      </PageTitleComp>

      {showAlert && (
        <AlertContainer
          color={"green"}
          icon={alertGreen}
          msg={"Selected orders are successfully merged"}
        />
      )}

      <style dangerouslySetInnerHTML={{
        __html: `
        .ant-tabs, .ant-tabs-content-holder, .ant-tabs-content, .ant-tabs-tabpane {
          overflow: visible !important;
        }
        .ant-table-sticky-holder {
          z-index: 101 !important;
        }
      `}} />
      <StyledTab>
        <Tabs
          defaultActiveKey={defaultActiveKey}
          onChange={handleTabChange}
          destroyInactiveTabPane={true}
          renderTabBar={(props, DefaultTabBar) => (
            <div ref={tabRef} style={{ position: "sticky", top: stickyOffsets.tabs, zIndex: 99, background: "#fff" }}>
              <DefaultTabBar {...props} />
            </div>
          )}
        >
          {tabHeads.map((tab) => (
            <Panes tab={tab.title} key={tab.key}>
              <TableLayoutData>
                <Form
                  id="form"
                  form={form}
                  name="basic"
                  autoComplete="off"
                  className="haberLogin"
                  onFinish={onFinish}
                // onFinishFailed={onFinishFailed}
                >
                  <div className="tableDataFormat">
                    <div ref={searchRef} style={{ backgroundColor: "#fff" }}>
                    <Row>
                      <Col style={{ width: "100%" }}>
                        {unitData && orderTypesData && (!isAddRewinderDimension ? (
                          <SearchContainer
                            placeholder={`Search${columnBlacklist.includes("orderno") ? "" : "Order or"} PO Number`}
                            fetchOrder={searchOrders}
                            clearSearch={clearSearch}
                            setClearSearch={setClearSearch}
                            searchedValue={searchValue}
                            //ismachineOrderSearch={true}
                            isAddRewinderDimension={
                              location?.state?.selected_type === "rewinding" &&
                              orderType == "other_orders"
                            }
                            onAddRewinderDimension={onAddRewinderDimension}
                            isMoveToSelection={
                              orderType == "other_orders" &&
                              !isAddRewinderDimension
                            }
                            onMoveToSelection={onMoveToSelection}
                            selectedRowKeys={selectedRowKeys}
                            isSelectedOrder={true}
                            hideExport={true}
                            orderTypesProp={orderTypesData}
                            unitDataProp={unitData}
                          />
                        ) : (
                          <SearchContainer
                            placeholder={`Search PO Number ${columnBlacklist.includes("orderno") ? "" : "Order No"}`}
                            fetchOrder={searchOrders}
                            // exportTrigger={() => exportHandler(tab.key,orderState)}
                            clearSearch={clearSearch}
                            setClearSearch={setClearSearch}
                            searchedValue={searchValue}
                            isAddRewinderDetailsPressed={isAddRewinderDimension}
                            cancelButtonClick={onCancelButtonPress}
                            reviewAndUpdateClick={onReviewAndUpdateClick}
                            filterOptions={[
                              {
                                key: 0,
                                label: "Filter by Created Date",
                                value: "created_date",
                                type: "date",
                              },
                              {
                                key: 1,
                                label: "Filter by PO Date",
                                value: "po_date",
                                type: "date",
                              },
                              {
                                key: 2,
                                label: "Filter by GSM",
                                value: "gsm",
                                type: "inputSelect",
                              },
                              {
                                key: 3,
                                label: "Filter by Grade/Quality",
                                value: "grade_quality",
                                type: "grade",
                              },
                              {
                                key: 4,
                                label: "Filter by Burst Factor",
                                value: "burst_factor",
                                type: "inputSelect",
                              },
                              {
                                key: 5,
                                label: "Filter by Reel OD",
                                value: "reel_od",
                                type: "inputSelect",
                                unitType: "length",
                              },
                              {
                                key: 6,
                                label: "Filter by Core ID",
                                value: "core_id",
                                type: "inputSelect",
                                unitType: "length",
                              },
                              {
                                key: 7,
                                label: "Filter by Delivery Date",
                                value: "delivery_date",
                                type: "date",
                              },
                              {
                                key: 8,
                                label: "Filter by Customer",
                                value: "customer",
                                type: "multiSelect",
                              },
                              {
                                key: 9,
                                label: "Filter by Order Type",
                                value: "order_type",
                                type: "multiSelect",
                              },
                              {
                                key: 10,
                                label: "Filter by Size",
                                value: "size",
                                type: "rangeTypeSelect",
                                unitType: "length",
                              },
                              {
                                key: 11,
                                label: "Filter by Consignee",
                                value: "consignee",
                                type: "multiSelect",
                              },
                              // {
                              //   key: 10,
                              //   label: "Filter by Status",
                              //   value: "orderStatus",
                              //   type: "multiSelect",
                              // },
                            ]}
                            applyFilter={applyfilter}
                            hideExport={true}
                            /// cancelButtonClick={onCancelButtonPress}

                            isDisableSave={
                              !selectedDataRows.length
                              // !form.getFieldValue("reelOd") ||
                              // !form.getFieldValue("coreOd")
                            }
                            orderTypesProp={orderTypesData}
                            unitDataProp={unitData}
                          />
                        ))}
                      </Col>
                    </Row>

                    {!isAddRewinderDimension &&
                      tableData &&
                      tableData.length ? (
                      <Row
                        gutter={{ xs: 1, sm: 3, md: 6, lg: 12 }}
                        style={{ marginBottom: "10px", marginTop: "5px" }}
                      >
                        <Col style={{ width: "100%" }}>
                          <Row
                            gutter={{ xs: 1, sm: 3, md: 6, lg: 12 }}
                            style={{
                              marginLeft: "-30px",
                              marginBottom: "-10px",
                            }}
                          >
                            {/* <Col
                            className="gutter-row"
                            style={{
                              width: "auto",
                              marginBottom: "10px",
                              paddingLeft: "0px",
                              paddingRight: "0px",
                            }}
                          >
                            {" "}
                            <OrderFilter
                              filterType={{
                                key: 1,
                                label: "Filter by Grade/Quality",
                                value: "grade_quality",
                                type: "grade",
                                name: "Grade & Quality",
                              }}
                              applyFilter={applyfilter}
                            ></OrderFilter>
                          </Col>
                          <Col
                            className="gutter-row"
                            style={{
                              width: "auto",
                              marginBottom: "10px",
                              paddingLeft: "0px",
                              paddingRight: "0px",
                            }}
                          >
                            {" "}
                            <OrderFilter
                              filterType={{
                                key: 2,
                                label: "Filter by GSM",
                                value: "gsm",
                                type: "inputSelect",
                                name: "GSM",
                              }}
                              applyFilter={applyfilter}
                            ></OrderFilter>
                          </Col>
                          <Col
                            className="gutter-row"
                            style={{
                              width: "auto",
                              marginBottom: "10px",
                              paddingLeft: "0px",
                              paddingRight: "0px",
                            }}
                          >
                            {" "}
                            <OrderFilter
                              filterType={{
                                key: 3,
                                label: "Filter by Burst Factor",
                                value: "burst_factor",
                                type: "inputSelect",
                                name: "BF",
                              }}
                              applyFilter={applyfilter}
                            ></OrderFilter>
                          </Col>
                          <Col
                            className="gutter-row"
                            style={{
                              width: "auto",
                              marginBottom: "10px",
                              paddingLeft: "0px",
                              paddingRight: "0px",
                            }}
                          >
                            {" "}
                            <OrderFilter
                              filterType={{
                                key: 4,
                                label: "Filter by PO Date",
                                value: "po_date",
                                type: "date",
                                name: "PO Date",
                              }}
                              applyFilter={applyfilter}
                            ></OrderFilter>
                          </Col>
                          <Col
                            className="gutter-row"
                            style={{
                              width: "auto",
                              marginBottom: "10px",
                              paddingLeft: "0px",
                              paddingRight: "0px",
                            }}
                          >
                            {" "}
                            <OrderFilter
                              filterType={{
                                key: 5,
                                label: "Filter by Delivery Date",
                                value: "delivery_date",
                                type: "date",
                                name: "Delivery Date",
                              }}
                              applyFilter={applyfilter}
                            ></OrderFilter>
                          </Col>
                          <Col
                            className="gutter-row"
                            style={{
                              width: "auto",
                              marginBottom: "10px",
                              paddingLeft: "0px",
                              paddingRight: "0px",
                            }}
                          >
                            {" "}
                            <OrderFilter
                              filterType={{
                                key: 6,
                                label: "Filter by Customer",
                                value: "customer",
                                type: "multiSelect",
                                name: "Customer",
                              }}
                              applyFilter={applyfilter}
                            ></OrderFilter>
                          </Col>
                          <Col
                            className="gutter-row"
                            style={{
                              width: "auto",
                              marginBottom: "10px",
                              paddingLeft: "0px",
                              paddingRight: "0px",
                            }}
                          >
                            {" "}
                            <OrderFilter
                              filterType={{
                                key: 7,
                                label: "Filter by Order Type",
                                value: "order_type",
                                type: "multiSelect",
                                name: "Order Type",
                              }}
                              applyFilter={applyfilter}
                            ></OrderFilter>
                          </Col>
                          <Col
                            className="gutter-row"
                            style={{
                              width: "auto",
                              marginBottom: "10px",
                              paddingLeft: "0px",
                              paddingRight: "0px",
                            }}
                          >
                            {" "}
                            <SearchContainer
                              style={{ padding: "0px !important" }}
                              filterOptions={[
                                {
                                  key: 0,
                                  label: "Filter by Created Date",
                                  value: "created_date",
                                  type: "date",
                                },
                                {
                                  key: 1,
                                  label: "Filter by Reel OD",
                                  value: "reel_od",
                                  type: "inputSelect",
                                  unitType: "length",
                                },
                                {
                                  key: 2,
                                  label: "Filter by Core ID",
                                  value: "core_id",
                                  type: "inputSelect",
                                  unitType: "length",
                                },
                                {
                                  key: 3,
                                  label: "Filter by Size",
                                  value: "size",
                                  type: "rangeTypeSelect",
                                  unitType: "length",
                                },
                                {
                                  key: 4,
                                  label: "Filter by Consignee",
                                  value: "consignee",
                                  type: "multiSelect",
                                },
                                // {
                                //   key: 10,
                                //   label: "Filter by Status",
                                //   value: "orderStatus",
                                //   type: "multiSelect",
                                // },
                              ]}
                              applyFilter={applyfilter}
                              isOtherFilter={true}
                              hideExport={true}
                            />
                          </Col> */}
                            {filtersToBeShown?.map((filterKey) => {
                              const filter = filterOptions.find(
                                (f) => f.value === filterKey
                              );
                              if (!filter) return null;
                              return (
                                <Col
                                  key={filter.key}
                                  className="gutter-row"
                                  style={{
                                    width: "auto",
                                    marginBottom: "10px",
                                    paddingLeft: "0px",
                                    paddingRight: "0px",
                                  }}
                                >
                                  {unitData && orderTypesData && <OrderFilter
                                    filterType={{
                                      key: filter.key,
                                      label: filter.label,
                                      value: filter.value,
                                      type: filter.type,
                                      name: filter.label.replace(
                                        "Filter by ",
                                        ""
                                      ),
                                      ...(filter.value === "size" && { unitType: filter.unitType })
                                    }}
                                    applyFilter={applyfilter}
                                    unitData={unitData}
                                    orderTypesData={orderTypesData}
                                  />}
                                </Col>
                              );
                            })}
                            {finalFilters?.length ? (
                              <Col
                                className="gutter-row"
                                style={{
                                  width: "auto",
                                  marginBottom: "10px",
                                  paddingLeft: "0px",
                                  paddingRight: "0px",
                                }}
                              >
                                {" "}
                                {unitData && orderTypesData && <SearchContainer
                                  style={{ padding: "0px !important" }}
                                  filterOptions={finalFilters}
                                  applyFilter={applyfilter}
                                  isOtherFilter={true}
                                  hideExport={true}
                                  unitDataProp={unitData}
                                  orderTypesProp={orderTypesData}
                                />}
                              </Col>
                            ) : null}
                          </Row>
                        </Col>
                      </Row>
                    ) : (
                      ""
                    )}
                    {!isAddRewinderDimension && (
                      <Row
                        gutter={{ xs: 1, sm: 3, md: 6, lg: 12 }}
                        style={{ marginBottom: "0px", marginTop: "0px" }}
                      >
                        <Col style={{ width: "70%" }}></Col>
                        <Col style={{ width: "30%" }}>
                          <OrderDetails style={{ height: "100%" }}>
                            <div
                              className="pendingDetailsStyle"
                              style={{
                                paddingBottom: "0px",
                                paddingTop: "10px",
                              }}
                            >
                              <span className="pendingOrderStyle">
                                {" "}
                                Selected Orders:{" "}
                                {selectedRowKeys?.length
                                  ? selectedRowKeys.length
                                  : 0}
                              </span>{" "}
                              Selected Quantity: {totalWeight.toFixed(3)}{" "}
                              {capitalize(
                                weightUnit[
                                  unitData.units_management.weight.default
                                ].displayName
                              )}
                            </div>
                          </OrderDetails>
                        </Col>
                      </Row>
                    )}

                    {isAddRewinderDimension && (
                      <DetailFields style={{ paddingBottom: "0px" }}>
                        <HaberForm>
                          <div className="groupDetailWrap">
                            {/* <Form
                name="basic"
                autoComplete="off"
                form={form}
                className="haberLogin"
                onFinish={onFinish}
              > */}
                            <Row gutter={[16, 16]} className="groupForm">
                              <Col span={8}>
                                <GroupTitle>
                                  <h2>Rewinder Dimensions</h2>
                                  <p>
                                    The diameter which will be used for
                                    rewinding the the selected orders
                                  </p>
                                </GroupTitle>
                              </Col>
                              <Col span={8} style={{ marginTop: "16px" }}>
                                <div className="boxFieldTitle">
                                  <label>Reel And Core Diameter</label>
                                  <p>
                                    The reel and core diameter for the reels
                                    that will be used for rewinding
                                  </p>
                                </div>
                              </Col>
                              <Col span={8} className="blockBreak">
                                <Row className="centerAlign">
                                  <Col span={24} className="d-flex threeFields">
                                    <div
                                      className="boxFormType unitSelect"
                                      style={{
                                        marginBottom: "0",
                                        maxWidth: "28%",
                                      }}
                                    >
                                      <span
                                        style={{
                                          fontSize: "12px",
                                          fontWeight: "normal",
                                        }}
                                      >
                                        Dia Type
                                      </span>
                                      <Form.Item
                                        name="diameter_type"
                                        rules={[
                                          {
                                            required: true,
                                            message: "This is a required field",
                                          },
                                        ]}
                                        className="dBlock"
                                        initialValue={selecteDia}
                                      >
                                        <Select
                                          placeholder="Dia type"
                                          showSearch
                                          suffixIcon={<DownArrowDraw />}
                                          onChange={(e) => {
                                            onDiameterChange(e);
                                          }}
                                        >
                                          {diameterType.map((item) => (
                                            <Option key={item.value}>
                                              {item.label}
                                            </Option>
                                          ))}
                                        </Select>
                                      </Form.Item>
                                    </div>
                                    {selecteDia == "constant" ? (
                                      <>
                                        <div>
                                          <span
                                            style={{
                                              fontSize: "12px",
                                              fontWeight: "normal",
                                            }}
                                          >
                                            Reel OD
                                          </span>
                                          <PaperMachineQualitySelect
                                            style={{
                                              marginBottom: "0",
                                              marginTop: "-7px",
                                            }}
                                          >
                                            <MultiSelectCard>
                                              <Multiselect
                                                className="multiQuality"
                                                options={reelValues}
                                                style={multiselectStyle}
                                                showArrow={true}
                                                selectedValues={selectedReelOD}
                                                displayValue={"value"}
                                                showCheckbox={true}
                                                onSelect={onChangeReelOdSelect}
                                                onRemove={onChangeReelOdSelect}
                                                hideSelectedList
                                                keepSearchTerm
                                              />
                                            </MultiSelectCard>
                                          </PaperMachineQualitySelect>
                                          <PaperMachineGradeSelect>
                                            <div className="mainMachineGrade">
                                              {selectedReelOD &&
                                                selectedReelOD?.map(
                                                  (item, index) => {
                                                    return (
                                                      index <= 1 && (
                                                        <span
                                                          className={
                                                            "MachineGradeSelect-active"
                                                          }
                                                        >
                                                          {item.value}
                                                          <Button
                                                            className="textTypeBtn textBtnIcon paperButtonBg"
                                                            onClick={() => {
                                                              removeReelOD(
                                                                item
                                                              );
                                                            }}
                                                          >
                                                            <Iconmoon
                                                              icon="wrong"
                                                              size={14}
                                                              color="#EA655B"
                                                            />
                                                          </Button>
                                                        </span>
                                                      )
                                                    );
                                                  }
                                                )}
                                            </div>
                                            {selectedReelOD &&
                                              selectedReelOD?.length > 1 &&
                                              selectedReelOD?.map(
                                                (item, index) => {
                                                  let tooltipData = "";
                                                  for (
                                                    let index = 2;
                                                    index <
                                                    selectedReelOD?.length;
                                                    index++
                                                  ) {
                                                    const data =
                                                      selectedReelOD[index];
                                                    tooltipData =
                                                      tooltipData +
                                                      data.value +
                                                      ", ";
                                                  }
                                                  tooltipData =
                                                    tooltipData.substring(
                                                      0,
                                                      tooltipData.length - 3
                                                    );
                                                  return (
                                                    index == 2 && (
                                                      <Tooltip
                                                        title={tooltipData}
                                                      >
                                                        {" "}
                                                        <span
                                                          style={{
                                                            display: "flex",
                                                            width: "maxContent",
                                                            justifyContent:
                                                              "flex-end",
                                                          }}
                                                        >
                                                          &{" "}
                                                          {selectedReelOD.length -
                                                            2}{" "}
                                                          More
                                                        </span>
                                                      </Tooltip>
                                                    )
                                                  );
                                                }
                                              )}
                                          </PaperMachineGradeSelect>
                                        </div>
                                        <div
                                          className="boxFormType unitSelect"
                                          style={{ marginBottom: "0" }}
                                        >
                                          <span
                                            style={{
                                              fontSize: "12px",
                                              fontWeight: "normal",
                                            }}
                                          >
                                            Core OD
                                          </span>
                                          <Form.Item
                                            name="coreDia"
                                            rules={[
                                              {
                                                required: true,
                                                message:
                                                  "This is a required field",
                                              },
                                            ]}
                                            className="dBlock"
                                          >
                                            <Select
                                              placeholder="Core OD"
                                              showSearch
                                              suffixIcon={<DownArrowDraw />}
                                              onChange={(e) => {
                                                onCoreodChange(e);
                                              }}
                                            >
                                              {coreValues.map((item) => (
                                                <Option key={item.value}>
                                                  {item.label}
                                                </Option>
                                              ))}
                                            </Select>
                                          </Form.Item>
                                        </div>
                                      </>
                                    ) : (
                                      <>
                                        <div
                                          className="boxFormType unitSelect"
                                          style={{ marginBottom: "0" }}
                                        >
                                          <span
                                            style={{
                                              fontSize: "12px",
                                              fontWeight: "normal",
                                            }}
                                          >
                                            Min OD
                                          </span>
                                          <Form.Item
                                            name="min_reel"
                                            rules={[
                                              {
                                                pattern: new RegExp(
                                                  /^\d+(\.\d{0,3})?$/
                                                ),
                                                message:
                                                  "Only Numeric value is possible upto 3 decimal point",
                                              },
                                              {
                                                required: true,
                                                message:
                                                  "This is a required field",
                                              },
                                              {
                                                validator(_, value) {
                                                  if (parseFloat(value) == 0) {
                                                    return Promise.reject(
                                                      "Min Reel can't be 0"
                                                    );
                                                  } else {
                                                    return Promise.resolve();
                                                  }
                                                },
                                              },
                                            ]}
                                            className="dBlock"
                                          >
                                            <Input
                                              placeholder="Min OD"
                                              className={
                                                reelODValidationError
                                                  ? "showErrorBorder"
                                                  : ""
                                              }
                                              onChange={(e) => {
                                                onMinReelODChange(e);
                                              }}
                                            />
                                          </Form.Item>
                                        </div>
                                        <div
                                          className="boxFormType unitSelect"
                                          style={{ marginBottom: "0" }}
                                        >
                                          <span
                                            style={{
                                              fontSize: "12px",
                                              fontWeight: "normal",
                                            }}
                                          >
                                            Max OD
                                          </span>
                                          <Form.Item
                                            name="max_reel"
                                            rules={[
                                              {
                                                pattern: new RegExp(
                                                  /^\d+(\.\d{0,3})?$/
                                                ),
                                                message:
                                                  "Only Numeric value is possible upto 3 decimal point",
                                              },
                                              {
                                                required: true,
                                                message:
                                                  "This is a required field",
                                              },
                                              {
                                                validator(_, value) {
                                                  if (parseFloat(value) == 0) {
                                                    return Promise.reject(
                                                      "Max Reel can't be 0"
                                                    );
                                                  } else {
                                                    return Promise.resolve();
                                                  }
                                                },
                                              },
                                            ]}
                                            className="dBlock"
                                          >
                                            <Input
                                              placeholder="Max OD"
                                              className={
                                                reelODValidationError
                                                  ? "showErrorBorder"
                                                  : ""
                                              }
                                              onChange={(e) => {
                                                onMaxReelODChange(e);
                                              }}
                                            />
                                          </Form.Item>
                                        </div>
                                        <div
                                          className="boxFormType unitSelect"
                                          style={{ marginBottom: "0" }}
                                        >
                                          <span
                                            style={{
                                              fontSize: "12px",
                                              fontWeight: "normal",
                                            }}
                                          >
                                            Unit
                                          </span>
                                          <Form.Item
                                            name="range_unit"
                                            rules={[
                                              {
                                                required: true,
                                                message:
                                                  "This is a required field",
                                              },
                                            ]}
                                            className="dBlock"
                                          >
                                            <Select
                                              placeholder="Unit"
                                              showSearch
                                              suffixIcon={<DownArrowDraw />}
                                              onChange={(e) => {
                                                onRangeUnitChange(e);
                                              }}
                                            >
                                              {measurementData?.data.units_management.length.data?.map(
                                                (reelUnit) => (
                                                  <Option
                                                    key={reelUnit}
                                                    value={reelUnit}
                                                  >
                                                    {
                                                      lengthUnit[reelUnit]
                                                        ?.displayName
                                                    }
                                                  </Option>
                                                )
                                              )}
                                            </Select>
                                          </Form.Item>
                                        </div>
                                      </>
                                    )}
                                  </Col>
                                  {selecteDia == "range" && (
                                    <Col
                                      span={24}
                                      className="d-flex threeFields"
                                    >
                                      <div
                                        className="boxFormType unitSelect"
                                        style={{
                                          marginBottom: "0",
                                          maxWidth: "13%",
                                        }}
                                      ></div>
                                      <div
                                        className="boxFormType"
                                        style={{ marginBottom: "0" }}
                                      >
                                        <span
                                          style={{
                                            fontSize: "12px",
                                            fontWeight: "normal",
                                          }}
                                        >
                                          Core OD
                                        </span>
                                        <Form.Item
                                          name="core_Dia"
                                          rules={[
                                            {
                                              required: true,
                                              message:
                                                "This is a required field",
                                            },
                                          ]}
                                          className="dBlock"
                                        >
                                          <Select
                                            style={{ width: "207%" }}
                                            placeholder="Core OD"
                                            showSearch
                                            suffixIcon={<DownArrowDraw />}
                                            onChange={(e) => {
                                              onCoreDiaChange(e);
                                            }}
                                          >
                                            {coreValues.map((item) => (
                                              <Option key={item?.value}>
                                                {item?.label}
                                              </Option>
                                            ))}
                                          </Select>
                                        </Form.Item>
                                      </div>
                                      <div
                                        className="boxFormType unitSelect"
                                        style={{ marginBottom: "0" }}
                                      ></div>
                                    </Col>
                                  )}
                                  {coreOdValidationError &&
                                    selecteDia == "constant" ? (
                                    <span
                                      className="errorText"
                                      style={{ color: "#ea4e2c" }}
                                    >
                                      Reel OD cannot be less than Core OD
                                    </span>
                                  ) : null}
                                  {selecteDia == "range" &&
                                    reelODValidationError ? (
                                    <span
                                      className="errorText"
                                      style={{
                                        color: "#ea4e2c",
                                        marginTop: "-2px",
                                      }}
                                    >
                                      Max dia cannot be less than Min dia
                                    </span>
                                  ) : null}
                                  {selecteDia == "range" &&
                                    rangeValidationError ? (
                                    <span
                                      className="errorText"
                                      style={{
                                        color: "#ea4e2c",
                                        marginTop: "-2px",
                                      }}
                                    >
                                      Min Reel dia cannot be less than Core OD
                                    </span>
                                  ) : null}
                                </Row>
                              </Col>
                            </Row>
                            {/* </Form> */}
                          </div>
                        </HaberForm>
                      </DetailFields>
                    )}
                    {isAddRewinderDimension && (
                      <Row style={{ width: "100%" }}>
                        <Col style={{ width: "60%" }}></Col>
                        <Col style={{ width: "40%" }}>
                          <OrderDetails style={{ height: "100%" }}>
                            <div
                              className="pendingDetailsStyle"
                              style={{
                                paddingBottom: "0px",
                                paddingTop: "15px",
                              }}
                            >
                              <span className="pendingOrderStyle">
                                {" "}
                                Selected Orders:{" "}
                                {selectedRowKeys?.length
                                  ? selectedRowKeys.length
                                  : 0}
                              </span>{" "}
                              Selected Quantity: {totalWeight.toFixed(3)}{" "}
                              {capitalize(
                                weightUnit[
                                  unitData.units_management.weight.default
                                ].displayName
                              )}
                            </div>
                          </OrderDetails>
                        </Col>
                      </Row>
                    )}
                    {filterTags.map((filter) => (
                      // <Tooltip
                      //   placement="bottomRight"
                      //   title={filter.tooltip || ""}
                      //   className="edit-tooltip"
                      //   getPopupContainer={(triggerNode) => triggerNode}
                      // >
                      <span className="filter-tags">
                        <Iconmoon icon="filter" size={13} color="#a8a8a8" />
                        &nbsp;
                        <span>{filter.formattedType}</span>
                        &nbsp;
                        <span>{filter.operand}</span>
                        &nbsp;
                        <span>{filter.value}</span>
                        <span>
                          {" "}
                          <button
                            onClick={() => {
                              removeFilter(filter);
                            }}
                          >
                            {" "}
                            <Iconmoon
                              icon="wrong"
                              size={15}
                              color="#a8a8a8"
                            />{" "}
                          </button>
                        </span>
                        <Styled></Styled>
                      </span>
                      // </Tooltip>
                    ))}
                    <OrderDetails>
                      <div
                        className="pendingDetailsStyle"
                        style={{ marginTop: "10px", paddingBottom: "5px" }}
                      >
                        <Button
                          key="1"
                          className="textTypeBtn textBtnIcon"
                          onClick={onClearSelection}
                        >
                          Clear Selection
                        </Button>
                      </div>
                    </OrderDetails>
                    </div>

                    {loading ? (
                      <TableShimmer
                        // header={columnsHead.current}
                        header={
                          orderManagementSettings?.fetch_balance_quantity?.value
                            ? columnsHead.current
                            : columnsHead.current?.filter(
                              (ele) => ele.dataIndex !== "balance_qty"
                            )
                        }
                        scroll={2000}
                      />
                    ) : tableData.length ? (
                      <Table
                        sticky={{
                          offsetHeader: stickyOffsets.table,
                          getContainer: () => {
                            let node = document.getElementById('right-layout-container');
                            while (node && node !== document.body) {
                              const style = window.getComputedStyle(node);
                              if (style.overflowY === 'auto' || style.overflowY === 'scroll') return node;
                              node = node.parentNode;
                            }
                            return window;
                          }
                        }}
                        // columns={
                        //   location?.state?.selected_type === "rewinding"
                        //     ? columnsHead.current
                        //     : location?.state?.selected_type === "cutting" &&
                        //       orderType == "selected_orders"
                        //     ? cutterSelectedOrderColumnsHead.current
                        //     : cutterOtherOrderColumnsHead.current
                        // }
                        columns={
                          location?.state?.selected_type === "rewinding"
                            ? orderManagementSettings?.fetch_balance_quantity
                              ?.value
                              ? columnsHead.current
                              : columnsHead.current?.filter(
                                (item) => item.dataIndex !== "balance_qty"
                              )
                            : location?.state?.selected_type === "cutting" &&
                              orderType === "selected_orders"
                              ? orderManagementSettings?.fetch_balance_quantity
                                ?.value
                                ? cutterSelectedOrderColumnsHead.current
                                : cutterSelectedOrderColumnsHead.current?.filter(
                                  (item) => item.dataIndex !== "balance_qty"
                                )
                              : orderManagementSettings?.fetch_balance_quantity
                                ?.value
                                ? cutterOtherOrderColumnsHead.current
                                : cutterOtherOrderColumnsHead.current?.filter(
                                  (item) => item.dataIndex !== "balance_qty"
                                )
                        }
                        rowSelection={{
                          columnWidth: "3%",
                          selectedRowKeys,
                          columnTitle: headerCheckbox,
                          onSelect:
                            orderType == "other_orders" &&
                              location?.state?.selected_type === "rewinding" &&
                              isAddRewinderDimension
                              ? handleSelectRewinder
                              : handleSelect,
                          getCheckboxProps: (record) => ({
                            disabled: record.isConflictingstate,
                          }),
                        }}
                        rowClassName={getRow}
                        dataSource={tableData}
                        onChange={onChange}
                        scroll={{ x: "max-content" }}
                        pagination={{
                          current: currentPage,
                          total: totalRecords,
                          showTitle: false,
                          pageSize: paginationParams.size,
                          showTotal: (total, range) =>
                            `Showing ${range[0]}-${range[1]} of ${total} results`,
                          pageSizeOptions: [10, 20, 50, 100],
                          showSizeChanger: true,
                          // locale: { items_per_page: "" },
                        }}
                      />
                    ) : (
                      <EmptyState
                        img={
                          emptyStateLabel === "noData" ||
                            emptyStateLabel === "filter"
                            ? emptyState_NoData
                            : emptyStateLabel === "search"
                              ? emptyState_Search
                              : emptyState_ConnectionAPIError
                        }
                        heading={emptyStatePropsData.heading}
                        subHeading={emptyStatePropsData.subHeading}
                        label={emptyStatePropsData.label}
                        refresh={refresh}
                      />
                    )}
                  </div>
                </Form>
              </TableLayoutData>
            </Panes>
          ))}
        </Tabs>
      </StyledTab>
      <ModalPopup visible={isVisibleModal}>
        <div className="Popup-img">
          <img src={warning} alt="Warning" />
        </div>
        <div className="Popup-content">
          <span>Remove Group?</span>
          <p>
            You are about to remove this order group, are you sure you want to
            continue?
          </p>
        </div>
        <div className="ant-modal-footer-section">
          <Button
            key="back"
            className="themeBtn-plane"
            onClick={() => modalClose()}
          >
            <div className="plusPopUpBorder">
              <Iconmoon
                icon="plus-sign"
                size={9}
                color="#EA655B"
                className="ant-ico-sec"
              />
            </div>
            Cancel
          </Button>

          <Button
            key="submit"
            className="themeBtn"
            onClick={() => modalConfirm()}
          >
            <Iconmoon icon="tick-mark" size={14} color="#ffff" />
            Confirm
          </Button>
        </div>
      </ModalPopup>

      <ConfirmationModal
        visible={viewCancelModal}
        icon={warning}
        confirmAction={confirmCancelModal}
        cancelAction={closeCancelModal}
      >
        <span>Cancel job card?</span>
        <p>
          You are about to cancel the deckle match process. Are you sure you
          want to continue?
        </p>
      </ConfirmationModal>

      {editReelCoreModal && selectedRecord && (
        <ReelCoreEditModal
          visible={editReelCoreModal}
          icon={warning}
          confirmAction={confirmEditReelCoreModal}
          cancelAction={closeEditReelCoreModal}
          orderData={selectedRecord}
          type={selectedType}
        >
          <span></span>
          <p></p>
        </ReelCoreEditModal>
      )}
      {visibleToaster && !actionToaster.error && (
        <AlertContainer
          color="green toaster"
          icon={alertGreen}
          msg={actionToaster.msg}
        />
      )}
      {visibleToaster && actionToaster.error && (
        <AlertContainer
          color="red toaster"
          icon={alertRed}
          msg={actionToaster.msg}
        />
      )}

      {viewDeckleOrders && (
        <MultiDiaEditOrderDrawer
          visible={viewDeckleOrders}
          onClose={onCloseViewDrawer}
          onCloseGrade={onCloseFullViewDrawer}
          selectedOrderNo={selectedRecord?.orderno}
          selectedState={selectedRecord?.status}
          selectedOrder={selectedRecord}
          actionType="view"
          type="deckleRecord"
          category={selectedRecord?.category}
        ></MultiDiaEditOrderDrawer>
      )}

      {resendApprovalData && (
        <MultiDiaEditOrderDrawer
          visible={resendApprovalData}
          onClose={onCloseNewGrade}
          onCloseGrade={onCloseFullViewDrawer}
          selectedOrderNo={selectedRecord?.orderno}
          selectedState={"approved"}
          rendering={setRendering}
          toasterAction={setActionToaster}
          showToaster={() => showToaster(setVisibleToaster)}
          isEditFromIncompleteOrder={true}
          type="deckleRecord"
          actionType="edit"
          category={selectedRecord?.category}
        ></MultiDiaEditOrderDrawer>
      )}
    </RightLayoutContainer>
  ) : null;
};

export default OrderSummaryData;
